import { Routes } from '@angular/router';

const Routing: Routes = [
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
  },

  {
    path: 'report/analyticsreport',
    loadChildren: () => import('./reports/analyticsreport/analyticsReportPage.module').then(m => m.AnalyticsReportPageModule)
  },
  {
    path: 'report/finance/agewisepayablereport',
    loadChildren: () => import('./reports/finance/AgewisePayable/AgewisePayableReport.module').then(m => m.AgewisePayableReportModule)
  },
  {
    path: 'report/finance/agewisereceivablereport',
    loadChildren: () => import('./reports/finance/AgewiseReceivable/AgewiseReceivableReport.module').then(m => m.AgewiseReceivableReportModule)
  },


  //{
  //  path: 'general/importsdata',
  //  loadChildren: () => import('./generalcomponents/importsdata/importsData.module').then(m => m.ImportsDataModule)
  //},

  {
    path: 'general/codegenerate/addcodegenerate',
    loadChildren: () => import('./generalcomponents/codegenerate/addcodegenerate/addCodeGenerate.module').then(m => m.AddCodeGenerateModule)
  },
  {
    path: 'general/codegenerate/addcodegenerate/:id',
    loadChildren: () => import('./generalcomponents/codegenerate/addcodegenerate/addCodeGenerate.module').then(m => m.AddCodeGenerateModule)
  },
  {
    path: 'general/codegenerate/fetchcodegenerate',
    loadChildren: () => import('./generalcomponents/codegenerate/fetchcodegenerate/fetchCodeGenerate.module').then(m => m.FetchCodeGenerateModule)
  },
  {
    path: 'general/codegenerate/codegeneratemapping',
    loadChildren: () => import('./generalcomponents/codegenerate/codegeneratemapping/codegeneratemapping.module').then(m => m.CodeGenerateMappingModule)
  },

  //{
  //  path: 'organisation/addorganisation',
  //  loadChildren: () => import('./generalcomponents/organisation/addorganisation/addOrganisation.module').then(m => m.AddOrganisationModule)
  //},
  //{
  //  path: 'organisation/addorganisation/:id',
  //  loadChildren: () => import('./generalcomponents/organisation/addorganisation/addOrganisation.module').then(m => m.AddOrganisationModule)
  //},
  //{
  //  path: 'organisation/fetchorganisation',
  //  loadChildren: () => import('./generalcomponents/organisation/fetchorganisation/fetchOrganisation.module').then(m => m.FetchOrganisationModule)
  //},
  ////
  //{
  //  path: 'general/calendar/addcalendar',
  //  loadChildren: () => import('./generalcomponents/calendar/addcalendar/addCalendar.module').then(m => m.AddCalendarModule)
  //},
  //{
  //  path: 'general/calendar/addcalendar/:id',
  //  loadChildren: () => import('./generalcomponents/calendar/addcalendar/addCalendar.module').then(m => m.AddCalendarModule)
  //},

  //{
  //  path: 'general/calendar/fetchcalendar',
  //  loadChildren: () => import('./generalcomponents/calendar/fetchcalendar/fetchCalendar.module').then(m => m.FetchCalendarModule)
  //},
  ////


  //{
  //  path: 'country/addcountry',
  //  loadChildren: () => import('./generalcomponents/country/addcountry/addCountry.module').then(m => m.AddCountryModule)
  //},
  //{
  //  path: 'country/addcountry/:id',
  //  loadChildren: () => import('./generalcomponents/country/addcountry/addCountry.module').then(m => m.AddCountryModule)
  //},

  //{
  //  path: 'country/fetchcountry',
  //  loadChildren: () => import('./generalcomponents/country/fetchcountry/fetchCountry.module').then(m => m.FetchCountryModule)
  //},

  //{
  //  path: 'usergroup/addusergroup',
  //  loadChildren: () => import('./generalcomponents/usergroup/addusergroup/addUserGroup.module').then(m => m.AddUserGroupModule)
  //},
  //{
  //  path: 'usergroup/addusergroup/:id',
  //  loadChildren: () => import('./generalcomponents/usergroup/addusergroup/addUserGroup.module').then(m => m.AddUserGroupModule)
  //},

  //{
  //  path: 'usergroup/fetchusergroup',
  //  loadChildren: () => import('./generalcomponents/usergroup/fetchusergroup/fetchUserGroup.module').then(m => m.FetchUserGroupModule)
  //},
  //{
  //  path: 'user/adduser',
  //  loadChildren: () => import('./generalcomponents/user/adduser/addUser.module').then(m => m.AddUserModule)
  //},
  //{
  //  path: 'user/adduser/:id',
  //  loadChildren: () => import('./generalcomponents/user/adduser/addUser.module').then(m => m.AddUserModule)
  //},
  //{
  //  path: 'user/fetchuser',
  //  loadChildren: () => import('./generalcomponents/user/fetchuser/fetchUser.module').then(m => m.FetchUserModule)
  //},

  {
    path: 'muser/addmuser',
    loadChildren: () => import('./generalcomponents/muser/addmuser/addMUser.module').then(m => m.AddMUserModule)
  },
  {
    path: 'muser/addmuser/:id',
    loadChildren: () => import('./generalcomponents/muser/addmuser/addMUser.module').then(m => m.AddMUserModule)
  },
  {
    path: 'muser/fetchmuser',
    loadChildren: () => import('./generalcomponents/muser/fetchmuser/fetchMUser.module').then(m => m.FetchMUserModule)
  },

  //{
  //  path: 'state/addstate',
  //  loadChildren: () => import('./generalcomponents/state/addstate/addstate.module').then(m => m.AddStateModule)
  //},
  //{
  //  path: 'state/addstate/:id',
  //  loadChildren: () => import('./generalcomponents/state/addstate/addstate.module').then(m => m.AddStateModule)
  //},

  //{
  //  path: 'state/fetchstates',
  //  loadChildren: () => import('./generalcomponents/state/fetchstates/fetchstates.module').then(m => m.FetchStateModule)
  //},


  //{
  //  path: 'city/addcity',
  //  loadChildren: () => import('./generalcomponents/city/addcity/addCity.module').then(m => m.AddCityModule)
  //},
  //{
  //  path: 'city/addcity/:id',
  //  loadChildren: () => import('./generalcomponents/city/addcity/addCity.module').then(m => m.AddCityModule)
  //},

  //{
  //  path: 'city/fetchcity',
  //  loadChildren: () => import('./generalcomponents/city/fetchcity/fetchCity.module').then(m => m.FetchCityModule)
  //},
  //{
  //  path: 'department/adddepartment',
  //  loadChildren: () => import('./generalcomponents/department/adddepartment/addDepartment.module').then(m => m.AddDepartmentModule)
  //},
  //{
  //  path: 'department/adddepartment/:id',
  //  loadChildren: () => import('./generalcomponents/department/adddepartment/addDepartment.module').then(m => m.AddDepartmentModule)
  //},

  //{
  //  path: 'department/fetchdepartment',
  //  loadChildren: () => import('./generalcomponents/department/fetchdepartment/fetchDepartment.module').then(m => m.FetchDepartmentModule)
  //},

  //{
  //  path: 'languages/addlanguages',
  //  loadChildren: () => import('./generalcomponents/languages/addlanguages/addLanguages.module').then(m => m.AddLanguagesModule)
  //},
  //{
  //  path: 'languages/addlanguages/:id',
  //  loadChildren: () => import('./generalcomponents/languages/addlanguages/addLanguages.module').then(m => m.AddLanguagesModule)
  //},

  //{
  //  path: 'languages/fetchlanguages',
  //  loadChildren: () => import('./generalcomponents/languages/fetchlanguages/fetchLanguages.module').then(m => m.FetchLanguagesModule)
  //},
  //{
  //  path: 'dimention/adddimention',
  //  loadChildren: () => import('./generalcomponents/dimention/adddimention/addDimention.module').then(m => m.AddDimentionModule)
  //},
  //{
  //  path: 'dimention/adddimention/:id',
  //  loadChildren: () => import('./generalcomponents/dimention/adddimention/addDimention.module').then(m => m.AddDimentionModule)
  //},

  //{
  //  path: 'dimention/fetchdimention',
  //  loadChildren: () => import('./generalcomponents/dimention/fetchdimention/fetchDimention.module').then(m => m.FetchDimentionModule)
  //},
  //{
  //  path: 'currency/addcurrency',
  //  loadChildren: () => import('./generalcomponents/currency/addcurrency/addCurrency.module').then(m => m.AddCurrencyModule)
  //},
  //{
  //  path: 'currency/addcurrency/:id',
  //  loadChildren: () => import('./generalcomponents/currency/addcurrency/addCurrency.module').then(m => m.AddCurrencyModule)
  //},

  //{
  //  path: 'currency/fetchcurrency',
  //  loadChildren: () => import('./generalcomponents/currency/fetchcurrency/fetchCurrency.module').then(m => m.FetchCurrencyModule)
  //},
  //{
  //  path: 'timezone/addtimezone',
  //  loadChildren: () => import('./generalcomponents/timezone/addtimezone/addTimeZone.module').then(m => m.AddTimeZoneModule)
  //},
  //{
  //  path: 'timezone/addtimezone/:id',
  //  loadChildren: () => import('./generalcomponents/timezone/addtimezone/addTimeZone.module').then(m => m.AddTimeZoneModule)
  //},

  //{
  //  path: 'timezone/fetchtimezone',
  //  loadChildren: () => import('./generalcomponents/timezone/fetchtimezone/fetchTimeZone.module').then(m => m.FetchTimeZoneModule)
  //},
  //{
  //  path: 'iso/addiso',
  //  loadChildren: () => import('./generalcomponents/iso/addiso/addIso.module').then(m => m.AddIsoModule)
  //},
  //{
  //  path: 'iso/addiso/:id',
  //  loadChildren: () => import('./generalcomponents/iso/addiso/addIso.module').then(m => m.AddIsoModule)
  //},

  //{
  //  path: 'iso/fetchiso',
  //  loadChildren: () => import('./generalcomponents/iso/fetchiso/fetchIso.module').then(m => m.FetchIsoModule)
  //},

  //{
  //  path: 'tms/tyreinspection/addtyreinspection',
  //  loadChildren: () => import('./tmscomponents/tyreinspection/addtyreinspection/addTyreInspection.module').then(m => m.AddTyreInspectionModule)
  //},
  //{
  //  path: 'tms/tyreinspection/addtyreinspection/:id',
  //  loadChildren: () => import('./tmscomponents/tyreinspection/addtyreinspection/addTyreInspection.module').then(m => m.AddTyreInspectionModule)
  //},

  //{
  //  path: 'tms/tyreinspection/fetchtyreinspection',
  //  loadChildren: () => import('./tmscomponents/tyreinspection/fetchtyreinspection/fetchTyreInspection.module').then(m => m.FetchTyreInspectionModule)
  //},
  ////

  //{
  //  path: 'tms/tyrespositiontemplate/addtyrespositiontemplate',
  //  loadChildren: () => import('./tmscomponents/tyrespositiontemplate/addtyrespositiontemplate/addTyresPositionTemplate.module').then(m => m.AddTyresPositionTemplateModule)
  //},
  //{
  //  path: 'tms/tyrespositiontemplate/addtyrespositiontemplate/:id',
  //  loadChildren: () => import('./tmscomponents/tyrespositiontemplate/addtyrespositiontemplate/addTyresPositionTemplate.module').then(m => m.AddTyresPositionTemplateModule)
  //},

  //{
  //  path: 'tms/tyrespositiontemplate/fetchtyrespositiontemplate',
  //  loadChildren: () => import('./tmscomponents/tyrespositiontemplate/fetchtyrespositiontemplate/fetchTyresPositionTemplate.module').then(m => m.FetchTyresPositionTemplateModule)
  //},
  ////

  //{
  //  path: 'tms/action/addaction',
  //  loadChildren: () => import('./tmscomponents/action/addaction/addAction.module').then(m => m.AddActionModule)
  //},
  //{
  //  path: 'tms/action/addaction/:id',
  //  loadChildren: () => import('./tmscomponents/action/addaction/addAction.module').then(m => m.AddActionModule)
  //},

  //{
  //  path: 'tms/action/fetchaction',
  //  loadChildren: () => import('./tmscomponents/action/fetchaction/fetchAction.module').then(m => m.FetchActionModule)
  //},
  ////

  //{
  //  path: 'tms/tyrelocation/addtyrelocation',
  //  loadChildren: () => import('./tmscomponents/tyrelocation/addtyrelocation/addTyreLocation.module').then(m => m.AddTyreLocationModule)
  //},
  //{
  //  path: 'tms/tyrelocation/addtyrelocation/:id',
  //  loadChildren: () => import('./tmscomponents/tyrelocation/addtyrelocation/addTyreLocation.module').then(m => m.AddTyreLocationModule)
  //},

  //{
  //  path: 'tms/tyrelocation/fetchtyrelocation',
  //  loadChildren: () => import('./tmscomponents/tyrelocation/fetchtyrelocation/fetchTyreLocation.module').then(m => m.FetchTyreLocationModule)
  //},
  ////
  //{
  //  path: 'tms/tyremaster/addtyremaster',
  //  loadChildren: () => import('./tmscomponents/tyremaster/addtyremaster/addTyreMaster.module').then(m => m.AddTyreMasterModule)
  //},
  //{
  //  path: 'tms/tyremaster/addtyremaster/:id',
  //  loadChildren: () => import('./tmscomponents/tyremaster/addtyremaster/addTyreMaster.module').then(m => m.AddTyreMasterModule)
  //},

  //{
  //  path: 'tms/tyremaster/fetchtyremaster',
  //  loadChildren: () => import('./tmscomponents/tyremaster/fetchtyremaster/fetchTyreMaster.module').then(m => m.FetchTyreMasterModule)
  //},
  //{
  //  path: 'tms/tyreistissue/addtyreistissue',
  //  loadChildren: () => import('./tmscomponents/tyreistissue/addtyreistissue/addTyreIstIssue.module').then(m => m.AddTyreIstIssueModule)
  //},
  //{
  //  path: 'tms/tyreistissue/addtyreistissue/:id',
  //  loadChildren: () => import('./tmscomponents/tyreistissue/addtyreistissue/addTyreIstIssue.module').then(m => m.AddTyreIstIssueModule)
  //},
  //{
  //  path: 'tms/tyreistissue/fetchtyreistissue',
  //  loadChildren: () => import('./tmscomponents/tyreistissue/fetchtyreistissue/fetchTyreIstIssue.module').then(m => m.FetchTyreIstIssueModule)
  //},
  ////

  //{
  //  path: 'tms/rethreadingissue/addrethreadingissue',
  //  loadChildren: () => import('./tmscomponents/tyrerethreadingissue/addtyrerethreadingissue/addTyreRethreadingIssue.module').then(m => m.AddTyreRethreadingIssueModule)
  //},
  //{
  //  path: 'tms/rethreadingissue/addrethreadingissue/:id',
  //  loadChildren: () => import('./tmscomponents/tyrerethreadingissue/addtyrerethreadingissue/addTyreRethreadingIssue.module').then(m => m.AddTyreRethreadingIssueModule)
  //},

  //{
  //  path: 'tms/rethreadingissue/fetchrethreadingissue',
  //  loadChildren: () => import('./tmscomponents/tyrerethreadingissue/fetchtyrerethreadingissue/fetchTyreRethreadingIssue.module').then(m => m.FetchTyreRethreadingIssueModule)
  //},
  ////

  //{
  //  path: 'tms/rethreadingreceipt/addrethreadingreceipt',
  //  loadChildren: () => import('./tmscomponents/tyrerethreadingreceipt/addtyrerethreadingreceipt/addTyreRethreadingReceipt.module').then(m => m.AddTyreRethreadingReceiptModule)
  //},
  //{
  //  path: 'tms/rethreadingreceipt/addrethreadingreceipt/:id',
  //  loadChildren: () => import('./tmscomponents/tyrerethreadingreceipt/addtyrerethreadingreceipt/addTyreRethreadingReceipt.module').then(m => m.AddTyreRethreadingReceiptModule)
  //},

  //{
  //  path: 'tms/rethreadingreceipt/fetchrethreadingreceipt',
  //  loadChildren: () => import('./tmscomponents/tyrerethreadingreceipt/fetchtyrerethreadingreceipt/fetchTyreRethreadingReceipt.module').then(m => m.FetchTyreRethreadingReceiptModule)
  //},
  ////

  //{
  //  path: 'tms/tyreistreceipt/addtyreistreceipt',
  //  loadChildren: () => import('./tmscomponents/tyreistreceipt/addtyreistreceipt/addTyreIstReceipt.module').then(m => m.AddTyreIstReceiptModule)
  //},
  //{
  //  path: 'tms/tyreistreceipt/addtyreistreceipt/:id',
  //  loadChildren: () => import('./tmscomponents/tyreistreceipt/addtyreistreceipt/addTyreIstReceipt.module').then(m => m.AddTyreIstReceiptModule)
  //},

  //{
  //  path: 'tms/tyreistreceipt/fetchtyreistreceipt',
  //  loadChildren: () => import('./tmscomponents/tyreistreceipt/fetchtyreistreceipt/fetchTyreIstReceipt.module').then(m => m.FetchTyreIstReceiptModule)
  //},
  ////

  //{
  //  path: 'tms/tyrelocationtransfer/addtyrelocationtransfer',
  //  loadChildren: () => import('./tmscomponents/tyrelocationtransfer/addtyrelocationtransfer/addTyreLocationTransfer.module').then(m => m.AddTyreLocationTransferModule)
  //},
  //{
  //  path: 'tms/tyrelocationtransfer/addtyrelocationtransfer/:id',
  //  loadChildren: () => import('./tmscomponents/tyrelocationtransfer/addtyrelocationtransfer/addTyreLocationTransfer.module').then(m => m.AddTyreLocationTransferModule)
  //},

  //{
  //  path: 'tms/tyrelocationtransfer/fetchtyrelocationtransfer',
  //  loadChildren: () => import('./tmscomponents/tyrelocationtransfer/fetchtyrelocationtransfer/fetchTyreLocationTransfer.module').then(m => m.FetchTyreLocationTransferModule)
  //},

  //{
  //  path: 'tms/tyrebatch/addtyrebatch',
  //  loadChildren: () => import('./tmscomponents/tyrebatch/addtyrebatch/addTyreBatch.module').then(m => m.AddTyreBatchModule)
  //},
  //{
  //  path: 'tms/tyrebatch/addtyrebatch/:id',
  //  loadChildren: () => import('./tmscomponents/tyrebatch/addtyrebatch/addTyreBatch.module').then(m => m.AddTyreBatchModule)
  //},

  //{
  //  path: 'tms/tyrebatch/fetchtyrebatch',
  //  loadChildren: () => import('./tmscomponents/tyrebatch/fetchtyrebatch/fetchTyreBatch.module').then(m => m.FetchTyreBatchModule)
  //},
  //{
  //  path: 'tms/tyretype/addtyretype',
  //  loadChildren: () => import('./tmscomponents/tyretype/addtyretype/addTyreType.module').then(m => m.AddTyreTypeModule)
  //},
  //{
  //  path: 'tms/tyretype/addtyretype/:id',
  //  loadChildren: () => import('./tmscomponents/tyretype/addtyretype/addTyreType.module').then(m => m.AddTyreTypeModule)
  //},

  //{
  //  path: 'tms/tyretype/fetchtyretype',
  //  loadChildren: () => import('./tmscomponents/tyretype/fetchtyretype/fetchTyreType.module').then(m => m.FetchTyreTypeModule)
  //},
  //{
  //  path: 'tms/tyrebrand/addtyrebrand',
  //  loadChildren: () => import('./tmscomponents/tyrebrand/addtyrebrand/addTyreBrand.module').then(m => m.AddTyreBrandModule)
  //},
  //{
  //  path: 'tms/tyrebrand/addtyrebrand/:id',
  //  loadChildren: () => import('./tmscomponents/tyrebrand/addtyrebrand/addTyreBrand.module').then(m => m.AddTyreBrandModule)
  //},

  //{
  //  path: 'tms/tyrebrand/fetchtyrebrand',
  //  loadChildren: () => import('./tmscomponents/tyrebrand/fetchtyrebrand/fetchTyreBrand.module').then(m => m.FetchTyreBrandModule)
  //},
  //{
  //  path: 'tms/tyrefailure/addtyrefailure',
  //  loadChildren: () => import('./tmscomponents/tyrefailure/addtyrefailure/addTyreFailure.module').then(m => m.AddTyreFailureModule)
  //},
  //{
  //  path: 'tms/tyrefailure/addtyrefailure/:id',
  //  loadChildren: () => import('./tmscomponents/tyrefailure/addtyrefailure/addTyreFailure.module').then(m => m.AddTyreFailureModule)
  //},

  //{
  //  path: 'tms/tyrefailure/fetchtyrefailure',
  //  loadChildren: () => import('./tmscomponents/tyrefailure/fetchtyrefailure/fetchTyreFailure.module').then(m => m.FetchTyreFailureModule)
  //},
  //{
  //  path: 'tms/tyrepattern/addtyrepattern',
  //  loadChildren: () => import('./tmscomponents/tyrepattern/addtyrepattern/addTyrePattern.module').then(m => m.AddTyrePatternModule)
  //},
  //{
  //  path: 'tms/tyrepattern/addtyrepattern/:id',
  //  loadChildren: () => import('./tmscomponents/tyrepattern/addtyrepattern/addTyrePattern.module').then(m => m.AddTyrePatternModule)
  //},

  //{
  //  path: 'tms/tyrepattern/fetchtyrepattern',
  //  loadChildren: () => import('./tmscomponents/tyrepattern/fetchtyrepattern/fetchTyrePattern.module').then(m => m.FetchTyrePatternModule)
  //},
  //{
  //  path: 'tms/tyreposition/addtyreposition',
  //  loadChildren: () => import('./tmscomponents/tyreposition/addtyreposition/addTyrePosition.module').then(m => m.AddTyrePositionModule)
  //},
  //{
  //  path: 'tms/tyreposition/addtyreposition/:id',
  //  loadChildren: () => import('./tmscomponents/tyreposition/addtyreposition/addTyrePosition.module').then(m => m.AddTyrePositionModule)
  //},

  //{
  //  path: 'tms/tyreposition/fetchtyreposition',
  //  loadChildren: () => import('./tmscomponents/tyreposition/fetchtyreposition/fetchTyrePosition.module').then(m => m.FetchTyrePositionModule)
  //},
  //{
  //  path: 'tms/tyresize/addtyresize',
  //  loadChildren: () => import('./tmscomponents/tyresize/addtyresize/addTyreSize.module').then(m => m.AddTyreSizeModule)
  //},
  //{
  //  path: 'tms/tyresize/addtyresize/:id',
  //  loadChildren: () => import('./tmscomponents/tyresize/addtyresize/addTyreSize.module').then(m => m.AddTyreSizeModule)
  //},

  //{
  //  path: 'tms/tyresize/fetchtyresize',
  //  loadChildren: () => import('./tmscomponents/tyresize/fetchtyresize/fetchTyreSize.module').then(m => m.FetchTyreSizeModule)
  //},
  //{
  //  path: 'tms/tyretechnician/addtyretechnician',
  //  loadChildren: () => import('./tmscomponents/tyretechnician/addtyretechnician/addTyreTechnician.module').then(m => m.AddTyreTechnicianModule)
  //},
  //{
  //  path: 'tms/tyretechnician/addtyretechnician/:id',
  //  loadChildren: () => import('./tmscomponents/tyretechnician/addtyretechnician/addTyreTechnician.module').then(m => m.AddTyreTechnicianModule)
  //},

  //{
  //  path: 'tms/tyretechnician/fetchtyretechnician',
  //  loadChildren: () => import('./tmscomponents/tyretechnician/fetchtyretechnician/fetchTyreTechnician.module').then(m => m.FetchTyreTechnicianModule)
  //},
  //{
  //  path: 'tms/tyrelocationtype/addtyrelocationtype',
  //  loadChildren: () => import('./tmscomponents/tyrelocationtype/addtyrelocationtype/addTyreLocationType.module').then(m => m.AddTyreLocationTypeModule)
  //},
  //{
  //  path: 'tms/tyrelocationtype/addtyrelocationtype/:id',
  //  loadChildren: () => import('./tmscomponents/tyrelocationtype/addtyrelocationtype/addTyreLocationType.module').then(m => m.AddTyreLocationTypeModule)
  //},

  //{
  //  path: 'tms/tyrelocationtype/fetchtyrelocationtype',
  //  loadChildren: () => import('./tmscomponents/tyrelocationtype/fetchtyrelocationtype/fetchTyreLocationType.module').then(m => m.FetchTyreLocationTypeModule)
  //},
  //{
  //  path: 'tms/trucktyremapping/addtrucktyremapping',
  //  loadChildren: () => import('./tmscomponents/trucktyremapping/addtrucktyremapping/addTruckTyreMapping.module').then(m => m.AddTruckTyreMappingModule)
  //},
  //{
  //  path: 'tms/trucktyremapping/addtrucktyremapping/:id',
  //  loadChildren: () => import('./tmscomponents/trucktyremapping/addtrucktyremapping/addTruckTyreMapping.module').then(m => m.AddTruckTyreMappingModule)
  //},

  //{
  //  path: 'tms/trucktyremapping/fetchtrucktyremapping',
  //  loadChildren: () => import('./tmscomponents/trucktyremapping/fetchtrucktyremapping/fetchTruckTyreMapping.module').then(m => m.FetchTruckTyreMappingModule)
  //},

  //{
  //  path: 'tms/tyreremoving/addtyreremoving',
  //  loadChildren: () => import('./tmscomponents/tyreremoval/addtyreremoval/addTyreRemoval.module').then(m => m.AddTyreRemovalModule)
  //},
  //{
  //  path: 'tms/tyreremoving/addtyreremoving/:id',
  //  loadChildren: () => import('./tmscomponents/tyreremoval/addtyreremoval/addTyreRemoval.module').then(m => m.AddTyreRemovalModule)
  //},

  //{
  //  path: 'tms/tyreremoving/fetchtyreremoving',
  //  loadChildren: () => import('./tmscomponents/tyreremoval/fetchtyreremoval/fetchTyreRemoval.module').then(m => m.FetchTyreRemovalModule)
  //},
  //{
  //  path: 'tms/tyremounting/addtyremounting',
  //  loadChildren: () => import('./tmscomponents/tyremounting/addtyremounting/addTyreMounting.module').then(m => m.AddTyreMountingModule)
  //},
  //{
  //  path: 'tms/tyremounting/addtyremounting/:id',
  //  loadChildren: () => import('./tmscomponents/tyremounting/addtyremounting/addTyreMounting.module').then(m => m.AddTyreMountingModule)
  //},

  //{
  //  path: 'tms/tyremounting/fetchtyremounting',
  //  loadChildren: () => import('./tmscomponents/tyremounting/fetchtyremounting/fetchTyreMounting.module').then(m => m.FetchTyreMountingModule)
  //},
  //{
  //  path: 'tms/tyremaster/addtyremaster',
  //  loadChildren: () => import('./tmscomponents/tyremaster/addtyremaster/addTyreMaster.module').then(m => m.AddTyreMasterModule)
  //},
  //{
  //  path: 'tms/tyremaster/addtyremaster/:id',
  //  loadChildren: () => import('./tmscomponents/tyremaster/addtyremaster/addTyreMaster.module').then(m => m.AddTyreMasterModule)
  //},

  //{
  //  path: 'tms/tyremaster/fetchtyremaster',
  //  loadChildren: () => import('./tmscomponents/tyremaster/fetchtyremaster/fetchTyreMaster.module').then(m => m.FetchTyreMasterModule)
  //},

  //{
  //    path: 'inventory/unitsetuommapping/addunitsetuommapping',
  //    loadChildren: () => import('./inventorycomponents/unitsetuommapping/addunitsetuommapping/addUnitSetUomMapping.module').then(m => m.AddUnitSetUomMappingModule)
  //},
  //{
  //    path: 'inventory/unitsetuommapping/addunitsetuommapping/:id',
  //    loadChildren: () => import('./inventorycomponents/unitsetuommapping/addunitsetuommapping/addUnitSetUomMapping.module').then(m => m.AddUnitSetUomMappingModule)
  //},

  //{
  //    path: 'inventory/unitsetuommapping/fetchunitsetuommapping',
  //    loadChildren: () => import('./inventorycomponents/unitsetuommapping/fetchunitsetuommapping/fetchUnitSetUomMapping.module').then(m => m.FetchUnitSetUomMappingModule)
  //},

  ////
  //{
  //  path: 'cms/storagereason/addstoragereason',
  //  loadChildren: () => import('./cmscomponents/storagereason/addstoragereason/addStorageReason.module').then(m => m.AddStorageReasonModule)
  //},
  //{
  //  path: 'cms/storagereason/addstoragereason/:id',
  //  loadChildren: () => import('./cmscomponents/storagereason/addstoragereason/addStorageReason.module').then(m => m.AddStorageReasonModule)
  //},

  //{
  //  path: 'cms/storagereason/fetchstoragereason',
  //  loadChildren: () => import('./cmscomponents/storagereason/fetchstoragereason/fetchStorageReason.module').then(m => m.FetchStorageReasonModule)
  //},


  ////
  //{
  //  path: 'cms/containersize/addcontainersize',
  //  loadChildren: () => import('./cmscomponents/containersize/addcontainersize/addContainerSize.module').then(m => m.AddContainerSizeModule)
  //},
  //{
  //  path: 'cms/containersize/addcontainersize/:id',
  //  loadChildren: () => import('./cmscomponents/containersize/addcontainersize/addContainerSize.module').then(m => m.AddContainerSizeModule)
  //},

  //{
  //  path: 'cms/containersize/fetchcontainersize',
  //  loadChildren: () => import('./cmscomponents/containersize/fetchcontainersize/fetchContainerSize.module').then(m => m.FetchContainerSizeModule)
  //},

  ////
  //{
  //  path: 'cms/shippingline/addshippingline',
  //  loadChildren: () => import('./cmscomponents/shippingline/addshippingline/addShippingLine.module').then(m => m.AddShippingLineModule)
  //},
  //{
  //  path: 'cms/shippingline/addshippingline/:id',
  //  loadChildren: () => import('./cmscomponents/shippingline/addshippingline/addShippingLine.module').then(m => m.AddShippingLineModule)
  //},

  //{
  //  path: 'cms/shippingline/fetchshippingline',
  //  loadChildren: () => import('./cmscomponents/shippingline/fetchshippingline/fetchShippingLine.module').then(m => m.FetchShippingLineModule)
  //},

  ////
  //{
  //  path: 'cms/storagelocation/addstoragelocation',
  //  loadChildren: () => import('./cmscomponents/storagelocation/addstoragelocation/addStorageLocation.module').then(m => m.AddStorageLocationModule)
  //},
  //{
  //  path: 'cms/storagelocation/addstoragelocation/:id',
  //  loadChildren: () => import('./cmscomponents/storagelocation/addstoragelocation/addStorageLocation.module').then(m => m.AddStorageLocationModule)
  //},

  //{
  //  path: 'cms/storagelocation/fetchstoragelocation',
  //  loadChildren: () => import('./cmscomponents/storagelocation/fetchstoragelocation/fetchStorageLocation.module').then(m => m.FetchStorageLocationModule)
  //},

  ////
  //{
  //  path: 'cms/containeractivity/addcontaineractivity',
  //  loadChildren: () => import('./cmscomponents/containeractivity/addcontaineractivity/addContainerActivity.module').then(m => m.AddContainerActivityModule)
  //},
  //{
  //  path: 'cms/containeractivity/addcontaineractivity/:id',
  //  loadChildren: () => import('./cmscomponents/containeractivity/addcontaineractivity/addContainerActivity.module').then(m => m.AddContainerActivityModule)
  //},

  //{
  //  path: 'cms/containeractivity/fetchcontaineractivity',
  //  loadChildren: () => import('./cmscomponents/containeractivity/fetchcontaineractivity/fetchContainerActivity.module').then(m => m.FetchContainerActivityModule)
  //},

  ////
  //{
  //  path: 'cms/containerinfo/addcontainerinfo',
  //  loadChildren: () => import('./cmscomponents/containerinfo/addcontainerinfo/addContainerInfo.module').then(m => m.AddContainerInfoModule)
  //},
  //{
  //  path: 'cms/containerinfo/addcontainerinfo/:id',
  //  loadChildren: () => import('./cmscomponents/containerinfo/addcontainerinfo/addContainerInfo.module').then(m => m.AddContainerInfoModule)
  //},

  //{
  //  path: 'cms/containerinfo/fetchcontainerinfo',
  //  loadChildren: () => import('./cmscomponents/containerinfo/fetchcontainerinfo/fetchContainerInfo.module').then(m => m.FetchContainerInfoModule)
  //},


  ////
  //{
  //  path: 'cms/containerexportstatus/addcontainerexportstatus',
  //  loadChildren: () => import('./cmscomponents/containerexportstatus/addcontainerexportstatus/addContainerExportStatus.module').then(m => m.AddContainerExportStatusModule)
  //},
  //{
  //  path: 'cms/containerexportstatus/addcontainerexportstatus/:id',
  //  loadChildren: () => import('./cmscomponents/containerexportstatus/addcontainerexportstatus/addContainerExportStatus.module').then(m => m.AddContainerExportStatusModule)
  //},

  //{
  //  path: 'cms/containerexportstatus/fetchcontainerexportstatus',
  //  loadChildren: () => import('./cmscomponents/containerexportstatus/fetchcontainerexportstatus/fetchContainerExportStatus.module').then(m => m.FetchContainerExportStatusModule)
  //},

  ////
  //{
  //  path: 'cms/containerconfiguration/addcontainerconfiguration',
  //  loadChildren: () => import('./cmscomponents/containerconfiguration/addcontainerconfiguration/addContainerConfiguration.module').then(m => m.AddContainerConfigurationModule)
  //},
  //{
  //  path: 'cms/containerconfiguration/addcontainerconfiguration/:id',
  //  loadChildren: () => import('./cmscomponents/containerconfiguration/addcontainerconfiguration/addContainerConfiguration.module').then(m => m.AddContainerConfigurationModule)
  //},

  //{
  //  path: 'cms/containerconfiguration/fetchcontainerconfiguration',
  //  loadChildren: () => import('./cmscomponents/containerconfiguration/fetchcontainerconfiguration/fetchContainerConfiguration.module').then(m => m.FetchContainerConfigurationModule)
  //},
  ////
  //{
  //  path: 'cms/parkoperator/addparkoperator',
  //  loadChildren: () => import('./cmscomponents/storagereason/addstoragereason/addStorageReason.module').then(m => m.AddStorageReasonModule)
  //},
  //{
  //  path: 'cms/parkoperator/addparkoperator/:id',
  //  loadChildren: () => import('./cmscomponents/storagereason/addstoragereason/addStorageReason.module').then(m => m.AddStorageReasonModule)
  //},

  //{
  //  path: 'cms/parkoperator/fetchparkoperator',
  //  loadChildren: () => import('./cmscomponents/storagereason/fetchstoragereason/fetchStorageReason.module').then(m => m.FetchStorageReasonModule)
  //},


  {
    path: 'inventory/storesissue/addstoresissue',
    loadChildren: () => import('./inventorycomponents/storesissue/addstoresissue/addStoresIssue.module').then(m => m.AddStoresIssueModule)
  },
  {
    path: 'inventory/storesissue/addstoresissue/:id',
    loadChildren: () => import('./inventorycomponents/storesissue/addstoresissue/addStoresIssue.module').then(m => m.AddStoresIssueModule)
  },

  {
    path: 'inventory/storesissue/fetchstoresissue',
    loadChildren: () => import('./inventorycomponents/storesissue/fetchstoresissue/fetchStoresIssue.module').then(m => m.FetchStoresIssueModule)
  },


  ////{
  ////    path: 'inventory/returnablednissue/addreturnablednissue',
  ////    loadChildren: () => import('./inventorycomponents/returnabledeliverynoteissue/addreturnabledeliverynoteissue/addReturnableDeliveryNoteIssue.module').then(m => m.AddReturnableDeliveryNoteIssueModule)
  ////},
  ////{
  ////    path: 'inventory/returnablednissue/addreturnablednissue/:id',
  ////    loadChildren: () => import('./inventorycomponents/returnabledeliverynoteissue/addreturnabledeliverynoteissue/addReturnableDeliveryNoteIssue.module').then(m => m.AddReturnableDeliveryNoteIssueModule)
  ////},

  ////{
  ////    path: 'inventory/returnablednissue/fetchreturnablednissue',
  ////    loadChildren: () => import('./inventorycomponents/returnabledeliverynoteissue/fetchreturnabledeliverynoteissue/fetchReturnableDeliveryNoteIssue.module').then(m => m.FetchReturnableDeliveryNoteIssueModule)
  ////},

  //{
  //  path: 'inventory/locationtransfer/addlocationtransfer',
  //  loadChildren: () => import('./inventorycomponents/locationtransfer/addlocationtransfer/addLocationTransfer.module').then(m => m.AddLocationTransferModule)
  //},
  //{
  //  path: 'inventory/locationtransfer/addlocationtransfer/:id',
  //  loadChildren: () => import('./inventorycomponents/locationtransfer/addlocationtransfer/addLocationTransfer.module').then(m => m.AddLocationTransferModule)
  //},

  //{
  //  path: 'inventory/locationtransfer/fetchlocationtransfer',
  //  loadChildren: () => import('./inventorycomponents/locationtransfer/fetchlocationtransfer/fetchLocationTransfer.module').then(m => m.FetchLocationTransferModule)
  //},



  //{
  //  path: 'finance/defineformula/adddefineformula',
  //  loadChildren: () => import('./generalcomponents/textformulagenerate/addtextformulagenerate/addTextFormulaGenerate.module').then(m => m.AddTextFormulaGenerateModule)
  //},
  //{
  //  path: 'finance/defineformula/adddefineformula/:id',
  //  loadChildren: () => import('./generalcomponents/textformulagenerate/addtextformulagenerate/addTextFormulaGenerate.module').then(m => m.AddTextFormulaGenerateModule)
  //},

  //{
  //  path: 'finance/defineformula/fetchdefineformula',
  //  loadChildren: () => import('./generalcomponents/textformulagenerate/fetchtextformulagenerate/fetchTextFormulaGenerate.module').then(m => m.FetchTextFormulaGenerateModule)
  //},
  //{
  //  path: 'technical/task/addtask',
  //  loadChildren: () => import('./technicalcomponents/taskmaster/addtaskmaster/addTaskMaster.module').then(m => m.AddTaskMasterModule)
  //},
  //{
  //  path: 'technical/task/addtask/:id',
  //  loadChildren: () => import('./technicalcomponents/taskmaster/addtaskmaster/addTaskMaster.module').then(m => m.AddTaskMasterModule)
  //},

  //{
  //  path: 'technical/task/fetchtask',
  //  loadChildren: () => import('./technicalcomponents/taskmaster/fetchtaskmaster/fetchTaskMaster.module').then(m => m.FetchTaskMasterModule)
  //},
  //{
  //  path: 'finance/controlaccount/addcontrolaccount',
  //  loadChildren: () => import('./financecomponents/controlaccount/addcontrolaccount/addControlAccount.module').then(m => m.AddControlAccountModule)
  //},
  //{
  //  path: 'finance/controlaccount/addcontrolaccount/:id',
  //  loadChildren: () => import('./financecomponents/controlaccount/addcontrolaccount/addControlAccount.module').then(m => m.AddControlAccountModule)
  //},

  //{
  //  path: 'finance/controlaccount/fetchcontrolaccount',
  //  loadChildren: () => import('./financecomponents/controlaccount/fetchcontrolaccount/fetchControlAccount.module').then(m => m.FetchControlAccountModule)
  //},
  //{
  //  path: 'finance/vendorpayment/addvendorpayment',
  //  loadChildren: () => import('./financecomponents/vendorpayment/addvendorpayment/addVendorPayment.module').then(m => m.AddVendorPaymentModule)
  //},
  //{
  //  path: 'finance/vendorpayment/addvendorpayment/:id',
  //  loadChildren: () => import('./financecomponents/vendorpayment/addvendorpayment/addVendorPayment.module').then(m => m.AddVendorPaymentModule)
  //},

  //{
  //  path: 'finance/vendorpayment/fetchvendorpayment',
  //  loadChildren: () => import('./financecomponents/vendorpayment/fetchvendorpayment/fetchVendorPayment.module').then(m => m.FetchVendorPaymentModule)
  //},

  {
    path: 'finance/customerreceipt/addcustomerreceipt',
    loadChildren: () => import('./financecomponents/customerreceipt/addcustomerreceipt/addCustomerReceipt.module').then(m => m.AddCustomerReceiptModule)
  },
  {
    path: 'finance/customerreceipt/addcustomerreceipt/:id',
    loadChildren: () => import('./financecomponents/customerreceipt/addcustomerreceipt/addCustomerReceipt.module').then(m => m.AddCustomerReceiptModule)
  },
  {
    path: 'finance/customerreceipt/fetchcustomerreceipt',
    loadChildren: () => import('./financecomponents/customerreceipt/fetchcustomerreceipt/fetchCustomerReceipt.module').then(m => m.FetchCustomerReceiptModule)
  },

  //{
  //  path: 'finance/materialaccounting/addmaterialaccounting',
  //  loadChildren: () => import('./financecomponents/materialaccounting/addmaterialaccounting/addMaterialAccounting.module').then(m => m.AddMaterialAccountingModule)
  //},
  //{
  //  path: 'finance/materialaccounting/addmaterialaccounting/:id',
  //  loadChildren: () => import('./financecomponents/materialaccounting/addmaterialaccounting/addMaterialAccounting.module').then(m => m.AddMaterialAccountingModule)
  //},

  //{
  //  path: 'finance/materialaccounting/fetchmaterialaccounting',
  //  loadChildren: () => import('./financecomponents/materialaccounting/fetchmaterialaccounting/fetchMaterialAccounting.module').then(m => m.FetchMaterialAccountingModule)
  //},
  //{
  //  path: 'finance/forexrates/addforexrates',
  //  loadChildren: () => import('./financecomponents/forexrates/addforexrates/addForexRates.module').then(m => m.AddForexRatesModule)
  //},
  //{
  //  path: 'finance/forexrates/addforexrates/:id',
  //  loadChildren: () => import('./financecomponents/forexrates/addforexrates/addForexRates.module').then(m => m.AddForexRatesModule)
  //},

  //{
  //  path: 'finance/forexrates/fetchforexrates',
  //  loadChildren: () => import('./financecomponents/forexrates/fetchforexrates/fetchForexRates.module').then(m => m.FetchForexRatesModule)
  //},
  //{
  //  path: 'finance/componentprofile/addcomponentprofile',
  //  loadChildren: () => import('./financecomponents/composprofile/addcomposprofile/addComposProfile.module').then(m => m.AddComposProfileModule)
  //},
  //{
  //  path: 'finance/componentprofile/addcomponentprofile/:id',
  //  loadChildren: () => import('./financecomponents/composprofile/addcomposprofile/addComposProfile.module').then(m => m.AddComposProfileModule)
  //},

  //{
  //  path: 'finance/componentprofile/fetchcomponentprofile',
  //  loadChildren: () => import('./financecomponents/composprofile/fetchcomposprofile/fetchComposProfile.module').then(m => m.FetchComposProfileModule)
  //},
  //{
  //  path: 'finance/chequebook/addchequebook',
  //  loadChildren: () => import('./financecomponents/chequebook/addchequebook/addChequebook.module').then(m => m.AddChequebookModule)
  //},
  //{
  //  path: 'finance/chequebook/addchequebook/:id',
  //  loadChildren: () => import('./financecomponents/chequebook/addchequebook/addChequebook.module').then(m => m.AddChequebookModule)
  //},

  //{
  //  path: 'finance/chequebook/fetchchequebook',
  //  loadChildren: () => import('./financecomponents/chequebook/fetchchequebook/fetchChequebook.module').then(m => m.FetchChequebookModule)
  //},
  //{
  //  path: 'finance/pettycashpayment/addpettycashpayment',
  //  loadChildren: () => import('./financecomponents/pettycashpayment/addpettycashpayment/addPettyCashPayment.module').then(m => m.AddPettyCashPaymentModule)
  //},
  //{
  //  path: 'finance/pettycashpayment/addpettycashpayment/:id',
  //  loadChildren: () => import('./financecomponents/pettycashpayment/addpettycashpayment/addPettyCashPayment.module').then(m => m.AddPettyCashPaymentModule)
  //},

  //{
  //  path: 'finance/pettycashpayment/fetchpettycashpayment',
  //  loadChildren: () => import('./financecomponents/pettycashpayment/fetchpettycashpayment/fetchPettyCashPayment.module').then(m => m.FetchPettyCashPaymentModule)
  //},
  //{
  //  path: 'finance/recurringjournalvoucher/addrecurringjournalvoucher',
  //  loadChildren: () => import('./financecomponents/recurringjournalvoucher/addrecurringjournalvoucher/addRecurringJournalVoucher.module').then(m => m.AddRecurringJournalVoucherModule)
  //},
  //{
  //  path: 'finance/recurringjournalvoucher/addrecurringjournalvoucher/:id',
  //  loadChildren: () => import('./financecomponents/recurringjournalvoucher/addrecurringjournalvoucher/addRecurringJournalVoucher.module').then(m => m.AddRecurringJournalVoucherModule)
  //},

  //{
  //  path: 'finance/recurringjournalvoucher/fetchrecurringjournalvoucher',
  //  loadChildren: () => import('./financecomponents/recurringjournalvoucher/fetchrecurringjournalvoucher/fetchRecurringJournalVoucher.module').then(m => m.FetchRecurringJournalVoucherModule)
  //},
  //{
  //  path: 'finance/pettycashreceipt/addpettycashreceipt',
  //  loadChildren: () => import('./financecomponents/pettycashreceipt/addpettycashreceipt/addPettyCashReceipt.module').then(m => m.AddPettyCashReceiptModule)
  //},
  //{
  //  path: 'finance/pettycashreceipt/addpettycashreceipt/:id',
  //  loadChildren: () => import('./financecomponents/pettycashreceipt/addpettycashreceipt/addPettyCashReceipt.module').then(m => m.AddPettyCashReceiptModule)
  //},

  //{
  //  path: 'finance/pettycashreceipt/fetchpettycashreceipt',
  //  loadChildren: () => import('./financecomponents/pettycashreceipt/fetchpettycashreceipt/fetchPettyCashReceipt.module').then(m => m.FetchPettyCashReceiptModule)
  //},
  //{
  //  path: 'finance/ardebitnote/addardebitnote',
  //  loadChildren: () => import('./financecomponents/ardebitnote/addardebitnote/addARDebitNote.module').then(m => m.AddARDebitNoteModule)
  //},
  //{
  //  path: 'finance/ardebitnote/addardebitnote/:id',
  //  loadChildren: () => import('./financecomponents/ardebitnote/addardebitnote/addARDebitNote.module').then(m => m.AddARDebitNoteModule)
  //},

  //{
  //  path: 'finance/ardebitnote/fetchardebitnote',
  //  loadChildren: () => import('./financecomponents/ardebitnote/fetchardebitnote/fetchARDebitNote.module').then(m => m.FetchARDebitNoteModule)
  //},
  //{
  //  path: 'finance/apdebitnote/addapdebitnote',
  //  loadChildren: () => import('./financecomponents/apdebitnote/addapdebitnote/addAPDebitNote.module').then(m => m.AddAPDebitNoteModule)
  //},
  //{
  //  path: 'finance/apdebitnote/addapdebitnote/:id',
  //  loadChildren: () => import('./financecomponents/apdebitnote/addapdebitnote/addAPDebitNote.module').then(m => m.AddAPDebitNoteModule)
  //},

  //{
  //  path: 'finance/apdebitnote/fetchapdebitnote',
  //  loadChildren: () => import('./financecomponents/apdebitnote/fetchapdebitnote/fetchAPDebitNote.module').then(m => m.FetchAPDebitNoteModule)
  //},
  //{
  //  path: 'finance/arcreditnote/addarcreditnote',
  //  loadChildren: () => import('./financecomponents/arcreditnote/addarcreditnote/addARCreditNote.module').then(m => m.AddARCreditNoteModule)
  //},
  //{
  //  path: 'finance/arcreditnote/addarcreditnote/:id',
  //  loadChildren: () => import('./financecomponents/arcreditnote/addarcreditnote/addARCreditNote.module').then(m => m.AddARCreditNoteModule)
  //},

  //{
  //  path: 'finance/arcreditnote/fetcharcreditnote',
  //  loadChildren: () => import('./financecomponents/arcreditnote/fetcharcreditnote/fetchARCreditNote.module').then(m => m.FetchARCreditNoteModule)
  //},
  //{
  //  path: 'finance/apcreditnote/addapcreditnote',
  //  loadChildren: () => import('./financecomponents/apcreditnote/addapcreditnote/addAPCreditNote.module').then(m => m.AddAPCreditNoteModule)
  //},
  //{
  //  path: 'finance/apcreditnote/addapcreditnote/:id',
  //  loadChildren: () => import('./financecomponents/apcreditnote/addapcreditnote/addAPCreditNote.module').then(m => m.AddAPCreditNoteModule)
  //},
  //{
  //  path: 'finance/apcreditnote/fetchapcreditnote',
  //  loadChildren: () => import('./financecomponents/apcreditnote/fetchapcreditnote/fetchAPCreditNote.module').then(m => m.FetchAPCreditNoteModule)
  //},
  //{
  //  path: 'finance/openingbalance/addopeningbalance',
  //  loadChildren: () => import('./financecomponents/openingbalance/addopeningbalance/addOpeningBalance.module').then(m => m.AddOpeningBalanceModule)
  //},
  //{
  //  path: 'finance/openingbalance/addopeningbalance/:id',
  //  loadChildren: () => import('./financecomponents/openingbalance/addopeningbalance/addOpeningBalance.module').then(m => m.AddOpeningBalanceModule)
  //},
  //{
  //  path: 'finance/openingbalance/addopeningbalancefulldetails',
  //  loadChildren: () => import('./financecomponents/openingbalance/addopeningbalancefulldetails/addOpeningBalanceFullDetails.module').then(m => m.AddOpeningBalanceFullDetailsModule)
  //},
  //{
  //  path: 'finance/openingbalance/addopeningbalancefulldetails/:id',
  //  loadChildren: () => import('./financecomponents/openingbalance/addopeningbalancefulldetails/addOpeningBalanceFullDetails.module').then(m => m.AddOpeningBalanceFullDetailsModule)
  //},
  //{
  //  path: 'finance/openingbalance/fetchopeningbalance',
  //  loadChildren: () => import('./financecomponents/openingbalance/fetchopeningbalance/fetchOpeningBalance.module').then(m => m.FetchOpeningBalanceModule)
  //},
  //{
  //  path: 'finance/journalvoucher/addjournalvoucher',
  //  loadChildren: () => import('./financecomponents/journalvoucher/addjournalvoucher/addJournalVoucher.module').then(m => m.AddJournalVoucherModule)
  //},
  //{
  //  path: 'finance/journalvoucher/addjournalvoucher/:id',
  //  loadChildren: () => import('./financecomponents/journalvoucher/addjournalvoucher/addJournalVoucher.module').then(m => m.AddJournalVoucherModule)
  //},

  //{
  //  path: 'finance/journalvoucher/fetchjournalvoucher',
  //  loadChildren: () => import('./financecomponents/journalvoucher/fetchjournalvoucher/fetchJournalVoucher.module').then(m => m.FetchJournalVoucherModule)
  //},
  //{
  //  path: 'finance/cjournalvoucher/addcjournalvoucher',
  //  loadChildren: () => import('./financecomponents/cjournalvoucher/addcjournalvoucher/addCJournalVoucher.module').then(m => m.AddCJournalVoucherModule)
  //},
  //{
  //  path: 'finance/cjournalvoucher/addcjournalvoucher/:id',
  //  loadChildren: () => import('./financecomponents/cjournalvoucher/addcjournalvoucher/addCJournalVoucher.module').then(m => m.AddCJournalVoucherModule)
  //},

  //{
  //  path: 'finance/cjournalvoucher/fetchcjournalvoucher',
  //  loadChildren: () => import('./financecomponents/cjournalvoucher/fetchcjournalvoucher/fetchCJournalVoucher.module').then(m => m.FetchCJournalVoucherModule)
  //},
  //{
  //  path: 'finance/purchaseserviceinvoice/addpurchaseserviceinvoice',
  //  loadChildren: () => import('./financecomponents/purchaseserviceinvoice/addpurchaseserviceinvoice/addPurchaseServiceInvoice.module').then(m => m.AddPurchaseServiceInvoiceModule)
  //},
  //{
  //  path: 'finance/purchaseserviceinvoice/addpurchaseserviceinvoice/:id',
  //  loadChildren: () => import('./financecomponents/purchaseserviceinvoice/addpurchaseserviceinvoice/addPurchaseServiceInvoice.module').then(m => m.AddPurchaseServiceInvoiceModule)
  //},

  //{
  //  path: 'finance/purchaseserviceinvoice/fetchpurchaseserviceinvoice',
  //  loadChildren: () => import('./financecomponents/purchaseserviceinvoice/fetchpurchaseserviceinvoice/fetchPurchaseServiceInvoice.module').then(m => m.FetchPurchaseServiceInvoiceModule)
  //},
  //{
  //  path: 'finance/bank/addbank',
  //  loadChildren: () => import('./financecomponents/bank/addbank/addBank.module').then(m => m.AddBankModule)
  //},
  //{
  //  path: 'finance/bank/addbank/:id',
  //  loadChildren: () => import('./financecomponents/bank/addbank/addBank.module').then(m => m.AddBankModule)
  //},

  //{
  //  path: 'finance/bank/fetchbank',
  //  loadChildren: () => import('./financecomponents/bank/fetchbank/fetchBank.module').then(m => m.FetchBankModule)
  //},
  //{
  //  path: 'finance/bankcashaccount/addbankcashaccount',
  //  loadChildren: () => import('./financecomponents/bankcashaccount/addbankcashaccount/addBankCashAccount.module').then(m => m.AddBankCashAccountModule)
  //},
  //{
  //  path: 'finance/bankcashaccount/addbankcashaccount/:id',
  //  loadChildren: () => import('./financecomponents/bankcashaccount/addbankcashaccount/addBankCashAccount.module').then(m => m.AddBankCashAccountModule)
  //},

  //{
  //  path: 'finance/bankcashaccount/fetchbankcashaccount',
  //  loadChildren: () => import('./financecomponents/bankcashaccount/fetchbankcashaccount/fetchBankCashAccount.module').then(m => m.FetchBankCashAccountModule)
  //},

  //{
  //  path: 'finance/banktype/addbanktype',
  //  loadChildren: () => import('./financecomponents/banktype/addbanktype/addBankType.module').then(m => m.AddBankTypeModule)
  //},
  //{
  //  path: 'finance/banktype/addbanktype/:id',
  //  loadChildren: () => import('./financecomponents/banktype/addbanktype/addBankType.module').then(m => m.AddBankTypeModule)
  //},

  //{
  //  path: 'finance/banktype/fetchbanktype',
  //  loadChildren: () => import('./financecomponents/banktype/fetchbanktype/fetchBankType.module').then(m => m.FetchBankTypeModule)
  //},
  //{
  //  path: 'finance/expendituretype/addexpendituretype',
  //  loadChildren: () => import('./financecomponents/expendituretype/addexpendituretype/addExpenditureType.module').then(m => m.AddExpenditureTypeModule)
  //},
  //{
  //  path: 'finance/expendituretype/addexpendituretype/:id',
  //  loadChildren: () => import('./financecomponents/expendituretype/addexpendituretype/addExpenditureType.module').then(m => m.AddExpenditureTypeModule)
  //},

  //{
  //  path: 'finance/expendituretype/fetchexpendituretype',
  //  loadChildren: () => import('./financecomponents/expendituretype/fetchexpendituretype/fetchExpenditureType.module').then(m => m.FetchExpenditureTypeModule)
  //},
  //{
  //  path: 'finance/accountgroup/addaccountgroup',
  //  loadChildren: () => import('./financecomponents/accountgroup/addaccountgroup/addAccountGroup.module').then(m => m.AddAccountGroupModule)
  //},
  //{
  //  path: 'finance/accountgroup/addaccountgroup/:id',
  //  loadChildren: () => import('./financecomponents/accountgroup/addaccountgroup/addAccountGroup.module').then(m => m.AddAccountGroupModule)
  //},

  //{
  //  path: 'finance/accountgroup/fetchaccountgroup',
  //  loadChildren: () => import('./financecomponents/accountgroup/fetchaccountgroup/fetchAccountGroup.module').then(m => m.FetchAccountGroupModule)
  //},
  //{
  //  path: 'finance/account/addaccount',
  //  loadChildren: () => import('./financecomponents/account/addaccount/addAccount.module').then(m => m.AddAccountModule)
  //},
  //{
  //  path: 'finance/account/addaccount/:id',
  //  loadChildren: () => import('./financecomponents/account/addaccount/addAccount.module').then(m => m.AddAccountModule)
  //},

  //{
  //  path: 'finance/account/fetchaccount',
  //  loadChildren: () => import('./financecomponents/account/fetchaccount/fetchAccount.module').then(m => m.FetchAccountModule)
  //},
  {
    path: 'finance/generalpayment/addgeneralpayment',
    loadChildren: () => import('./financecomponents/generalledger/addgeneralpayment/addGeneralPayment.module').then(m => m.AddGeneralPaymentModule)
  },
  {
    path: 'finance/generalpayment/addgeneralpayment/:id',
    loadChildren: () => import('./financecomponents/generalledger/addgeneralpayment/addGeneralPayment.module').then(m => m.AddGeneralPaymentModule)
  },
  {
    path: 'finance/generalpayment/fetchgeneralpayment',
    loadChildren: () => import('./financecomponents/generalledger/fetchgeneralpayment/fetchGeneralPayment.module').then(m => m.FetchGeneralPaymentModule)
  },


  //{
  //  path: 'finance/generalreceipt/addgeneralreceipt',
  //  loadChildren: () => import('./financecomponents/generalreceipt/addgeneralreceipt/addGeneralReceipt.module').then(m => m.AddGeneralReceiptModule)
  //},
  //{
  //  path: 'finance/generalreceipt/addgeneralreceipt/:id',
  //  loadChildren: () => import('./financecomponents/generalreceipt/addgeneralreceipt/addGeneralReceipt.module').then(m => m.AddGeneralReceiptModule)
  //},

  //{
  //  path: 'finance/generalreceipt/fetchgeneralreceipt',
  //  loadChildren: () => import('./financecomponents/generalreceipt/fetchgeneralreceipt/fetchGeneralReceipt.module').then(m => m.FetchGeneralReceiptModule)
  //},
  //{
  //  path: 'finance/consolidationdefinition/addconsolidationdefinition',
  //  loadChildren: () => import('./financecomponents/consolidationdefinition/addconsolidationdefinition/addConsolidationDefinition.module').then(m => m.AddConsolidationDefinitionModule)
  //},
  //{
  //  path: 'finance/consolidationdefinition/addconsolidationdefinition/:id',
  //  loadChildren: () => import('./financecomponents/consolidationdefinition/addconsolidationdefinition/addConsolidationDefinition.module').then(m => m.AddConsolidationDefinitionModule)
  //},

  //{
  //  path: 'finance/consolidationdefinition/fetchconsolidationdefinition',
  //  loadChildren: () => import('./financecomponents/consolidationdefinition/fetchconsolidationdefinition/fetchConsolidationDefinition.module').then(m => m.FetchConsolidationDefinitionModule)
  //},
  //{
  //  path: 'finance/coadefinition/addcoadefinition',
  //  loadChildren: () => import('./financecomponents/coadefinition/addcoadefinition/addCOADefinition.module').then(m => m.AddCOADefinitionModule)
  //},
  //{
  //  path: 'finance/coadefinition/addcoadefinition/:id',
  //  loadChildren: () => import('./financecomponents/coadefinition/addcoadefinition/addCOADefinition.module').then(m => m.AddCOADefinitionModule)
  //},

  //{
  //  path: 'finance/coadefinition/fetchcoadefinition',
  //  loadChildren: () => import('./financecomponents/coadefinition/fetchcoadefinition/fetchCOADefinition.module').then(m => m.FetchCOADefinitionModule)
  //},
  //{
  //  path: 'finance/assets/addassets',
  //  loadChildren: () => import('./financecomponents/assets/addassets/addAssets.module').then(m => m.AddAssetsModule)
  //},
  //{
  //  path: 'finance/assets/addassets/:id',
  //  loadChildren: () => import('./financecomponents/assets/addassets/addAssets.module').then(m => m.AddAssetsModule)
  //},

  //{
  //  path: 'finance/assets/fetchassets',
  //  loadChildren: () => import('./financecomponents/assets/fetchassets/fetchAssets.module').then(m => m.FetchAssetsModule)
  //},
  //{
  //  path: 'finance/segmentdefinition/addsegmentdefinition',
  //  loadChildren: () => import('./financecomponents/segmentdefinition/addsegmentdefinition/addSegmentDefinition.module').then(m => m.AddSegmentDefinitionModule)
  //},
  //{
  //  path: 'finance/segmentdefinition/addsegmentdefinition/:id',
  //  loadChildren: () => import('./financecomponents/segmentdefinition/addsegmentdefinition/addSegmentDefinition.module').then(m => m.AddSegmentDefinitionModule)
  //},

  //{
  //  path: 'finance/segmentdefinition/fetchsegmentdefinition',
  //  loadChildren: () => import('./financecomponents/segmentdefinition/fetchsegmentdefinition/fetchSegmentDefinition.module').then(m => m.FetchSegmentDefinitionModule)
  //},
  //{
  //  path: 'finance/definecomponents/adddefinecomponents',
  //  loadChildren: () => import('./financecomponents/definecomponents/adddefinecomponents/addDefineComponents.module').then(m => m.AddDefineComponentsModule)
  //},
  //{
  //  path: 'finance/definecomponents/adddefinecomponents/:id',
  //  loadChildren: () => import('./financecomponents/definecomponents/adddefinecomponents/addDefineComponents.module').then(m => m.AddDefineComponentsModule)
  //},
  //{
  //  path: 'finance/definecomponents/fetchdefinecomponents',
  //  loadChildren: () => import('./financecomponents/definecomponents/fetchdefinecomponents/fetchDefineComponents.module').then(m => m.FetchDefineComponentsModule)
  //},
  //{
  //  path: 'finance/cashaccount/addcashaccount',
  //  loadChildren: () => import('./financecomponents/cashaccount/addcashaccount/addCashAccount.module').then(m => m.AddCashAccountModule)
  //},
  //{
  //  path: 'finance/cashaccount/addcashaccount/:id',
  //  loadChildren: () => import('./financecomponents/cashaccount/addcashaccount/addCashAccount.module').then(m => m.AddCashAccountModule)
  //},

  //{
  //  path: 'finance/cashaccount/fetchcashaccount',
  //  loadChildren: () => import('./financecomponents/cashaccount/fetchcashaccount/fetchCashAccount.module').then(m => m.FetchCashAccountModule)
  //},

  //{
  //  path: 'finance/coaaccountgroup/addcoaaccountgroup',
  //  loadChildren: () => import('./financecomponents/coaaccountgroup/addcoaaccountgroup/addCoaAccountGroup.module').then(m => m.AddCoaAccountGroupModule)
  //},
  //{
  //  path: 'finance/coaaccountgroup/addcoaaccountgroup/:id',
  //  loadChildren: () => import('./financecomponents/coaaccountgroup/addcoaaccountgroup/addCoaAccountGroup.module').then(m => m.AddCoaAccountGroupModule)
  //},

  //{
  //  path: 'finance/coaaccountgroup/fetchcoaaccountgroup',
  //  loadChildren: () => import('./financecomponents/coaaccountgroup/fetchcoaaccountgroup/fetchCoaAccountGroup.module').then(m => m.FetchCoaAccountGroupModule)
  //},

  //{
  //  path: 'finance/conaccountgroup/addconaccountgroup',
  //  loadChildren: () => import('./financecomponents/conaccountgroup/addconaccountgroup/addConAccountGroup.module').then(m => m.AddConAccountGroupModule)
  //},
  //{
  //  path: 'finance/conaccountgroup/addconaccountgroup/:id',
  //  loadChildren: () => import('./financecomponents/conaccountgroup/addconaccountgroup/addConAccountGroup.module').then(m => m.AddConAccountGroupModule)
  //},

  //{
  //  path: 'finance/conaccountgroup/fetchconaccountgroup',
  //  loadChildren: () => import('./financecomponents/conaccountgroup/fetchconaccountgroup/fetchConAccountGroup.module').then(m => m.FetchConAccountGroupModule)
  //},
  //{
  //  path: 'finance/segmentstructure/addsegmentstructure',
  //  loadChildren: () => import('./financecomponents/segmentstructure/addsegmentstructure/addSegmentStructure.module').then(m => m.AddSegmentStructureModule)
  //},
  //{
  //  path: 'finance/segmentstructure/addsegmentstructure/:id',
  //  loadChildren: () => import('./financecomponents/segmentstructure/addsegmentstructure/addSegmentStructure.module').then(m => m.AddSegmentStructureModule)
  //},

  //{
  //  path: 'finance/segmentstructure/fetchsegmentstructure',
  //  loadChildren: () => import('./financecomponents/segmentstructure/fetchsegmentstructure/fetchSegmentStructure.module').then(m => m.FetchSegmentStructureModule)
  //},
  //{
  //  path: 'finance/segmentgroup/addsegmentgroup',
  //  loadChildren: () => import('./financecomponents/segmentgroup/addsegmentgroup/addSegmentGroup.module').then(m => m.AddSegmentGroupModule)
  //},
  //{
  //  path: 'finance/segmentgroup/addsegmentgroup/:id',
  //  loadChildren: () => import('./financecomponents/segmentgroup/addsegmentgroup/addSegmentGroup.module').then(m => m.AddSegmentGroupModule)
  //},

  //{
  //  path: 'finance/segmentgroup/fetchsegmentgroup',
  //  loadChildren: () => import('./financecomponents/segmentgroup/fetchsegmentgroup/fetchSegmentGroup.module').then(m => m.FetchSegmentGroupModule)
  //},
  //{
  //  path: 'finance/segment/addsegment',
  //  loadChildren: () => import('./financecomponents/segment/addsegment/addSegment.module').then(m => m.AddSegmentModule)
  //},
  //{
  //  path: 'finance/segment/addsegment/:id',
  //  loadChildren: () => import('./financecomponents/segment/addsegment/addSegment.module').then(m => m.AddSegmentModule)
  //},

  //{
  //  path: 'finance/segment/fetchsegment',
  //  loadChildren: () => import('./financecomponents/segment/fetchsegment/fetchSegment.module').then(m => m.FetchSegmentModule)
  //},
  {
    path: 'finance/paymentrequest/addpaymentrequest',
    loadChildren: () => import('./financecomponents/paymentrequest/addpaymentrequest/addPaymentRequest.module').then(m => m.AddPaymentRequestModule)
  },
  {
    path: 'finance/paymentrequest/addpaymentrequest/:id',
    loadChildren: () => import('./financecomponents/paymentrequest/addpaymentrequest/addPaymentRequest.module').then(m => m.AddPaymentRequestModule)
  },
  {
    path: 'finance/paymentrequest/fetchpaymentrequest',
    loadChildren: () => import('./financecomponents/paymentrequest/fetchpaymentrequest/fetchPaymentRequest.module').then(m => m.FetchPaymentRequestModule)
  },
  //{
  //  path: 'hrm/nonstandarddeductions/addnonstandarddeductions',
  //  loadChildren: () => import('./hrmcomponents/nonstandarddeductions/addnonstandarddeductions/addNonStandardDeductions.module').then(m => m.AddNonStandardDeductionsModule)
  //},
  //{
  //  path: 'hrm/nonstandarddeductions/addnonstandarddeductions/:id',
  //  loadChildren: () => import('./hrmcomponents/nonstandarddeductions/addnonstandarddeductions/addNonStandardDeductions.module').then(m => m.AddNonStandardDeductionsModule)
  //},

  //{
  //  path: 'hrm/nonstandarddeductions/fetchnonstandarddeductions',
  //  loadChildren: () => import('./hrmcomponents/nonstandarddeductions/fetchnonstandarddeductions/fetchNonStandardDeductions.module').then(m => m.FetchNonStandardDeductionsModule)
  //},
  //{
  //  path: 'hrm/loanrequisition/addloanrequisition',
  //  loadChildren: () => import('./hrmcomponents/loanrequisition/addloanrequisition/addLoanRequisition.module').then(m => m.AddLoanRequisitionModule)
  //},
  //{
  //  path: 'hrm/loanrequisition/addloanrequisition/:id',
  //  loadChildren: () => import('./hrmcomponents/loanrequisition/addloanrequisition/addLoanRequisition.module').then(m => m.AddLoanRequisitionModule)
  //},

  //{
  //  path: 'hrm/loanrequisition/fetchloanrequisition',
  //  loadChildren: () => import('./hrmcomponents/loanrequisition/fetchloanrequisition/fetchLoanRequisition.module').then(m => m.FetchLoanRequisitionModule)
  //},
  //{
  //  path: 'hrm/advancerequisition/addadvancerequisition',
  //  loadChildren: () => import('./hrmcomponents/advancerequisition/addadvancerequisition/addAdvanceRequisition.module').then(m => m.AddAdvanceRequisitionModule)
  //},
  //{
  //  path: 'hrm/advancerequisition/addadvancerequisition/:id',
  //  loadChildren: () => import('./hrmcomponents/advancerequisition/addadvancerequisition/addAdvanceRequisition.module').then(m => m.AddAdvanceRequisitionModule)
  //},

  //{
  //  path: 'hrm/advancerequisition/fetchadvancerequisition',
  //  loadChildren: () => import('./hrmcomponents/advancerequisition/fetchadvancerequisition/fetchAdvanceRequisition.module').then(m => m.FetchAdvanceRequisitionModule)
  //},
  //{
  //  path: 'hrm/leaverequisition/addleaverequisition',
  //  loadChildren: () => import('./hrmcomponents/leaverequisition/addleaverequisition/addLeaveRequisition.module').then(m => m.AddLeaveRequisitionModule)
  //},
  //{
  //  path: 'hrm/leaverequisition/addleaverequisition/:id',
  //  loadChildren: () => import('./hrmcomponents/leaverequisition/addleaverequisition/addLeaveRequisition.module').then(m => m.AddLeaveRequisitionModule)
  //},

  //{
  //  path: 'hrm/leaverequisition/fetchleaverequisition',
  //  loadChildren: () => import('./hrmcomponents/leaverequisition/fetchleaverequisition/fetchLeaveRequisition.module').then(m => m.FetchLeaveRequisitionModule)
  //},
  //{
  //  path: 'hrm/stopsalary/addstopsalary',
  //  loadChildren: () => import('./hrmcomponents/stopsalary/addstopsalary/addStopSalary.module').then(m => m.AddStopSalaryModule)
  //},
  //{
  //  path: 'hrm/stopsalary/addstopsalary/:id',
  //  loadChildren: () => import('./hrmcomponents/stopsalary/addstopsalary/addStopSalary.module').then(m => m.AddStopSalaryModule)
  //},

  //{
  //  path: 'hrm/stopsalary/fetchstopsalary',
  //  loadChildren: () => import('./hrmcomponents/stopsalary/fetchstopsalary/fetchStopSalary.module').then(m => m.FetchStopSalaryModule)
  //},
  //{
  //  path: 'hrm/medicalinsurance/addmedicalinsurance',
  //  loadChildren: () => import('./hrmcomponents/medicalinsurance/addmedicalinsurance/addMedicalInsurance.module').then(m => m.AddMedicalInsuranceModule)
  //},
  //{
  //  path: 'hrm/medicalinsurance/addmedicalinsurance/:id',
  //  loadChildren: () => import('./hrmcomponents/medicalinsurance/addmedicalinsurance/addMedicalInsurance.module').then(m => m.AddMedicalInsuranceModule)
  //},

  //{
  //  path: 'hrm/medicalinsurance/fetchmedicalinsurance',
  //  loadChildren: () => import('./hrmcomponents/medicalinsurance/fetchmedicalinsurance/fetchMedicalInsurance.module').then(m => m.FetchMedicalInsuranceModule)
  //},
  //{
  //  path: 'hrm/consolidatedleave/addconsolidatedleave',
  //  loadChildren: () => import('./hrmcomponents/consolidatedleave/addconsolidatedleave/addConsolidatedLeave.module').then(m => m.AddConsolidatedLeaveModule)
  //},
  //{
  //  path: 'hrm/consolidatedleave/addconsolidatedleave/:id',
  //  loadChildren: () => import('./hrmcomponents/consolidatedleave/addconsolidatedleave/addConsolidatedLeave.module').then(m => m.AddConsolidatedLeaveModule)
  //},

  //{
  //  path: 'hrm/consolidatedleave/fetchconsolidatedleave',
  //  loadChildren: () => import('./hrmcomponents/consolidatedleave/fetchconsolidatedleave/fetchConsolidatedLeave.module').then(m => m.FetchConsolidatedLeaveModule)
  //},
  //{
  //  path: 'hrm/expressiondefinition/addexpressiondefinition',
  //  loadChildren: () => import('./hrmcomponents/expressiondefinition/addexpressiondefinition/addExpressionDefinition.module').then(m => m.AddExpressionDefinitionModule)
  //},
  //{
  //  path: 'hrm/expressiondefinition/addexpressiondefinition/:id',
  //  loadChildren: () => import('./hrmcomponents/expressiondefinition/addexpressiondefinition/addExpressionDefinition.module').then(m => m.AddExpressionDefinitionModule)
  //},

  //{
  //  path: 'hrm/expressiondefinition/fetchexpressiondefinition',
  //  loadChildren: () => import('./hrmcomponents/expressiondefinition/fetchexpressiondefinition/fetchExpressionDefinition.module').then(m => m.FetchExpressionDefinitionModule)
  //},
  //{
  //  path: 'hrm/advancepolicy/addadvancepolicy',
  //  loadChildren: () => import('./hrmcomponents/advancepolicy/addadvancepolicy/addAdvancePolicy.module').then(m => m.AddAdvancePolicyModule)
  //},
  //{
  //  path: 'hrm/advancepolicy/addadvancepolicy/:id',
  //  loadChildren: () => import('./hrmcomponents/advancepolicy/addadvancepolicy/addAdvancePolicy.module').then(m => m.AddAdvancePolicyModule)
  //},

  //{
  //  path: 'hrm/advancepolicy/fetchadvancepolicy',
  //  loadChildren: () => import('./hrmcomponents/advancepolicy/fetchadvancepolicy/fetchAdvancePolicy.module').then(m => m.FetchAdvancePolicyModule)
  //},
  //{
  //  path: 'hrm/loanpolicy/addloanpolicy',
  //  loadChildren: () => import('./hrmcomponents/loanpolicy/addloanpolicy/addLoanPolicy.module').then(m => m.AddLoanPolicyModule)
  //},
  //{
  //  path: 'hrm/loanpolicy/addloanpolicy/:id',
  //  loadChildren: () => import('./hrmcomponents/loanpolicy/addloanpolicy/addLoanPolicy.module').then(m => m.AddLoanPolicyModule)
  //},

  //{
  //  path: 'hrm/loanpolicy/fetchloanpolicy',
  //  loadChildren: () => import('./hrmcomponents/loanpolicy/fetchloanpolicy/fetchLoanPolicy.module').then(m => m.FetchLoanPolicyModule)
  //},
  //{
  //  path: 'hrm/payrollpolicy/addpayrollpolicy',
  //  loadChildren: () => import('./hrmcomponents/payrollpolicy/addpayrollpolicy/addPayrollPolicy.module').then(m => m.AddPayrollPolicyModule)
  //},
  //{
  //  path: 'hrm/payrollpolicy/addpayrollpolicy/:id',
  //  loadChildren: () => import('./hrmcomponents/payrollpolicy/addpayrollpolicy/addPayrollPolicy.module').then(m => m.AddPayrollPolicyModule)
  //},

  //{
  //  path: 'hrm/payrollpolicy/fetchpayrollpolicy',
  //  loadChildren: () => import('./hrmcomponents/payrollpolicy/fetchpayrollpolicy/fetchPayrollPolicy.module').then(m => m.FetchPayrollPolicyModule)
  //},
  //{
  //  path: 'hrm/daycalculation/adddaycalculation',
  //  loadChildren: () => import('./hrmcomponents/daycalculation/adddaycalculation/addDayCalculation.module').then(m => m.AddDayCalculationModule)
  //},
  //{
  //  path: 'hrm/daycalculation/adddaycalculation/:id',
  //  loadChildren: () => import('./hrmcomponents/daycalculation/adddaycalculation/addDayCalculation.module').then(m => m.AddDayCalculationModule)
  //},

  //{
  //  path: 'hrm/daycalculation/fetchdaycalculation',
  //  loadChildren: () => import('./hrmcomponents/daycalculation/fetchdaycalculation/fetchDayCalculation.module').then(m => m.FetchDayCalculationModule)
  //},
  //{
  //  path: 'hrm/loanissue/addloanissue',
  //  loadChildren: () => import('./hrmcomponents/loanissue/addloanissue/addLoanIssue.module').then(m => m.AddLoanIssueModule)
  //},
  //{
  //  path: 'hrm/loanissue/addloanissue/:id',
  //  loadChildren: () => import('./hrmcomponents/loanissue/addloanissue/addLoanIssue.module').then(m => m.AddLoanIssueModule)
  //},

  //{
  //  path: 'hrm/loanissue/fetchloanissue',
  //  loadChildren: () => import('./hrmcomponents/loanissue/fetchloanissue/fetchLoanIssue.module').then(m => m.FetchLoanIssueModule)
  //},
  //{
  //  path: 'hrm/advanceissue/addadvanceissue',
  //  loadChildren: () => import('./hrmcomponents/advanceissue/addadvanceissue/addAdvanceIssue.module').then(m => m.AddAdvanceIssueModule)
  //},
  //{
  //  path: 'hrm/advanceissue/addadvanceissue/:id',
  //  loadChildren: () => import('./hrmcomponents/advanceissue/addadvanceissue/addAdvanceIssue.module').then(m => m.AddAdvanceIssueModule)
  //},

  //{
  //  path: 'hrm/advanceissue/fetchadvanceissue',
  //  loadChildren: () => import('./hrmcomponents/advanceissue/fetchadvanceissue/fetchAdvanceIssue.module').then(m => m.FetchAdvanceIssueModule)
  //},
  //{
  //  path: 'hrm/loanforecloser/addloanforecloser',
  //  loadChildren: () => import('./hrmcomponents/loanforecloser/addloanforecloser/addLoanForeCloser.module').then(m => m.AddLoanForeCloserModule)
  //},
  //{
  //  path: 'hrm/loanforecloser/addloanforecloser/:id',
  //  loadChildren: () => import('./hrmcomponents/loanforecloser/addloanforecloser/addLoanForeCloser.module').then(m => m.AddLoanForeCloserModule)
  //},

  //{
  //  path: 'hrm/loanforecloser/fetchloanforecloser',
  //  loadChildren: () => import('./hrmcomponents/loanforecloser/fetchloanforecloser/fetchLoanForeCloser.module').then(m => m.FetchLoanForeCloserModule)
  //},
  //{
  //  path: 'hrm/employee/addemployee',
  //  loadChildren: () => import('./hrmcomponents/employee/addemployee/addEmployee.module').then(m => m.AddEmployeeModule)
  //},
  //{
  //  path: 'hrm/employee/addemployee/:id',
  //  loadChildren: () => import('./hrmcomponents/employee/addemployee/addEmployee.module').then(m => m.AddEmployeeModule)
  //},

  //{
  //  path: 'hrm/employee/fetchemployee',
  //  loadChildren: () => import('./hrmcomponents/employee/fetchemployee/fetchEmployee.module').then(m => m.FetchEmployeeModule)
  //},
  ////
  //{
  //  path: 'hrm/advancetype/addadvancetype',
  //  loadChildren: () => import('./hrmcomponents/advancetype/addadvancetype/addAdvanceType.module').then(m => m.AddAdvanceTypeModule)
  //},
  //{
  //  path: 'hrm/advancetype/addadvancetype/:id',
  //  loadChildren: () => import('./hrmcomponents/advancetype/addadvancetype/addAdvanceType.module').then(m => m.AddAdvanceTypeModule)
  //},

  //{
  //  path: 'hrm/advancetype/fetchadvancetype',
  //  loadChildren: () => import('./hrmcomponents/advancetype/fetchadvancetype/fetchAdvanceType.module').then(m => m.FetchAdvanceTypeModule)
  //},
  //{
  //  path: 'hrm/benefits/addbenefits',
  //  loadChildren: () => import('./hrmcomponents/benefits/addbenefits/addBenefits.module').then(m => m.AddBenefitsModule)
  //},
  //{
  //  path: 'hrm/benefits/addbenefits/:id',
  //  loadChildren: () => import('./hrmcomponents/benefits/addbenefits/addBenefits.module').then(m => m.AddBenefitsModule)
  //},

  //{
  //  path: 'hrm/benefits/fetchbenefits',
  //  loadChildren: () => import('./hrmcomponents/benefits/fetchbenefits/fetchBenefits.module').then(m => m.FetchBenefitsModule)
  //},
  //{
  //  path: 'hrm/daytype/adddaytype',
  //  loadChildren: () => import('./hrmcomponents/daytype/adddaytype/addDayType.module').then(m => m.AddDayTypeModule)
  //},
  //{
  //  path: 'hrm/daytype/adddaytype/:id',
  //  loadChildren: () => import('./hrmcomponents/daytype/adddaytype/addDayType.module').then(m => m.AddDayTypeModule)
  //},

  //{
  //  path: 'hrm/daytype/fetchdaytype',
  //  loadChildren: () => import('./hrmcomponents/daytype/fetchdaytype/fetchDayType.module').then(m => m.FetchDayTypeModule)
  //},
  //{
  //  path: 'hrm/gradegroup/addgradegroup',
  //  loadChildren: () => import('./hrmcomponents/gradegroup/addgradegroup/addGradeGroup.module').then(m => m.AddGradeGroupModule)
  //},
  //{
  //  path: 'hrm/gradegroup/addgradegroup/:id',
  //  loadChildren: () => import('./hrmcomponents/gradegroup/addgradegroup/addGradeGroup.module').then(m => m.AddGradeGroupModule)
  //},

  //{
  //  path: 'hrm/gradegroup/fetchgradegroup',
  //  loadChildren: () => import('./hrmcomponents/gradegroup/fetchgradegroup/fetchGradeGroup.module').then(m => m.FetchGradeGroupModule)
  //},
  //{
  //  path: 'hrm/interviewphase/addinterviewphase',
  //  loadChildren: () => import('./hrmcomponents/interviewphase/addinterviewphase/addInterviewPhase.module').then(m => m.AddInterviewPhaseModule)
  //},
  //{
  //  path: 'hrm/interviewphase/addinterviewphase/:id',
  //  loadChildren: () => import('./hrmcomponents/interviewphase/addinterviewphase/addInterviewPhase.module').then(m => m.AddInterviewPhaseModule)
  //},

  //{
  //  path: 'hrm/interviewphase/fetchinterviewphase',
  //  loadChildren: () => import('./hrmcomponents/interviewphase/fetchinterviewphase/fetchInterviewPhase.module').then(m => m.FetchInterviewPhaseModule)
  //},
  //{
  //  path: 'hrm/leavetype/addleavetype',
  //  loadChildren: () => import('./hrmcomponents/leavetype/addleavetype/addLeaveType.module').then(m => m.AddLeaveTypeModule)
  //},
  //{
  //  path: 'hrm/leavetype/addleavetype/:id',
  //  loadChildren: () => import('./hrmcomponents/leavetype/addleavetype/addLeaveType.module').then(m => m.AddLeaveTypeModule)
  //},

  //{
  //  path: 'hrm/leavetype/fetchleavetype',
  //  loadChildren: () => import('./hrmcomponents/leavetype/fetchleavetype/fetchLeaveType.module').then(m => m.FetchLeaveTypeModule)
  //},
  //{
  //  path: 'hrm/loantype/addloantype',
  //  loadChildren: () => import('./hrmcomponents/loantype/addloantype/addLoanType.module').then(m => m.AddLoanTypeModule)
  //},
  //{
  //  path: 'hrm/loantype/addloantype/:id',
  //  loadChildren: () => import('./hrmcomponents/loantype/addloantype/addLoanType.module').then(m => m.AddLoanTypeModule)
  //},

  //{
  //  path: 'hrm/loantype/fetchloantype',
  //  loadChildren: () => import('./hrmcomponents/loantype/fetchloantype/fetchLoanType.module').then(m => m.FetchLoanTypeModule)
  //},
  //{
  //  path: 'hrm/physicaldisability/addphysicaldisability',
  //  loadChildren: () => import('./hrmcomponents/physicaldisability/addphysicaldisability/addPhysicalDisability.module').then(m => m.AddPhysicalDisabilityModule)
  //},
  //{
  //  path: 'hrm/physicaldisability/addphysicaldisability/:id',
  //  loadChildren: () => import('./hrmcomponents/physicaldisability/addphysicaldisability/addPhysicalDisability.module').then(m => m.AddPhysicalDisabilityModule)
  //},

  //{
  //  path: 'hrm/physicaldisability/fetchphysicaldisability',
  //  loadChildren: () => import('./hrmcomponents/physicaldisability/fetchphysicaldisability/fetchPhysicalDisability.module').then(m => m.FetchPhysicalDisabilityModule)
  //},
  //{
  //  path: 'hrm/qualification/addqualification',
  //  loadChildren: () => import('./hrmcomponents/qualification/addqualification/addQualification.module').then(m => m.AddQualificationModule)
  //},
  //{
  //  path: 'hrm/qualification/addqualification/:id',
  //  loadChildren: () => import('./hrmcomponents/qualification/addqualification/addQualification.module').then(m => m.AddQualificationModule)
  //},

  //{
  //  path: 'hrm/qualification/fetchqualification',
  //  loadChildren: () => import('./hrmcomponents/qualification/fetchqualification/fetchQualification.module').then(m => m.FetchQualificationModule)
  //},
  //{
  //  path: 'hrm/responsibility/addresponsibility',
  //  loadChildren: () => import('./hrmcomponents/responsibility/addresponsibility/addResponsibility.module').then(m => m.AddResponsibilityModule)
  //},
  //{
  //  path: 'hrm/responsibility/addresponsibility/:id',
  //  loadChildren: () => import('./hrmcomponents/responsibility/addresponsibility/addResponsibility.module').then(m => m.AddResponsibilityModule)
  //},

  //{
  //  path: 'hrm/responsibility/fetchresponsibility',
  //  loadChildren: () => import('./hrmcomponents/responsibility/fetchresponsibility/fetchResponsibility.module').then(m => m.FetchResponsibilityModule)
  //},
  //{
  //  path: 'hrm/salutation/addsalutation',
  //  loadChildren: () => import('./hrmcomponents/salutation/addsalutation/addSalutation.module').then(m => m.AddSalutationModule)
  //},
  //{
  //  path: 'hrm/salutation/addsalutation/:id',
  //  loadChildren: () => import('./hrmcomponents/salutation/addsalutation/addSalutation.module').then(m => m.AddSalutationModule)
  //},

  //{
  //  path: 'hrm/salutation/fetchsalutation',
  //  loadChildren: () => import('./hrmcomponents/salutation/fetchsalutation/fetchSalutation.module').then(m => m.FetchSalutationModule)
  //},
  ////

  //{
  //  path: 'hrm/skills/addskills',
  //  loadChildren: () => import('./hrmcomponents/skills/addskills/addSkills.module').then(m => m.AddSkillsModule)
  //},
  //{
  //  path: 'hrm/skills/addskills/:id',
  //  loadChildren: () => import('./hrmcomponents/skills/addskills/addSkills.module').then(m => m.AddSkillsModule)
  //},

  //{
  //  path: 'hrm/skills/fetchskills',
  //  loadChildren: () => import('./hrmcomponents/skills/fetchskills/fetchSkills.module').then(m => m.FetchSkillsModule)
  //},

  //{
  //  path: 'hrm/trainingtype/addtrainingtype',
  //  loadChildren: () => import('./hrmcomponents/trainingtype/addtrainingtype/addTrainingType.module').then(m => m.AddTrainingTypeModule)
  //},
  //{
  //  path: 'hrm/trainingtype/addtrainingtype/:id',
  //  loadChildren: () => import('./hrmcomponents/trainingtype/addtrainingtype/addTrainingType.module').then(m => m.AddTrainingTypeModule)
  //},

  //{
  //  path: 'hrm/trainingtype/fetchtrainingtype',
  //  loadChildren: () => import('./hrmcomponents/trainingtype/fetchtrainingtype/fetchTrainingType.module').then(m => m.FetchTrainingTypeModule)
  //},


  ////{
  ////  path: 'hrm/trainingmatrix/addtrainingmatrix',
  ////  loadChildren: () => import('./hrmcomponents/trainingmatrix/addtrainingmatrix/addTrainingMatrix.module').then(m => m.AddTrainingMatrixModule)
  ////},
  ////{
  ////  path: 'hrm/trainingmatrix/addtrainingmatrix/:id',
  ////  loadChildren: () => import('./hrmcomponents/trainingmatrix/addtrainingmatrix/addTrainingMatrix.module').then(m => m.AddTrainingMatrixModule)
  ////},

  ////{
  ////  path: 'hrm/trainingmatrix/fetchtrainingmatrix',
  ////  loadChildren: () => import('./hrmcomponents/trainingmatrix/fetchtrainingmatrix/fetchTrainingMatrix.module').then(m => m.FetchTrainingMatrixModule)
  ////},


  //{
  //  path: 'hrm/vacancytype/addvacancytype',
  //  loadChildren: () => import('./hrmcomponents/vacancytype/addvacancytype/addVacancyType.module').then(m => m.AddVacancyTypeModule)
  //},
  //{
  //  path: 'hrm/vacancytype/addvacancytype/:id',
  //  loadChildren: () => import('./hrmcomponents/vacancytype/addvacancytype/addVacancyType.module').then(m => m.AddVacancyTypeModule)
  //},

  //{
  //  path: 'hrm/vacancytype/fetchvacancytype',
  //  loadChildren: () => import('./hrmcomponents/vacancytype/fetchvacancytype/fetchVacancyType.module').then(m => m.FetchVacancyTypeModule)
  //},
  //{
  //  path: 'hrm/designation/adddesignation',
  //  loadChildren: () => import('./hrmcomponents/designation/adddesignation/addDesignation.module').then(m => m.AddDesignationModule)
  //},
  //{
  //  path: 'hrm/designation/adddesignation/:id',
  //  loadChildren: () => import('./hrmcomponents/designation/adddesignation/addDesignation.module').then(m => m.AddDesignationModule)
  //},

  //{
  //  path: 'hrm/designation/fetchdesignation',
  //  loadChildren: () => import('./hrmcomponents/designation/fetchdesignation/fetchDesignation.module').then(m => m.FetchDesignationModule)
  //},
  //{
  //  path: 'hrm/grade/addgrade',
  //  loadChildren: () => import('./hrmcomponents/grade/addgrade/addGrade.module').then(m => m.AddGradeModule)
  //},
  //{
  //  path: 'hrm/grade/addgrade/:id',
  //  loadChildren: () => import('./hrmcomponents/grade/addgrade/addGrade.module').then(m => m.AddGradeModule)
  //},

  //{
  //  path: 'hrm/grade/fetchgrade',
  //  loadChildren: () => import('./hrmcomponents/grade/fetchgrade/fetchGrade.module').then(m => m.FetchGradeModule)
  //},

  //{
  //  path: 'hrm/incomeanddeduction/addincomeanddeduction',
  //  loadChildren: () => import('./hrmcomponents/incomeanddeduction/addincomeanddeduction/addIncomeandDeduction.module').then(m => m.AddIncomeandDeductionModule)
  //},
  //{
  //  path: 'hrm/incomeanddeduction/addincomeanddeduction/:id',
  //  loadChildren: () => import('./hrmcomponents/incomeanddeduction/addincomeanddeduction/addIncomeandDeduction.module').then(m => m.AddIncomeandDeductionModule)
  //},

  //{
  //  path: 'hrm/incomeanddeduction/fetchincomeanddeduction',
  //  loadChildren: () => import('./hrmcomponents/incomeanddeduction/fetchincomeanddeduction/fetchIncomeandDeduction.module').then(m => m.FetchIncomeandDeductionModule)
  //},
  //{
  //  path: 'hrm/leavepolicy/addleavepolicy',
  //  loadChildren: () => import('./hrmcomponents/leavepolicy/addleavepolicy/addLeavePolicy.module').then(m => m.AddLeavePolicyModule)
  //},
  //{
  //  path: 'hrm/leavepolicy/addleavepolicy/:id',
  //  loadChildren: () => import('./hrmcomponents/leavepolicy/addleavepolicy/addLeavePolicy.module').then(m => m.AddLeavePolicyModule)
  //},

  //{
  //  path: 'hrm/leavepolicy/fetchleavepolicy',
  //  loadChildren: () => import('./hrmcomponents/leavepolicy/fetchleavepolicy/fetchLeavePolicy.module').then(m => m.FetchLeavePolicyModule)
  //},
  //{
  //  path: 'hrm/leaveencashment/addleaveencashment',
  //  loadChildren: () => import('./hrmcomponents/leaveencashmentrequisition/addleaveencashmentrequisition/addLeaveEncashmentRequisition.module').then(m => m.AddLeaveEncashmentRequisitionModule)
  //},
  //{
  //  path: 'hrm/leaveencashment/addleaveencashment/:id',
  //  loadChildren: () => import('./hrmcomponents/leaveencashmentrequisition/addleaveencashmentrequisition/addLeaveEncashmentRequisition.module').then(m => m.AddLeaveEncashmentRequisitionModule)
  //},

  //{
  //  path: 'hrm/leaveencashment/fetchleaveencashment',
  //  loadChildren: () => import('./hrmcomponents/leaveencashmentrequisition/fetchleaveencashmentrequisition/fetchLeaveEncashmentRequisition.module').then(m => m.FetchLeaveEncashmentRequisitionModule)
  //},

  //{
  //  path: 'hrm/leaveissue/addleaveissue',
  //  loadChildren: () => import('./hrmcomponents/leaveissue/addleaveissue/addLeaveIssue.module').then(m => m.AddLeaveIssueModule)
  //},
  //{
  //  path: 'hrm/leaveissue/addleaveissue/:id',
  //  loadChildren: () => import('./hrmcomponents/leaveissue/addleaveissue/addLeaveIssue.module').then(m => m.AddLeaveIssueModule)
  //},

  //{
  //  path: 'hrm/leaveissue/fetchleaveissue',
  //  loadChildren: () => import('./hrmcomponents/leaveissue/fetchleaveissue/fetchLeaveIssue.module').then(m => m.FetchLeaveIssueModule)
  //},
  ////

  //{
  //  path: 'hrm/payrollgroup/addpayrollgroup',
  //  loadChildren: () => import('./hrmcomponents/payrollgroup/addpayrollgroup/addPayrollGroup.module').then(m => m.AddPayrollGroupModule)
  //},
  //{
  //  path: 'hrm/payrollgroup/addpayrollgroup/:id',
  //  loadChildren: () => import('./hrmcomponents/payrollgroup/addpayrollgroup/addPayrollGroup.module').then(m => m.AddPayrollGroupModule)
  //},

  //{
  //  path: 'hrm/payrollgroup/fetchpayrollgroup',
  //  loadChildren: () => import('./hrmcomponents/payrollgroup/fetchpayrollgroup/fetchPayrollGroup.module').then(m => m.FetchPayrollGroupModule)
  //},
  //{
  //  path: 'hrm/dailyattendance/adddailyattendance',
  //  loadChildren: () => import('./hrmcomponents/dailyattendance/adddailyattendance/addDailyAttendance.module').then(m => m.AddDailyAttendanceModule)
  //},
  //{
  //  path: 'hrm/dailyattendance/adddailyattendance/:id',
  //  loadChildren: () => import('./hrmcomponents/dailyattendance/adddailyattendance/addDailyAttendance.module').then(m => m.AddDailyAttendanceModule)
  //},

  //{
  //  path: 'hrm/dailyattendance/fetchdailyattendance',
  //  loadChildren: () => import('./hrmcomponents/dailyattendance/fetchdailyattendance/fetchDailyAttendance.module').then(m => m.FetchDailyAttendanceModule)
  //},
  //{
  //  path: 'hrm/consolidatedattendance/addconsolidatedattendance',
  //  loadChildren: () => import('./hrmcomponents/consolidatedattendance/addconsolidatedattendance/addConsolidatedAttendance.module').then(m => m.AddConsolidatedAttendanceModule)
  //},
  //{
  //  path: 'hrm/consolidatedattendance/addconsolidatedattendance/:id',
  //  loadChildren: () => import('./hrmcomponents/consolidatedattendance/addconsolidatedattendance/addConsolidatedAttendance.module').then(m => m.AddConsolidatedAttendanceModule)
  //},

  //{
  //  path: 'hrm/consolidatedattendance/fetchconsolidatedattendance',
  //  loadChildren: () => import('./hrmcomponents/consolidatedattendance/fetchconsolidatedattendance/fetchConsolidatedAttendance.module').then(m => m.FetchConsolidatedAttendanceModule)
  //},
  //{
  //  path: 'hrm/leaveopeningbalance/addleaveopeningbalance',
  //  loadChildren: () => import('./hrmcomponents/leaveopeningbalance/addleaveopeningbalance/addLeaveOpeningBalance.module').then(m => m.AddLeaveOpeningBalanceModule)
  //},
  //{
  //  path: 'hrm/leaveopeningbalance/addleaveopeningbalance/:id',
  //  loadChildren: () => import('./hrmcomponents/leaveopeningbalance/addleaveopeningbalance/addLeaveOpeningBalance.module').then(m => m.AddLeaveOpeningBalanceModule)
  //},

  //{
  //  path: 'hrm/leaveopeningbalance/fetchleaveopeningbalance',
  //  loadChildren: () => import('./hrmcomponents/leaveopeningbalance/fetchleaveopeningbalance/fetchLeaveOpeningBalance.module').then(m => m.FetchLeaveOpeningBalanceModule)
  //},
  //{
  //  path: 'hrm/transferpromotion/addtransferpromotion',
  //  loadChildren: () => import('./hrmcomponents/transferpromotion/addtransferpromotion/addTransferPromotion.module').then(m => m.AddTransferPromotionModule)
  //},
  //{
  //  path: 'hrm/transferpromotion/addtransferpromotion/:id',
  //  loadChildren: () => import('./hrmcomponents/transferpromotion/addtransferpromotion/addTransferPromotion.module').then(m => m.AddTransferPromotionModule)
  //},

  //{
  //  path: 'hrm/transferpromotion/fetchtransferpromotion',
  //  loadChildren: () => import('./hrmcomponents/transferpromotion/fetchtransferpromotion/fetchTransferPromotion.module').then(m => m.FetchTransferPromotionModule)
  //},
  //{
  //  path: 'hrm/servicetermination/addservicetermination',
  //  loadChildren: () => import('./hrmcomponents/servicetermination/addservicetermination/addServiceTermination.module').then(m => m.AddServiceTerminationModule)
  //},
  //{
  //  path: 'hrm/servicetermination/addservicetermination/:id',
  //  loadChildren: () => import('./hrmcomponents/servicetermination/addservicetermination/addServiceTermination.module').then(m => m.AddServiceTerminationModule)
  //},

  //{
  //  path: 'hrm/servicetermination/fetchservicetermination',
  //  loadChildren: () => import('./hrmcomponents/servicetermination/fetchservicetermination/fetchServiceTermination.module').then(m => m.FetchServiceTerminationModule)
  //},
  //{
  //  path: 'procurement/fuelinvoice/addfuelinvoice',
  //  loadChildren: () => import('./procurementcomponents/fuelinvoice/addfuelinvoice/addFuelInvoice.module').then(m => m.AddFuelInvoiceModule)
  //},
  //{
  //  path: 'procurement/fuelinvoice/addfuelinvoice/:id',
  //  loadChildren: () => import('./procurementcomponents/fuelinvoice/addfuelinvoice/addFuelInvoice.module').then(m => m.AddFuelInvoiceModule)
  //},

  //{
  //  path: 'procurement/fuelinvoice/fetchfuelinvoice',
  //  loadChildren: () => import('./procurementcomponents/fuelinvoice/fetchfuelinvoice/fetchFuelInvoice.module').then(m => m.FetchFuelInvoiceModule)
  //},
  //{
  //  path: 'procurement/deliverymodes/adddeliverymodes',
  //  loadChildren: () => import('./procurementcomponents/deliverymodes/adddeliverymodes/addDeliveryModes.module').then(m => m.AddDeliveryModesModule)
  //},
  //{
  //  path: 'procurement/deliverymodes/adddeliverymodes/:id',
  //  loadChildren: () => import('./procurementcomponents/deliverymodes/adddeliverymodes/addDeliveryModes.module').then(m => m.AddDeliveryModesModule)
  //},

  //{
  //  path: 'procurement/deliverymodes/fetchdeliverymodes',
  //  loadChildren: () => import('./procurementcomponents/deliverymodes/fetchdeliverymodes/fetchDeliveryModes.module').then(m => m.FetchDeliveryModesModule)
  //},
  //{
  //  path: 'procurement/vendortype/addvendortype',
  //  loadChildren: () => import('./procurementcomponents/vendortype/addvendortype/addVendorType.module').then(m => m.AddVendorTypeModule)
  //},
  //{
  //  path: 'procurement/vendortype/addvendortype/:id',
  //  loadChildren: () => import('./procurementcomponents/vendortype/addvendortype/addVendorType.module').then(m => m.AddVendorTypeModule)
  //},
  //{
  //  path: 'procurement/vendortype/fetchvendortype',
  //  loadChildren: () => import('./procurementcomponents/vendortype/fetchvendortype/fetchVendorType.module').then(m => m.FetchVendorTypeModule)
  //},
  //{
  //  path: 'procurement/vendorcategory/addvendorcategory',
  //  loadChildren: () => import('./procurementcomponents/vendorcategory/addvendorcategory/addVendorCategory.module').then(m => m.AddVendorCategoryModule)
  //},
  //{
  //  path: 'procurement/vendorcategory/addvendorcategory/:id',
  //  loadChildren: () => import('./procurementcomponents/vendorcategory/addvendorcategory/addVendorCategory.module').then(m => m.AddVendorCategoryModule)
  //},

  //{
  //  path: 'procurement/vendorcategory/fetchvendorcategory',
  //  loadChildren: () => import('./procurementcomponents/vendorcategory/fetchvendorcategory/fetchVendorCategory.module').then(m => m.FetchVendorCategoryModule)
  //},
  //{
  //  path: 'procurement/deliveryterms/adddeliveryterms',
  //  loadChildren: () => import('./procurementcomponents/deliveryterms/adddeliveryterms/addDeliveryTerms.module').then(m => m.AddDeliveryTermsModule)
  //},
  //{
  //  path: 'procurement/deliveryterms/adddeliveryterms/:id',
  //  loadChildren: () => import('./procurementcomponents/deliveryterms/adddeliveryterms/addDeliveryTerms.module').then(m => m.AddDeliveryTermsModule)
  //},

  //{
  //  path: 'procurement/deliveryterms/fetchdeliveryterms',
  //  loadChildren: () => import('./procurementcomponents/deliveryterms/fetchdeliveryterms/fetchDeliveryTerms.module').then(m => m.FetchDeliveryTermsModule)
  //},
  //{
  //  path: 'procurement/deliverytype/adddeliverytype',
  //  loadChildren: () => import('./procurementcomponents/deliverytype/adddeliverytype/addDeliveryType.module').then(m => m.AddDeliveryTypeModule)
  //},
  //{
  //  path: 'procurement/deliverytype/adddeliverytype/:id',
  //  loadChildren: () => import('./procurementcomponents/deliverytype/adddeliverytype/addDeliveryType.module').then(m => m.AddDeliveryTypeModule)
  //},

  //{
  //  path: 'procurement/deliverytype/fetchdeliverytype',
  //  loadChildren: () => import('./procurementcomponents/deliverytype/fetchdeliverytype/fetchDeliveryType.module').then(m => m.FetchDeliveryTypeModule)
  //},
  //{
  //  path: 'procurement/division/adddivision',
  //  loadChildren: () => import('./procurementcomponents/division/adddivision/addDivision.module').then(m => m.AddDivisionModule)
  //},
  //{
  //  path: 'procurement/division/adddivision/:id',
  //  loadChildren: () => import('./procurementcomponents/division/adddivision/addDivision.module').then(m => m.AddDivisionModule)
  //},

  //{
  //  path: 'procurement/division/fetchdivision',
  //  loadChildren: () => import('./procurementcomponents/division/fetchdivision/fetchDivision.module').then(m => m.FetchDivisionModule)
  //},
  //{
  //  path: 'procurement/documenttype/adddocumenttype',
  //  loadChildren: () => import('./procurementcomponents/documenttype/adddocumenttype/addDocumentType.module').then(m => m.AddDocumentTypeModule)
  //},
  //{
  //  path: 'procurement/documenttype/adddocumenttype/:id',
  //  loadChildren: () => import('./procurementcomponents/documenttype/adddocumenttype/addDocumentType.module').then(m => m.AddDocumentTypeModule)
  //},

  //{
  //  path: 'procurement/documenttype/fetchdocumenttype',
  //  loadChildren: () => import('./procurementcomponents/documenttype/fetchdocumenttype/fetchDocumentType.module').then(m => m.FetchDocumentTypeModule)
  //},
  //{
  //  path: 'procurement/paymentterms/addpaymentterms',
  //  loadChildren: () => import('./procurementcomponents/paymentterms/addpaymentterms/addPaymentTerms.module').then(m => m.AddPaymentTermsModule)
  //},
  //{
  //  path: 'procurement/paymentterms/addpaymentterms/:id',
  //  loadChildren: () => import('./procurementcomponents/paymentterms/addpaymentterms/addPaymentTerms.module').then(m => m.AddPaymentTermsModule)
  //},

  //{
  //  path: 'procurement/paymentterms/fetchpaymentterms',
  //  loadChildren: () => import('./procurementcomponents/paymentterms/fetchpaymentterms/fetchPaymentTerms.module').then(m => m.FetchPaymentTermsModule)
  //},
  //{
  //  path: 'procurement/vendorgroup/addvendorgroup',
  //  loadChildren: () => import('./procurementcomponents/vendorgroup/addvendorgroup/addVendorGroup.module').then(m => m.AddVendorGroupModule)
  //},
  //{
  //  path: 'procurement/vendorgroup/addvendorgroup/:id',
  //  loadChildren: () => import('./procurementcomponents/vendorgroup/addvendorgroup/addVendorGroup.module').then(m => m.AddVendorGroupModule)
  //},

  //{
  //  path: 'procurement/vendorgroup/fetchvendorgroup',
  //  loadChildren: () => import('./procurementcomponents/vendorgroup/fetchvendorgroup/fetchVendorGroup.module').then(m => m.FetchVendorGroupModule)
  //},
  //{
  //  path: 'procurement/vendermaster/addvendermaster',
  //  loadChildren: () => import('./procurementcomponents/vendermaster/addvendermaster/addVenderMaster.module').then(m => m.AddVenderMasterModule)
  //},
  //{
  //  path: 'procurement/vendermaster/addvendermaster/:id',
  //  loadChildren: () => import('./procurementcomponents/vendermaster/addvendermaster/addVenderMaster.module').then(m => m.AddVenderMasterModule)
  //},

  //{
  //  path: 'procurement/vendermaster/fetchvendermaster',
  //  loadChildren: () => import('./procurementcomponents/vendermaster/fetchvendermaster/fetchVenderMaster.module').then(m => m.FetchVenderMasterModule)
  //},
  //{
  //  path: 'procurement/categories/addcategories',
  //  loadChildren: () => import('./procurementcomponents/categories/addcategories/addCategories.module').then(m => m.AddCategoriesModule)
  //},
  //{
  //  path: 'procurement/categories/addcategories/:id',
  //  loadChildren: () => import('./procurementcomponents/categories/addcategories/addCategories.module').then(m => m.AddCategoriesModule)
  //},

  //{
  //  path: 'procurement/categories/fetchcategories',
  //  loadChildren: () => import('./procurementcomponents/categories/fetchcategories/fetchCategories.module').then(m => m.FetchCategoriesModule)
  //},
  //{
  //  path: 'procurement/registrationcategory/addregistrationcategory',
  //  loadChildren: () => import('./procurementcomponents/registrationcategory/addregistrationcategory/addRegistrationCategory.module').then(m => m.AddRegistrationCategoryModule)
  //},
  //{
  //  path: 'procurement/registrationcategory/addregistrationcategory/:id',
  //  loadChildren: () => import('./procurementcomponents/registrationcategory/addregistrationcategory/addRegistrationCategory.module').then(m => m.AddRegistrationCategoryModule)
  //},

  //{
  //  path: 'procurement/registrationcategory/fetchregistrationcategory',
  //  loadChildren: () => import('./procurementcomponents/registrationcategory/fetchregistrationcategory/fetchRegistrationCategory.module').then(m => m.FetchRegistrationCategoryModule)
  //},
  //{
  //  path: 'procurement/invoicetype/addinvoicetype',
  //  loadChildren: () => import('./procurementcomponents/invoicetype/addinvoicetype/addInvoicetype.module').then(m => m.AddInvoiceTypeModule)
  //},
  //{
  //  path: 'procurement/invoicetype/addinvoicetype/:id',
  //  loadChildren: () => import('./procurementcomponents/invoicetype/addinvoicetype/addInvoicetype.module').then(m => m.AddInvoiceTypeModule)
  //},

  //{
  //  path: 'procurement/invoicetype/fetchinvoicetype',
  //  loadChildren: () => import('./procurementcomponents/invoicetype/fetchinvoicetype/fetchInvoicetype.module').then(m => m.FetchInvoiceTypeModule)
  //},
  //{
  //  path: 'procurement/purchaserequisition/addpurchaserequisition',
  //  loadChildren: () => import('./procurementcomponents/purchaserequisition/addpurchaserequisition/addPurchaseRequisition.module').then(m => m.AddPurchaseRequisitionModule)
  //},
  //{
  //  path: 'procurement/purchaserequisition/addpurchaserequisition/:id',
  //  loadChildren: () => import('./procurementcomponents/purchaserequisition/addpurchaserequisition/addPurchaseRequisition.module').then(m => m.AddPurchaseRequisitionModule)
  //},

  //{
  //  path: 'procurement/purchaserequisition/fetchpurchaserequisition',
  //  loadChildren: () => import('./procurementcomponents/purchaserequisition/fetchpurchaserequisition/fetchPurchaseRequisition.module').then(m => m.FetchPurchaseRequisitionModule)
  //},
  {
    path: 'procurement/purchaseorder/addpurchaseorder',
    loadChildren: () => import('./procurementcomponents/purchaseorder/addpurchaseorder/addPurchaseOrder.module').then(m => m.AddPurchaseOrderModule)
  },
  {
    path: 'procurement/purchaseorder/addpurchaseorder/:id',
    loadChildren: () => import('./procurementcomponents/purchaseorder/addpurchaseorder/addPurchaseOrder.module').then(m => m.AddPurchaseOrderModule)
  },
  {
    path: 'procurement/purchaseorder/fetchpurchaseorder',
    loadChildren: () => import('./procurementcomponents/purchaseorder/fetchpurchaseorder/fetchPurchaseOrder.module').then(m => m.FetchPurchaseOrderModule)
  },
  {
    path: 'procurement/purchaseinvoice/addpurchaseinvoice',
    loadChildren: () => import('./procurementcomponents/purchaseinvoice/addpurchaseinvoice/addPurchaseInvoice.module').then(m => m.AddPurchaseInvoiceModule)
  },
  {
    path: 'procurement/purchaseinvoice/addpurchaseinvoice/:id',
    loadChildren: () => import('./procurementcomponents/purchaseinvoice/addpurchaseinvoice/addPurchaseInvoice.module').then(m => m.AddPurchaseInvoiceModule)
  },
  {
    path: 'procurement/purchaseinvoice/fetchpurchaseinvoice',
    loadChildren: () => import('./procurementcomponents/purchaseinvoice/fetchpurchaseinvoice/fetchPurchaseInvoice.module').then(m => m.FetchPurchaseInvoiceModule)
  },
  //{
  //  path: 'procurement/proformainvoice/addproformainvoice',
  //  loadChildren: () => import('./procurementcomponents/proformainvoice/addproformainvoice/addProformaInvoice.module').then(m => m.AddProformaInvoiceModule)
  //},
  //{
  //  path: 'procurement/proformainvoice/addproformainvoice/:id',
  //  loadChildren: () => import('./procurementcomponents/proformainvoice/addproformainvoice/addProformaInvoice.module').then(m => m.AddProformaInvoiceModule)
  //},

  //{
  //  path: 'procurement/proformainvoice/fetchproformainvoice',
  //  loadChildren: () => import('./procurementcomponents/proformainvoice/fetchproformainvoice/fetchProformaInvoice.module').then(m => m.FetchProformaInvoiceModule)
  //},

  //{
  //  path: 'inventory/purchasereturn/addpurchasereturn',
  //  loadChildren: () => import('./procurementcomponents/purchasereturn/addpurchasereturn/addPurchaseReturn.module').then(m => m.AddPurchaseReturnModule)
  //},
  //{
  //  path: 'inventory/purchasereturn/addpurchasereturn/:id',
  //  loadChildren: () => import('./procurementcomponents/purchasereturn/addpurchasereturn/addPurchaseReturn.module').then(m => m.AddPurchaseReturnModule)
  //},

  //{
  //  path: 'inventory/purchasereturn/fetchpurchasereturn',
  //  loadChildren: () => import('./procurementcomponents/purchasereturn/fetchpurchasereturn/fetchPurchaseReturn.module').then(m => m.FetchPurchaseReturnModule)
  //},
  //{
  //  path: 'inventory/itemtype/additemtype',
  //  loadChildren: () => import('./inventorycomponents/itemtype/additemtype/addItemType.module').then(m => m.AddItemTypeModule)
  //},
  //{
  //  path: 'inventory/itemtype/additemtype/:id',
  //  loadChildren: () => import('./inventorycomponents/itemtype/additemtype/addItemType.module').then(m => m.AddItemTypeModule)
  //},

  //{
  //  path: 'inventory/itemtype/fetchitemtype',
  //  loadChildren: () => import('./inventorycomponents/itemtype/fetchitemtype/fetchItemType.module').then(m => m.FetchItemTypeModule)
  //},
  ////{
  ////    path: 'inventory/bintype/addbintype',
  ////    loadChildren: () => import('./inventorycomponents/bintype/addbintype/addBinType.module').then(m => m.AddBinTypeModule)
  ////},
  ////{
  ////    path: 'inventory/bintype/addbintype/:id',
  ////    loadChildren: () => import('./inventorycomponents/bintype/addbintype/addBinType.module').then(m => m.AddBinTypeModule)
  ////},

  ////{
  ////    path: 'inventory/bintype/fetchbintype',
  ////    loadChildren: () => import('./inventorycomponents/bintype/fetchbintype/fetchBinType.module').then(m => m.FetchBinTypeModule)
  ////},
  //{
  //  path: 'inventory/location/addlocation',
  //  loadChildren: () => import('./procurementcomponents/location/addlocation/addLocation.module').then(m => m.AddLocationModule)
  //},
  //{
  //  path: 'inventory/location/addlocation/:id',
  //  loadChildren: () => import('./procurementcomponents/location/addlocation/addLocation.module').then(m => m.AddLocationModule)
  //},

  //{
  //  path: 'inventory/location/fetchlocation',
  //  loadChildren: () => import('./procurementcomponents/location/fetchlocation/fetchLocation.module').then(m => m.FetchLocationModule)
  //},
  ////{
  ////    path: 'inventory/unitset/addunitset',
  ////    loadChildren: () => import('./inventorycomponents/unitset/addunitset/addUnitSet.module').then(m => m.AddUnitSetModule)
  ////},
  ////{
  ////    path: 'inventory/unitset/addunitset/:id',
  ////    loadChildren: () => import('./inventorycomponents/unitset/addunitset/addUnitSet.module').then(m => m.AddUnitSetModule)
  ////},

  ////{
  ////    path: 'inventory/unitset/fetchunitset',
  ////    loadChildren: () => import('./inventorycomponents/unitset/fetchunitset/fetchUnitSet.module').then(m => m.FetchUnitSetModule)
  ////},
  //{
  //  path: 'inventory/itemcategory/additemcategory',
  //  loadChildren: () => import('./inventorycomponents/itemcategory/additemcategory/addItemCategory.module').then(m => m.AddItemCategoryModule)
  //},
  //{
  //  path: 'inventory/itemcategory/additemcategory/:id',
  //  loadChildren: () => import('./inventorycomponents/itemcategory/additemcategory/addItemCategory.module').then(m => m.AddItemCategoryModule)
  //},

  //{
  //  path: 'inventory/itemcategory/fetchitemcategory',
  //  loadChildren: () => import('./inventorycomponents/itemcategory/fetchitemcategory/fetchItemCategory.module').then(m => m.FetchItemCategoryModule)
  //},
  ////{
  ////    path: 'inventory/itemspecification/additemspecification',
  ////    loadChildren: () => import('./inventorycomponents/itemspecification/additemspecification/addItemSpecification.module').then(m => m.AddItemSpecificationModule)
  ////},
  ////{
  ////    path: 'inventory/itemspecification/additemspecification/:id',
  ////    loadChildren: () => import('./inventorycomponents/itemspecification/additemspecification/addItemSpecification.module').then(m => m.AddItemSpecificationModule)
  ////},

  ////{
  ////    path: 'inventory/itemspecification/fetchitemspecification',
  ////    loadChildren: () => import('./inventorycomponents/itemspecification/fetchitemspecification/fetchItemSpecification.module').then(m => m.FetchItemSpecificationModule)
  ////},
  //{
  //  path: 'inventory/itemgroup/additemgroup',
  //  loadChildren: () => import('./inventorycomponents/itemgroup/additemgroup/addItemGroup.module').then(m => m.AddItemGroupModule)
  //},
  //{
  //  path: 'inventory/itemgroup/additemgroup/:id',
  //  loadChildren: () => import('./inventorycomponents/itemgroup/additemgroup/addItemGroup.module').then(m => m.AddItemGroupModule)
  //},

  //{
  //  path: 'inventory/itemgroup/fetchitemgroup',
  //  loadChildren: () => import('./inventorycomponents/itemgroup/fetchitemgroup/fetchItemGroup.module').then(m => m.FetchItemGroupModule)
  //},
  //{
  //  path: 'inventory/itemmasterproduction/additemmaster',
  //  loadChildren: () => import('./inventorycomponents/itemmaster/additemmaster/addItemMaster.module').then(m => m.AddItemMasterModule)
  //},
  //{
  //  path: 'inventory/itemmasterproduction/additemmaster/:id',
  //  loadChildren: () => import('./inventorycomponents/itemmaster/additemmaster/addItemMaster.module').then(m => m.AddItemMasterModule)
  //},

  //{
  //  path: 'inventory/itemmasterproduction/fetchitemmaster',
  //  loadChildren: () => import('./inventorycomponents/itemmaster/fetchitemmaster/fetchItemMaster.module').then(m => m.FetchItemMasterModule)
  //},
  //{
  //  path: 'inventory/itemmaster/additemmaster',
  //  loadChildren: () => import('./inventorycomponents/itemmastertransportation/additemmastertransportation/addItemMasterTransportation.module').then(m => m.AddItemMasterTransportationModule)
  //},
  //{
  //  path: 'inventory/itemmaster/additemmaster/:id',
  //  loadChildren: () => import('./inventorycomponents/itemmastertransportation/additemmastertransportation/addItemMasterTransportation.module').then(m => m.AddItemMasterTransportationModule)
  //},

  //{
  //  path: 'inventory/itemmaster/fetchitemmaster',
  //  loadChildren: () => import('./inventorycomponents/itemmastertransportation/fetchitemmastertransportation/fetchItemMasterTransportation.module').then(m => m.FetchItemMasterTransportationModule)
  //},

  //{
  //  path: 'inventory/itemmeasures/additemmeasures',
  //  loadChildren: () => import('./inventorycomponents/itemmeasures/additemmeasures/addItemMeasures.module').then(m => m.AddItemMeasuresModule)
  //},
  //{
  //  path: 'inventory/itemmeasures/additemmeasures/:id',
  //  loadChildren: () => import('./inventorycomponents/itemmeasures/additemmeasures/addItemMeasures.module').then(m => m.AddItemMeasuresModule)
  //},

  //{
  //  path: 'inventory/itemmeasures/fetchitemmeasures',
  //  loadChildren: () => import('./inventorycomponents/itemmeasures/fetchitemmeasures/fetchItemMeasures.module').then(m => m.FetchItemMeasuresModule)
  //},
  //{
  //  path: 'inventory/warehouse/addwarehouse',
  //  loadChildren: () => import('./inventorycomponents/warehouse/addwarehouse/addWareHouse.module').then(m => m.AddWareHouseModule)
  //},
  //{
  //  path: 'inventory/warehouse/addwarehouse/:id',
  //  loadChildren: () => import('./inventorycomponents/warehouse/addwarehouse/addWareHouse.module').then(m => m.AddWareHouseModule)
  //},

  //{
  //  path: 'inventory/warehouse/fetchwarehouse',
  //  loadChildren: () => import('./inventorycomponents/warehouse/fetchwarehouse/fetchWareHouse.module').then(m => m.FetchWareHouseModule)
  //},
  //{
  //  path: 'inventory/stocktype/addstocktype',
  //  loadChildren: () => import('./inventorycomponents/stocktype/addstocktype/addStockType.module').then(m => m.AddStockTypeModule)
  //},
  //{
  //  path: 'inventory/stocktype/addstocktype/:id',
  //  loadChildren: () => import('./inventorycomponents/stocktype/addstocktype/addStockType.module').then(m => m.AddStockTypeModule)
  //},

  //{
  //  path: 'inventory/stocktype/fetchstocktype',
  //  loadChildren: () => import('./inventorycomponents/stocktype/fetchstocktype/fetchStockType.module').then(m => m.FetchStockTypeModule)
  //},

  //{
  //  path: 'inventory/uom/adduom',
  //  loadChildren: () => import('./inventorycomponents/uom/adduom/addUom.module').then(m => m.AddUomModule)
  //},
  //{
  //  path: 'inventory/uom/adduom/:id',
  //  loadChildren: () => import('./inventorycomponents/uom/adduom/addUom.module').then(m => m.AddUomModule)
  //},

  //{
  //  path: 'inventory/uom/fetchuom',
  //  loadChildren: () => import('./inventorycomponents/uom/fetchuom/fetchUom.module').then(m => m.FetchUomModule)
  //},
  //{
  //  path: 'inventory/stockreconciliation/addstockreconciliation',
  //  loadChildren: () => import('./inventorycomponents/stockreconciliation/addstockreconciliation/addStockReconciliation.module').then(m => m.AddStockReconciliationModule)
  //},
  //{
  //  path: 'inventory/stockreconciliation/addstockreconciliation/:id',
  //  loadChildren: () => import('./inventorycomponents/stockreconciliation/addstockreconciliation/addStockReconciliation.module').then(m => m.AddStockReconciliationModule)
  //},

  //{
  //  path: 'inventory/stockreconciliation/fetchstockreconciliation',
  //  loadChildren: () => import('./inventorycomponents/stockreconciliation/fetchstockreconciliation/fetchStockReconciliation.module').then(m => m.FetchStockReconciliationModule)
  //},

  {
    path: 'inventory/deliverynote/adddeliverynote',
    loadChildren: () => import('./inventorycomponents/deliverynote/adddeliverynote/addDeliveryNote.module').then(m => m.AddDeliveryNoteModule)
  },
  {
    path: 'inventory/deliverynote/adddeliverynote/:id',
    loadChildren: () => import('./inventorycomponents/deliverynote/adddeliverynote/addDeliveryNote.module').then(m => m.AddDeliveryNoteModule)
  },
  {
    path: 'inventory/deliverynote/fetchdeliverynote',
    loadChildren: () => import('./inventorycomponents/deliverynote/fetchdeliverynote/fetchDeliveryNote.module').then(m => m.FetchDeliveryNoteModule)
  },
  ////
  ////{
  ////    path: 'inventory/bins/addbins',
  ////    loadChildren: () => import('./inventorycomponents/bins/addbins/addBins.module').then(m => m.AddBinsModule)
  ////},
  ////{
  ////    path: 'inventory/bins/addbins/:id',
  ////    loadChildren: () => import('./inventorycomponents/bins/addbins/addBins.module').then(m => m.AddBinsModule)
  ////},

  ////{
  ////    path: 'inventory/bins/fetchbins',
  ////    loadChildren: () => import('./inventorycomponents/bins/fetchbins/fetchBins.module').then(m => m.FetchBinsModule)
  ////},
  //{
  //  path: 'inventory/subcontractingorder/addsubcontractingorder',
  //  loadChildren: () => import('./inventorycomponents/subcontractingorder/addsubcontractingorder/addSubContractingOrder.module').then(m => m.AddSubContractingOrderModule)
  //},
  //{
  //  path: 'inventory/subcontractingorder/addsubcontractingorder/:id',
  //  loadChildren: () => import('./inventorycomponents/subcontractingorder/addsubcontractingorder/addSubContractingOrder.module').then(m => m.AddSubContractingOrderModule)
  //},

  //{
  //  path: 'inventory/subcontractingorder/fetchsubcontractingorder',
  //  loadChildren: () => import('./inventorycomponents/subcontractingorder/fetchsubcontractingorder/fetchSubContractingOrder.module').then(m => m.FetchSubContractingOrderModule)
  //},
  //{
  //  path: 'inventory/subcontractingissue/addsubcontractingissue',
  //  loadChildren: () => import('./inventorycomponents/subcontractingissue/addsubcontractingissue/addSubContractingIssue.module').then(m => m.AddSubContractingIssueModule)
  //},
  //{
  //  path: 'inventory/subcontractingissue/addsubcontractingissue/:id',
  //  loadChildren: () => import('./inventorycomponents/subcontractingissue/addsubcontractingissue/addSubContractingIssue.module').then(m => m.AddSubContractingIssueModule)
  //},

  //{
  //  path: 'inventory/subcontractingissue/fetchsubcontractingissue',
  //  loadChildren: () => import('./inventorycomponents/subcontractingissue/fetchsubcontractingissue/fetchSubContractingIssue.module').then(m => m.FetchSubContractingIssueModule)
  //},
  //{
  //  path: 'inventory/subcontractingreceipt/addsubcontractingreceipt',
  //  loadChildren: () => import('./inventorycomponents/subcontractingreceipt/addsubcontractingreceipt/addSubContractingReceipt.module').then(m => m.AddSubContractingReceiptModule)
  //},
  //{
  //  path: 'inventory/subcontractingreceipt/addsubcontractingreceipt/:id',
  //  loadChildren: () => import('./inventorycomponents/subcontractingreceipt/addsubcontractingreceipt/addSubContractingReceipt.module').then(m => m.AddSubContractingReceiptModule)
  //},

  //{
  //  path: 'inventory/subcontractingreceipt/fetchsubcontractingreceipt',
  //  loadChildren: () => import('./inventorycomponents/subcontractingreceipt/fetchsubcontractingreceipt/fetchSubContractingReceipt.module').then(m => m.FetchSubContractingReceiptModule)
  //},
  //{
  //  path: 'inventory/purchaseindent/addpurchaseindent',
  //  loadChildren: () => import('./inventorycomponents/purchaseindent/addpurchaseindent/addPurchaseIndent.module').then(m => m.AddPurchaseIndentModule)
  //},
  //{
  //  path: 'inventory/purchaseindent/addpurchaseindent/:id',
  //  loadChildren: () => import('./inventorycomponents/purchaseindent/addpurchaseindent/addPurchaseIndent.module').then(m => m.AddPurchaseIndentModule)
  //},

  //{
  //  path: 'inventory/purchaseindent/fetchpurchaseindent',
  //  loadChildren: () => import('./inventorycomponents/purchaseindent/fetchpurchaseindent/fetchPurchaseIndent.module').then(m => m.FetchPurchaseIndentModule)
  //},
  //{
  //  path: 'inventory/returnablegatepass/addreturnablegatepass',
  //  loadChildren: () => import('./inventorycomponents/returnablegatepass/addreturnablegatepass/addReturnableGatePass.module').then(m => m.AddReturnableGatePassModule)
  //},
  //{
  //  path: 'inventory/returnablegatepass/addreturnablegatepass/:id',
  //  loadChildren: () => import('./inventorycomponents/returnablegatepass/addreturnablegatepass/addReturnableGatePass.module').then(m => m.AddReturnableGatePassModule)
  //},
  //{
  //  path: 'inventory/returnablegatepass/fetchreturnablegatepass',
  //  loadChildren: () => import('./inventorycomponents/returnablegatepass/fetchreturnablegatepass/fetchReturnableGatePass.module').then(m => m.FetchReturnableGatePassModule)
  //},

  //{
  //  path: 'inventory/istindent/addistindent',
  //  loadChildren: () => import('./inventorycomponents/istindent/addistindent/addIstIndent.module').then(m => m.AddIstIndentModule)
  //},
  //{
  //  path: 'inventory/istindent/addistindent/:id',
  //  loadChildren: () => import('./inventorycomponents/istindent/addistindent/addIstIndent.module').then(m => m.AddIstIndentModule)
  //},

  //{
  //  path: 'inventory/istindent/fetchistindent',
  //  loadChildren: () => import('./inventorycomponents/istindent/fetchistindent/fetchIstIndent.module').then(m => m.FetchIstIndentModule)
  //},
  //{
  //    path: 'inventory/itemlocationmapping/additemlocationmapping',
  //    loadChildren: () => import('./inventorycomponents/itemlocationmapping/additemlocationmapping/addItemLocationMapping.module').then(m => m.AddItemLocationMappingModule)
  //},
  //{
  //    path: 'inventory/itemlocationmapping/additemlocationmapping/:suborgid/:warehouseid/:itemid',
  //    loadChildren: () => import('./inventorycomponents/itemlocationmapping/additemlocationmapping/addItemLocationMapping.module').then(m => m.AddItemLocationMappingModule)
  //},

  //{
  //    path: 'inventory/itemlocationmapping/fetchitemlocationmapping',
  //    loadChildren: () => import('./inventorycomponents/itemlocationmapping/fetchitemlocationmapping/fetchItemLocationMapping.module').then(m => m.FetchItemLocationMappingModule)
  //},
  {
    path: 'inventory/grn/addgrn',
    loadChildren: () => import('./inventorycomponents/grn/addgrn/addGRN.module').then(m => m.AddGRNModule)
  },
  {
    path: 'inventory/grn/addgrn/:id',
    loadChildren: () => import('./inventorycomponents/grn/addgrn/addGRN.module').then(m => m.AddGRNModule)
  },
  {
    path: 'inventory/grn/fetchgrn',
    loadChildren: () => import('./inventorycomponents/grn/fetchgrn/fetchGRN.module').then(m => m.FetchGRNModule)
  },
  //{
  //  path: 'inventory/stockopeningbalance/addstockopeningbalance',
  //  loadChildren: () => import('./inventorycomponents/stockopeningbalance/addstockopeningbalance/addStockOpeningBalance.module').then(m => m.AddStockOpeningBalanceModule)
  //},
  //{
  //  path: 'inventory/stockopeningbalance/addstockopeningbalance/:id',
  //  loadChildren: () => import('./inventorycomponents/stockopeningbalance/addstockopeningbalance/addStockOpeningBalance.module').then(m => m.AddStockOpeningBalanceModule)
  //},
  //{
  //  path: 'inventory/stockopeningbalance/fetchstockopeningbalance',
  //  loadChildren: () => import('./inventorycomponents/stockopeningbalance/fetchstockopeningbalance/fetchStockOpeningBalance.module').then(m => m.FetchStockOpeningBalanceModule)
  //},
  //{
  //  path: 'inventory/istissue/addistissue',
  //  loadChildren: () => import('./inventorycomponents/istissue/addistissue/addISTIssue.module').then(m => m.AddISTIssueModule)
  //},
  //{
  //  path: 'inventory/istissue/addistissue/:id',
  //  loadChildren: () => import('./inventorycomponents/istissue/addistissue/addISTIssue.module').then(m => m.AddISTIssueModule)
  //},

  //{
  //  path: 'inventory/istissue/fetchistissue',
  //  loadChildren: () => import('./inventorycomponents/istissue/fetchistissue/fetchISTIssue.module').then(m => m.FetchISTIssueModule)
  //},
  //{
  //  path: 'inventory/istreceipt/addistreceipt',
  //  loadChildren: () => import('./inventorycomponents/istreceipt/addistreceipt/addISTReceipt.module').then(m => m.AddISTReceiptModule)
  //},
  //{
  //  path: 'inventory/istreceipt/addistreceipt/:id',
  //  loadChildren: () => import('./inventorycomponents/istreceipt/addistreceipt/addISTReceipt.module').then(m => m.AddISTReceiptModule)
  //},

  //{
  //  path: 'inventory/istreceipt/fetchistreceipt',
  //  loadChildren: () => import('./inventorycomponents/istreceipt/fetchistreceipt/fetchISTReceipt.module').then(m => m.FetchISTReceiptModule)
  //},
  //{
  //  path: 'operations/fuelslip/addfuelslip',
  //  loadChildren: () => import('./operationscomponents/fuelslip/addfuelslip/addFuelSlip.module').then(m => m.AddFuelSlipModule)
  //},
  //{
  //  path: 'operations/fuelslip/addfuelslip/:id',
  //  loadChildren: () => import('./operationscomponents/fuelslip/addfuelslip/addFuelSlip.module').then(m => m.AddFuelSlipModule)
  //},

  //{
  //  path: 'operations/fuelslip/fetchfuelslip',
  //  loadChildren: () => import('./operationscomponents/fuelslip/fetchfuelslip/fetchFuelSlip.module').then(m => m.FetchFuelSlipModule)
  //},
  //{
  //  path: 'operations/fuelissue/addfuelissue',
  //  loadChildren: () => import('./operationscomponents/fuelissue/addfuelissue/addFuelIssue.module').then(m => m.AddFuelIssueModule)
  //},
  //{
  //  path: 'operations/fuelissue/addfuelissue/:id',
  //  loadChildren: () => import('./operationscomponents/fuelissue/addfuelissue/addFuelIssue.module').then(m => m.AddFuelIssueModule)
  //},

  //{
  //  path: 'operations/fuelissue/fetchfuelissue',
  //  loadChildren: () => import('./operationscomponents/fuelissue/fetchfuelissue/fetchFuelIssue.module').then(m => m.FetchFuelIssueModule)
  //},
  //{
  //  path: 'operations/tripplan/addtripplan',
  //  loadChildren: () => import('./operationscomponents/tripplan/addtripplan/addTripPlan.module').then(m => m.AddTripPlanModule)
  //},
  //{
  //  path: 'operations/tripplan/addtripplan/:id',
  //  loadChildren: () => import('./operationscomponents/tripplan/addtripplan/addTripPlan.module').then(m => m.AddTripPlanModule)
  //},

  //{
  //  path: 'operations/tripplan/fetchtripplan',
  //  loadChildren: () => import('./operationscomponents/tripplan/fetchtripplan/fetchTripPlan.module').then(m => m.FetchTripPlanModule)
  //},
  //{
  //  path: 'operations/businessplan/addbusinessplan',
  //  loadChildren: () => import('./operationscomponents/businessplan/addbusinessplan/addBusinessPlan.module').then(m => m.AddBusinessPlanModule)
  //},
  //{
  //  path: 'operations/businessplan/addbusinessplan/:id',
  //  loadChildren: () => import('./operationscomponents/businessplan/addbusinessplan/addBusinessPlan.module').then(m => m.AddBusinessPlanModule)
  //},

  //{
  //  path: 'operations/businessplan/fetchbusinessplan',
  //  loadChildren: () => import('./operationscomponents/businessplan/fetchbusinessplan/fetchBusinessPlan.module').then(m => m.FetchBusinessPlanModule)
  //},
  {
    path: 'operations/unitmapping/addunitmapping',
    loadChildren: () => import('./operationscomponents/unitmapping/addunitmapping/addUnitMapping.module').then(m => m.AddUnitMappingModule)
  },
  {
    path: 'operations/unitmapping/addunitmapping/:id',
    loadChildren: () => import('./operationscomponents/unitmapping/addunitmapping/addUnitMapping.module').then(m => m.AddUnitMappingModule)
  },
  {
    path: 'operations/unitmapping/fetchunitmapping',
    loadChildren: () => import('./operationscomponents/unitmapping/fetchunitmapping/fetchUnitMapping.module').then(m => m.FetchUnitMappingModule)
  },
  //{
  //  path: 'operations/fuelconfiguration/addfuelconfiguration',
  //  loadChildren: () => import('./operationscomponents/fuelconfiguration/addfuelconfiguration/addFuelConfiguration.module').then(m => m.AddFuelConfigurationModule)
  //},
  //{
  //  path: 'operations/fuelconfiguration/addfuelconfiguration/:id',
  //  loadChildren: () => import('./operationscomponents/fuelconfiguration/addfuelconfiguration/addFuelConfiguration.module').then(m => m.AddFuelConfigurationModule)
  //},

  //{
  //  path: 'operations/fuelconfiguration/fetchfuelconfiguration',
  //  loadChildren: () => import('./operationscomponents/fuelconfiguration/fetchfuelconfiguration/fetchFuelConfiguration.module').then(m => m.FetchFuelConfigurationModule)
  //},
  ////

  //{
  //  path: 'operations/containertype/addcontainertype',
  //  loadChildren: () => import('./operationscomponents/containertype/addcontainertype/addContainerType.module').then(m => m.AddContainerTypeModule)
  //},
  //{
  //  path: 'operations/containertype/addcontainertype/:id',
  //  loadChildren: () => import('./operationscomponents/containertype/addcontainertype/addContainerType.module').then(m => m.AddContainerTypeModule)
  //},

  //{
  //  path: 'operations/containertype/fetchcontainertype',
  //  loadChildren: () => import('./operationscomponents/containertype/fetchcontainertype/fetchContainerType.module').then(m => m.FetchContainerTypeModule)
  //},
  //{
  //  path: 'commercial/manifestmaster/addmanifestmaster',
  //  loadChildren: () => import('./salescomponents/manifestbook/addmanifestbook/addManifestBook.module').then(m => m.AddManifestBookModule)
  //},
  //{
  //  path: 'commercial/manifestmaster/addmanifestmaster/:id',
  //  loadChildren: () => import('./salescomponents/manifestbook/addmanifestbook/addManifestBook.module').then(m => m.AddManifestBookModule)
  //},

  //{
  //  path: 'commercial/manifestmaster/fetchmanifestmaster',
  //  loadChildren: () => import('./salescomponents/manifestbook/fetchmanifestbook/fetchManifestBook.module').then(m => m.FetchManifestBookModule)
  //},
  //{
  //  path: 'commercial/contracttype/addcontracttype',
  //  loadChildren: () => import('./commercialcomponents/contracttype/addcontracttype/addContractType.module').then(m => m.AddContractTypeModule)
  //},
  //{
  //  path: 'commercial/contracttype/addcontracttype/:id',
  //  loadChildren: () => import('./commercialcomponents/contracttype/addcontracttype/addContractType.module').then(m => m.AddContractTypeModule)
  //},

  //{
  //  path: 'commercial/contracttype/fetchcontracttype',
  //  loadChildren: () => import('./commercialcomponents/contracttype/fetchcontracttype/fetchContractType.module').then(m => m.FetchContractTypeModule)
  //},
  //{
  //  path: 'sales/customergroup/addcustomergroup',
  //  loadChildren: () => import('./salescomponents/customergroup/addcustomergroup/addCustomerGroup.module').then(m => m.AddCustomerGroupModule)
  //},
  //{
  //  path: 'sales/customergroup/addcustomergroup/:id',
  //  loadChildren: () => import('./salescomponents/customergroup/addcustomergroup/addCustomerGroup.module').then(m => m.AddCustomerGroupModule)
  //},

  //{
  //  path: 'sales/customergroup/fetchcustomergroup',
  //  loadChildren: () => import('./salescomponents/customergroup/fetchcustomergroup/fetchCustomerGroup.module').then(m => m.FetchCustomerGroupModule)
  //},

  //{
  //  path: 'sales/customertype/addcustomertype',
  //  loadChildren: () => import('./salescomponents/customertype/addcustomertype/addCustomerType.module').then(m => m.AddCustomerTypeModule)
  //},
  //{
  //  path: 'sales/customertype/addcustomertype/:id',
  //  loadChildren: () => import('./salescomponents/customertype/addcustomertype/addCustomerType.module').then(m => m.AddCustomerTypeModule)
  //},

  //{
  //  path: 'sales/customertype/fetchcustomertype',
  //  loadChildren: () => import('./salescomponents/customertype/fetchcustomertype/fetchCustomerType.module').then(m => m.FetchCustomerTypeModule)
  //},

  {
    path: 'sales/salesperson/addsalesperson',
    loadChildren: () => import('./salescomponents/salesperson/addsalesperson/addSalesperson.module').then(m => m.AddSalespersonModule)
  },
  {
    path: 'sales/salesperson/addsalesperson/:id',
    loadChildren: () => import('./salescomponents/salesperson/addsalesperson/addSalesperson.module').then(m => m.AddSalespersonModule)
  },
  {
    path: 'sales/salesperson/fetchsalesperson',
    loadChildren: () => import('./salescomponents/salesperson/fetchsalesperson/fetchSalesperson.module').then(m => m.FetchSalespersonModule)
  },

  //{
  //  path: 'sales/salesregion/addsalesregion',
  //  loadChildren: () => import('./salescomponents/salesregion/addsalesregion/addSalesregion.module').then(m => m.AddSalesregionModule)
  //},
  //{
  //  path: 'sales/salesregion/addsalesregion/:id',
  //  loadChildren: () => import('./salescomponents/salesregion/addsalesregion/addSalesregion.module').then(m => m.AddSalesregionModule)
  //},

  //{
  //  path: 'sales/salesregion/fetchsalesregion',
  //  loadChildren: () => import('./salescomponents/salesregion/fetchsalesregion/fetchSalesregion.module').then(m => m.FetchSalesregionModule)
  //},
  //{
  //  path: 'sales/salesdivision/addsalesdivision',
  //  loadChildren: () => import('./salescomponents/salesdivision/addsalesdivision/addSalesDivision.module').then(m => m.AddSalesDivisionModule)
  //},
  //{
  //  path: 'sales/salesdivision/addsalesdivision/:id',
  //  loadChildren: () => import('./salescomponents/salesdivision/addsalesdivision/addSalesDivision.module').then(m => m.AddSalesDivisionModule)
  //},

  //{
  //  path: 'sales/salesdivision/fetchsalesdivision',
  //  loadChildren: () => import('./salescomponents/salesdivision/fetchsalesdivision/fetchSalesDivision.module').then(m => m.FetchSalesDivisionModule)
  //},

  //{
  //  path: 'sales/customermaster/addcustomermaster',
  //  loadChildren: () => import('./salescomponents/customermaster/addcustomermaster/addCustomerMaster.module').then(m => m.AddCustomerMasterModule)
  //},
  //{
  //  path: 'sales/customermaster/addcustomermaster/:id',
  //  loadChildren: () => import('./salescomponents/customermaster/addcustomermaster/addCustomerMaster.module').then(m => m.AddCustomerMasterModule)
  //},

  //{
  //  path: 'sales/customermaster/fetchcustomermaster',
  //  loadChildren: () => import('./salescomponents/customermaster/fetchcustomermaster/fetchCustomerMaster.module').then(m => m.FetchCustomerMasterModule)
  //},
  //
  {
    path: 'sales/salesreturn/addsalesreturn',
    loadChildren: () => import('./salescomponents/salesreturn/addsalesreturn/addSalesReturn.module').then(m => m.AddSalesReturnModule)
  },
  {
    path: 'sales/salesreturn/addsalesreturn/:id',
    loadChildren: () => import('./salescomponents/salesreturn/addsalesreturn/addSalesReturn.module').then(m => m.AddSalesReturnModule)
  },
  {
    path: 'sales/salesreturn/fetchsalesreturn',
    loadChildren: () => import('./salescomponents/salesreturn/fetchsalesreturn/fetchSalesReturn.module').then(m => m.FetchSalesReturnModule)
  },
  //{
  //  path: 'operations/fueltank/addfueltank',
  //  loadChildren: () => import('./operationscomponents/fueltank/addfueltank/addFuelTank.module').then(m => m.AddFuelTankModule)
  //},
  //{
  //  path: 'operations/fueltank/addfueltank/:id',
  //  loadChildren: () => import('./operationscomponents/fueltank/addfueltank/addFuelTank.module').then(m => m.AddFuelTankModule)
  //},

  //{
  //  path: 'operations/fueltank/fetchfueltank',
  //  loadChildren: () => import('./operationscomponents/fueltank/fetchfueltank/fetchFuelTank.module').then(m => m.FetchFuelTankModule)
  //},
  //{
  //  path: 'operations/internalfuelstation/addinternalfuelstation',
  //  loadChildren: () => import('./operationscomponents/internalfuelstation/addinternalfuelstation/addInternalFuelStation.module').then(m => m.AddInternalFuelStationModule)
  //},
  //{
  //  path: 'operations/internalfuelstation/addinternalfuelstation/:id',
  //  loadChildren: () => import('./operationscomponents/internalfuelstation/addinternalfuelstation/addInternalFuelStation.module').then(m => m.AddInternalFuelStationModule)
  //},

  //{
  //  path: 'operations/internalfuelstation/fetchinternalfuelstation',
  //  loadChildren: () => import('./operationscomponents/internalfuelstation/fetchinternalfuelstation/fetchInternalFuelStation.module').then(m => m.FetchInternalFuelStationModule)
  //},
  //{
  //  path: 'operations/make/addmake',
  //  loadChildren: () => import('./operationscomponents/make/addmake/addMake.module').then(m => m.AddMakeModule)
  //},
  //{
  //  path: 'operations/make/addmake/:id',
  //  loadChildren: () => import('./operationscomponents/make/addmake/addMake.module').then(m => m.AddMakeModule)
  //},

  //{
  //  path: 'operations/make/fetchmake',
  //  loadChildren: () => import('./operationscomponents/make/fetchmake/fetchMake.module').then(m => m.FetchMakeModule)
  //},
  //{
  //  path: 'operations/brand/addbrand',
  //  loadChildren: () => import('./operationscomponents/brand/addbrand/addBrand.module').then(m => m.AddBrandModule)
  //},
  //{
  //  path: 'operations/brand/addbrand/:id',
  //  loadChildren: () => import('./operationscomponents/brand/addbrand/addBrand.module').then(m => m.AddBrandModule)
  //},

  //{
  //  path: 'operations/brand/fetchbrand',
  //  loadChildren: () => import('./operationscomponents/brand/fetchbrand/fetchBrand.module').then(m => m.FetchBrandModule)
  //},
  //{
  //  path: 'operations/operationsdivision/addoperationsdivision',
  //  loadChildren: () => import('./operationscomponents/operationsdivision/addoperationsdivision/addOperationsDivision.module').then(m => m.AddOperationsDivisionModule)
  //},
  //{
  //  path: 'operations/operationsdivision/addoperationsdivision/:id',
  //  loadChildren: () => import('./operationscomponents/operationsdivision/addoperationsdivision/addOperationsDivision.module').then(m => m.AddOperationsDivisionModule)
  //},

  //{
  //  path: 'operations/operationsdivision/fetchoperationsdivision',
  //  loadChildren: () => import('./operationscomponents/operationsdivision/fetchoperationsdivision/fetchOperationsDivision.module').then(m => m.FetchOperationsDivisionModule)
  //},
  //{
  //  path: 'operations/externalfuelstation/addexternalfuelstation',
  //  loadChildren: () => import('./operationscomponents/externalfuelstation/addexternalfuelstation/addExternalFuelStation.module').then(m => m.AddExternalFuelStationModule)
  //},
  //{
  //  path: 'operations/externalfuelstation/addexternalfuelstation/:id',
  //  loadChildren: () => import('./operationscomponents/externalfuelstation/addexternalfuelstation/addExternalFuelStation.module').then(m => m.AddExternalFuelStationModule)
  //},

  //{
  //  path: 'operations/externalfuelstation/fetchexternalfuelstation',
  //  loadChildren: () => import('./operationscomponents/externalfuelstation/fetchexternalfuelstation/fetchExternalFuelStation.module').then(m => m.FetchExternalFuelStationModule)
  //},
  //{
  //  path: 'operations/trailercategory/addtrailercategory',
  //  loadChildren: () => import('./operationscomponents/trailercategory/addtrailercategory/addTrailerCategory.module').then(m => m.AddTrailerCategoryModule)
  //},
  //{
  //  path: 'operations/trailercategory/addtrailercategory/:id',
  //  loadChildren: () => import('./operationscomponents/trailercategory/addtrailercategory/addTrailerCategory.module').then(m => m.AddTrailerCategoryModule)
  //},

  //{
  //  path: 'operations/trailercategory/fetchtrailercategory',
  //  loadChildren: () => import('./operationscomponents/trailercategory/fetchtrailercategory/fetchTrailerCategory.module').then(m => m.FetchTrailerCategoryModule)
  //},
  //{
  //  path: 'operations/trailertype/addtrailertype',
  //  loadChildren: () => import('./operationscomponents/trailertype/addtrailertype/addTrailerType.module').then(m => m.AddTrailerTypeModule)
  //},
  //{
  //  path: 'operations/trailertype/addtrailertype/:id',
  //  loadChildren: () => import('./operationscomponents/trailertype/addtrailertype/addTrailerType.module').then(m => m.AddTrailerTypeModule)
  //},

  //{
  //  path: 'operations/trailertype/fetchtrailertype',
  //  loadChildren: () => import('./operationscomponents/trailertype/fetchtrailertype/fetchTrailerType.module').then(m => m.FetchTrailerTypeModule)
  //},
  {
    path: 'operations/driver/adddriver',
    loadChildren: () => import('./operationscomponents/driver/adddriver/addDriver.module').then(m => m.AddDriverModule)
  },
  {
    path: 'operations/driver/adddriver/:id',
    loadChildren: () => import('./operationscomponents/driver/adddriver/addDriver.module').then(m => m.AddDriverModule)
  },

  {
    path: 'operations/driver/fetchdriver',
    loadChildren: () => import('./operationscomponents/driver/fetchdriver/fetchDriver.module').then(m => m.FetchDriverModule)
  },
  //{
  //  path: 'operations/drivershortages/adddrivershortages',
  //  loadChildren: () => import('./operationscomponents/drivershortages/adddrivershortages/addDriverShortages.module').then(m => m.AddDriverShortagesModule)
  //},
  //{
  //  path: 'operations/drivershortages/adddrivershortages/:id',
  //  loadChildren: () => import('./operationscomponents/drivershortages/adddrivershortages/addDriverShortages.module').then(m => m.AddDriverShortagesModule)
  //},

  //{
  //  path: 'operations/drivershortage/fetchdrivershortage',
  //  loadChildren: () => import('./operationscomponents/drivershortages/fetchdrivershortages/fetchDriverShortages.module').then(m => m.FetchDriverShortagesModule)
  //},
  //{
  //  path: 'operations/truckhead/addtruckhead',
  //  loadChildren: () => import('./operationscomponents/truckhead/addtruckhead/addTruckHead.module').then(m => m.AddTruckHeadModule)
  //},
  //{
  //  path: 'operations/truckhead/addtruckhead/:id',
  //  loadChildren: () => import('./operationscomponents/truckhead/addtruckhead/addTruckHead.module').then(m => m.AddTruckHeadModule)
  //},

  //{
  //  path: 'operations/truckhead/fetchtruckhead',
  //  loadChildren: () => import('./operationscomponents/truckhead/fetchtruckhead/fetchTruckHead.module').then(m => m.FetchTruckHeadModule)
  //},
  //{
  //  path: 'operations/trailer/addtrailer',
  //  loadChildren: () => import('./operationscomponents/trailer/addtrailer/addTrailer.module').then(m => m.AddTrailerModule)
  //},
  //{
  //  path: 'operations/trailer/addtrailer/:id',
  //  loadChildren: () => import('./operationscomponents/trailer/addtrailer/addTrailer.module').then(m => m.AddTrailerModule)
  //},

  //{
  //  path: 'operations/trailer/fetchtrailer',
  //  loadChildren: () => import('./operationscomponents/trailer/fetchtrailer/fetchTrailer.module').then(m => m.FetchTrailerModule)
  //},
  //{
  //  path: 'operations/dolly/adddolly',
  //  loadChildren: () => import('./operationscomponents/dolly/adddolly/addDolly.module').then(m => m.AddDollyModule)
  //},
  //{
  //  path: 'operations/dolly/adddolly/:id',
  //  loadChildren: () => import('./operationscomponents/dolly/adddolly/addDolly.module').then(m => m.AddDollyModule)
  //},

  //{
  //  path: 'operations/dolly/fetchdolly',
  //  loadChildren: () => import('./operationscomponents/dolly/fetchdolly/fetchDolly.module').then(m => m.FetchDollyModule)
  //},
  //{
  //  path: 'operations/variant/addvariant',
  //  loadChildren: () => import('./operationscomponents/variant/addvariant/addVariant.module').then(m => m.AddVariantModule)
  //},
  //{
  //  path: 'operations/variant/addvariant/:id',
  //  loadChildren: () => import('./operationscomponents/variant/addvariant/addVariant.module').then(m => m.AddVariantModule)
  //},

  //{
  //  path: 'operations/variant/fetchvariant',
  //  loadChildren: () => import('./operationscomponents/variant/fetchvariant/fetchVariant.module').then(m => m.FetchVariantModule)
  //},
  ////
  //{
  //  path: 'operations/models/addmodels',
  //  loadChildren: () => import('./operationscomponents/models/addmodels/addModels.module').then(m => m.AddModelsModule)
  //},
  //{
  //  path: 'operations/models/addmodels/:id',
  //  loadChildren: () => import('./operationscomponents/models/addmodels/addModels.module').then(m => m.AddModelsModule)
  //},

  //{
  //  path: 'operations/models/fetchmodels',
  //  loadChildren: () => import('./operationscomponents/models/fetchmodels/fetchModels.module').then(m => m.FetchModelsModule)
  //},
  {
    path: 'operations/unit/addunit',
    loadChildren: () => import('./operationscomponents/unit/addunit/addUnit.module').then(m => m.AddUnitModule)
  },
  {
    path: 'operations/unit/addunit/:id',
    loadChildren: () => import('./operationscomponents/unit/addunit/addUnit.module').then(m => m.AddUnitModule)
  },

  {
    path: 'operations/unit/fetchunit',
    loadChildren: () => import('./operationscomponents/unit/fetchunit/fetchUnit.module').then(m => m.FetchUnitModule)
  },
  //{
  //  path: 'operations/operationsofficer/addoperationsofficer',
  //  loadChildren: () => import('./operationscomponents/operationsofficer/addoperationsofficer/addOperationsOfficer.module').then(m => m.AddOperationsOfficerModule)
  //},
  //{
  //  path: 'operations/operationsofficer/addoperationsofficer/:id',
  //  loadChildren: () => import('./operationscomponents/operationsofficer/addoperationsofficer/addOperationsOfficer.module').then(m => m.AddOperationsOfficerModule)
  //},

  //{
  //  path: 'operations/operationsofficer/fetchoperationsofficer',
  //  loadChildren: () => import('./operationscomponents/operationsofficer/fetchoperationsofficer/fetchOperationsOfficer.module').then(m => m.FetchOperationsOfficerModule)
  //},
  //{
  //  path: 'operations/driveraccidents/adddriveraccidents',
  //  loadChildren: () => import('./operationscomponents/driveraccidents/adddriveraccidents/addDriverAccidents.module').then(m => m.AddDriverAccidentsModule)
  //},
  //{
  //  path: 'operations/driveraccidents/adddriveraccidents/:id',
  //  loadChildren: () => import('./operationscomponents/driveraccidents/adddriveraccidents/addDriverAccidents.module').then(m => m.AddDriverAccidentsModule)
  //},

  //{
  //  path: 'operations/driveraccidents/fetchdriveraccidents',
  //  loadChildren: () => import('./operationscomponents/driveraccidents/fetchdriveraccidents/fetchDriverAccidents.module').then(m => m.FetchDriverAccidentsModule)
  //},
  //{
  //  path: 'operations/drivercard/adddrivercard',
  //  loadChildren: () => import('./operationscomponents/drivercard/adddrivercard/addDriverCard.module').then(m => m.AddDriverCardModule)
  //},
  //{
  //  path: 'operations/drivercard/adddrivercard/:id',
  //  loadChildren: () => import('./operationscomponents/drivercard/adddrivercard/addDriverCard.module').then(m => m.AddDriverCardModule)
  //},

  //{
  //  path: 'operations/drivercard/fetchdrivercard',
  //  loadChildren: () => import('./operationscomponents/drivercard/fetchdrivercard/fetchDriverCard.module').then(m => m.FetchDriverCardModule)
  //},
  //{
  //  path: 'operations/destination/adddestination',
  //  loadChildren: () => import('./operationscomponents/destination/adddestination/addDestination.module').then(m => m.AddDestinationModule)
  //},
  //{
  //  path: 'operations/destination/adddestination/:id',
  //  loadChildren: () => import('./operationscomponents/destination/adddestination/addDestination.module').then(m => m.AddDestinationModule)
  //},

  //{
  //  path: 'operations/destination/fetchdestination',
  //  loadChildren: () => import('./operationscomponents/destination/fetchdestination/fetchDestination.module').then(m => m.FetchDestinationModule)
  //},


  //{
  //  path: 'operations/route/addroute',
  //  loadChildren: () => import('./operationscomponents/route/addroute/addRoute.module').then(m => m.AddRouteModule)
  //},
  //{
  //  path: 'operations/route/addroute/:id',
  //  loadChildren: () => import('./operationscomponents/route/addroute/addRoute.module').then(m => m.AddRouteModule)
  //},

  //{
  //  path: 'operations/route/fetchroute',
  //  loadChildren: () => import('./operationscomponents/route/fetchroute/fetchRoute.module').then(m => m.FetchRouteModule)
  //},

  //{
  //  path: 'commercial/route/addroute',
  //  loadChildren: () => import('./commercialcomponents/route/addroute/addRoute.module').then(m => m.AddRouteModule)
  //},
  //{
  //  path: 'commercial/route/addroute/:id',
  //  loadChildren: () => import('./commercialcomponents/route/addroute/addRoute.module').then(m => m.AddRouteModule)
  //},

  //{
  //  path: 'commercial/route/fetchroute',
  //  loadChildren: () => import('./commercialcomponents/route/fetchroute/fetchRoute.module').then(m => m.FetchRouteModule)
  //},

  //{
  //  path: 'operations/truckinsurance/addtruckinsurance',
  //  loadChildren: () => import('./operationscomponents/truckinsurance/addtruckinsurance/addTruckInsurance.module').then(m => m.AddTruckInsuranceModule)
  //},
  //{
  //  path: 'operations/truckinsurance/addtruckinsurance/:id',
  //  loadChildren: () => import('./operationscomponents/truckinsurance/addtruckinsurance/addTruckInsurance.module').then(m => m.AddTruckInsuranceModule)
  //},

  //{
  //  path: 'operations/truckinsurance/fetchtruckinsurance',
  //  loadChildren: () => import('./operationscomponents/truckinsurance/fetchtruckinsurance/fetchTruckInsurance.module').then(m => m.FetchTruckInsuranceModule)
  //},

  //{
  //  path: 'operations/registration/addregistration',
  //  loadChildren: () => import('./operationscomponents/registration/addregistration/addRegistration.module').then(m => m.AddRegistrationModule)
  //},
  //{
  //  path: 'operations/registration/addregistration/:id',
  //  loadChildren: () => import('./operationscomponents/registration/addregistration/addRegistration.module').then(m => m.AddRegistrationModule)
  //},

  //{
  //  path: 'operations/registration/fetchregistration',
  //  loadChildren: () => import('./operationscomponents/registration/fetchregistration/fetchRegistration.module').then(m => m.FetchRegistrationModule)
  //},

  //{
  //  path: 'operations/driverincentive/adddriverincentive',
  //  loadChildren: () => import('./operationscomponents/driverincentive/adddriverincentive/addDriverIncentive.module').then(m => m.AddDriverIncentiveModule)
  //},
  //{
  //  path: 'operations/driverincentive/adddriverincentive/:id',
  //  loadChildren: () => import('./operationscomponents/driverincentive/adddriverincentive/addDriverIncentive.module').then(m => m.AddDriverIncentiveModule)
  //},

  //{
  //  path: 'operations/driverincentive/fetchdriverincentive',
  //  loadChildren: () => import('./operationscomponents/driverincentive/fetchdriverincentive/fetchDriverIncentive.module').then(m => m.FetchDriverIncentiveModule)
  //},

  //{
  //  path: 'operations/emptytrip/addemptytrip',
  //  loadChildren: () => import('./operationscomponents/emptytrip/addemptytrip/addEmptyTrip.module').then(m => m.AddEmptyTripModule)
  //},
  //{
  //  path: 'operations/emptytrip/addemptytrip/:id',
  //  loadChildren: () => import('./operationscomponents/emptytrip/addemptytrip/addEmptyTrip.module').then(m => m.AddEmptyTripModule)
  //},

  //{
  //  path: 'operations/emptytrip/fetchemptytrip',
  //  loadChildren: () => import('./operationscomponents/emptytrip/fetchemptytrip/fetchEmptyTrip.module').then(m => m.FetchEmptyTripModule)
  //},

  //{
  //  path: 'operations/trip/addtrip',
  //  loadChildren: () => import('./operationscomponents/trip/addtrip/addTrip.module').then(m => m.AddTripModule)
  //},
  //{
  //  path: 'operations/trip/addtrip/:id',
  //  loadChildren: () => import('./operationscomponents/trip/addtrip/addTrip.module').then(m => m.AddTripModule)
  //},

  //{
  //  path: 'operations/trip/fetchtrip',
  //  loadChildren: () => import('./operationscomponents/trip/fetchtrip/fetchTrip.module').then(m => m.FetchTripModule)
  //},

  //{
  //  path: 'operations/tripexpensesrequest/addtripexpensesrequest',
  //  loadChildren: () => import('./operationscomponents/tripexpensesrequest/addtripexpensesrequest/addTripExpensesRequest.module').then(m => m.AddTripExpensesRequestModule)
  //},
  //{
  //  path: 'operations/tripexpensesrequest/addtripexpensesrequest/:id',
  //  loadChildren: () => import('./operationscomponents/tripexpensesrequest/addtripexpensesrequest/addTripExpensesRequest.module').then(m => m.AddTripExpensesRequestModule)
  //},

  //{
  //  path: 'operations/tripexpensesrequest/fetchtripexpensesrequest',
  //  loadChildren: () => import('./operationscomponents/tripexpensesrequest/fetchtripexpensesrequest/fetchTripExpensesRequest.module').then(m => m.FetchTripExpensesRequestModule)
  //},

  //{
  //  path: 'operations/tripexpensessettlement/addtripexpensessettlement',
  //  loadChildren: () => import('./operationscomponents/tripexpensessettlement/addtripexpensessettlement/addTripExpensesSettlement.module').then(m => m.AddTripExpensesSettlementModule)
  //},
  //{
  //  path: 'operations/tripexpensessettlement/addtripexpensessettlement/:id',
  //  loadChildren: () => import('./operationscomponents/tripexpensessettlement/addtripexpensessettlement/addTripExpensesSettlement.module').then(m => m.AddTripExpensesSettlementModule)
  //},

  //{
  //  path: 'operations/tripexpensessettlement/fetchtripexpensessettlement',
  //  loadChildren: () => import('./operationscomponents/tripexpensessettlement/fetchtripexpensessettlement/fetchTripExpensesSettlement.module').then(m => m.FetchTripExpensesSettlementModule)
  //},

  //{
  //  path: 'technical/actionitems/addactionitems',
  //  loadChildren: () => import('./technicalcomponents/actionitems/addactionitems/addActionItems.module').then(m => m.AddActionItemsModule)
  //},
  //{
  //  path: 'technical/actionitems/addactionitems/:id',
  //  loadChildren: () => import('./technicalcomponents/actionitems/addactionitems/addActionItems.module').then(m => m.AddActionItemsModule)
  //},

  //{
  //  path: 'technical/actionitems/fetchactionitems',
  //  loadChildren: () => import('./technicalcomponents/actionitems/fetchactionitems/fetchActionItems.module').then(m => m.FetchActionItemsModule)
  //},

  //{
  //  path: 'technical/technicaldivision/addtechnicaldivision',
  //  loadChildren: () => import('./technicalcomponents/technicaldivision/addtechnicaldivision/addTechnicalDivision.module').then(m => m.AddTechnicalDivisionModule)
  //},
  //{
  //  path: 'technical/technicaldivision/addtechnicaldivision/:id',
  //  loadChildren: () => import('./technicalcomponents/technicaldivision/addtechnicaldivision/addTechnicalDivision.module').then(m => m.AddTechnicalDivisionModule)
  //},

  //{
  //  path: 'technical/technicaldivision/fetchtechnicaldivision',
  //  loadChildren: () => import('./technicalcomponents/technicaldivision/fetchtechnicaldivision/fetchTechnicalDivision.module').then(m => m.FetchTechnicalDivisionModule)
  //},

  //{
  //  path: 'technical/skilllevel/addskilllevel',
  //  loadChildren: () => import('./technicalcomponents/skilllevel/addskilllevel/addSkillLevel.module').then(m => m.AddSkillLevelModule)
  //},
  //{
  //  path: 'technical/skilllevel/addskilllevel/:id',
  //  loadChildren: () => import('./technicalcomponents/skilllevel/addskilllevel/addSkillLevel.module').then(m => m.AddSkillLevelModule)
  //},

  //{
  //  path: 'technical/skilllevel/fetchskilllevel',
  //  loadChildren: () => import('./technicalcomponents/skilllevel/fetchskilllevel/fetchSkillLevel.module').then(m => m.FetchSkillLevelModule)
  //},

  //{
  //  path: 'technical/trade/addtrade',
  //  loadChildren: () => import('./technicalcomponents/trade/addtrade/addTrade.module').then(m => m.AddTradeModule)
  //},
  //{
  //  path: 'technical/trade/addtrade/:id',
  //  loadChildren: () => import('./technicalcomponents/trade/addtrade/addTrade.module').then(m => m.AddTradeModule)
  //},

  //{
  //  path: 'technical/trade/fetchtrade',
  //  loadChildren: () => import('./technicalcomponents/trade/fetchtrade/fetchTrade.module').then(m => m.FetchTradeModule)
  //},
  //{
  //  path: 'technical/taskstoppagereason/addtaskstoppagereason',
  //  loadChildren: () => import('./technicalcomponents/taskstoppagereason/addtaskstoppagereason/addTaskStoppageReason.module').then(m => m.AddTaskStoppageReasonModule)
  //},
  //{
  //  path: 'technical/taskstoppagereason/addtaskstoppagereason/:id',
  //  loadChildren: () => import('./technicalcomponents/taskstoppagereason/addtaskstoppagereason/addTaskStoppageReason.module').then(m => m.AddTaskStoppageReasonModule)
  //},

  //{
  //  path: 'technical/taskstoppagereason/fetchtaskstoppagereason',
  //  loadChildren: () => import('./technicalcomponents/taskstoppagereason/fetchtaskstoppagereason/fetchTaskStoppageReason.module').then(m => m.FetchTaskStoppageReasonModule)
  //},

  //{
  //  path: 'technical/supervisor/addsupervisor',
  //  loadChildren: () => import('./technicalcomponents/supervisor/addsupervisor/addSupervisor.module').then(m => m.AddSupervisorModule)
  //},
  //{
  //  path: 'technical/supervisor/addsupervisor/:id',
  //  loadChildren: () => import('./technicalcomponents/supervisor/addsupervisor/addSupervisor.module').then(m => m.AddSupervisorModule)
  //},

  //{
  //  path: 'technical/supervisor/fetchsupervisor',
  //  loadChildren: () => import('./technicalcomponents/supervisor/fetchsupervisor/fetchSupervisor.module').then(m => m.FetchSupervisorModule)
  //},

  //{
  //  path: 'technical/workshoptype/addworkshoptype',
  //  loadChildren: () => import('./technicalcomponents/workshoptype/addworkshoptype/addWorkshopType.module').then(m => m.AddWorkshopTypeModule)
  //},
  //{
  //  path: 'technical/workshoptype/addworkshoptype/:id',
  //  loadChildren: () => import('./technicalcomponents/workshoptype/addworkshoptype/addWorkshopType.module').then(m => m.AddWorkshopTypeModule)
  //},

  //{
  //  path: 'technical/workshoptype/fetchworkshoptype',
  //  loadChildren: () => import('./technicalcomponents/workshoptype/fetchworkshoptype/fetchWorkshopType.module').then(m => m.FetchWorkshopTypeModule)
  //},

  //{
  //  path: 'technical/technicalmanager/addtechnicalmanager',
  //  loadChildren: () => import('./technicalcomponents/technicalmanager/addtechnicalmanager/addTechnicalManager.module').then(m => m.AddTechnicalManagerModule)
  //},
  //{
  //  path: 'technical/technicalmanager/addtechnicalmanager/:id',
  //  loadChildren: () => import('./technicalcomponents/technicalmanager/addtechnicalmanager/addTechnicalManager.module').then(m => m.AddTechnicalManagerModule)
  //},

  //{
  //  path: 'technical/technicalmanager/fetchtechnicalmanager',
  //  loadChildren: () => import('./technicalcomponents/technicalmanager/fetchtechnicalmanager/fetchTechnicalManager.module').then(m => m.FetchTechnicalManagerModule)
  //},

  //{
  //  path: 'technical/tasktype/addtasktype',
  //  loadChildren: () => import('./technicalcomponents/tasktype/addtasktype/addTaskType.module').then(m => m.AddTaskTypeModule)
  //},
  //{
  //  path: 'technical/tasktype/addtasktype/:id',
  //  loadChildren: () => import('./technicalcomponents/tasktype/addtasktype/addTaskType.module').then(m => m.AddTaskTypeModule)
  //},

  //{
  //  path: 'technical/tasktype/fetchtasktype',
  //  loadChildren: () => import('./technicalcomponents/tasktype/fetchtasktype/fetchTaskType.module').then(m => m.FetchTaskTypeModule)
  //},

  //{
  //  path: 'technical/failurecode/addfailurecode',
  //  loadChildren: () => import('./technicalcomponents/failurecode/addfailurecode/addFailureCode.module').then(m => m.AddFailureCodeModule)
  //},
  //{
  //  path: 'technical/failurecode/addfailurecode/:id',
  //  loadChildren: () => import('./technicalcomponents/failurecode/addfailurecode/addFailureCode.module').then(m => m.AddFailureCodeModule)
  //},

  //{
  //  path: 'technical/failurecode/fetchfailurecode',
  //  loadChildren: () => import('./technicalcomponents/failurecode/fetchfailurecode/fetchFailureCode.module').then(m => m.FetchFailureCodeModule)
  //},

  //{
  //  path: 'technical/mechanic/addmechanic',
  //  loadChildren: () => import('./technicalcomponents/mechanic/addmechanic/addMechanic.module').then(m => m.AddMechanicModule)
  //},
  //{
  //  path: 'technical/mechanic/addmechanic/:id',
  //  loadChildren: () => import('./technicalcomponents/mechanic/addmechanic/addMechanic.module').then(m => m.AddMechanicModule)
  //},

  //{
  //  path: 'technical/mechanic/fetchmechanic',
  //  loadChildren: () => import('./technicalcomponents/mechanic/fetchmechanic/fetchMechanic.module').then(m => m.FetchMechanicModule)
  //},

  //{
  //  path: 'technical/workshop/addworkshop',
  //  loadChildren: () => import('./technicalcomponents/workshop/addworkshop/addWorkShop.module').then(m => m.AddWorkShopModule)
  //},
  //{
  //  path: 'technical/workshop/addworkshop/:id',
  //  loadChildren: () => import('./technicalcomponents/workshop/addworkshop/addWorkShop.module').then(m => m.AddWorkShopModule)
  //},

  //{
  //  path: 'technical/workshop/fetchworkshop',
  //  loadChildren: () => import('./technicalcomponents/workshop/fetchworkshop/fetchWorkShop.module').then(m => m.FetchWorkShopModule)
  //},

  {
    path: 'technical/jobcard/addjobcard',
    loadChildren: () => import('./technicalcomponents/jobcard/addjobcard/addJobCard.module').then(m => m.AddJobCardModule)
  },
  {
    path: 'technical/jobcard/addjobcard/:id',
    loadChildren: () => import('./technicalcomponents/jobcard/addjobcard/addJobCard.module').then(m => m.AddJobCardModule)
  },
  {
    path: 'technical/jobcard/fetchjobcard',
    loadChildren: () => import('./technicalcomponents/jobcard/fetchjobcard/fetchJobCard.module').then(m => m.FetchJobCardModule)
  },

  //{
  //  path: 'technical/taskdetails/addtaskdetails',
  //  loadChildren: () => import('./technicalcomponents/taskdetails/addtaskdetails/addTaskDetails.module').then(m => m.AddTaskDetailsModule)
  //},
  //{
  //  path: 'technical/taskdetails/addtaskdetails/:id',
  //  loadChildren: () => import('./technicalcomponents/taskdetails/addtaskdetails/addTaskDetails.module').then(m => m.AddTaskDetailsModule)
  //},

  //{
  //  path: 'technical/taskdetails/fetchtaskdetails',
  //  loadChildren: () => import('./technicalcomponents/taskdetails/fetchtaskdetails/fetchTaskDetails.module').then(m => m.FetchTaskDetailsModule)
  //},
  //{
  //  path: 'technical/manpowerdetails/addmanpowerdetails',
  //  loadChildren: () => import('./technicalcomponents/manpowerdetails/addmanpowerdetails/addManPowerDetails.module').then(m => m.AddManPowerDetailsModule)
  //},
  //{
  //  path: 'technical/manpowerdetails/addmanpowerdetails/:id',
  //  loadChildren: () => import('./technicalcomponents/manpowerdetails/addmanpowerdetails/addManPowerDetails.module').then(m => m.AddManPowerDetailsModule)
  //},

  //{
  //  path: 'technical/manpowerdetails/fetchmanpowerdetails',
  //  loadChildren: () => import('./technicalcomponents/manpowerdetails/fetchmanpowerdetails/fetchManPowerDetails.module').then(m => m.FetchManPowerDetailsModule)
  //},
  //{
  //  path: 'technical/technicalindent/addtechnicalindent',
  //  loadChildren: () => import('./technicalcomponents/indent/addtechnicalindent/addTechnicalIndent.module').then(m => m.AddTechnicalIndentModule)
  //},
  //{
  //  path: 'technical/technicalindent/addtechnicalindent/:id',
  //  loadChildren: () => import('./technicalcomponents/indent/addtechnicalindent/addTechnicalIndent.module').then(m => m.AddTechnicalIndentModule)
  //},
  //{
  //  path: 'technical/technicalindent/fetchtechnicalindent',
  //  loadChildren: () => import('./technicalcomponents/indent/fetchtechnicalindent/fetchTechnicalIndent.module').then(m => m.FetchTechnicalIndentModule)
  //},

  //{
  //  path: 'inventory/storesindent/addstoresindent',
  //  loadChildren: () => import('./technicalcomponents/indent/addtechnicalindent/addTechnicalIndent.module').then(m => m.AddTechnicalIndentModule)
  //},
  //{
  //  path: 'inventory/storesindent/addstoresindent/:id',
  //  loadChildren: () => import('./technicalcomponents/indent/addtechnicalindent/addTechnicalIndent.module').then(m => m.AddTechnicalIndentModule)
  //},

  //{
  //  path: 'inventory/storesindent/fetchstoresindent',
  //  loadChildren: () => import('./technicalcomponents/indent/fetchtechnicalindent/fetchTechnicalIndent.module').then(m => m.FetchTechnicalIndentModule)
  //},
  //{
  //  path: 'fixedasset/assetcategory/addassetcategory',
  //  loadChildren: () => import('./fixedassetcomponents/assetcategory/addassetcategory/addAssetCategory.module').then(m => m.AddAssetCategoryModule)
  //},
  //{
  //  path: 'fixedasset/assetcategory/addassetcategory/:id',
  //  loadChildren: () => import('./fixedassetcomponents/assetcategory/addassetcategory/addAssetCategory.module').then(m => m.AddAssetCategoryModule)
  //},

  //{
  //  path: 'fixedasset/assetcategory/fetchassetcategory',
  //  loadChildren: () => import('./fixedassetcomponents/assetcategory/fetchassetcategory/fetchAssetCategory.module').then(m => m.FetchAssetCategoryModule)
  //},

  //{
  //  path: 'fixedasset/assetacquisition/addassetacquisition',
  //  loadChildren: () => import('./fixedassetcomponents/assetacquisition/addassetacquisition/addAssetAcquisition.module').then(m => m.AddAssetAcquisitionModule)
  //},
  //{
  //  path: 'fixedasset/assetacquisition/addassetacquisition/:id',
  //  loadChildren: () => import('./fixedassetcomponents/assetacquisition/addassetacquisition/addAssetAcquisition.module').then(m => m.AddAssetAcquisitionModule)
  //},

  //{
  //  path: 'fixedasset/assetacquisition/fetchassetacquisition',
  //  loadChildren: () => import('./fixedassetcomponents/assetacquisition/fetchassetacquisition/fetchAssetAcquisition.module').then(m => m.FetchAssetAcquisitionModule)
  //},


  //{
  //  path: 'operations/commissioning/addcommissioning',
  //  loadChildren: () => import('./operationscomponents/commissioning/addcommissioning/addCommissioning.module').then(m => m.AddCommissioningModule)
  //},
  //{
  //  path: 'operations/commissioning/addcommissioning/:id',
  //  loadChildren: () => import('./operationscomponents/commissioning/addcommissioning/addCommissioning.module').then(m => m.AddCommissioningModule)
  //},

  //{
  //  path: 'operations/commissioning/fetchcommissioning',
  //  loadChildren: () => import('./operationscomponents/commissioning/fetchcommissioning/fetchCommissioning.module').then(m => m.FetchCommissioningModule)
  //},

  //{
  //  path: 'operations/decommissioning/adddecommissioning',
  //  loadChildren: () => import('./operationscomponents/decommissioning/addDecommissioning/addDecommissioning.module').then(m => m.AddDecommissioningModule)
  //},
  //{
  //  path: 'operations/decommissioning/adddecommissioning/:id',
  //  loadChildren: () => import('./operationscomponents/decommissioning/addDecommissioning/addDecommissioning.module').then(m => m.AddDecommissioningModule)
  //},

  //{
  //  path: 'operations/decommissioning/fetchdecommissioning',
  //  loadChildren: () => import('./operationscomponents/decommissioning/fetchDecommissioning/fetchDecommissioning.module').then(m => m.FetchDecommissioningModule)
  //},

  //{
  //  path: 'sales/salesquotation/addsalesquotation',
  //  loadChildren: () => import('./salescomponents/salesquotation/addsalesquotation/addSalesQuotation.module').then(m => m.AddSalesQuotationModule)
  //},
  //{
  //  path: 'sales/salesquotation/addsalesquotation/:id',
  //  loadChildren: () => import('./salescomponents/salesquotation/addsalesquotation/addSalesQuotation.module').then(m => m.AddSalesQuotationModule)
  //},

  //{
  //  path: 'sales/salesquotation/fetchsalesquotation',
  //  loadChildren: () => import('./salescomponents/salesquotation/fetchsalesquotation/fetchSalesQuotation.module').then(m => m.FetchSalesQuotationModule)
  //},

  {
    path: 'sales/salesorder/addsalesorder',
    loadChildren: () => import('./salescomponents/salesorder/addsalesorder/addSalesOrder.module').then(m => m.AddSalesOrderModule)
  },
  {
    path: 'sales/salesorder/addsalesorder/:id',
    loadChildren: () => import('./salescomponents/salesorder/addsalesorder/addSalesOrder.module').then(m => m.AddSalesOrderModule)
  },
  {
    path: 'sales/salesorder/fetchsalesorder',
    loadChildren: () => import('./salescomponents/salesorder/fetchsalesorder/fetchSalesOrder.module').then(m => m.FetchSalesOrderModule)
  },

  {
    path: 'sales/salesorderrequest/addsalesorderrequest',
    loadChildren: () => import('./salescomponents/salesorderrequest/addsalesorderrequest/addSalesOrderRequest.module').then(m => m.AddSalesOrderRequestModule)
  },
  {
    path: 'sales/salesorderrequest/addsalesorderrequest/:id',
    loadChildren: () => import('./salescomponents/salesorderrequest/addsalesorderrequest/addSalesOrderRequest.module').then(m => m.AddSalesOrderRequestModule)
  },
  {
    path: 'sales/salesorderrequest/fetchsalesorderrequest',
    loadChildren: () => import('./salescomponents/salesorderrequest/fetchsalesorderrequest/fetchSalesOrderRequest.module').then(m => m.FetchSalesOrderRequestModule)
  },

  {
    path: 'sales/salesinvoice/addsalesinvoice',
    loadChildren: () => import('./salescomponents/salesinvoice/addsalesinvoice/addSalesInvoice.module').then(m => m.AddSalesInvoiceModule)
  },
  {
    path: 'sales/salesinvoice/addsalesinvoice/:id',
    loadChildren: () => import('./salescomponents/salesinvoice/addsalesinvoice/addSalesInvoice.module').then(m => m.AddSalesInvoiceModule)
  },
  {
    path: 'sales/salesinvoice/fetchsalesinvoice',
    loadChildren: () => import('./salescomponents/salesinvoice/fetchsalesinvoice/fetchSalesInvoice.module').then(m => m.FetchSalesInvoiceModule)
  },

  //{
  //  path: 'sales/integrationaccount/addintegrationaccount',
  //  loadChildren: () => import('./salescomponents/integrationaccount/addintegrationaccount/addIntegrationAccount.module').then(m => m.AddIntegrationAccountModule)
  //},
  //{
  //  path: 'sales/integrationaccount/addintegrationaccount/:id',
  //  loadChildren: () => import('./salescomponents/integrationaccount/addintegrationaccount/addIntegrationAccount.module').then(m => m.AddIntegrationAccountModule)
  //},

  //{
  //  path: 'sales/integrationaccount/fetchintegrationaccount',
  //  loadChildren: () => import('./salescomponents/integrationaccount/fetchintegrationaccount/fetchIntegrationAccount.module').then(m => m.FetchIntegrationAccountModule)
  //},

  //{
  //  path: 'sales/contract/addcontract',
  //  loadChildren: () => import('./salescomponents/contract/addcontract/addContract.module').then(m => m.AddContractModule)
  //},
  //{
  //  path: 'sales/contract/addcontract/:id',
  //  loadChildren: () => import('./salescomponents/contract/addcontract/addContract.module').then(m => m.AddContractModule)
  //},

  //{
  //  path: 'sales/contract/fetchcontract',
  //  loadChildren: () => import('./salescomponents/contract/fetchcontract/fetchContract.module').then(m => m.FetchContractModule)
  //},


  //{
  //  path: 'sales/triporder/addtriporder',
  //  loadChildren: () => import('./salescomponents/triporder/addtriporder/addTripOrder.module').then(m => m.AddTripOrderModule)
  //},
  //{
  //  path: 'sales/triporder/addtriporder/:id',
  //  loadChildren: () => import('./salescomponents/triporder/addtriporder/addTripOrder.module').then(m => m.AddTripOrderModule)
  //},

  //{
  //  path: 'sales/triporder/fetchtriporder',
  //  loadChildren: () => import('./salescomponents/triporder/fetchtriporder/fetchTripOrder.module').then(m => m.FetchTripOrderModule)
  //},


  {
    path: 'commercial/commodity/addcommodity',
    loadChildren: () => import('./commercialcomponents/commodity/addcommodity/addCommodity.module').then(m => m.AddCommodityModule)
  },
  {
    path: 'commercial/commodity/addcommodity/:id',
    loadChildren: () => import('./commercialcomponents/commodity/addcommodity/addCommodity.module').then(m => m.AddCommodityModule)
  },
  {
    path: 'commercial/commodity/fetchcommodity',
    loadChildren: () => import('./commercialcomponents/commodity/fetchcommodity/fetchCommodity.module').then(m => m.FetchCommodityModule)
  },


  //{
  //  path: 'commercial/freightcontract/addfreightcontract',
  //  loadChildren: () => import('./salescomponents/contract/addcontract/addContract.module').then(m => m.AddContractModule)
  //},
  //{
  //  path: 'commercial/freightcontract/addfreightcontract/:id',
  //  loadChildren: () => import('./salescomponents/contract/addcontract/addContract.module').then(m => m.AddContractModule)
  //},

  //{
  //  path: 'commercial/freightcontract/addfreightcontract/:id/:isView/:amend',
  //  loadChildren: () => import('./salescomponents/contract/addcontract/addContract.module').then(m => m.AddContractModule)
  //},
  //{
  //  path: 'commercial/freightcontract/fetchfreightcontract',
  //  loadChildren: () => import('./salescomponents/contract/fetchcontract/fetchContract.module').then(m => m.FetchContractModule)
  //},


  //{
  //  path: 'sales/productgroup/addproductgroup',
  //  loadChildren: () => import('./salescomponents/productgroup/addproductgroup/addProductGroup.module').then(m => m.AddProductGroupModule)
  //},
  //{
  //  path: 'sales/productgroup/addproductgroup/:id',
  //  loadChildren: () => import('./salescomponents/productgroup/addproductgroup/addProductGroup.module').then(m => m.AddProductGroupModule)
  //},

  //{
  //  path: 'sales/productgroup/fetchproductgroup',
  //  loadChildren: () => import('./salescomponents/productgroup/fetchproductgroup/fetchProductGroup.module').then(m => m.FetchProductGroupModule)
  //},

  //{
  //  path: 'sales/fleetgroup/addfleetgroup',
  //  loadChildren: () => import('./salescomponents/fleetgroup/addfleetgroup/addFleetGroup.module').then(m => m.AddFleetGroupModule)
  //},
  //{
  //  path: 'sales/fleetgroup/addfleetgroup/:id',
  //  loadChildren: () => import('./salescomponents/fleetgroup/addfleetgroup/addFleetGroup.module').then(m => m.AddFleetGroupModule)
  //},

  //{
  //  path: 'sales/fleetgroup/fetchfleetgroup',
  //  loadChildren: () => import('./salescomponents/fleetgroup/fetchfleetgroup/fetchFleetGroup.module').then(m => m.FetchFleetGroupModule)
  //},

  {
    path: 'sales/manifestcreation/addmanifestcreation',
    loadChildren: () => import('./salescomponents/manifestcreation/addmanifestcreation/addManifestCreation.module').then(m => m.AddManifestCreationModule)
  },
  {
    path: 'sales/manifestcreation/addmanifestcreation/:id',
    loadChildren: () => import('./salescomponents/manifestcreation/addmanifestcreation/addManifestCreation.module').then(m => m.AddManifestCreationModule)
  },

  {
    path: 'sales/manifestcreation/fetchmanifestcreation',
    loadChildren: () => import('./salescomponents/manifestcreation/fetchmanifestcreation/fetchManifestCreation.module').then(m => m.FetchManifestCreationModule)
  },

  {
    path: 'sales/manifestacknowledge/addmanifestacknowledge/:id',
    loadChildren: () => import('./salescomponents/manifestacknowledge/addmanifestacknowledge/addManifestAcknowledge.module').then(m => m.AddManifestAcknowledgeModule)
  },

  {
    path: 'sales/manifestacknowledge/fetchmanifestacknowledge',
    loadChildren: () => import('./salescomponents/manifestacknowledge/fetchmanifestacknowledge/fetchManifestAcknowledge.module').then(m => m.FetchManifestAcknowledgeModule)
  },

  {
    path: 'sales/manifestinvoice/addmanifestinvoice',
    loadChildren: () => import('./salescomponents/manifestinvoice/addmanifestinvoice/addManifestInvoice.module').then(m => m.AddManifestInvoiceModule)
  },
  {
    path: 'sales/manifestinvoice/addmanifestinvoice/:id',
    loadChildren: () => import('./salescomponents/manifestinvoice/addmanifestinvoice/addManifestInvoice.module').then(m => m.AddManifestInvoiceModule)
  },
  {
    path: 'sales/manifestinvoice/fetchmanifestinvoice',
    loadChildren: () => import('./salescomponents/manifestinvoice/fetchmanifestinvoice/fetchManifestInvoice.module').then(m => m.FetchManifestInvoiceModule)
  },

  //{
  //  path: 'sales/tripinvoice/addtripinvoice',
  //  loadChildren: () => import('./salescomponents/tripinvoice/addtripinvoice/addTripInvoice.module').then(m => m.AddTripInvoiceModule)
  //},
  //{
  //  path: 'sales/tripinvoice/addtripinvoice/:id',
  //  loadChildren: () => import('./salescomponents/tripinvoice/addtripinvoice/addTripInvoice.module').then(m => m.AddTripInvoiceModule)
  //},

  //{
  //  path: 'sales/tripinvoice/fetchtripinvoice',
  //  loadChildren: () => import('./salescomponents/tripinvoice/fetchtripinvoice/fetchTripInvoice.module').then(m => m.FetchTripInvoiceModule)
  //},

  ////{
  ////    path: 'inventory/consignmentindent/addconsignmentindent',
  ////    loadChildren: () => import('./inventorycomponents/consignmentindent/addconsignmentindent/addConsignmentIndent.module').then(m => m.AddConsignmentIndentModule)
  ////},
  ////{
  ////    path: 'inventory/consignmentindent/addconsignmentindent/:id',
  ////    loadChildren: () => import('./inventorycomponents/consignmentindent/addconsignmentindent/addConsignmentIndent.module').then(m => m.AddConsignmentIndentModule)
  ////},

  ////{
  ////    path: 'inventory/consignmentindent/fetchconsignmentindent',
  ////    loadChildren: () => import('./inventorycomponents/consignmentindent/fetchconsignmentindent/fetchConsignmentIndent.module').then(m => m.FetchConsignmentIndentModule)
  ////},

  ////{
  ////    path: 'inventory/consignmentout/addconsignmentout',
  ////    loadChildren: () => import('./inventorycomponents/consignmentout/addconsignmentout/addConsignmentOut.module').then(m => m.AddConsignmentOutModule)
  ////},
  ////{
  ////    path: 'inventory/consignmentout/addconsignmentout/:id',
  ////    loadChildren: () => import('./inventorycomponents/consignmentout/addconsignmentout/addConsignmentOut.module').then(m => m.AddConsignmentOutModule)
  ////},

  ////{
  ////    path: 'inventory/consignmentout/fetchconsignmentout',
  ////    loadChildren: () => import('./inventorycomponents/consignmentout/fetchconsignmentout/fetchConsignmentOut.module').then(m => m.FetchConsignmentOutModule)
  ////},


  //{
  //  path: 'procurement/commercialfleetmanifestinvoice/addcommercialfleetmanifestinvoice',
  //  loadChildren: () => import('./procurementcomponents/commercialfleetmanifestinvoice/addcommercialfleetmanifestinvoice/addCommercialFleetManifestInvoice.module').then(m => m.AddCommercialFleetManifestInvoiceModule)
  //},
  //{
  //  path: 'procurement/commercialfleetmanifestinvoice/addcommercialfleetmanifestinvoice/:id',
  //  loadChildren: () => import('./procurementcomponents/commercialfleetmanifestinvoice/addcommercialfleetmanifestinvoice/addCommercialFleetManifestInvoice.module').then(m => m.AddCommercialFleetManifestInvoiceModule)
  //},

  //{
  //  path: 'procurement/commercialfleetmanifestinvoice/fetchcommercialfleetmanifestinvoice',
  //  loadChildren: () => import('./procurementcomponents/commercialfleetmanifestinvoice/fetchcommercialfleetmanifestinvoice/fetchCommercialFleetManifestInvoice.module').then(m => m.FetchCommercialFleetManifestInvoiceModule)
  //},


  //{
  //  path: 'procurement/commercialfleetcontract/addcommercialfleetcontract',
  //  loadChildren: () => import('./procurementcomponents/commercialfleetcontract/addcommercialfleetcontract/addCommercialFleetContract.module').then(m => m.AddCommercialFleetContractModule)
  //},
  //{
  //  path: 'procurement/commercialfleetcontract/addcommercialfleetcontract/:id',
  //  loadChildren: () => import('./procurementcomponents/commercialfleetcontract/addcommercialfleetcontract/addCommercialFleetContract.module').then(m => m.AddCommercialFleetContractModule)
  //},

  //{
  //  path: 'procurement/commercialfleetcontract/fetchcommercialfleetcontract',
  //  loadChildren: () => import('./procurementcomponents/commercialfleetcontract/fetchcommercialfleetcontract/fetchCommercialFleetContract.module').then(m => m.FetchCommercialFleetContractModule)
  //},
  //{
  //  path: 'sales/salesproformainvoice/addsalesproformainvoice',
  //  loadChildren: () => import('./salescomponents/salesproformainvoice/addsalesproformainvoice/addSalesProformaInvoice.module').then(m => m.AddSalesProformaInvoiceModule)
  //},
  //{
  //  path: 'sales/salesproformainvoice/addsalesproformainvoice/:id',
  //  loadChildren: () => import('./salescomponents/salesproformainvoice/addsalesproformainvoice/addSalesProformaInvoice.module').then(m => m.AddSalesProformaInvoiceModule)
  //},

  //{
  //  path: 'sales/salesproformainvoice/fetchsalesproformainvoice',
  //  loadChildren: () => import('./salescomponents/salesproformainvoice/fetchsalesproformainvoice/fetchSalesProformaInvoice.module').then(m => m.FetchSalesProformaInvoiceModule)
  //},




  //{
  //  path: 'fixedasset/rodcompact/addrodcompact',
  //  loadChildren: () => import('./fixedassetcomponents/rodcompact/addrodcompact/addRODCompAct.module').then(m => m.AddRODCompActModule)
  //},
  //{
  //  path: 'fixedasset/rodcompact/addrodcompact/:id',
  //  loadChildren: () => import('./fixedassetcomponents/rodcompact/addrodcompact/addRODCompAct.module').then(m => m.AddRODCompActModule)
  //},

  //{
  //  path: 'fixedasset/rodcompact/fetchrodcompact',
  //  loadChildren: () => import('./fixedassetcomponents/rodcompact/fetchrodcompact/fetchRODCompAct.module').then(m => m.FetchRODCompActModule)
  //},

  //{
  //  path: 'fixedasset/roditact/addroditact',
  //  loadChildren: () => import('./fixedassetcomponents/roditact/addroditact/addRODITAct.module').then(m => m.AddRODITActModule)
  //},
  //{
  //  path: 'fixedasset/roditact/addroditact/:id',
  //  loadChildren: () => import('./fixedassetcomponents/roditact/addroditact/addRODITAct.module').then(m => m.AddRODITActModule)
  //},

  //{
  //  path: 'fixedasset/roditact/fetchroditact',
  //  loadChildren: () => import('./fixedassetcomponents/roditact/fetchroditact/fetchRODITAct.module').then(m => m.FetchRODITActModule)
  //},

  //{
  //  path: 'fixedasset/costcenter/addcostcenter',
  //  loadChildren: () => import('./fixedassetcomponents/costcenter/addcostcenter/addCostCenter.module').then(m => m.AddCostCenterModule)
  //},
  //{
  //  path: 'fixedasset/costcenter/addcostcenter/:id',
  //  loadChildren: () => import('./fixedassetcomponents/costcenter/addcostcenter/addCostCenter.module').then(m => m.AddCostCenterModule)
  //},

  //{
  //  path: 'fixedasset/costcenter/fetchcostcenter',
  //  loadChildren: () => import('./fixedassetcomponents/costcenter/fetchcostcenter/fetchCostCenter.module').then(m => m.FetchCostCenterModule)
  //},

  //{
  //  path: 'fixedasset/assetcategory/addassetcategory',
  //  loadChildren: () => import('./fixedassetcomponents/assetcategory/addassetcategory/addAssetCategory.module').then(m => m.AddAssetCategoryModule)
  //},
  //{
  //  path: 'fixedasset/assetcategory/addassetcategory/:id',
  //  loadChildren: () => import('./fixedassetcomponents/assetcategory/addassetcategory/addAssetCategory.module').then(m => m.AddAssetCategoryModule)
  //},

  //{
  //  path: 'fixedasset/assetcategory/fetchassetcategory',
  //  loadChildren: () => import('./fixedassetcomponents/assetcategory/fetchassetcategory/fetchAssetCategory.module').then(m => m.FetchAssetCategoryModule)
  //},

  //{
  //  path: 'fixedasset/assettype/addassettype',
  //  loadChildren: () => import('./fixedassetcomponents/assettype/addassettype/addAssetType.module').then(m => m.AddAssetTypeModule)
  //},
  //{
  //  path: 'fixedasset/assettype/addassettype/:id',
  //  loadChildren: () => import('./fixedassetcomponents/assettype/addassettype/addAssetType.module').then(m => m.AddAssetTypeModule)
  //},

  //{
  //  path: 'fixedasset/assettype/fetchassettype',
  //  loadChildren: () => import('./fixedassetcomponents/assettype/fetchassettype/fetchAssetType.module').then(m => m.FetchAssetTypeModule)
  //},

  //{
  //  path: 'fixedasset/assetlocation/addassetlocation',
  //  loadChildren: () => import('./fixedassetcomponents/assetlocation/addassetlocation/addAssetLocation.module').then(m => m.AddAssetLocationModule)
  //},
  //{
  //  path: 'fixedasset/assetlocation/addassetlocation/:id',
  //  loadChildren: () => import('./fixedassetcomponents/assetlocation/addassetlocation/addAssetLocation.module').then(m => m.AddAssetLocationModule)
  //},

  //{
  //  path: 'fixedasset/assetlocation/fetchassetlocation',
  //  loadChildren: () => import('./fixedassetcomponents/assetlocation/fetchassetlocation/fetchAssetLocation.module').then(m => m.FetchAssetLocationModule)
  //},




  //{
  //  path: 'fixedasset/rodcompact/addrodcompact',
  //  loadChildren: () => import('./fixedassetcomponents/rodcompact/addrodcompact/addRODCompAct.module').then(m => m.AddRODCompActModule)
  //},
  //{
  //  path: 'fixedasset/rodcompact/addrodcompact/:id',
  //  loadChildren: () => import('./fixedassetcomponents/rodcompact/addrodcompact/addRODCompAct.module').then(m => m.AddRODCompActModule)
  //},

  //{
  //  path: 'fixedasset/rodcompact/fetchrodcompact',
  //  loadChildren: () => import('./fixedassetcomponents/rodcompact/fetchrodcompact/fetchRODCompAct.module').then(m => m.FetchRODCompActModule)
  //},



  //{
  //  path: 'fixedasset/roditact/addroditact',
  //  loadChildren: () => import('./fixedassetcomponents/roditact/addroditact/addRODITAct.module').then(m => m.AddRODITActModule)
  //},
  //{
  //  path: 'fixedasset/roditact/addroditact/:id',
  //  loadChildren: () => import('./fixedassetcomponents/roditact/addroditact/addRODITAct.module').then(m => m.AddRODITActModule)
  //},

  //{
  //  path: 'fixedasset/roditact/fetchroditact',
  //  loadChildren: () => import('./fixedassetcomponents/roditact/fetchroditact/fetchRODITAct.module').then(m => m.FetchRODITActModule)
  //},




  //{
  //  path: 'fixedasset/costcenter/addcostcenter',
  //  loadChildren: () => import('./fixedassetcomponents/costcenter/addcostcenter/addCostCenter.module').then(m => m.AddCostCenterModule)
  //},
  //{
  //  path: 'fixedasset/costcenter/addcostcenter/:id',
  //  loadChildren: () => import('./fixedassetcomponents/costcenter/addcostcenter/addCostCenter.module').then(m => m.AddCostCenterModule)
  //},

  //{
  //  path: 'fixedasset/costcenter/fetchcostcenter',
  //  loadChildren: () => import('./fixedassetcomponents/costcenter/fetchcostcenter/fetchCostCenter.module').then(m => m.FetchCostCenterModule)
  //},


  //{
  //  path: 'fixedasset/assetcategory/addassetcategory',
  //  loadChildren: () => import('./fixedassetcomponents/assetcategory/addassetcategory/addAssetCategory.module').then(m => m.AddAssetCategoryModule)
  //},
  //{
  //  path: 'fixedasset/assetcategory/addassetcategory/:id',
  //  loadChildren: () => import('./fixedassetcomponents/assetcategory/addassetcategory/addAssetCategory.module').then(m => m.AddAssetCategoryModule)
  //},

  //{
  //  path: 'fixedasset/assetcategory/fetchassetcategory',
  //  loadChildren: () => import('./fixedassetcomponents/assetcategory/fetchassetcategory/fetchAssetCategory.module').then(m => m.FetchAssetCategoryModule)
  //},


  //{
  //  path: 'fixedasset/assettransfersameunit/addassettransfersameunit',
  //  loadChildren: () => import('./fixedassetcomponents/assettrasameunit/addassettrasameunit/addAssetTraSameUnit.module').then(m => m.AddTraSameUnitModuel)
  //},
  //{
  //  path: 'fixedasset/assettransfersameunit/addassettransfersameunit/:id',
  //  loadChildren: () => import('./fixedassetcomponents/assettrasameunit/addassettrasameunit/addAssetTraSameUnit.module').then(m => m.AddTraSameUnitModuel)
  //},

  //{
  //  path: 'fixedasset/assettransfersameunit/fetchassettransfersameunit',
  //  loadChildren: () => import('./fixedassetcomponents/assettrasameunit/fetchassettrasameunit/fetchAssetTraSameUnit.module').then(m => m.FetchAssetTraSameUnitModule)
  //},

  //{
  //  path: 'fixedasset/assettransferdiffunit/addassettransferdiffunit',
  //  loadChildren: () => import('./fixedassetcomponents/assettradiffunit/addassettradiffunit/addAssetTraDiffUnit.module').then(m => m.AddTraDiffUnitModuel)
  //},
  //{
  //  path: 'fixedasset/assettransferdiffunit/addassettransferdiffunit/:id',
  //  loadChildren: () => import('./fixedassetcomponents/assettradiffunit/addassettradiffunit/addAssetTraDiffUnit.module').then(m => m.AddTraDiffUnitModuel)
  //},

  //{
  //  path: 'fixedasset/assettransferdiffunit/fetchassettransferdiffunit',
  //  loadChildren: () => import('./fixedassetcomponents/assettradiffunit/fetchassettradiffunit/fetchAssetTraDiffUnit.module').then(m => m.FetchAssetTraDiffUnitModule)
  //},
  //{
  //  path: 'fixedasset/assetopbal/addassetopbal',
  //  loadChildren: () => import('./fixedassetcomponents/assetopenbal/addassetopenbal/addAssetOpenBal.module').then(m => m.AddAssetOpenBalModule)
  //},
  //{
  //  path: 'fixedasset/assetopbal/addassetopbal/:id',
  //  loadChildren: () => import('./fixedassetcomponents/assetopenbal/addassetopenbal/addAssetOpenBal.module').then(m => m.AddAssetOpenBalModule)
  //},

  //{
  //  path: 'fixedasset/assetopbal/fetchassetopbal',
  //  loadChildren: () => import('./fixedassetcomponents/assetopenbal/fetchassetopenbal/fetchAssetOpenBal.module').then(m => m.FetchAssetOpenBalModule)
  //},



  //{
  //  path: 'fixedasset/salesordiscard/addsalesordiscard',
  //  loadChildren: () => import('./fixedassetcomponents/salesordiscard/addsalesordiscard/addSalesOrDiscard.module').then(m => m.AddSalesOrDiscardModule)
  //},
  //{
  //  path: 'fixedasset/salesordiscard/addsalesordiscard/:id',
  //  loadChildren: () => import('./fixedassetcomponents/salesordiscard/addsalesordiscard/addSalesOrDiscard.module').then(m => m.AddSalesOrDiscardModule)
  //},

  //{
  //  path: 'fixedasset/salesordiscard/fetchsalesordiscard',
  //  loadChildren: () => import('./fixedassetcomponents/salesordiscard/fetchsalesordiscard/fetchSalesOrDiscard.module').then(m => m.FetchSalesOrDiscardModule)
  //},



  //{
  //  path: 'fixedasset/assetrevaluation/addassetrevaluation',
  //  loadChildren: () => import('./fixedassetcomponents/assetrevaluation/addassetrevaluation/addAssetRevaluation.module').then(m => m.AddAssetRevaluationModule)
  //},
  //{
  //  path: 'fixedasset/assetrevaluation/addassetrevaluation/:id',
  //  loadChildren: () => import('./fixedassetcomponents/assetrevaluation/addassetrevaluation/addAssetRevaluation.module').then(m => m.AddAssetRevaluationModule)
  //},

  //{
  //  path: 'fixedasset/assetrevaluation/fetchassetrevaluation',
  //  loadChildren: () => import('./fixedassetcomponents/assetrevaluation/fetchassetrevaluation/fetchAssetRevaluation.module').then(m => m.FetchAssetRevaluationModule)
  //},


  //{
  //  path: 'finance/budgetyearly/addbudgetyearly',
  //  loadChildren: () => import('./financecomponents/budgetyearly/addbudgetyearly/addBudgetYearly.module').then(m => m.AddBudgetYearlyModule)
  //},
  //{
  //  path: 'finance/budgetyearly/addbudgetyearly/:id',
  //  loadChildren: () => import('./financecomponents/budgetyearly/addbudgetyearly/addBudgetYearly.module').then(m => m.AddBudgetYearlyModule)
  //},

  //{
  //  path: 'finance/budgetyearly/fetchbudgetyearly',
  //  loadChildren: () => import('./financecomponents/budgetyearly/fetchbudgetyearly/fetchBudgetYearly.module').then(m => m.FetchBudgetYearlyModule)
  //},
  //{
  //  path: 'finance/budgetmonthly/addbudgetmonthly',
  //  loadChildren: () => import('./financecomponents/budgetmonthly/addbudgetmonthly/addBudgetMonthly.module').then(m => m.AddBudgetMonthlyModule)
  //},
  //{
  //  path: 'finance/budgetmonthly/addbudgetmonthly/:id',
  //  loadChildren: () => import('./financecomponents/budgetmonthly/addbudgetmonthly/addBudgetMonthly.module').then(m => m.AddBudgetMonthlyModule)
  //},

  //{
  //  path: 'finance/budgetmonthly/fetchbudgetmonthly',
  //  loadChildren: () => import('./financecomponents/budgetmonthly/fetchbudgetmonthly/fetchBudgetMonthly.module').then(m => m.FetchBudgetMonthlyModule)
  //},

  //{
  //  path: 'finance/fyclosure/addfyclosure',
  //  loadChildren: () => import('./financecomponents/fyclosure/addfyclosure/addFYClosure.module').then(m => m.AddFYClosureModule)
  //},
  //{
  //  path: 'finance/fyclosure/addfyclosure/:id',
  //  loadChildren: () => import('./financecomponents/fyclosure/addfyclosure/addFYClosure.module').then(m => m.AddFYClosureModule)
  //},

  //{
  //  path: 'finance/fyclosure/fetchfyclosure',
  //  loadChildren: () => import('./financecomponents/fyclosure/fetchfyclosure/fetchFYClosure.module').then(m => m.FetchFYClosureModule)
  //},

  //{
  //  path: 'finance/periodclosure/addperiodclosure',
  //  loadChildren: () => import('./financecomponents/periodclosure/addperiodclosure/addPeriodClosure.module').then(m => m.AddPeriodClosureModule)
  //},
  //{
  //  path: 'finance/periodclosure/addperiodclosure/:id',
  //  loadChildren: () => import('./financecomponents/periodclosure/addperiodclosure/addPeriodClosure.module').then(m => m.AddPeriodClosureModule)
  //},

  //{
  //  path: 'finance/periodclosure/fetchperiodclosure',
  //  loadChildren: () => import('./financecomponents/periodclosure/fetchperiodclosure/fetchPeriodClosure.module').then(m => m.FetchPeriodClosureModule)
  //},


  //{
  //  path: 'technical/jobcard/addjobcard',
  //  loadChildren: () => import('./technicalcomponents/jobcard/addjobcard/addJobCard.module').then(m => m.AddJobCardModule)
  //},
  //{
  //  path: 'technical/jobcard/addjobcard/:id',
  //  loadChildren: () => import('./technicalcomponents/jobcard/addjobcard/addJobCard.module').then(m => m.AddJobCardModule)
  //},

  //{
  //  path: 'technical/jobcard/fetchjobcard',
  //  loadChildren: () => import('./technicalcomponents/jobcard/fetchjobcard/fetchJobCard.module').then(m => m.FetchJobCardModule)
  //},


  //{
  //  path: 'finance/generalreceipt/addgeneralreceipt',
  //  loadChildren: () => import('./financecomponents/generalreceipt/addgeneralreceipt/addGeneralReceipt.module').then(m => m.AddGeneralReceiptModule)
  //},
  //{
  //  path: 'finance/generalreceipt/addgeneralreceipt/:id',
  //  loadChildren: () => import('./financecomponents/generalreceipt/addgeneralreceipt/addGeneralReceipt.module').then(m => m.AddGeneralReceiptModule)
  //},

  //{
  //  path: 'finance/generalreceipt/fetchgeneralreceipt',
  //  loadChildren: () => import('./financecomponents/generalreceipt/fetchgeneralreceipt/fetchGeneralReceipt.module').then(m => m.FetchGeneralReceiptModule)
  //},
  //{
  //  path: 'finance/salesserviceinvoice/addsalesserviceinvoice',
  //  loadChildren: () => import('./financecomponents/salesserviceinvoice/addsalesserviceinvoice/addSalesServiceInvoice.module').then(m => m.AddSalesServiceInvoiceModule)
  //},
  //{
  //  path: 'finance/salesserviceinvoice/addsalesserviceinvoice/:id',
  //  loadChildren: () => import('./financecomponents/salesserviceinvoice/addsalesserviceinvoice/addSalesServiceInvoice.module').then(m => m.AddSalesServiceInvoiceModule)
  //},

  //{
  //  path: 'finance/salesserviceinvoice/fetchsalesserviceinvoice',
  //  loadChildren: () => import('./financecomponents/salesserviceinvoice/fetchsalesserviceinvoice/fetchSalesServiceInvoice.module').then(m => m.FetchSalesServiceInvoiceModule)
  //},



  //{
  //  path: 'procurement/requestforquotation/addrequestforquotation',
  //  loadChildren: () => import('./procurementcomponents/requestforquotation/addrequestforquotation/addRequestforQuotation.module').then(m => m.AddRequestforQuotationModule)
  //},
  //{
  //  path: 'procurement/requestforquotation/addrequestforquotation/:id',
  //  loadChildren: () => import('./procurementcomponents/requestforquotation/addrequestforquotation/addRequestforQuotation.module').then(m => m.AddRequestforQuotationModule)
  //},

  //{
  //  path: 'procurement/requestforquotation/fetchrequestforquotation',
  //  loadChildren: () => import('./procurementcomponents/requestforquotation/fetchrequestforquotation/fetchRequestforQuotation.module').then(m => m.FetchRequestforQuotationModule)
  //},


  ////{
  ////    path: 'sales/salesrequestforquotation/addsalesrequestforquotation',
  ////    loadChildren: () => import('./salescomponents/salesrequestforquotation/addsalesrequestforquotation/addSalesRequestforQuotation.module').then(m => m.AddSalesRequestforQuotationModule)
  ////},
  ////{
  ////    path: 'sales/salesrequestforquotation/addsalesrequestforquotation/:id',
  ////    loadChildren: () => import('./salescomponents/salesrequestforquotation/addsalesrequestforquotation/addSalesRequestforQuotation.module').then(m => m.AddSalesRequestforQuotationModule)
  ////},

  ////{
  ////    path: 'sales/salesrequestforquotation/fetchsalesrequestforquotation',
  ////    loadChildren: () => import('./salescomponents/salesrequestforquotation/fetchsalesrequestforquotation/fetchSalesRequestforQuotation.module').then(m => m.FetchSalesRequestforQuotationModule)
  ////},
  //{
  //  path: 'procurement/purchasequotation/addpurchasequotation',
  //  loadChildren: () => import('./procurementcomponents/purchasequotation/addpurchasequotation/addPurchaseQuotation.module').then(m => m.AddPurchaseQuotationModule)
  //},
  //{
  //  path: 'procurement/purchasequotation/addpurchasequotation/:id',
  //  loadChildren: () => import('./procurementcomponents/purchasequotation/addpurchasequotation/addPurchaseQuotation.module').then(m => m.AddPurchaseQuotationModule)
  //},

  //{
  //  path: 'procurement/purchasequotation/fetchpurchasequotation',
  //  loadChildren: () => import('./procurementcomponents/purchasequotation/fetchpurchasequotation/fetchPurchaseQuotation.module').then(m => m.FetchPurchaseQuotationModule)
  //},

  ////
  //{
  //  path: 'inventory/reconditioningworkorder/addreconditioningworkorder',
  //  loadChildren: () => import('./inventorycomponents/reconditioningorder/addreconditioningorder/addReConditioningOrder.module').then(m => m.AddReConditioningOrderModule)
  //},
  //{
  //  path: 'inventory/reconditioningworkorder/addreconditioningworkorder/:id',
  //  loadChildren: () => import('./inventorycomponents/reconditioningorder/addreconditioningorder/addReConditioningOrder.module').then(m => m.AddReConditioningOrderModule)
  //},

  //{
  //  path: 'inventory/reconditioningworkorder/fetchreconditioningworkorder',
  //  loadChildren: () => import('./inventorycomponents/reconditioningorder/fetchreconditioningorder/fetchReConditioningOrder.module').then(m => m.FetchReConditioningOrderModule)
  //},
  //{
  //  path: 'inventory/reconditioningissue/addreconditioningissue',
  //  loadChildren: () => import('./inventorycomponents/reconditioningissue/addreconditioningissue/addReConditioningIssue.module').then(m => m.AddReConditioningIssueModule)
  //},
  //{
  //  path: 'inventory/reconditioningissue/addreconditioningissue/:id',
  //  loadChildren: () => import('./inventorycomponents/reconditioningissue/addreconditioningissue/addReConditioningIssue.module').then(m => m.AddReConditioningIssueModule)
  //},

  //{
  //  path: 'inventory/reconditioningissue/fetchreconditioningissue',
  //  loadChildren: () => import('./inventorycomponents/reconditioningissue/fetchreconditioningissue/fetchReConditioningIssue.module').then(m => m.FetchReConditioningIssueModule)
  //},

  //{
  //  path: 'inventory/reconditioningreceipt/addreconditioningreceipt',
  //  loadChildren: () => import('./inventorycomponents/reconditioningreceipt/addreconditioningreceipt/addReConditioningReceipt.module').then(m => m.AddReConditioningReceiptModule)
  //},
  //{
  //  path: 'inventory/reconditioningreceipt/addreconditioningreceipt/:id',
  //  loadChildren: () => import('./inventorycomponents/reconditioningreceipt/addreconditioningreceipt/addReConditioningReceipt.module').then(m => m.AddReConditioningReceiptModule)
  //},

  //{
  //  path: 'inventory/reconditioningreceipt/fetchreconditioningreceipt',
  //  loadChildren: () => import('./inventorycomponents/reconditioningreceipt/fetchreconditioningreceipt/fetchReConditioningReceipt.module').then(m => m.FetchReConditioningReceiptModule)
  //},

  //{
  //  path: 'inventory/consignmentin/addconsignmentin',
  //  loadChildren: () => import('./inventorycomponents/consignmentin/addconsignmentin/addConsignmentIn.module').then(m => m.AddConsignmentInModule)
  //},
  //{
  //  path: 'inventory/consignmentin/addconsignmentin/:id',
  //  loadChildren: () => import('./inventorycomponents/consignmentin/addconsignmentin/addConsignmentIn.module').then(m => m.AddConsignmentInModule)
  //},

  //{
  //  path: 'inventory/consignmentin/fetchconsignmentin',
  //  loadChildren: () => import('./inventorycomponents/consignmentin/fetchconsignmentin/fetchConsignmentIn.module').then(m => m.FetchConsignmentInModule)
  //},
  //{
  //  path: 'inventory/returnabledeliverynotereceipt/addreturnabledeliverynotereceipt',
  //  loadChildren: () => import('./inventorycomponents/returnabledeliverynotereceipt/addreturnabledeliverynotereceipt/addReturnableDeliveryNoteReceipt.module').then(m => m.AddReturnableDeliveryNoteReceiptModule)
  //},
  //{
  //  path: 'inventory/returnabledeliverynotereceipt/addreturnabledeliverynotereceipt/:id',
  //  loadChildren: () => import('./inventorycomponents/returnabledeliverynotereceipt/addreturnabledeliverynotereceipt/addReturnableDeliveryNoteReceipt.module').then(m => m.AddReturnableDeliveryNoteReceiptModule)
  //},

  //{
  //  path: 'inventory/returnabledeliverynotereceipt/fetchreturnabledeliverynotereceipt',
  //  loadChildren: () => import('./inventorycomponents/returnabledeliverynotereceipt/fetchreturnabledeliverynotereceipt/fetchReturnableDeliveryNoteReceipt.module').then(m => m.FetchReturnableDeliveryNoteReceiptModule)
  //},
  //{
  //  path: 'hrm/hrcategory/addhrcategory',
  //  loadChildren: () => import('./hrmcomponents/hrcategory/addhrcategory/addHrCategory.module').then(m => m.AddHrCategoryModule)
  //},
  //{
  //  path: 'hrm/hrcategory/addhrcategory/:id',
  //  loadChildren: () => import('./hrmcomponents/hrcategory/addhrcategory/addHrCategory.module').then(m => m.AddHrCategoryModule)
  //},

  //{
  //  path: 'hrm/hrcategory/fetchhrcategory',
  //  loadChildren: () => import('./hrmcomponents/hrcategory/fetchhrcategory/fetchHrCategory.module').then(m => m.FetchHrCategoryModule)
  //},

  {
    path: 'feature/userfeature',
    loadChildren: () => import('./generalcomponents/feature/userfeature/userfeature.module').then(m => m.UserFeatureModule)
  },
  {
    path: 'feature/userfeatureaccess',
    loadChildren: () => import('./generalcomponents/feature/userfeatureaccess/userfeatureaccess.module').then(m => m.UserFeatureAccessModule)
  },

  //{
  //  path: 'finance/bankreconciliation/addbankreconciliation',
  //  loadChildren: () => import('./financecomponents/bankreconciliation/addbankreconciliation/addBankReconciliation.module').then(m => m.AddBankReconciliationModule)
  //},
  //{
  //  path: 'finance/bankreconciliation/addbankreconciliation/:id',
  //  loadChildren: () => import('./financecomponents/bankreconciliation/addbankreconciliation/addBankReconciliation.module').then(m => m.AddBankReconciliationModule)
  //},

  //{
  //  path: 'finance/bankreconciliation/fetchbankreconciliation',
  //  loadChildren: () => import('./financecomponents/bankreconciliation/fetchbankreconciliation/fetchBankReconciliation.module').then(m => m.FetchBankReconciliationModule)
  //},

  //{
  //  path: 'procurement/advancerequest/addadvancerequest',
  //  loadChildren: () => import('./procurementcomponents/advancerequest/addadvancerequest/addAdvanceRequest.module').then(m => m.AddAdvanceRequestModule)
  //},
  //{
  //  path: 'procurement/advancerequest/addadvancerequest/:id',
  //  loadChildren: () => import('./procurementcomponents/advancerequest/addadvancerequest/addAdvanceRequest.module').then(m => m.AddAdvanceRequestModule)
  //},

  //{
  //  path: 'procurement/advancerequest/fetchadvancerequest',
  //  loadChildren: () => import('./procurementcomponents/advancerequest/fetchadvancerequest/fetchAdvanceRequest.module').then(m => m.FetchAdvanceRequestModule)
  //},
  //{
  //  path: 'general/userusergroup/adduserusergroup',
  //  loadChildren: () => import('./generalcomponents/userusergroup/adduserusergroup/addUserUserGroup.module').then(m => m.AddUserUserGroupModule)
  //},
  //{
  //  path: 'general/userusergroup/adduserusergroup/:id',
  //  loadChildren: () => import('./generalcomponents/userusergroup/adduserusergroup/addUserUserGroup.module').then(m => m.AddUserUserGroupModule)
  //},

  //{
  //  path: 'general/userusergroup/fetchuserusergroup',
  //  loadChildren: () => import('./generalcomponents/userusergroup/fetchuserusergroup/fetchUserUserGroup.module').then(m => m.FetchUserUserGroupModule)
  //},

  //{
  //  "path": 'finance/intrabranchtransactions/fetchintrabranchtransactions',
  //  loadChildren: () => import('./financecomponents/intrabranchtransactions/fetchintrabranchtransactions/fetchIntraBranchTransactions.module').then(m => m.FetchIntraBranchTransactionsModule)
  //},
  //{
  //  "path": 'finance/intrabranchtransactions/addintrabranchtransactions/:id',
  //  loadChildren: () => import('./financecomponents/intrabranchtransactions/addintrabranchtransactions/addIntraBranchTransactions.module').then(m => m.AddIntraBranchTransactionsModule)
  //},

  ////
  //{
  //    path: 'general/support',
  //    loadChildren: () => import('./generalcomponents/clientsupport/addclientsupport/addClientSupport.module').then(m => m.AddClientSupportModule)
  //},
  //{
  //    path: 'general/support/createticket',
  //    loadChildren: () => import('./generalcomponents/clientsupport/addsupportticket/addSupportTicket.module').then(m => m.AddSupportTicketModule)
  //},
  ////
  //{
  //    path: 'support/buglist/fetchbug',
  //    loadChildren: () => import('./supportcomponents/buglist/fetchbug/fetchBug.module').then(m => m.FetchBugModule)
  //},
  //{
  //    path: 'support/buglist/addbug',
  //    loadChildren: () => import('./supportcomponents/buglist/addbug/addBug.module').then(m => m.AddBugModule)
  //},
  //{
  //    path: 'support/buglist/addbug/:id',
  //    loadChildren: () => import('./supportcomponents/buglist/addbug/addBug.module').then(m => m.AddBugModule)
  //},


  //{
  //    path: 'support/buglist/fetchbug',
  //    loadChildren: () => import('./supportcomponents/buglist/fetchbug/fetchBug.module').then(m => m.FetchBugModule)
  //},
  //{
  //    path: 'support/buglist/addbug',
  //    loadChildren: () => import('./supportcomponents/buglist/addbug/addBug.module').then(m => m.AddBugModule)
  //},
  //{
  //    path: 'support/buglist/addbug/:id',
  //    loadChildren: () => import('./supportcomponents/buglist/addbug/addBug.module').then(m => m.AddBugModule)
  //},


  //  //
  //  {
  //    path: 'general/profile/overview',
  //    loadChildren: () => import('./generalcomponents/profile/overview/overview.module').then(m => m.OverviewModule)
  //  },
  //  {
  //    path: 'general/profile/accountinformation',
  //    loadChildren: () => import('./generalcomponents/profile/accountinformation/accountInformation.module').then(m => m.AccountInformationModule)
  //  },
  //  {
  //    path: 'general/profile/changepassword',
  //    loadChildren: () => import('./generalcomponents/profile/changepassword/changePassword.module').then(m => m.ChangePasswordModule)
  //  },
  //  {
  //    path: 'general/profile/emailsetting',
  //    loadChildren: () => import('./generalcomponents/profile/emailsetting/emailSetting.module').then(m => m.EmailSettingModule)
  //  },
  //  {
  //    path: 'general/profile/personalinformation',
  //    loadChildren: () => import('./generalcomponents/profile/personalinformation/personalInformation.module').then(m => m.PersonalInformationModule)
  //  }, //

  //  //
  //  {
  //    path: 'inventory/returnabledeliverynoteissue/addreturnabledeliverynoteissue',
  //    loadChildren: () => import('./inventorycomponents/returnabledeliverynoteissue/addreturnabledeliverynoteissue/addReturnableDeliveryNoteIssue.module').then(m => m.AddReturnableDeliveryNoteIssueModule)
  //  },
  //  {
  //    path: 'inventory/returnabledeliverynoteissue/addreturnabledeliverynoteissue/:id',
  //    loadChildren: () => import('./inventorycomponents/returnabledeliverynoteissue/addreturnabledeliverynoteissue/addReturnableDeliveryNoteIssue.module').then(m => m.AddReturnableDeliveryNoteIssueModule)
  //  },

  //  {
  //    path: 'inventory/returnabledeliverynoteissue/fetchreturnabledeliverynoteissue',
  //    loadChildren: () => import('./inventorycomponents/returnabledeliverynoteissue/fetchreturnabledeliverynoteissue/fetchReturnableDeliveryNoteIssue.module').then(m => m.FetchReturnableDeliveryNoteIssueModule)
  //  },

  //  {
  //    path: 'inventory/returnabledeliverynotereceipt/addreturnabledeliverynotereceipt',
  //    loadChildren: () => import('./inventorycomponents/returnabledeliverynotereceipt/addreturnabledeliverynotereceipt/addReturnableDeliveryNoteReceipt.module').then(m => m.AddReturnableDeliveryNoteReceiptModule)
  //  },
  //  {
  //    path: 'inventory/returnabledeliverynotereceipt/addreturnabledeliverynotereceipt/:id',
  //    loadChildren: () => import('./inventorycomponents/returnabledeliverynotereceipt/addreturnabledeliverynotereceipt/addReturnableDeliveryNoteReceipt.module').then(m => m.AddReturnableDeliveryNoteReceiptModule)
  //  },

  //  {
  //    path: 'inventory/returnabledeliverynotereceipt/fetchreturnabledeliverynotereceipt',
  //    loadChildren: () => import('./inventorycomponents/returnabledeliverynotereceipt/fetchreturnabledeliverynotereceipt/fetchReturnableDeliveryNoteReceipt.module').then(m => m.FetchReturnableDeliveryNoteReceiptModule)
  //  },

  //  {
  //    path: 'inventory/nonreturnablegatepass/addnonreturnablegatepass',
  //    loadChildren: () => import('./inventorycomponents/nonreturnablegatepass/addnonreturnablegatepass/addNonReturnableGatePass.module').then(m => m.AddNonReturnableGatePassModule)
  //  },
  //  {
  //    path: 'inventory/nonreturnablegatepass/addnonreturnablegatepass/:id',
  //    loadChildren: () => import('./inventorycomponents/nonreturnablegatepass/addnonreturnablegatepass/addNonReturnableGatePass.module').then(m => m.AddNonReturnableGatePassModule)
  //  },

  //  {
  //    path: 'inventory/nonreturnablegatepass/fetchnonreturnablegatepass',
  //    loadChildren: () => import('./inventorycomponents/nonreturnablegatepass/fetchnonreturnablegatepass/fetchNonReturnableGatePass.module').then(m => m.FetchNonReturnableGatePassModule)
  //  },

  {
    path: 'csvreportgeneration/addcsvreportgeneration',
    loadChildren: () => import('./generalcomponents/csvreportgeneration/addcsvreportgeneration/addCsvReportGeneration.module').then(m => m.AddCsvReportGenerationModule)
  },
  {
    path: 'csvreportgeneration/addcsvreportgeneration/:id',
    loadChildren: () => import('./generalcomponents/csvreportgeneration/addcsvreportgeneration/addCsvReportGeneration.module').then(m => m.AddCsvReportGenerationModule)
  },

  {
    path: 'csvreportgeneration/fetchcsvreportgeneration',
    loadChildren: () => import('./generalcomponents/csvreportgeneration/fetchcsvreportgeneration/fetchCsvReportGeneration.module').then(m => m.FetchCsvReportGenerationModule)
  },

  {
    path: 'csvexport/csvexport',
    loadChildren: () => import('./generalcomponents/csvexport/fetchcsvreportexport/fetchCsvReportExport.module').then(m => m.FetchCsvReportExportModule)
  },

  //  {
  //    path: 'crm/campaigntype/addcampaigntype',
  //    loadChildren: () => import('./crmcomponents/campaigntype/addcampaigntype/addCampaignType.module').then(m => m.AddCampaignTypeModule)
  //  },
  //  {
  //    path: 'crm/campaigntype/addcampaigntype/:id',
  //    loadChildren: () => import('./crmcomponents/campaigntype/addcampaigntype/addCampaignType.module').then(m => m.AddCampaignTypeModule)
  //  },

  //  {
  //    path: 'crm/campaigntype/fetchcampaigntype',
  //    loadChildren: () => import('./crmcomponents/campaigntype/fetchcampaigntype/fetchCampaignType.module').then(m => m.FetchCampaignTypeModule)
  //  },
  //  {
  //    path: 'crm/targettype/addtargettype',
  //    loadChildren: () => import('./crmcomponents/targettype/addtargettype/addTargetType.module').then(m => m.AddTargetTypeModule)
  //  },
  //  {
  //    path: 'crm/targettype/addtargettype/:id',
  //    loadChildren: () => import('./crmcomponents/targettype/addtargettype/addTargetType.module').then(m => m.AddTargetTypeModule)
  //  },

  //  {
  //    path: 'crm/targettype/fetchtargettype',
  //    loadChildren: () => import('./crmcomponents/targettype/fetchtargettype/fetchTargetType.module').then(m => m.FetchTargetTypeModule)
  //  },
  //  {
  //    path: 'crm/accounttype/addaccounttype',
  //    loadChildren: () => import('./crmcomponents/accounttype/addaccounttype/addAccountType.module').then(m => m.AddAccountTypeModule)
  //  },
  //  {
  //    path: 'crm/accounttype/addaccounttype/:id',
  //    loadChildren: () => import('./crmcomponents/accounttype/addaccounttype/addAccountType.module').then(m => m.AddAccountTypeModule)
  //  },

  //  {
  //    path: 'crm/accounttype/fetchaccounttype',
  //    loadChildren: () => import('./crmcomponents/accounttype/fetchaccounttype/fetchAccountType.module').then(m => m.FetchAccountTypeModule)
  //  },
  //  {
  //    path: 'crm/leadsource/addleadsource',
  //    loadChildren: () => import('./crmcomponents/leadsource/addleadsource/addLeadSource.module').then(m => m.AddLeadSourceModule)
  //  },
  //  {
  //    path: 'crm/leadsource/addleadsource/:id',
  //    loadChildren: () => import('./crmcomponents/leadsource/addleadsource/addLeadSource.module').then(m => m.AddLeadSourceModule)
  //  },

  //  {
  //    path: 'crm/leadsource/fetchleadsource',
  //    loadChildren: () => import('./crmcomponents/leadsource/fetchleadsource/fetchLeadSource.module').then(m => m.FetchLeadSourceModule)
  //  },

  //  {
  //    path: 'crm/opportunitygroup/addopportunitygroup',
  //    loadChildren: () => import('./crmcomponents/opportunitygroup/addopportunitygroup/addOpportunityGroup.module').then(m => m.AddOpportunityGroupModule)
  //  },
  //  {
  //    path: 'crm/opportunitygroup/addopportunitygroup/:id',
  //    loadChildren: () => import('./crmcomponents/opportunitygroup/addopportunitygroup/addOpportunityGroup.module').then(m => m.AddOpportunityGroupModule)
  //  },

  //  {
  //    path: 'crm/opportunitygroup/fetchopportunitygroup',
  //    loadChildren: () => import('./crmcomponents/opportunitygroup/fetchopportunitygroup/fetchOpportunityGroup.module').then(m => m.FetchOpportunityGroupModule)
  //  },
  //  {
  //    path: 'crm/salesstage/addsalesstage',
  //    loadChildren: () => import('./crmcomponents/salesstage/addsalesstage/addSalesStage.module').then(m => m.AddSalesStageModule)
  //  },
  //  {
  //    path: 'crm/salesstage/addsalesstage/:id',
  //    loadChildren: () => import('./crmcomponents/salesstage/addsalesstage/addSalesStage.module').then(m => m.AddSalesStageModule)
  //  },

  //  {
  //    path: 'crm/salesstage/fetchsalesstage',
  //    loadChildren: () => import('./crmcomponents/salesstage/fetchsalesstage/fetchSalesStage.module').then(m => m.FetchSalesStageModule)
  //  },
  //  {
  //    path: 'crm/documentcategory/adddocumentcategory',
  //    loadChildren: () => import('./crmcomponents/documentcategory/adddocumentcategory/addDocumentCategory.module').then(m => m.AddDocumentCategoryModule)
  //  },
  //  {
  //    path: 'crm/documentcategory/adddocumentcategory/:id',
  //    loadChildren: () => import('./crmcomponents/documentcategory/adddocumentcategory/addDocumentCategory.module').then(m => m.AddDocumentCategoryModule)
  //  },

  //  {
  //    path: 'crm/documentcategory/fetchdocumentcategory',
  //    loadChildren: () => import('./crmcomponents/documentcategory/fetchdocumentcategory/fetchDocumentCategory.module').then(m => m.FetchDocumentCategoryModule)
  //  },
  //  {
  //    path: 'crm/industries/addindustries',
  //    loadChildren: () => import('./crmcomponents/industries/addindustries/addIndustries.module').then(m => m.AddIndustriesModule)
  //  },
  //  {
  //    path: 'crm/industries/addindustries/:id',
  //    loadChildren: () => import('./crmcomponents/industries/addindustries/addIndustries.module').then(m => m.AddIndustriesModule)
  //  },

  //  {
  //    path: 'crm/industries/fetchindustries',
  //    loadChildren: () => import('./crmcomponents/industries/fetchindustries/fetchIndustries.module').then(m => m.FetchIndustriesModule)
  //  },

  //  {
  //    path: 'crm/activity/addactivity',
  //    loadChildren: () => import('./crmcomponents/activity/addactivity/addActivity.module').then(m => m.AddActivityModule)
  //  },
  //  {
  //    path: 'crm/activity/addactivity/:id',
  //    loadChildren: () => import('./crmcomponents/activity/addactivity/addActivity.module').then(m => m.AddActivityModule)
  //  },

  //  {
  //    path: 'crm/activity/fetchactivity',
  //    loadChildren: () => import('./crmcomponents/activity/fetchactivity/fetchActivity.module').then(m => m.FetchActivityModule)
  //  },
  //  {
  //    path: 'crm/accounts/addaccounts',
  //    loadChildren: () => import('./crmcomponents/accounts/addaccounts/addAccounts.module').then(m => m.AddAccountsModule)
  //  },
  //  {
  //    path: 'crm/accounts/addaccounts/:id',
  //    loadChildren: () => import('./crmcomponents/accounts/addaccounts/addAccounts.module').then(m => m.AddAccountsModule)
  //  },

  //  {
  //    path: 'crm/accounts/fetchaccounts',
  //    loadChildren: () => import('./crmcomponents/accounts/fetchaccounts/fetchAccounts.module').then(m => m.FetchAccountsModule)
  //  },

  //  {
  //    path: 'crm/campaign/addcampaign',
  //    loadChildren: () => import('./crmcomponents/campaign/addcampaign/addCampaign.module').then(m => m.AddCampaignModule)
  //  },
  //  {
  //    path: 'crm/campaign/addcampaign/:id',
  //    loadChildren: () => import('./crmcomponents/campaign/addcampaign/addCampaign.module').then(m => m.AddCampaignModule)
  //  },

  //  {
  //    path: 'crm/campaign/fetchcampaign',
  //    loadChildren: () => import('./crmcomponents/campaign/fetchcampaign/fetchCampaign.module').then(m => m.FetchCampaignModule)
  //  },

  //  {
  //    path: 'crm/target/addtarget',
  //    loadChildren: () => import('./crmcomponents/target/addtarget/addTarget.module').then(m => m.AddTargetModule)
  //  },
  //  {
  //    path: 'crm/target/addtarget/:id',
  //    loadChildren: () => import('./crmcomponents/target/addtarget/addTarget.module').then(m => m.AddTargetModule)
  //  },

  //  {
  //    path: 'crm/target/fetchtarget',
  //    loadChildren: () => import('./crmcomponents/target/fetchtarget/fetchTarget.module').then(m => m.FetchTargetModule)
  //  },

  //  {
  //    path: 'crm/surveys/addsurveys',
  //    loadChildren: () => import('./crmcomponents/surveys/addsurveys/addSurveys.module').then(m => m.AddSurveysModule)
  //  },
  //  {
  //    path: 'crm/surveys/addsurveys/:id',
  //    loadChildren: () => import('./crmcomponents/surveys/addsurveys/addSurveys.module').then(m => m.AddSurveysModule)
  //  },

  //  {
  //    path: 'crm/surveys/fetchsurveys',
  //    loadChildren: () => import('./crmcomponents/surveys/fetchsurveys/fetchSurveys.module').then(m => m.FetchSurveysModule)
  //  },

  {
    path: 'hrm/companyobjectives/addcompanyobjectives',
    loadChildren: () => import('./hrmcomponents/companyobjectives/addcompanyobjectives/addCompanyObjectives.module').then(m => m.AddCompanyObjectivesModule)
  },
  {
    path: 'hrm/companyobjectives/addcompanyobjectives/:id',
    loadChildren: () => import('./hrmcomponents/companyobjectives/addcompanyobjectives/addCompanyObjectives.module').then(m => m.AddCompanyObjectivesModule)
  },
  {
    path: 'hrm/companyobjectives/fetchcompanyobjectives',
    loadChildren: () => import('./hrmcomponents/companyobjectives/fetchcompanyobjectives/fetchCompanyObjectives.module').then(m => m.fetchCompanyObjectivesModule)
  },

  //  {
  //    path: 'crm/contacts/addcontacts',
  //    loadChildren: () => import('./crmcomponents/contacts/addcontacts/addContacts.module').then(m => m.AddContactsModule)
  //  },
  //  {
  //    path: 'crm/contacts/addcontacts/:id',
  //    loadChildren: () => import('./crmcomponents/contacts/addcontacts/addContacts.module').then(m => m.AddContactsModule)
  //  },

  //  {
  //    path: 'crm/contacts/fetchcontacts',
  //    loadChildren: () => import('./crmcomponents/contacts/fetchcontacts/fetchContacts.module').then(m => m.FetchContactsModule)
  //  },

  //  {
  //    path: 'crm/project/addproject',
  //    loadChildren: () => import('./crmcomponents/project/addproject/addProject.module').then(m => m.AddProjectModule)
  //  },
  //  {
  //    path: 'crm/project/addproject/:id',
  //    loadChildren: () => import('./crmcomponents/project/addproject/addProject.module').then(m => m.AddProjectModule)
  //  },

  //  {
  //    path: 'crm/project/fetchproject',
  //    loadChildren: () => import('./crmcomponents/project/fetchproject/fetchProject.module').then(m => m.FetchProjectModule)
  //  },

  //  {
  //    path: 'crm/documents/adddocuments',
  //    loadChildren: () => import('./crmcomponents/documents/adddocuments/addDocuments.module').then(m => m.AddDocumentsModule)
  //  },
  //  {
  //    path: 'crm/documents/adddocuments/:id',
  //    loadChildren: () => import('./crmcomponents/documents/adddocuments/addDocuments.module').then(m => m.AddDocumentsModule)
  //  },

  //  {
  //    path: 'crm/documents/fetchdocuments',
  //    loadChildren: () => import('./crmcomponents/documents/fetchdocuments/fetchDocuments.module').then(m => m.FetchDocumentsModule)
  //  },

  //  {
  //    path: 'crm/leads/addleads',
  //    loadChildren: () => import('./crmcomponents/leads/addleads/addLeads.module').then(m => m.AddLeadsModule)
  //  },
  //  {
  //    path: 'crm/leads/addleads/:id',
  //    loadChildren: () => import('./crmcomponents/leads/addleads/addLeads.module').then(m => m.AddLeadsModule)
  //  },

  //  {
  //    path: 'crm/leads/fetchleads',
  //    loadChildren: () => import('./crmcomponents/leads/fetchleads/fetchLeads.module').then(m => m.FetchLeadsModule)
  //  },

  //  {
  //    path: 'crm/opportunity/addopportunity',
  //    loadChildren: () => import('./crmcomponents/opportunity/addopportunity/addOpportunity.module').then(m => m.AddOpportunityModule)
  //  },
  //  {
  //    path: 'crm/opportunity/addopportunity/:id',
  //    loadChildren: () => import('./crmcomponents/opportunity/addopportunity/addOpportunity.module').then(m => m.AddOpportunityModule)
  //  },

  //  {
  //    path: 'crm/opportunity/fetchopportunity',
  //    loadChildren: () => import('./crmcomponents/opportunity/fetchopportunity/fetchOpportunity.module').then(m => m.FetchOpportunityModule)
  //  },
  //  {
  //    path: 'finance/aradjustment/addaradjustment',
  //    loadChildren: () => import('./financecomponents/aradjustment/addaradjustment/addARAdjustment.module').then(m => m.AddARAdjustmentModule)
  //  },
  //  {
  //    path: 'finance/aradjustment/addaradjustment/:id',
  //    loadChildren: () => import('./financecomponents/aradjustment/addaradjustment/addARAdjustment.module').then(m => m.AddARAdjustmentModule)
  //  },




  //  {
  //    path: 'finance/consolidationaccountmapping/fetchconsolidationaccountmapping',
  //    loadChildren: () => import('./financecomponents/consolidationmapping/consolidationMapping.module').then(m => m.ConsolidationMappingModule)
  //  },
  //  {
  //    path: 'finance/chequereturn/addchequereturn',
  //    loadChildren: () => import('./financecomponents/chequereturn/addchequereturn/addChequeReturn.module').then(m => m.AddChequeReturnModule)
  //  },
  //  {
  //    path: 'finance/chequereturn/addchequereturn/:id',
  //    loadChildren: () => import('./financecomponents/chequereturn/addchequereturn/addChequeReturn.module').then(m => m.AddChequeReturnModule)
  //  },

  //  {
  //    path: 'finance/chequereturn/fetchchequereturn',
  //    loadChildren: () => import('./financecomponents/chequereturn/fetchchequereturn/fetchChequeReturn.module').then(m => m.FetchChequeReturnModule)
  //  },
  //  {
  //    path: 'hrm/requisition/addrequisition',
  //    loadChildren: () => import('./hrmcomponents/requisition/addRequisition/addRequisition.module').then(m => m.AddRequisitionModule)
  //  },
  //  {
  //    path: 'hrm/requisition/addrequisition/:id',
  //    loadChildren: () => import('./hrmcomponents/requisition/addRequisition/addRequisition.module').then(m => m.AddRequisitionModule)
  //  },

  //  {
  //    path: 'hrm/requisition/fetchrequisition',
  //    loadChildren: () => import('./hrmcomponents/requisition/fetchRequisition/fetchRequisition.module').then(m => m.FetchRequisitionModule)
  //  },
  //  {
  //    path: 'hrm/trainingplan/addtrainingplan',
  //    loadChildren: () => import('./hrmcomponents/trainingplan/addtrainingplan/addTrainingPlan.module').then(m => m.AddTrainingPlanModule)
  //  },
  //  {
  //    path: 'hrm/trainingplan/addtrainingplan/:id',
  //    loadChildren: () => import('./hrmcomponents/trainingplan/addtrainingplan/addTrainingPlan.module').then(m => m.AddTrainingPlanModule)
  //  },

  //  {
  //    path: 'hrm/trainingplan/fetchtrainingplan',
  //    loadChildren: () => import('./hrmcomponents/trainingplan/fetchtrainingplan/fetchTrainingPlan.module').then(m => m.FetchTrainingPlanModule)
  //  },

  //  {
  //    path: 'hrm/resumebank/addresumebank',
  //    loadChildren: () => import('./hrmcomponents/resumebank/addresumebank/addResumeBank.module').then(m => m.AddResumeBankModule)
  //  },
  //  {
  //    path: 'hrm/resumebank/addresumebank/:id',
  //    loadChildren: () => import('./hrmcomponents/resumebank/addresumebank/addResumeBank.module').then(m => m.AddResumeBankModule)
  //  },

  //  {
  //    path: 'hrm/resumebank/fetchresumebank',
  //    loadChildren: () => import('./hrmcomponents/resumebank/fetchresumebank/fetchResumeBank.module').then(m => m.FetchResumeBankModule)
  //  },

  //  {
  //    path: 'hrm/vacancygroup/addvacancygroup',
  //    loadChildren: () => import('./hrmcomponents/vacancygroup/addvacancygroup/addVacancyGroup.module').then(m => m.AddVacancyGroupModule)
  //  },
  //  {
  //    path: 'hrm/vacancygroup/addvacancygroup/:id',
  //    loadChildren: () => import('./hrmcomponents/vacancygroup/addvacancygroup/addVacancyGroup.module').then(m => m.AddVacancyGroupModule)
  //  },

  //  {
  //    path: 'hrm/vacancygroup/fetchvacancygroup',
  //    loadChildren: () => import('./hrmcomponents/vacancygroup/fetchvacancygroup/fetchVacancyGroup.module').then(m => m.FetchVacancyGroupModule)
  //  },

  //  {
  //    path: 'hrm/resumeshortlist/addresumeshortlist',
  //    loadChildren: () => import('./hrmcomponents/resumeshortlist/addresumeshortlist/addResumeShortlist.module').then(m => m.AddResumeShortlistModule)
  //  },
  //  {
  //    path: 'hrm/resumeshortlist/addresumeshortlist/:id',
  //    loadChildren: () => import('./hrmcomponents/resumeshortlist/addresumeshortlist/addResumeShortlist.module').then(m => m.AddResumeShortlistModule)
  //  },

  //  {
  //    path: 'hrm/resumeshortlist/fetchresumeshortlist',
  //    loadChildren: () => import('./hrmcomponents/resumeshortlist/fetchresumeshortlist/fetchResumeShortlist.module').then(m => m.FetchResumeShortlistModule)
  //  },

  //  {
  //    path: 'hrm/selectionstatusupdation/addselectionstatusupdation',
  //    loadChildren: () => import('./hrmcomponents/selectionstatusupdation/addselectionstatusupdation/addSelectionStatusUpdation.module').then(m => m.AddSelectionStatusUpdationModule)
  //  },
  //  {
  //    path: 'hrm/selectionstatusupdation/addselectionstatusupdation/:id',
  //    loadChildren: () => import('./hrmcomponents/selectionstatusupdation/addselectionstatusupdation/addSelectionStatusUpdation.module').then(m => m.AddSelectionStatusUpdationModule)
  //  },

  //  {
  //    path: 'hrm/selectionstatusupdation/fetchselectionstatusupdation',
  //    loadChildren: () => import('./hrmcomponents/selectionstatusupdation/fetchselectionstatusupdation/fetchSelectionStatusUpdation.module').then(m => m.FetchSelectionStatusUpdationModule)
  //  },

  //  {
  //    path: 'hrm/pretraining/addpretraining',
  //    loadChildren: () => import('./hrmcomponents/pretraining/addpretraining/addPreTraining.module').then(m => m.AddPreTrainingModule)
  //  },
  //  {
  //    path: 'hrm/pretraining/addpretraining/:id',
  //    loadChildren: () => import('./hrmcomponents/pretraining/addpretraining/addPreTraining.module').then(m => m.AddPreTrainingModule)
  //  },

  //  {
  //    path: 'hrm/pretraining/fetchpretraining',
  //    loadChildren: () => import('./hrmcomponents/pretraining/fetchpretraining/fetchPreTraining.module').then(m => m.FetchPreTrainingModule)
  //  },

  //  {
  //    path: 'hrm/joboffergeneration/addjoboffergeneration',
  //    loadChildren: () => import('./hrmcomponents/joboffergeneration/addjoboffergeneration/addJobOfferGeneration.module').then(m => m.AddJobOfferGenerationModule)
  //  },
  //  {
  //    path: 'hrm/joboffergeneration/addjoboffergeneration/:id',
  //    loadChildren: () => import('./hrmcomponents/joboffergeneration/addjoboffergeneration/addJobOfferGeneration.module').then(m => m.AddJobOfferGenerationModule)
  //  },

  //  {
  //    path: 'hrm/joboffergeneration/fetchjoboffergeneration',
  //    loadChildren: () => import('./hrmcomponents/joboffergeneration/fetchjoboffergeneration/fetchJobOfferGeneration.module').then(m => m.FetchJobOfferGenerationModule)
  //  },
  //  {
  //    path: 'finance/coacompanymapping/fetchcoacompanymapping',
  //    loadChildren: () => import('./financecomponents/companymapping/CompanyMapping.module').then(m => m.CompanyMappingModule)
  //  },

  //  {
  //    path: 'hrm/trainingrequisition/addtrainingrequisition',
  //    loadChildren: () => import('./hrmcomponents/trainingrequisition/addtrainingrequisition/addTrainingRequisition.module').then(m => m.AddTrainingRequisitionModule)
  //  },
  //  {
  //    path: 'hrm/trainingrequisition/addtrainingrequisition/:id',
  //    loadChildren: () => import('./hrmcomponents/trainingrequisition/addtrainingrequisition/addTrainingRequisition.module').then(m => m.AddTrainingRequisitionModule)
  //  },

  //  {
  //    path: 'hrm/trainingrequisition/fetchtrainingrequisition',
  //    loadChildren: () => import('./hrmcomponents/trainingrequisition/fetchtrainingrequisition/fetchTrainingRequisition.module').then(m => m.FetchTrainingRequisitionModule)
  //  },

  //  {
  //    path: 'hrm/trainingschedule/addtrainingschedule',
  //    loadChildren: () => import('./hrmcomponents/trainingschedule/addtrainingschedule/addTrainingSchedule.module').then(m => m.AddTrainingScheduleModule)
  //  },
  //  {
  //    path: 'hrm/trainingschedule/addtrainingschedule/:id',
  //    loadChildren: () => import('./hrmcomponents/trainingschedule/addtrainingschedule/addTrainingSchedule.module').then(m => m.AddTrainingScheduleModule)
  //  },

  //  {
  //    path: 'hrm/trainingschedule/fetchtrainingschedule',
  //    loadChildren: () => import('./hrmcomponents/trainingschedule/fetchtrainingschedule/fetchTrainingSchedule.module').then(m => m.FetchTrainingScheduleModule)
  //  },

  //  {
  //    path: 'hrm/trainingexecution/addtrainingexecution',
  //    loadChildren: () => import('./hrmcomponents/trainingexecution/addtrainingexecution/addTrainingExecution.module').then(m => m.AddTrainingExecutionModule)
  //  },
  //  {
  //    path: 'hrm/trainingexecution/addtrainingexecution/:id',
  //    loadChildren: () => import('./hrmcomponents/trainingexecution/addtrainingexecution/addTrainingExecution.module').then(m => m.AddTrainingExecutionModule)
  //  },

  //  {
  //    path: 'hrm/trainingexecution/fetchtrainingexecution',
  //    loadChildren: () => import('./hrmcomponents/trainingexecution/fetchtrainingexecution/fetchTrainingExecution.module').then(m => m.FetchTrainingExecutionModule)
  //  },
  //  {
  //    path: 'hrm/trainingcertificate/addtrainingcertificate',
  //    loadChildren: () => import('./hrmcomponents/trainingcertificate/addtrainingcertificate/addTrainingCertificate.module').then(m => m.AddTrainingCertificateModule)
  //  },
  //  {
  //    path: 'hrm/trainingcertificate/addtrainingcertificate/:id',
  //    loadChildren: () => import('./hrmcomponents/trainingcertificate/addtrainingcertificate/addTrainingCertificate.module').then(m => m.AddTrainingCertificateModule)
  //  },

  //  {
  //    path: 'hrm/trainingcertificate/fetchtrainingcertificate',
  //    loadChildren: () => import('./hrmcomponents/trainingcertificate/fetchtrainingcertificate/fetchTrainingCertificate.module').then(m => m.FetchTrainingCertificateModule)
  //  },
  //  {
  //    path: 'hrm/trainingfeedbackanalysis/addtrainingfeedbackanalysis',
  //    loadChildren: () => import('./hrmcomponents/trainingfeedbackanalysis/addtrainingfeedbackanalysis/addTrainingFeedbackAnalysis.module').then(m => m.AddTrainingFeedbackAnalysisModule)
  //  },
  //  {
  //    path: 'hrm/trainingfeedbackanalysis/addtrainingfeedbackanalysis/:id',
  //    loadChildren: () => import('./hrmcomponents/trainingfeedbackanalysis/addtrainingfeedbackanalysis/addTrainingFeedbackAnalysis.module').then(m => m.AddTrainingFeedbackAnalysisModule)
  //  },

  //  {
  //    path: 'hrm/trainingfeedbackanalysis/fetchtrainingfeedbackanalysis',
  //    loadChildren: () => import('./hrmcomponents/trainingfeedbackanalysis/fetchtrainingfeedbackanalysis/fetchTrainingFeedbackAnalysis.module').then(m => m.FetchTrainingFeedbackAnalysisModule)
  //  },
  //  {
  //    path: 'hrm/trainingevaluation/addtrainingevaluation',
  //    loadChildren: () => import('./hrmcomponents/trainingevaluation/addtrainingevaluation/addTrainingEvaluation.module').then(m => m.AddTrainingEvaluationModule)
  //  },
  //  {
  //    path: 'hrm/trainingevaluation/addtrainingevaluation/:id',
  //    loadChildren: () => import('./hrmcomponents/trainingevaluation/addtrainingevaluation/addTrainingEvaluation.module').then(m => m.AddTrainingEvaluationModule)
  //  },

  //  {
  //    path: 'hrm/trainingevaluation/fetchtrainingevaluation',
  //    loadChildren: () => import('./hrmcomponents/trainingevaluation/fetchtrainingevaluation/fetchTrainingEvaluation.module').then(m => m.FetchTrainingEvaluationModule)
  //  },


  //  {
  //    path: 'hrm/travelfeedback/addtravelfeedback',
  //    loadChildren: () => import('./hrmcomponents/travelfeedback/addtravelfeedback/addTravelFeedback.module').then(m => m.AddTravelFeedbackModule)
  //  },
  //  {
  //    path: 'hrm/travelfeedback/addtravelfeedback/:id',
  //    loadChildren: () => import('./hrmcomponents/travelfeedback/addtravelfeedback/addTravelFeedback.module').then(m => m.AddTravelFeedbackModule)
  //  },

  //  {
  //    path: 'hrm/travelfeedback/fetchtravelfeedback',
  //    loadChildren: () => import('./hrmcomponents/travelfeedback/fetchtravelfeedback/fetchTravelFeedback.module').then(m => m.FetchTravelFeedbackModule)
  //  },
  //  {
  //    path: 'hrm/trainingevaluation/addtrainingevaluation',
  //    loadChildren: () => import('./hrmcomponents/trainingevaluation/addtrainingevaluation/addTrainingEvaluation.module').then(m => m.AddTrainingEvaluationModule)
  //  },
  //  {
  //    path: 'hrm/trainingevaluation/addtrainingevaluation/:id',
  //    loadChildren: () => import('./hrmcomponents/trainingevaluation/addtrainingevaluation/addTrainingEvaluation.module').then(m => m.AddTrainingEvaluationModule)
  //  },

  //  {
  //    path: 'hrm/trainingevaluation/fetchtrainingevaluation',
  //    loadChildren: () => import('./hrmcomponents/trainingevaluation/fetchtrainingevaluation/fetchTrainingEvaluation.module').then(m => m.FetchTrainingEvaluationModule)
  //  },
  //  {
  //    path: 'hrm/overtime/addovertime',
  //    loadChildren: () => import('./hrmcomponents/overtime/addovertime/addOverTime.module').then(m => m.AddOverTimeModule)
  //  },
  //  {
  //    path: 'hrm/overtime/addovertime/:id',
  //    loadChildren: () => import('./hrmcomponents/overtime/addovertime/addOverTime.module').then(m => m.AddOverTimeModule)
  //  },

  //  {
  //    path: 'hrm/overtime/fetchovertime',
  //    loadChildren: () => import('./hrmcomponents/overtime/fetchovertime/fetchOverTime.module').then(m => m.FetchOverTimeModule)
  //  },

  //  {
  //    path: 'hrm/overtimepolicy/addovertimepolicy',
  //    loadChildren: () => import('./hrmcomponents/overtimepolicy/addovertimepolicy/addOverTimePolicy.module').then(m => m.AddOverTimePolicyModule)
  //  },
  //  {
  //    path: 'hrm/overtimepolicy/addovertimepolicy/:id',
  //    loadChildren: () => import('./hrmcomponents/overtimepolicy/addovertimepolicy/addOverTimePolicy.module').then(m => m.AddOverTimePolicyModule)
  //  },

  //  {
  //    path: 'hrm/overtimepolicy/fetchovertimepolicy',
  //    loadChildren: () => import('./hrmcomponents/overtimepolicy/fetchovertimepolicy/fetchOverTimePolicy.module').then(m => m.FetchOverTimePolicyModule)
  //  },
  //  {
  //    path: 'hrm/groupvisa/addgroupvisa',
  //    loadChildren: () => import('./hrmcomponents/groupvisa/addgroupvisa/addGroupVisa.module').then(m => m.AddGroupVisaModule)
  //  },
  //  {
  //    path: 'hrm/groupvisa/addgroupvisa/:id',
  //    loadChildren: () => import('./hrmcomponents/groupvisa/addgroupvisa/addGroupVisa.module').then(m => m.AddGroupVisaModule)
  //  },

  //  {
  //    path: 'hrm/groupvisa/fetchgroupvisa',
  //    loadChildren: () => import('./hrmcomponents/groupvisa/fetchgroupvisa/fetchGroupVisa.module').then(m => m.FetchGroupVisaModule)
  //  },

  //  {
  //    path: 'hrm/visaapplication/addvisaapplication',
  //    loadChildren: () => import('./hrmcomponents/visaapplication/addvisaapplication/addVisaApplication.module').then(m => m.AddHRMVisaApplicationModule)
  //  },
  //  {
  //    path: 'hrm/visaapplication/addvisaapplication/:id',
  //    loadChildren: () => import('./hrmcomponents/visaapplication/addvisaapplication/addVisaApplication.module').then(m => m.AddHRMVisaApplicationModule)
  //  },

  //  {
  //    path: 'hrm/visaapplication/fetchvisaapplication',
  //    loadChildren: () => import('./hrmcomponents/visaapplication/fetchvisaapplication/fetchVisaApplication.module').then(m => m.FetchHRMVisaApplicationModule)
  //  },
  //  {
  //    path: 'hrm/visareceipt/addvisareceipt',
  //    loadChildren: () => import('./hrmcomponents/visareceipt/addvisareceipt/addVisaReceipt.module').then(m => m.AddVisaReceiptModule)
  //  },
  //  {
  //    path: 'hrm/visareceipt/addvisareceipt/:id',
  //    loadChildren: () => import('./hrmcomponents/visareceipt/addvisareceipt/addVisaReceipt.module').then(m => m.AddVisaReceiptModule)
  //  },

  //  {
  //    path: 'hrm/visareceipt/fetchvisareceipt',
  //    loadChildren: () => import('./hrmcomponents/visareceipt/fetchvisareceipt/fetchVisaReceipt.module').then(m => m.FetchVisaReceiptModule)
  //  },

  //  {
  //    path: 'hrm/visareplacement/addvisareplacement',
  //    loadChildren: () => import('./hrmcomponents/visareplacement/addvisareplacement/addVisaReplacement.module').then(m => m.AddVisaReplacementModule)
  //  },
  //  {
  //    path: 'hrm/visareplacement/addvisareplacement/:id',
  //    loadChildren: () => import('./hrmcomponents/visareplacement/addvisareplacement/addVisaReplacement.module').then(m => m.AddVisaReplacementModule)
  //  },

  //  {
  //    path: 'hrm/visareplacement/fetchvisareplacement',
  //    loadChildren: () => import('./hrmcomponents/visareplacement/fetchvisareplacement/fetchVisaReplacement.module').then(m => m.FetchVisaReplacementModule)
  //  },

  //  {
  //    path: 'hrm/travelrequisition/addtravelrequisition',
  //    loadChildren: () => import('./hrmcomponents/travelrequisition/addtravelrequisition/addTravelRequisition.module').then(m => m.AddTravelRequisitionModule)
  //  },
  //  {
  //    path: 'hrm/travelrequisition/addtravelrequisition/:id',
  //    loadChildren: () => import('./hrmcomponents/travelrequisition/addtravelrequisition/addTravelRequisition.module').then(m => m.AddTravelRequisitionModule)
  //  },

  //  {
  //    path: 'hrm/travelrequisition/fetchtravelrequisition',
  //    loadChildren: () => import('./hrmcomponents/travelrequisition/fetchtravelrequisition/fetchTravelRequisition.module').then(m => m.FetchTravelRequisitionModule)
  //  },

  //  {
  //    path: 'hrm/travelplan/addtravelplan',
  //    loadChildren: () => import('./hrmcomponents/travelplan/addtravelplan/addTravelPlan.module').then(m => m.AddTravelPlanModule)
  //  },
  //  {
  //    path: 'hrm/travelplan/addtravelplan/:id',
  //    loadChildren: () => import('./hrmcomponents/travelplan/addtravelplan/addTravelPlan.module').then(m => m.AddTravelPlanModule)
  //  },

  //  {
  //    path: 'hrm/travelplan/fetchtravelplan',
  //    loadChildren: () => import('./hrmcomponents/travelplan/fetchtravelplan/fetchTravelPlan.module').then(m => m.FetchTravelPlanModule)
  //  },

  //  {
  //    path: 'hrm/movementorder/addmovementorder',
  //    loadChildren: () => import('./hrmcomponents/movementorder/addmovementorder/addMovementOrder.module').then(m => m.AddMovementOrderModule)
  //  },
  //  {
  //    path: 'hrm/movementorder/addmovementorder/:id',
  //    loadChildren: () => import('./hrmcomponents/movementorder/addmovementorder/addMovementOrder.module').then(m => m.AddMovementOrderModule)
  //  },

  //  {
  //    path: 'hrm/movementorder/fetchmovementorder',
  //    loadChildren: () => import('./hrmcomponents/movementorder/fetchmovementorder/fetchMovementOrder.module').then(m => m.FetchMovementOrderModule)
  //  },



  //  {
  //    path: 'report/finance/agewisepayablereport',
  //    loadChildren: () => import('./reports/finance/AgewisePayable/AgewisePayableReport.module').then(m => m.AgewisePayableReportModule)
  //  },
  //  {
  //    path: 'report/finance/agewisereceivablereport',
  //    loadChildren: () => import('./reports/finance/AgewiseReceivable/AgewiseReceivableReport.module').then(m => m.AgewiseReceivableReportModule)
  //  },


  //production
  {
    path: 'production/machinecategory/addmachinecategory',
    loadChildren: () => import('./productioncomponents/machinecategory/addmachinecategory/addMachineCategory.module').then(m => m.AddMachineCategoryModule)
  },
  {
    path: 'production/machinecategory/addmachinecategory/:id',
    loadChildren: () => import('./productioncomponents/machinecategory/addmachinecategory/addMachineCategory.module').then(m => m.AddMachineCategoryModule)
  },

  {
    path: 'production/machinecategory/fetchmachinecategory',
    loadChildren: () => import('./productioncomponents/machinecategory/fetchmachinecategory/fetchMachineCategory.module').then(m => m.FetchMachineCategoryModule)
  },
  {
    path: 'production/machine/addmachine',
    loadChildren: () => import('./productioncomponents/machine/addmachine/addMachine.module').then(m => m.AddMachineModule)
  },
  {
    path: 'production/machine/addmachine/:id',
    loadChildren: () => import('./productioncomponents/machine/addmachine/addMachine.module').then(m => m.AddMachineModule)
  },

  {
    path: 'production/machine/fetchmachine',
    loadChildren: () => import('./productioncomponents/machine/fetchmachine/fetchMachine.module').then(m => m.FetchMachineModule)
  },

  {
    path: 'production/plant/addplant',
    loadChildren: () => import('./productioncomponents/plant/addplant/addPlant.module').then(m => m.AddPlantModule)
  },
  {
    path: 'production/plant/addplant/:id',
    loadChildren: () => import('./productioncomponents/plant/addplant/addPlant.module').then(m => m.AddPlantModule)
  },

  {
    path: 'production/plant/fetchplant',
    loadChildren: () => import('./productioncomponents/plant/fetchplant/fetchPlant.module').then(m => m.FetchPlantModule)
  },

  {
    path: 'production/workcenterlocation/addworkcenterlocation',
    loadChildren: () => import('./productioncomponents/workcenterlocation/addworkcenterlocation/addWorkcenterLocation.module').then(m => m.AddWorkcenterLocationModule)
  },
  {
    path: 'production/workcenterlocation/addworkcenterlocation/:id',
    loadChildren: () => import('./productioncomponents/workcenterlocation/addworkcenterlocation/addWorkcenterLocation.module').then(m => m.AddWorkcenterLocationModule)
  },

  {
    path: 'production/workcenterlocation/fetchworkcenterlocation',
    loadChildren: () => import('./productioncomponents/workcenterlocation/fetchworkcenterlocation/fetchWorkcenterLocation.module').then(m => m.FetchWorkcenterLocationModule)
  },

  {
    path: 'production/wipwarehouse/addwipwarehouse',
    loadChildren: () => import('./productioncomponents/wipwarehouse/addwipwarehouse/addWipWarehouse.module').then(m => m.AddWipWarehouseModule)
  },
  {
    path: 'production/wipwarehouse/addwipwarehouse/:id',
    loadChildren: () => import('./productioncomponents/wipwarehouse/addwipwarehouse/addWipWarehouse.module').then(m => m.AddWipWarehouseModule)
  },

  {
    path: 'production/wipwarehouse/fetchwipwarehouse',
    loadChildren: () => import('./productioncomponents/wipwarehouse/fetchwipwarehouse/fetchWipWarehouse.module').then(m => m.FetchWipWarehouseModule)
  },

  {
    path: 'production/bomgroup/addbomgroup',
    loadChildren: () => import('./productioncomponents/bomgroup/addbomgroup/addBomGroup.module').then(m => m.AddBomGroupModule)
  },
  {
    path: 'production/bomgroup/addbomgroup/:id',
    loadChildren: () => import('./productioncomponents/bomgroup/addbomgroup/addBomGroup.module').then(m => m.AddBomGroupModule)
  },

  {
    path: 'production/bomgroup/fetchbomgroup',
    loadChildren: () => import('./productioncomponents/bomgroup/fetchbomgroup/fetchBomGroup.module').then(m => m.FetchBomGroupModule)
  },
  {
    path: 'production/routinggroup/addroutinggroup',
    loadChildren: () => import('./productioncomponents/routinggroup/addroutinggroup/addRoutingGroup.module').then(m => m.AddRoutingGroupModule)
  },
  {
    path: 'production/routinggroup/addroutinggroup/:id',
    loadChildren: () => import('./productioncomponents/routinggroup/addroutinggroup/addRoutingGroup.module').then(m => m.AddRoutingGroupModule)
  },

  {
    path: 'production/routinggroup/fetchroutinggroup',
    loadChildren: () => import('./productioncomponents/routinggroup/fetchroutinggroup/fetchRoutingGroup.module').then(m => m.FetchRoutingGroupModule)
  },
  //
  {
    path: 'production/productionbom/addproductionbom',
    loadChildren: () => import('./productioncomponents/productionbom/addproductionbom/addProductionBom.module').then(m => m.AddProductionBomModule)
  },
  {
    path: 'production/productionbom/addproductionbom/:id',
    loadChildren: () => import('./productioncomponents/productionbom/addproductionbom/addProductionBom.module').then(m => m.AddProductionBomModule)
  },

  {
    path: 'production/productionbom/fetchproductionbom',
    loadChildren: () => import('./productioncomponents/productionbom/fetchproductionbom/fetchProductionBom.module').then(m => m.FetchProductionBomModule)
  },
  //
  {
    path: 'production/productionoperation/addproductionoperation',
    loadChildren: () => import('./productioncomponents/productionoperation/addproductionoperation/addProductionOperation.module').then(m => m.AddProductionOperationModule)
  },
  {
    path: 'production/productionoperation/addproductionoperation/:id',
    loadChildren: () => import('./productioncomponents/productionoperation/addproductionoperation/addProductionOperation.module').then(m => m.AddProductionOperationModule)
  },

  {
    path: 'production/productionoperation/fetchproductionoperation',
    loadChildren: () => import('./productioncomponents/productionoperation/fetchproductionoperation/fetchProductionOperation.module').then(m => m.FetchProductionOperationModule)
  },
  {
    path: 'production/productionrouting/addproductionrouting',
    loadChildren: () => import('./productioncomponents/productionrouting/addproductionrouting/addProductionRouting.module').then(m => m.AddProductionRoutingModule)
  },
  {
    path: 'production/productionrouting/addproductionrouting/:id',
    loadChildren: () => import('./productioncomponents/productionrouting/addproductionrouting/addProductionRouting.module').then(m => m.AddProductionRoutingModule)
  },

  {
    path: 'production/productionrouting/fetchproductionrouting',
    loadChildren: () => import('./productioncomponents/productionrouting/fetchproductionrouting/fetchProductionRouting.module').then(m => m.FetchProductionRoutingModule)
  },
  {
    path: 'production/itemwiserouting/additemwiserouting',
    loadChildren: () => import('./productioncomponents/itemwiserouting/additemwiserouting/addItemWiseRouting.module').then(m => m.AddItemWiseRoutingModule)
  },
  {
    path: 'production/itemwiserouting/additemwiserouting/:id',
    loadChildren: () => import('./productioncomponents/itemwiserouting/additemwiserouting/addItemWiseRouting.module').then(m => m.AddItemWiseRoutingModule)
  },

  {
    path: 'production/itemwiserouting/fetchitemwiserouting',
    loadChildren: () => import('./productioncomponents/itemwiserouting/fetchitemwiserouting/fetchItemWiseRouting.module').then(m => m.FetchItemWiseRoutingModule)
  },
  {
    path: 'production/workcenter/addworkcenter',
    loadChildren: () => import('./productioncomponents/workcenter/addworkcenter/addWorkCenter.module').then(m => m.AddWorkCenterModule)
  },
  {
    path: 'production/workcenter/addworkcenter/:id',
    loadChildren: () => import('./productioncomponents/workcenter/addworkcenter/addWorkCenter.module').then(m => m.AddWorkCenterModule)
  },

  {
    path: 'production/workcenter/fetchworkcenter',
    loadChildren: () => import('./productioncomponents/workcenter/fetchworkcenter/fetchWorkCenter.module').then(m => m.FetchWorkCenterModule)
  },
  {
    path: 'production/resource/addresource',
    loadChildren: () => import('./productioncomponents/resource/addresource/addResource.module').then(m => m.AddResourceModule)
  },
  {
    path: 'production/resource/addresource/:id',
    loadChildren: () => import('./productioncomponents/resource/addresource/addResource.module').then(m => m.AddResourceModule)
  },

  {
    path: 'production/resource/fetchresource',
    loadChildren: () => import('./productioncomponents/resource/fetchresource/fetchResource.module').then(m => m.FetchResourceModule)
  },
  {
    path: 'production/routingbom/addroutingbom',
    loadChildren: () => import('./productioncomponents/routingbom/addroutingbom/addRoutingBom.module').then(m => m.AddRoutingBomModule)
  },
  {
    path: 'production/routingbom/addroutingbom/:id',
    loadChildren: () => import('./productioncomponents/routingbom/addroutingbom/addRoutingBom.module').then(m => m.AddRoutingBomModule)
  },

  {
    path: 'production/routingbom/fetchroutingbom',
    loadChildren: () => import('./productioncomponents/routingbom/fetchroutingbom/fetchRoutingBom.module').then(m => m.FetchRoutingBomModule)
  },
  {
    path: 'production/productionscheduling/addproductionscheduling',
    loadChildren: () => import('./productioncomponents/productionscheduling/addproductionscheduling/addProductionScheduling.module').then(m => m.AddProductionSchedulingModule)
  },
  {
    path: 'production/productionscheduling/addproductionscheduling/:id',
    loadChildren: () => import('./productioncomponents/productionscheduling/addproductionscheduling/addProductionScheduling.module').then(m => m.AddProductionSchedulingModule)
  },

  {
    path: 'production/productionscheduling/fetchproductionscheduling',
    loadChildren: () => import('./productioncomponents/productionscheduling/fetchproductionscheduling/fetchProductionScheduling.module').then(m => m.FetchProductionSchedulingModule)
  },

  {
    path: 'production/plannedorderrelease/addplannedorderrelease',
    loadChildren: () => import('./productioncomponents/plannedorderrelease/addplannedorderrelease/addPlannedOrderRelease.module').then(m => m.AddPlannedOrderReleaseModule)
  },
  {
    path: 'production/plannedorderrelease/addplannedorderrelease/:id',
    loadChildren: () => import('./productioncomponents/plannedorderrelease/addplannedorderrelease/addPlannedOrderRelease.module').then(m => m.AddPlannedOrderReleaseModule)
  },

  {
    path: 'production/plannedorderrelease/fetchplannedorderrelease',
    loadChildren: () => import('./productioncomponents/plannedorderrelease/fetchplannedorderrelease/fetchPlannedOrderRelease.module').then(m => m.FetchPlannedOrderReleaseModule)
  },

  {
    path: 'production/productionorder/addproductionorder',
    loadChildren: () => import('./productioncomponents/productionorder/addproductionorder/addProductionOrder.module').then(m => m.AddProductionOrderModule)
  },
  {
    path: 'production/productionorder/addproductionorder/:id',
    loadChildren: () => import('./productioncomponents/productionorder/addproductionorder/addProductionOrder.module').then(m => m.AddProductionOrderModule)
  },

  {
    path: 'production/productionorder/fetchproductionorder',
    loadChildren: () => import('./productioncomponents/productionorder/fetchproductionorder/fetchProductionOrder.module').then(m => m.FetchProductionOrderModule)
  },

  {
    path: 'production/jobcard/addjobcard',
    loadChildren: () => import('./productioncomponents/jobcard/addjobcard/addJobCard.module').then(m => m.AddJobCardModule)
  },
  {
    path: 'production/jobcard/addjobcard/:id',
    loadChildren: () => import('./productioncomponents/jobcard/addjobcard/addJobCard.module').then(m => m.AddJobCardModule)
  },

  {
    path: 'production/jobcard/fetchjobcard',
    loadChildren: () => import('./productioncomponents/jobcard/fetchjobcard/fetchJobCard.module').then(m => m.FetchJobCardModule)
  },
  //
  {
    path: 'production/productionordersettlement/addproductionordersettlement',
    loadChildren: () => import('./productioncomponents/productionordersettlement/addproductionordersettlement/addProductionOrderSettlement.module').then(m => m.AddProductionOrderSettlementModule)
  },
  {
    path: 'production/productionordersettlement/addproductionordersettlement/:id',
    loadChildren: () => import('./productioncomponents/productionordersettlement/addproductionordersettlement/addProductionOrderSettlement.module').then(m => m.AddProductionOrderSettlementModule)
  },

  {
    path: 'production/productionordersettlement/fetchproductionordersettlement',
    loadChildren: () => import('./productioncomponents/productionordersettlement/fetchproductionordersettlement/fetchProductionOrderSettlement.module').then(m => m.FetchProductionOrderSettlementModule)
  },

  //  {
  //    path: 'carrenting/vehicle/addvehicle',
  //    loadChildren: () => import('./carrentingcomponents/vehicle/addvehicle/addVehicle.module').then(m => m.AddVehicleModule)
  //  },
  //  {
  //    path: 'carrenting/vehicle/addvehicle/:id',
  //    loadChildren: () => import('./carrentingcomponents/vehicle/addvehicle/addVehicle.module').then(m => m.AddVehicleModule)
  //  },

  //  {
  //    path: 'carrenting/vehicle/fetchvehicle',
  //    loadChildren: () => import('./carrentingcomponents/vehicle/fetchvehicle/fetchVehicle.module').then(m => m.FetchVehicleModule)
  //  },
  //  {
  //    path: 'carrenting/carrentingrates/addcarrentingrates',
  //    loadChildren: () => import('./carrentingcomponents/carrentingrates/addcarrentingrates/addCarRentingRates.module').then(m => m.AddCarRentingRatesModule)
  //  },
  //  {
  //    path: 'carrenting/carrentingrates/addcarrentingrates/:id',
  //    loadChildren: () => import('./carrentingcomponents/carrentingrates/addcarrentingrates/addCarRentingRates.module').then(m => m.AddCarRentingRatesModule)
  //  },

  //  {
  //    path: 'carrenting/carrentingrates/fetchcarrentingrates',
  //    loadChildren: () => import('./carrentingcomponents/carrentingrates/fetchcarrentingrates/fetchCarRentingRates.module').then(m => m.FetchCarRentingRatesModule)
  //  },
  //  //
  //  {
  //    path: 'carrenting/carreservation/addcarreservation',
  //    loadChildren: () => import('./carrentingcomponents/carreservation/addcarreservation/addCarReservation.module').then(m => m.addCarReservationModule)
  //  },
  //  {
  //    path: 'carrenting/carreservation/addcarreservation/:id',
  //    loadChildren: () => import('./carrentingcomponents/carreservation/addcarreservation/addCarReservation.module').then(m => m.addCarReservationModule)
  //  },

  //  {
  //    path: 'carrenting/carreservation/fetchcarreservation',
  //    loadChildren: () => import('./carrentingcomponents/carreservation/fetchcarreservation/fetchCarReservation.module').then(m => m.fetchCarReservationModule)
  //  },
  //  {
  //    path: 'carrenting/caragreement/addcaragreement',
  //    loadChildren: () => import('./carrentingcomponents/caragreement/addcaragreement/addCarAgreement.module').then(m => m.AddCarAgreementModule)
  //  },
  //  {
  //    path: 'carrenting/caragreement/addcaragreement/:id',
  //    loadChildren: () => import('./carrentingcomponents/caragreement/addcaragreement/addCarAgreement.module').then(m => m.AddCarAgreementModule)
  //  },

  //  {
  //    path: 'carrenting/caragreement/fetchcaragreement',
  //    loadChildren: () => import('./carrentingcomponents/caragreement/fetchcaragreement/fetchCarAgreement.module').then(m => m.FetchCarAgreementModule)
  //  },
  //  {
  //    path: 'sales/salesindent/addsalesindent',
  //    loadChildren: () => import('./salescomponents/salesindent/addsalesindent/addSalesIndent.module').then(m => m.AddSalesIndentModule)
  //  },
  //  {
  //    path: 'sales/salesindent/addsalesindent/:id',
  //    loadChildren: () => import('./salescomponents/salesindent/addsalesindent/addSalesIndent.module').then(m => m.AddSalesIndentModule)
  //  },

  //  {
  //    path: 'sales/salesindent/fetchsalesindent',
  //    loadChildren: () => import('./salescomponents/salesindent/fetchsalesindent/fetchSalesIndent.module').then(m => m.FetchSalesIndentModule)
  //  },


  //  {
  //    path: 'finance/salarysheetpreparation/addsalarysheetpreparation',
  //    loadChildren: () => import('./financecomponents/salarysheetpreparation/addsalarysheetpreparation/addSalarySheetPreparation.module').then(m => m.AddSalarySheetPreparationModule)
  //  },
  //  {
  //    path: 'finance/salarysheetpreparation/addsalarysheetpreparation/:id',
  //    loadChildren: () => import('./financecomponents/salarysheetpreparation/addsalarysheetpreparation/addSalarySheetPreparation.module').then(m => m.AddSalarySheetPreparationModule)
  //  },

  //  {
  //    path: 'finance/salarysheetpreparation/fetchsalarysheetpreparation',
  //    loadChildren: () => import('./financecomponents/salarysheetpreparation/fetchsalarysheetpreparation/fetchSalarySheetPreparation.module').then(m => m.FetchSalarySheetPreparationModule)
  //  },
  //  {
  //    path: 'general/featureusergroup/addfeatureusergroup',
  //    loadChildren: () => import('./generalcomponents/featureusergroup/addfeatureusergroup/addfeatureusergroup.module').then(m => m.FeatureUserGroupModule)
  //  },
  //  {
  //    path: 'general/featureusergroup/addfeatureusergroup/:id',
  //    loadChildren: () => import('./generalcomponents/featureusergroup/addfeatureusergroup/addfeatureusergroup.module').then(m => m.FeatureUserGroupModule)
  //  },

  //  {
  //    path: 'cms/containerreceiptnote/addcontainerreceiptnote',
  //    loadChildren: () => import('./cmscomponents/containerreceiptnote/addcontainerreceiptnote/addContainerReceiptNote.module').then(m => m.AddContainerReceiptNoteModule)
  //  },
  //  {
  //    path: 'cms/containerreceiptnote/addcontainerreceiptnote/:id',
  //    loadChildren: () => import('./cmscomponents/containerreceiptnote/addcontainerreceiptnote/addContainerReceiptNote.module').then(m => m.AddContainerReceiptNoteModule)
  //  },

  //  {
  //    path: 'cms/containerreceiptnote/fetchcontainerreceiptnote',
  //    loadChildren: () => import('./cmscomponents/containerreceiptnote/fetchcontainerreceiptnote/fetchContainerReceiptNote.module').then(m => m.FetchContainerReceiptNoteModule)
  //  },

  //  {
  //    path: 'cms/containerdeliverynote/addcontainerdeliverynote',
  //    loadChildren: () => import('./cmscomponents/containerdeliverynote/addcontainerdeliverynote/addContainerDeliveryNote.module').then(m => m.AddContainerDeliveryNoteModule)
  //  },
  //  {
  //    path: 'cms/containerdeliverynote/addcontainerdeliverynote/:id',
  //    loadChildren: () => import('./cmscomponents/containerdeliverynote/addcontainerdeliverynote/addContainerDeliveryNote.module').then(m => m.AddContainerDeliveryNoteModule)
  //  },

  //  {
  //    path: 'cms/containerdeliverynote/fetchcontainerdeliverynote',
  //    loadChildren: () => import('./cmscomponents/containerdeliverynote/fetchcontainerdeliverynote/fetchContainerDeliveryNote.module').then(m => m.FetchContainerDeliveryNoteModule)
  //  },

  //  {
  //    path: 'cms/containerinvoice/addcontainerinvoice',
  //    loadChildren: () => import('./cmscomponents/containerinvoice/addcontainerinvoice/addContainerInvoice.module').then(m => m.AddContainerInvoiceModule)
  //  },
  //  {
  //    path: 'cms/containerinvoice/addcontainerinvoice/:id',
  //    loadChildren: () => import('./cmscomponents/containerinvoice/addcontainerinvoice/addContainerInvoice.module').then(m => m.AddContainerInvoiceModule)
  //  },

  //  {
  //    path: 'cms/containerinvoice/fetchcontainerinvoice',
  //    loadChildren: () => import('./cmscomponents/containerinvoice/fetchcontainerinvoice/fetchContainerInvoice.module').then(m => m.FetchContainerInvoiceModule)
  //  },

  {
    path: 'report/singlereport/transactionreport/:id/:code',
    loadChildren: () => import('./singleprintreport/singlereportpage/singleReportPage.module').then(m => m.SingleReportPageModule)
  },
  {
    path: 'report/singlereport/transactionreport/:id/:code/:isView',
    loadChildren: () => import('./singleprintreport/singlereportpage/singleReportPage.module').then(m => m.SingleReportPageModule)
  },

  //  {
  //    path: 'sales/salesconfiguration/addsalesconfiguration',
  //    loadChildren: () => import('./salescomponents/salesconfiguration/addsalesconfiguration/addSalesConfiguration.module').then(m => m.AddSalesConfigurationModule)
  //  },
  //  {
  //    path: 'sales/salesconfiguration/addsalesconfiguration/:id',
  //    loadChildren: () => import('./salescomponents/salesconfiguration/addsalesconfiguration/addSalesConfiguration.module').then(m => m.AddSalesConfigurationModule)
  //  },

  //  {
  //    path: 'sales/salesconfiguration/fetchsalesconfiguration',
  //    loadChildren: () => import('./salescomponents/salesconfiguration/fetchsalesconfiguration/fetchSalesConfiguration.module').then(m => m.FetchSalesConfigurationModule)
  //  },

  //  {
  //    path: 'cms/containercontract/addcontainercontract',
  //    loadChildren: () => import('./cmscomponents/containercontract/addcontainercontract/addContainerContract.module').then(m => m.AddContainerContractModule)
  //  },
  //  {
  //    path: 'cms/containercontract/addcontainercontract/:id',
  //    loadChildren: () => import('./cmscomponents/containercontract/addcontainercontract/addContainerContract.module').then(m => m.AddContainerContractModule)
  //  },

  //  {
  //    path: 'cms/containercontract/fetchcontainercontract',
  //    loadChildren: () => import('./cmscomponents/containercontract/fetchcontainercontract/fetchContainerContract.module').then(m => m.FetchContainerContractModule)
  //  },
  //  {
  //    path: 'cms/containerconfiguration/addcontainerconfiguration',
  //    loadChildren: () => import('./cmscomponents/containerconfiguration/addcontainerconfiguration/addContainerConfiguration.module').then(m => m.AddContainerConfigurationModule)
  //  },
  //  {
  //    path: 'cms/containerconfiguration/addcontainerconfiguration/:id',
  //    loadChildren: () => import('./cmscomponents/containerconfiguration/addcontainerconfiguration/addContainerConfiguration.module').then(m => m.AddContainerConfigurationModule)
  //  },

  //  {
  //    path: 'cms/containerconfiguration/fetchcontainerconfiguration',
  //    loadChildren: () => import('./cmscomponents/containerconfiguration/fetchcontainerconfiguration/fetchContainerConfiguration.module').then(m => m.FetchContainerConfigurationModule)
  //  },

  //  {
  //    path: 'general/workflowmaster/addworkflowmaster',
  //    loadChildren: () => import('./generalcomponents/workflowmaster/addworkflowmaster/addWorkFlowMaster.module').then(m => m.AddWorkFlowMasterModule)
  //  },
  //  {
  //    path: 'general/workflowmaster/addworkflowmaster/:id',
  //    loadChildren: () => import('./generalcomponents/workflowmaster/addworkflowmaster/addWorkFlowMaster.module').then(m => m.AddWorkFlowMasterModule)
  //  },

  //  {
  //    path: 'general/workflowmaster/fetchworkflowmaster',
  //    loadChildren: () => import('./generalcomponents/workflowmaster/fetchworkflowmaster/fetchWorkFlowMaster.module').then(m => m.FetchWorkFlowMasterModule)
  //  },
  //  {
  //    path: 'procurement/loadingrequest/addloadingrequest',
  //    loadChildren: () => import('./procurementcomponents/loadingrequest/addloadingrequest/addLoadingRequest.module').then(m => m.AddLoadingRequestModule)
  //  },
  //  {
  //    path: 'procurement/loadingrequest/addloadingrequest/:id',
  //    loadChildren: () => import('./procurementcomponents/loadingrequest/addloadingrequest/addLoadingRequest.module').then(m => m.AddLoadingRequestModule)
  //  },

  //  {
  //    path: 'procurement/loadingrequest/fetchloadingrequest',
  //    loadChildren: () => import('./procurementcomponents/loadingrequest/fetchloadingrequest/fetchLoadingRequest.module').then(m => m.FetchLoadingRequestModule)
  //  },

  {
    path: 'procurement/transportcharges/addtransportcharges',
    loadChildren: () => import('./procurementcomponents/transportcharges/addtransportcharges/addTransportCharges.module').then(m => m.AddTransportChargesModule)
  },
  {
    path: 'procurement/transportcharges/addtransportcharges/:id',
    loadChildren: () => import('./procurementcomponents/transportcharges/addtransportcharges/addTransportCharges.module').then(m => m.AddTransportChargesModule)
  },
  {
    path: 'procurement/transportcharges/fetchtransportcharges',
    loadChildren: () => import('./procurementcomponents/transportcharges/fetchtransportcharges/fetchTransportCharges.module').then(m => m.FetchTransportChargesModule)
  },
  //
  {
    path: 'procurement/transportchargesadvance/addtransportchargesadvance',
    loadChildren: () => import('./procurementcomponents/transportchargesadvance/addtransportchargesadvance/addTransportChargesAdvance.module').then(m => m.AddTransportChargesAdvanceModule)
  },
  {
    path: 'procurement/transportchargesadvance/addtransportchargesadvance/:id',
    loadChildren: () => import('./procurementcomponents/transportchargesadvance/addtransportchargesadvance/addTransportChargesAdvance.module').then(m => m.AddTransportChargesAdvanceModule)
  },
  {
    path: 'procurement/transportchargesadvance/fetchtransportchargesadvance',
    loadChildren: () => import('./procurementcomponents/transportchargesadvance/fetchtransportchargesadvance/fetchTransportChargesAdvance.module').then(m => m.FetchTransportChargesAdvanceModule)
  },
  //
  {
    path: 'procurement/transportchargesfinal/addtransportchargesfinal',
    loadChildren: () => import('./procurementcomponents/transportchargesfinal/addtransportchargesfinal/addTransportChargesFinal.module').then(m => m.AddTransportChargesFinalModule)
  },
  {
    path: 'procurement/transportchargesfinal/addtransportchargesfinal/:id',
    loadChildren: () => import('./procurementcomponents/transportchargesfinal/addtransportchargesfinal/addTransportChargesFinal.module').then(m => m.AddTransportChargesFinalModule)
  },
  {
    path: 'procurement/transportchargesfinal/fetchtransportchargesfinal',
    loadChildren: () => import('./procurementcomponents/transportchargesfinal/fetchtransportchargesfinal/fetchTransportChargesFinal.module').then(m => m.FetchTransportChargesFinalModule)
  },

  //  {
  //    path: 'operations/commercialtruckmaster/addcommercialtruckmaster',
  //    loadChildren: () => import('./operationscomponents/commercialtruckmaster/addcommercialtruckmaster/addCommercialTruckMaster.module').then(m => m.AddCommercialTruckMasterModule)
  //  },
  //  {
  //    path: 'operations/commercialtruckmaster/addcommercialtruckmaster/:id',
  //    loadChildren: () => import('./operationscomponents/commercialtruckmaster/addcommercialtruckmaster/addCommercialTruckMaster.module').then(m => m.AddCommercialTruckMasterModule)
  //  },

  //  {
  //    path: 'operations/commercialtruckmaster/fetchcommercialtruckmaster',
  //    loadChildren: () => import('./operationscomponents/commercialtruckmaster/fetchcommercialtruckmaster/fetchCommercialTruckMaster.module').then(m => m.FetchCommercialTruckMasterModule)
  //  },

  //  {
  //    path: 'sales/deliverynoteschedule/adddeliverynoteschedule',
  //    loadChildren: () => import('./salescomponents/deliverynoteschedule/adddeliverynoteschedule/addDeliveryNoteSchedule.module').then(m => m.AddDeliveryNoteScheduleModule)
  //  },
  //  {
  //    path: 'sales/deliverynoteschedule/adddeliverynoteschedule/:id',
  //    loadChildren: () => import('./salescomponents/deliverynoteschedule/adddeliverynoteschedule/addDeliveryNoteSchedule.module').then(m => m.AddDeliveryNoteScheduleModule)
  //  },
  //  {
  //    path: 'sales/deliverynoteschedule/fetchdeliverynoteschedule',
  //    loadChildren: () => import('./salescomponents/deliverynoteschedule/fetchdeliverynoteschedule/fetchDeliveryNoteSchedule.module').then(m => m.FetchDeliveryNoteScheduleModule)
  //  },


  //  {
  //    path: 'inventory/itemmasterproduction/additemmasterproduction',
  //    loadChildren: () => import('./inventorycomponents/itemmasterproduction/additemmasterproduction/addItemMasterProduction.module').then(m => m.AddItemMasterProductionModule)
  //  },
  //  {
  //    path: 'inventory/itemmasterproduction/additemmasterproduction/:id',
  //    loadChildren: () => import('./inventorycomponents/itemmasterproduction/additemmasterproduction/addItemMasterProduction.module').then(m => m.AddItemMasterProductionModule)
  //  },

  //  {
  //    path: 'inventory/itemmasterproduction/fetchitemmasterproduction',
  //    loadChildren: () => import('./inventorycomponents/itemmasterproduction/fetchitemmasterproduction/fetchItemMasterProduction.module').then(m => m.FetchItemMasterProductionModule)
  //  },

  //  {
  //    path: 'report/analyticsreport',
  //    loadChildren: () => import('./reports/analyticsreport/analyticsReportPage.module').then(m => m.AnalyticsReportPageModule)
  //  },


  //  {
  //    path: 'general/userwarehousemapping/adduserwarehousemapping',
  //    loadChildren: () => import('./generalcomponents/userwarehousemapping/adduserwarehousemapping/addUserWareHouseMapping.module').then(m => m.AddUserWareHouseMappingModule)
  //  },
  //  {
  //    path: 'general/userwarehousemapping/adduserwarehousemapping/:id',
  //    loadChildren: () => import('./generalcomponents/userwarehousemapping/adduserwarehousemapping/addUserWareHouseMapping.module').then(m => m.AddUserWareHouseMappingModule)
  //  },

  //  {
  //    path: 'general/userwarehousemapping/fetchuserwarehousemapping',
  //    loadChildren: () => import('./generalcomponents/userwarehousemapping/fetchuserwarehousemapping/fetchUserWareHouseMapping.module').then(m => m.FetchUserWareHouseMappingModule)
  //  },

  //  {
  //    path: 'general/useraccountmapping/adduseraccountmapping',
  //    loadChildren: () => import('./generalcomponents/useraccountmapping/adduseraccountmapping/addUserAccountMapping.module').then(m => m.AddUserAccountMappingModule)
  //  },
  //  {
  //    path: 'general/useraccountmapping/adduseraccountmapping/:id',
  //    loadChildren: () => import('./generalcomponents/useraccountmapping/adduseraccountmapping/addUserAccountMapping.module').then(m => m.AddUserAccountMappingModule)
  //  },

  //  {
  //    path: 'general/useraccountmapping/fetchuseraccountmapping',
  //    loadChildren: () => import('./generalcomponents/useraccountmapping/fetchuseraccountmapping/fetchUserAccountMapping.module').then(m => m.FetchUserAccountMappingModule)
  //  },

  //  {
  //    path: 'general/userbankcashaccountmapping/adduserbankcashaccountmapping',
  //    loadChildren: () => import('./generalcomponents/userbankcashaccountmapping/adduserbankcashaccountmapping/addUserBankCashAccountMapping.module').then(m => m.AddUserBankCashAccountMappingModule)
  //  },
  //  {
  //    path: 'general/userbankcashaccountmapping/adduserbankcashaccountmapping/:id',
  //    loadChildren: () => import('./generalcomponents/userbankcashaccountmapping/adduserbankcashaccountmapping/addUserBankCashAccountMapping.module').then(m => m.AddUserBankCashAccountMappingModule)
  //  },

  //  {
  //    path: 'general/userbankcashaccountmapping/fetchuserbankcashaccountmapping',
  //    loadChildren: () => import('./generalcomponents/userbankcashaccountmapping/fetchuserbankcashaccountmapping/fetchUserBankCashAccountMapping.module').then(m => m.FetchUserBankCashAccountMappingModule)
  //  },

  //  {
  //    path: 'inventory/productionissue/addproductionissue',
  //    loadChildren: () => import('./inventorycomponents/productionissue/addproductionissue/addProductionIssue.module').then(m => m.AddProductionIssueModule)
  //  },
  //  {
  //    path: 'inventory/productionissue/addproductionissue/:id',
  //    loadChildren: () => import('./inventorycomponents/productionissue/addproductionissue/addProductionIssue.module').then(m => m.AddProductionIssueModule)
  //  },

  //  {
  //    path: 'inventory/productionissue/fetchproductionissue',
  //    loadChildren: () => import('./inventorycomponents/productionissue/fetchproductionissue/fetchProductionIssue.module').then(m => m.FetchProductionIssueModule)
  //  },

  //  {
  //    path: 'inventory/productionreceipt/addproductionreceipt',
  //    loadChildren: () => import('./inventorycomponents/productionreceipt/addproductionreceipt/addProductionReceipt.module').then(m => m.AddProductionReceiptModule)
  //  },
  //  {
  //    path: 'inventory/productionreceipt/addproductionreceipt/:id',
  //    loadChildren: () => import('./inventorycomponents/productionreceipt/addproductionreceipt/addProductionReceipt.module').then(m => m.AddProductionReceiptModule)
  //  },

  //  {
  //    path: 'inventory/productionreceipt/fetchproductionreceipt',
  //    loadChildren: () => import('./inventorycomponents/productionreceipt/fetchproductionreceipt/fetchProductionReceipt.module').then(m => m.FetchProductionReceiptModule)
  //  },

  //  {
  //    path: 'inventory/productionorder/addproductionorder',
  //    loadChildren: () => import('./inventorycomponents/productionorder/addproductionorder/addProductionOrder.module').then(m => m.AddProductionOrderModule)
  //  },
  //  {
  //    path: 'inventory/productionorder/addproductionorder/:id',
  //    loadChildren: () => import('./inventorycomponents/productionorder/addproductionorder/addProductionOrder.module').then(m => m.AddProductionOrderModule)
  //  },

  //  {
  //    path: 'inventory/productionorder/fetchproductionorder',
  //    loadChildren: () => import('./inventorycomponents/productionorder/fetchproductionorder/fetchProductionOrder.module').then(m => m.FetchProductionOrderModule)
  //  },

  {
    path: 'production/productionreceipts/addproductionreceipts',
    loadChildren: () => import('./productioncomponents/productionreceipts/addproductionreceipts/addProductionReceipts.module').then(m => m.AddProductionReceiptsModule)
  },
  {
    path: 'production/productionreceipts/addproductionreceipts/:id',
    loadChildren: () => import('./productioncomponents/productionreceipts/addproductionreceipts/addProductionReceipts.module').then(m => m.AddProductionReceiptsModule)
  },
  {
    path: 'production/productionreceipts/fetchproductionreceipts',
    loadChildren: () => import('./productioncomponents/productionreceipts/fetchproductionreceipts/fetchProductionReceipts.module').then(m => m.FetchProductionReceiptsModule)
  },

  //  {
  //    path: 'procurement/vendorpaymentrequest/addvendorpaymentrequest',
  //    loadChildren: () => import('./procurementcomponents/vendorpaymentrequest/addvendorpaymentrequest/addVendorPaymentRequest.module').then(m => m.AddVendorPaymentRequestModule)
  //  },
  //  {
  //    path: 'procurement/vendorpaymentrequest/addvendorpaymentrequest/:id',
  //    loadChildren: () => import('./procurementcomponents/vendorpaymentrequest/addvendorpaymentrequest/addVendorPaymentRequest.module').then(m => m.AddVendorPaymentRequestModule)
  //  },

  //  {
  //    path: 'procurement/vendorpaymentrequest/fetchvendorpaymentrequest',
  //    loadChildren: () => import('./procurementcomponents/vendorpaymentrequest/fetchvendorpaymentrequest/fetchVendorPaymentRequest.module').then(m => m.FetchVendorPaymentRequestModule)
  //  },

  {
    path: 'general/feature/userreportaccess',
    loadChildren: () => import('./generalcomponents/feature/userreportaccess/userreportaccess.module').then(m => m.UserReportAccessModule)
  },

  //  {
  //    path: 'finance/employeepayment/addemployeepayment',
  //    loadChildren: () => import('./financecomponents/employeepayment/addemployeepayment/addEmployeePayment.module').then(m => m.AddEmployeePaymentModule)
  //  },
  //  {
  //    path: 'finance/employeepayment/addemployeepayment/:id',
  //    loadChildren: () => import('./financecomponents/employeepayment/addemployeepayment/addEmployeePayment.module').then(m => m.AddEmployeePaymentModule)
  //  },

  //  {
  //    path: 'finance/employeepayment/fetchemployeepayment',
  //    loadChildren: () => import('./financecomponents/employeepayment/fetchemployeepayment/fetchEmployeePayment.module').then(m => m.FetchEmployeePaymentModule)
  //  },

  //  {
  //    path: 'finance/employeereceipt/addemployeereceipt',
  //    loadChildren: () => import('./financecomponents/employeereceipt/addemployeereceipt/addEmployeeReceipt.module').then(m => m.AddEmployeeReceiptModule)
  //  },
  //  {
  //    path: 'finance/employeereceipt/addemployeereceipt/:id',
  //    loadChildren: () => import('./financecomponents/employeereceipt/addemployeereceipt/addEmployeeReceipt.module').then(m => m.AddEmployeeReceiptModule)
  //  },

  //  {
  //    path: 'finance/employeereceipt/fetchemployeereceipt',
  //    loadChildren: () => import('./financecomponents/employeereceipt/fetchemployeereceipt/fetchEmployeeReceipt.module').then(m => m.FetchEmployeeReceiptModule)
  //  },

  //  //
  //  {
  //    path: 'inventory/stockreceipts/addstockreceipts',
  //    loadChildren: () => import('./inventorycomponents/stockreceipts/addstockreceipts/addStockReceipts.module').then(m => m.AddStockReceiptsModule)
  //  },
  //  {
  //    path: 'inventory/stockreceipts/addstockreceipts/:id',
  //    loadChildren: () => import('./inventorycomponents/stockreceipts/addstockreceipts/addStockReceipts.module').then(m => m.AddStockReceiptsModule)
  //  },

  //  {
  //    path: 'inventory/stockreceipts/fetchstockreceipts',
  //    loadChildren: () => import('./inventorycomponents/stockreceipts/fetchstockreceipts/fetchStockReceipts.module').then(m => m.FetchStockReceiptsModule)
  //  },
  //  //
  //  {
  //    path: 'finance/operationalpaymentrequest/addoperationalpaymentrequest',
  //    loadChildren: () => import('./financecomponents/operationalpaymentrequest/addoperationalpaymentrequest/addOperationalPaymentRequest.module').then(m => m.AddOperationalPaymentRequestModule)
  //  },
  //  {
  //    path: 'finance/operationalpaymentrequest/addoperationalpaymentrequest/:id',
  //    loadChildren: () => import('./financecomponents/operationalpaymentrequest/addoperationalpaymentrequest/addOperationalPaymentRequest.module').then(m => m.AddOperationalPaymentRequestModule)
  //  },

  //  {
  //    path: 'finance/operationalpaymentrequest/fetchoperationalpaymentrequest',
  //    loadChildren: () => import('./financecomponents/operationalpaymentrequest/fetchoperationalpaymentrequest/fetchOperationalPaymentRequest.module').then(m => m.FetchOperationalPaymentRequestModule)
  //  },

  //  {
  //    path: 'operations/weighbridge/addweighbridge',
  //    loadChildren: () => import('./operationscomponents/weighbridge/addweighbridge/addWeighBridge.module').then(m => m.AddWeighBridgeModule)
  //  },
  //  {
  //    path: 'operations/weighbridge/addweighbridge/:id',
  //    loadChildren: () => import('./operationscomponents/weighbridge/addweighbridge/addWeighBridge.module').then(m => m.AddWeighBridgeModule)
  //  },

  //  {
  //    path: 'operations/weighbridge/fetchweighbridge',
  //    loadChildren: () => import('./operationscomponents/weighbridge/fetchweighbridge/fetchWeighBridge.module').then(m => m.FetchWeighBridgeModule)
  //  },


  //  {
  //    path: 'operations/waybill/addwaybill',
  //    loadChildren: () => import('./operationscomponents/waybill/addwaybill/addWayBill.module').then(m => m.AddWayBillModule)
  //  },
  //  {
  //    path: 'operations/waybill/addwaybill/:id',
  //    loadChildren: () => import('./operationscomponents/waybill/addwaybill/addWayBill.module').then(m => m.AddWayBillModule)
  //  },

  //  {
  //    path: 'operations/waybill/fetchwaybill',
  //    loadChildren: () => import('./operationscomponents/waybill/fetchwaybill/fetchWayBill.module').then(m => m.FetchWayBillModule)
  //  },

  //  //
  //  {
  //    path: 'operations/weighbridgesupplier/addweighbridgesupplier',
  //    loadChildren: () => import('./operationscomponents/weighbridgesupplier/addweighbridgesupplier/addWeighBridgeSupplier.module').then(m => m.AddWeighBridgeSupplierModule)
  //  },
  //  {
  //    path: 'operations/weighbridgesupplier/addweighbridgesupplier/:id',
  //    loadChildren: () => import('./operationscomponents/weighbridgesupplier/addweighbridgesupplier/addWeighBridgeSupplier.module').then(m => m.AddWeighBridgeSupplierModule)
  //  },

  //  {
  //    path: 'operations/weighbridgesupplier/fetchweighbridgesupplier',
  //    loadChildren: () => import('./operationscomponents/weighbridgesupplier/fetchweighbridgesupplier/fetchWeighBridgeSupplier.module').then(m => m.FetchWeighBridgeSupplierModule)
  //  },
  //  //
  //  {
  //    path: 'sales/otherinvoice/addotherinvoice',
  //    loadChildren: () => import('./salescomponents/otherinvoice/addotherinvoice/addOtherInvoice.module').then(m => m.AddOtherInvoiceModule)
  //  },
  //  {
  //    path: 'sales/otherinvoice/addotherinvoice/:id',
  //    loadChildren: () => import('./salescomponents/otherinvoice/addotherinvoice/addOtherInvoice.module').then(m => m.AddOtherInvoiceModule)
  //  },

  //  {
  //    path: 'sales/otherinvoice/fetchotherinvoice',
  //    loadChildren: () => import('./salescomponents/otherinvoice/fetchotherinvoice/fetchOtherInvoice.module').then(m => m.FetchOtherInvoiceModule)
  //  },

  //  {
  //    path: 'finance/vendorreceipt/addvendorreceipt',
  //    loadChildren: () => import('./financecomponents/vendorreceipt/addvendorreceipt/addVendorReceipt.module').then(m => m.AddVendorReceiptModule)
  //  },
  //  {
  //    path: 'finance/vendorreceipt/addvendorreceipt/:id',
  //    loadChildren: () => import('./financecomponents/vendorreceipt/addvendorreceipt/addVendorReceipt.module').then(m => m.AddVendorReceiptModule)
  //  },

  //  {
  //    path: 'finance/vendorreceipt/fetchvendorreceipt',
  //    loadChildren: () => import('./financecomponents/vendorreceipt/fetchvendorreceipt/fetchVendorReceipt.module').then(m => m.FetchVendorReceiptModule)
  //  },

  //  {
  //    path: 'qualitycontrol/charecteristics/addcharecteristics',
  //    loadChildren: () => import('./qualitycontrolcomponents/charecteristics/addcharecteristics/addCharecteristics.module').then(m => m.AddCharecteristicsModule)
  //  },
  //  {
  //    path: 'qualitycontrol/charecteristics/addcharecteristics/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/charecteristics/addcharecteristics/addCharecteristics.module').then(m => m.AddCharecteristicsModule)
  //  },

  //  {
  //    path: 'qualitycontrol/charecteristics/fetchcharecteristics',
  //    loadChildren: () => import('./qualitycontrolcomponents/charecteristics/fetchcharecteristics/fetchCharecteristics.module').then(m => m.FetchCharecteristicsModule)
  //  },

  //  {
  //    path: 'qualitycontrol/aspect/addaspect',
  //    loadChildren: () => import('./qualitycontrolcomponents/aspect/addaspect/addAspect.module').then(m => m.AddAspectModule)
  //  },
  //  {
  //    path: 'qualitycontrol/aspect/addaspect/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/aspect/addaspect/addAspect.module').then(m => m.AddAspectModule)
  //  },

  //  {
  //    path: 'qualitycontrol/aspect/fetchaspect',
  //    loadChildren: () => import('./qualitycontrolcomponents/aspect/fetchaspect/fetchAspect.module').then(m => m.FetchAspectModule)
  //  },

  //  {
  //    path: 'qualitycontrol/samplesize/addsamplesize',
  //    loadChildren: () => import('./qualitycontrolcomponents/samplesize/addsamplesize/addSampleSize.module').then(m => m.AddSampleSizeModule)
  //  },
  //  {
  //    path: 'qualitycontrol/samplesize/addsamplesize/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/samplesize/addsamplesize/addSampleSize.module').then(m => m.AddSampleSizeModule)
  //  },

  //  {
  //    path: 'qualitycontrol/samplesize/fetchsamplesize',
  //    loadChildren: () => import('./qualitycontrolcomponents/samplesize/fetchsamplesize/fetchSampleSize.module').then(m => m.FetchSampleSizeModule)
  //  },

  //  {
  //    path: 'qualitycontrol/samplingmethod/addsamplingmethod',
  //    loadChildren: () => import('./qualitycontrolcomponents/samplingmethod/addsamplingmethod/addSamplingMethod.module').then(m => m.AddSamplingMethodModule)
  //  },
  //  {
  //    path: 'qualitycontrol/samplingmethod/addsamplingmethod/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/samplingmethod/addsamplingmethod/addSamplingMethod.module').then(m => m.AddSamplingMethodModule)
  //  },

  //  {
  //    path: 'qualitycontrol/samplingmethod/fetchsamplingmethod',
  //    loadChildren: () => import('./qualitycontrolcomponents/samplingmethod/fetchsamplingmethod/fetchSamplingMethod.module').then(m => m.FetchSamplingMethodModule)
  //  },

  //  {
  //    path: 'qualitycontrol/charsamplingmethod/addcharsamplingmethod',
  //    loadChildren: () => import('./qualitycontrolcomponents/charsamplingmethod/addcharsamplingmethod/addCharSamplingMethod.module').then(m => m.AddCharSamplingMethodModule)
  //  },
  //  {
  //    path: 'qualitycontrol/charsamplingmethod/addcharsamplingmethod/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/charsamplingmethod/addcharsamplingmethod/addCharSamplingMethod.module').then(m => m.AddCharSamplingMethodModule)
  //  },

  //  {
  //    path: 'qualitycontrol/charsamplingmethod/fetchcharsamplingmethod',
  //    loadChildren: () => import('./qualitycontrolcomponents/charsamplingmethod/fetchcharsamplingmethod/fetchCharSamplingMethod.module').then(m => m.FetchCharSamplingMethodModule)
  //  },

  //  {
  //    path: 'qualitycontrol/frequency/addfrequency',
  //    loadChildren: () => import('./qualitycontrolcomponents/frequency/addfrequency/addFrequency.module').then(m => m.AddFrequencyModule)
  //  },
  //  {
  //    path: 'qualitycontrol/frequency/addfrequency/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/frequency/addfrequency/addFrequency.module').then(m => m.AddFrequencyModule)
  //  },

  //  {
  //    path: 'qualitycontrol/frequency/fetchfrequency',
  //    loadChildren: () => import('./qualitycontrolcomponents/frequency/fetchfrequency/fetchFrequency.module').then(m => m.FetchFrequencyModule)
  //  },

  //  {
  //    path: 'qualitycontrol/testplan/addtestplan',
  //    loadChildren: () => import('./qualitycontrolcomponents/testplan/addtestplan/addTestPlan.module').then(m => m.AddTestPlanModule)
  //  },
  //  {
  //    path: 'qualitycontrol/testplan/addtestplan/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/testplan/addtestplan/addTestPlan.module').then(m => m.AddTestPlanModule)
  //  },

  //  {
  //    path: 'qualitycontrol/testplan/fetchtestplan',
  //    loadChildren: () => import('./qualitycontrolcomponents/testplan/fetchtestplan/fetchTestPlan.module').then(m => m.FetchTestPlanModule)
  //  },

  //  {
  //    path: 'qualitycontrol/testgroup/addtestgroup',
  //    loadChildren: () => import('./qualitycontrolcomponents/testgroup/addtestgroup/addTestGroup.module').then(m => m.AddTestGroupModule)
  //  },
  //  {
  //    path: 'qualitycontrol/testgroup/addtestgroup/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/testgroup/addtestgroup/addTestGroup.module').then(m => m.AddTestGroupModule)
  //  },

  //  {
  //    path: 'qualitycontrol/testgroup/fetchtestgroup',
  //    loadChildren: () => import('./qualitycontrolcomponents/testgroup/fetchtestgroup/fetchTestGroup.module').then(m => m.FetchTestGroupModule)
  //  },
  //  //
  //  {
  //    path: 'qualitycontrol/testdefinition/addtestdefinition',
  //    loadChildren: () => import('./qualitycontrolcomponents/testdefinition/addtestdefinition/addTestDefinition.module').then(m => m.AddTestDefinitionModule)
  //  },
  //  {
  //    path: 'qualitycontrol/testdefinition/addtestdefinition/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/testdefinition/addtestdefinition/addTestDefinition.module').then(m => m.AddTestDefinitionModule)
  //  },

  //  {
  //    path: 'qualitycontrol/testdefinition/fetchtestdefinition',
  //    loadChildren: () => import('./qualitycontrolcomponents/testdefinition/fetchtestdefinition/fetchTestDefinition.module').then(m => m.FetchTestDefinitionModule)
  //  },
  //  //
  //  {
  //    path: 'qualitycontrol/itemwisetest/additemwisetest',
  //    loadChildren: () => import('./qualitycontrolcomponents/itemwisetest/additemwisetest/addItemWiseTest.module').then(m => m.AddItemWiseTestModule)
  //  },
  //  {
  //    path: 'qualitycontrol/itemwisetest/additemwisetest/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/itemwisetest/additemwisetest/addItemWiseTest.module').then(m => m.AddItemWiseTestModule)
  //  },

  //  {
  //    path: 'qualitycontrol/itemwisetest/fetchitemwisetest',
  //    loadChildren: () => import('./qualitycontrolcomponents/itemwisetest/fetchitemwisetest/fetchItemWiseTest.module').then(m => m.FetchItemWiseTestModule)
  //  },
  //  //
  //  {
  //    path: 'qualitycontrol/calibrationdefinition/addcalibrationdefinition',
  //    loadChildren: () => import('./qualitycontrolcomponents/calibrationdefinition/addcalibrationdefinition/addCalibrationDefinition.module').then(m => m.AddCalibrationDefinitionModule)
  //  },
  //  {
  //    path: 'qualitycontrol/calibrationdefinition/addcalibrationdefinition/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/calibrationdefinition/addcalibrationdefinition/addCalibrationDefinition.module').then(m => m.AddCalibrationDefinitionModule)
  //  },

  //  {
  //    path: 'qualitycontrol/calibrationdefinition/fetchcalibrationdefinition',
  //    loadChildren: () => import('./qualitycontrolcomponents/calibrationdefinition/fetchcalibrationdefinition/fetchCalibrationDefinition.module').then(m => m.FetchCalibrationDefinitionModule)
  //  },

  //  {
  //    path: 'finance/coaaccount/addcoaaccount',
  //    loadChildren: () => import('./financecomponents/coaaccount/addcoaaccount/addCoaAccount.module').then(m => m.AddCoaAccountModule)
  //  },
  //  {
  //    path: 'finance/coaaccount/addcoaaccount/:id',
  //    loadChildren: () => import('./financecomponents/coaaccount/addcoaaccount/addCoaAccount.module').then(m => m.AddCoaAccountModule)
  //  },

  //  {
  //    path: 'finance/coaaccount/fetchcoaaccount',
  //    loadChildren: () => import('./financecomponents/coaaccount/fetchcoaaccount/fetchCoaAccount.module').then(m => m.FetchCoaAccountModule)
  //  },
  //  {
  //    path: 'finance/coacompanymapping/fetchcoacompanymapping',
  //    loadChildren: () => import('./financecomponents/companymapping/CompanyMapping.module').then(m => m.CompanyMappingModule)
  //  },

  //  {
  //    path: 'finance/coacompanymapping/fetchcoacompanymapping',
  //    loadChildren: () => import('./financecomponents/companymapping/CompanyMapping.module').then(m => m.CompanyMappingModule)
  //  },

  //  {
  //    path: 'cms/containerproformainvoice/addcontainerproformainvoice',
  //    loadChildren: () => import('./cmscomponents/containerproformainvoice/addcontainerproformainvoice/addContainerProformaInvoice.module').then(m => m.AddContainerProformaInvoiceModule)
  //  },
  //  {
  //    path: 'cms/containerproformainvoice/addcontainerproformainvoice/:id',
  //    loadChildren: () => import('./cmscomponents/containerproformainvoice/addcontainerproformainvoice/addContainerProformaInvoice.module').then(m => m.AddContainerProformaInvoiceModule)
  //  },

  //  {
  //    path: 'cms/containerproformainvoice/fetchcontainerproformainvoice',
  //    loadChildren: () => import('./cmscomponents/containerproformainvoice/fetchcontainerproformainvoice/fetchContainerProformaInvoice.module').then(m => m.FetchContainerProformaInvoiceModule)
  //  },
  //  {
  //    path: 'qualitycontrol/silocode/addsilocode',
  //    loadChildren: () => import('./qualitycontrolcomponents/silocode/addsilocode/addSiloCode.module').then(m => m.AddSiloCodeModule)
  //  },
  //  {
  //    path: 'qualitycontrol/silocode/addsilocode/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/silocode/addsilocode/addSiloCode.module').then(m => m.AddSiloCodeModule)
  //  },

  //  {
  //    path: 'qualitycontrol/silocode/fetchsilocode',
  //    loadChildren: () => import('./qualitycontrolcomponents/silocode/fetchsilocode/fetchSiloCode.module').then(m => m.FetchSiloCodeModule)
  //  },
  //  {
  //    path: 'qualitycontrol/flourtype/addflourtype',
  //    loadChildren: () => import('./qualitycontrolcomponents/flourtype/addflourtype/addFlourType.module').then(m => m.AddFlourTypeModule)
  //  },
  //  {
  //    path: 'qualitycontrol/flourtype/addflourtype/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/flourtype/addflourtype/addFlourType.module').then(m => m.AddFlourTypeModule)
  //  },

  //  {
  //    path: 'qualitycontrol/flourtype/fetchflourtype',
  //    loadChildren: () => import('./qualitycontrolcomponents/flourtype/fetchflourtype/fetchFlourType.module').then(m => m.FetchFlourTypeModule)
  //  },
  //  {
  //    path: 'qualitycontrol/flouraspect/addflouraspect',
  //    loadChildren: () => import('./qualitycontrolcomponents/flouraspect/addflouraspect/addFlourAspect.module').then(m => m.AddFlourAspectModule)
  //  },
  //  {
  //    path: 'qualitycontrol/flouraspect/addflouraspect/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/flouraspect/addflouraspect/addFlourAspect.module').then(m => m.AddFlourAspectModule)
  //  },

  //  {
  //    path: 'qualitycontrol/flouraspect/fetchflouraspect',
  //    loadChildren: () => import('./qualitycontrolcomponents/flouraspect/fetchflouraspect/fetchFlourAspect.module').then(m => m.FetchFlourAspectModule)
  //  },
  //  //
  //  {
  //    path: 'operations/speedviolation/addspeedviolation',
  //    loadChildren: () => import('./operationscomponents/speedviolation/addspeedviolation/addSpeedViolation.module').then(m => m.AddSpeedViolationModule)
  //  },
  //  {
  //    path: 'operations/speedviolation/addspeedviolation/:id',
  //    loadChildren: () => import('./operationscomponents/speedviolation/addspeedviolation/addSpeedViolation.module').then(m => m.AddSpeedViolationModule)
  //  },

  //  {
  //    path: 'operations/speedviolation/fetchspeedviolation',
  //    loadChildren: () => import('./operationscomponents/speedviolation/fetchspeedviolation/fetchSpeedViolation.module').then(m => m.FetchSpeedViolationModule)
  //  },

  //  {
  //    path: 'qualitycontrol/wheatcleaningtest/addwheatcleaningtest',
  //    loadChildren: () => import('./qualitycontrolcomponents/wheatcleaningtest/addwheatcleaningtest/addWheatCleaningTest.module').then(m => m.AddWheatCleaningTestModule)
  //  },
  //  {
  //    path: 'qualitycontrol/wheatcleaningtest/addwheatcleaningtest/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/wheatcleaningtest/addwheatcleaningtest/addWheatCleaningTest.module').then(m => m.AddWheatCleaningTestModule)
  //  },

  //  {
  //    path: 'qualitycontrol/wheatcleaningtest/fetchwheatcleaningtest',
  //    loadChildren: () => import('./qualitycontrolcomponents/wheatcleaningtest/fetchwheatcleaningtest/fetchWheatCleaningTest.module').then(m => m.FetchWheatCleaningTestModule)
  //  },
  //  {
  //    path: 'qualitycontrol/millingtest/addmillingtest',
  //    loadChildren: () => import('./qualitycontrolcomponents/millingtest/addmillingtest/addMillingTest.module').then(m => m.AddMillingTestModule)
  //  },
  //  {
  //    path: 'qualitycontrol/millingtest/addmillingtest/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/millingtest/addmillingtest/addMillingTest.module').then(m => m.AddMillingTestModule)
  //  },

  //  {
  //    path: 'qualitycontrol/millingtest/fetchmillingtest',
  //    loadChildren: () => import('./qualitycontrolcomponents/millingtest/fetchmillingtest/fetchMillingTest.module').then(m => m.FetchMillingTestModule)
  //  },
  //  {
  //    path: 'cms/hiringmachines/addhiringmachines',
  //    loadChildren: () => import('./cmscomponents/hiringmachines/addhiringmachines/addHiringMachines.module').then(m => m.AddHiringMachinesModule)
  //  },
  //  {
  //    path: 'cms/hiringmachines/addhiringmachines/:id',
  //    loadChildren: () => import('./cmscomponents/hiringmachines/addhiringmachines/addHiringMachines.module').then(m => m.AddHiringMachinesModule)
  //  },

  //  {
  //    path: 'cms/hiringmachines/fetchhiringmachines',
  //    loadChildren: () => import('./cmscomponents/hiringmachines/fetchhiringmachines/fetchHiringMachines.module').then(m => m.FetchHiringMachinesModule)
  //  },

  //  {
  //    path: 'cms/machinerental/addmachinerental',
  //    loadChildren: () => import('./cmscomponents/machinerental/addmachinerental/addMachineRental.module').then(m => m.AddMachineRentalModule)
  //  },
  //  {
  //    path: 'cms/machinerental/addmachinerental/:id',
  //    loadChildren: () => import('./cmscomponents/machinerental/addmachinerental/addMachineRental.module').then(m => m.AddMachineRentalModule)
  //  },

  //  {
  //    path: 'cms/machinerental/fetchmachinerental',
  //    loadChildren: () => import('./cmscomponents/machinerental/fetchmachinerental/fetchMachineRental.module').then(m => m.FetchMachineRentalModule)
  //  },

  //  //
  //  {
  //    path: 'qualitycontrol/rheologytest/addrheologytest',
  //    loadChildren: () => import('./qualitycontrolcomponents/rheologytest/addrheologytest/addRheologyTest.module').then(m => m.AddRheologyTestModule)
  //  },
  //  {
  //    path: 'qualitycontrol/rheologytest/addrheologytest/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/rheologytest/addrheologytest/addRheologyTest.module').then(m => m.AddRheologyTestModule)
  //  },

  //  {
  //    path: 'qualitycontrol/rheologytest/fetchrheologytest',
  //    loadChildren: () => import('./qualitycontrolcomponents/rheologytest/fetchrheologytest/fetchRheologyTest.module').then(m => m.FetchRheologyTestModule)
  //  },
  //  //
  //  {
  //    path: 'qualitycontrol/labtest/addlabtest',
  //    loadChildren: () => import('./qualitycontrolcomponents/labtest/addlabtest/addLabTest.module').then(m => m.AddLabTestModule)
  //  },
  //  {
  //    path: 'qualitycontrol/labtest/addlabtest/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/labtest/addlabtest/addLabTest.module').then(m => m.AddLabTestModule)
  //  },

  //  {
  //    path: 'qualitycontrol/labtest/fetchlabtest',
  //    loadChildren: () => import('./qualitycontrolcomponents/labtest/fetchlabtest/fetchLabTest.module').then(m => m.FetchLabTestModule)
  //  },
  //  //
  //  {
  //    path: 'qualitycontrol/breadbakingtest/addbreadbakingtest',
  //    loadChildren: () => import('./qualitycontrolcomponents/breadbakingtest/addbreadbakingtest/addBreadBakingTest.module').then(m => m.AddBreadBakingTestModule)
  //  },
  //  {
  //    path: 'qualitycontrol/breadbakingtest/addbreadbakingtest/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/breadbakingtest/addbreadbakingtest/addBreadBakingTest.module').then(m => m.AddBreadBakingTestModule)
  //  },

  //  {
  //    path: 'qualitycontrol/breadbakingtest/fetchbreadbakingtest',
  //    loadChildren: () => import('./qualitycontrolcomponents/breadbakingtest/fetchbreadbakingtest/fetchBreadBakingTest.module').then(m => m.FetchBreadBakingTestModule)
  //  },
  //  //
  //  {
  //    path: 'qualitycontrol/doughnuttest/adddoughnuttest',
  //    loadChildren: () => import('./qualitycontrolcomponents/doughnuttest/adddoughnuttest/addDoughnutTest.module').then(m => m.AddDoughnutTestModule)
  //  },
  //  {
  //    path: 'qualitycontrol/doughnuttest/adddoughnuttest/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/doughnuttest/adddoughnuttest/addDoughnutTest.module').then(m => m.AddDoughnutTestModule)
  //  },

  //  {
  //    path: 'qualitycontrol/doughnuttest/fetchdoughnuttest',
  //    loadChildren: () => import('./qualitycontrolcomponents/doughnuttest/fetchdoughnuttest/fetchDoughnutTest.module').then(m => m.FetchDoughnutTestModule)
  //  },

  //  //
  //  //
  //  {
  //    path: 'cms/hiringmachines/addhiringmachines',
  //    loadChildren: () => import('./cmscomponents/hiringmachines/addhiringmachines/addHiringMachines.module').then(m => m.AddHiringMachinesModule)
  //  },
  //  {
  //    path: 'cms/hiringmachines/addhiringmachines/:id',
  //    loadChildren: () => import('./cmscomponents/hiringmachines/addhiringmachines/addHiringMachines.module').then(m => m.AddHiringMachinesModule)
  //  },

  //  {
  //    path: 'cms/hiringmachines/fetchhiringmachines',
  //    loadChildren: () => import('./cmscomponents/hiringmachines/fetchhiringmachines/fetchHiringMachines.module').then(m => m.FetchHiringMachinesModule)
  //  },
  //  //
  //  {
  //    path: 'cms/machinerental/addmachinerental',
  //    loadChildren: () => import('./cmscomponents/machinerental/addmachinerental/addMachineRental.module').then(m => m.AddMachineRentalModule)
  //  },
  //  {
  //    path: 'cms/machinerental/addmachinerental/:id',
  //    loadChildren: () => import('./cmscomponents/machinerental/addmachinerental/addMachineRental.module').then(m => m.AddMachineRentalModule)
  //  },

  //  {
  //    path: 'cms/machinerental/fetchmachinerental',
  //    loadChildren: () => import('./cmscomponents/machinerental/fetchmachinerental/fetchMachineRental.module').then(m => m.FetchMachineRentalModule)
  //  },
  //  //

  //  {
  //    path: 'cms/machinerentalinvoice/addmachinerentalinvoice',
  //    loadChildren: () => import('./cmscomponents/machinerentalinvoice/addmachinerentalinvoice/addMachineRentalInvoice.module').then(m => m.AddMachineRentalInvoiceModule)
  //  },
  //  {
  //    path: 'cms/machinerentalinvoice/addmachinerentalinvoice/:id',
  //    loadChildren: () => import('./cmscomponents/machinerentalinvoice/addmachinerentalinvoice/addMachineRentalInvoice.module').then(m => m.AddMachineRentalInvoiceModule)
  //  },

  //  {
  //    path: 'cms/machinerentalinvoice/fetchmachinerentalinvoice',
  //    loadChildren: () => import('./cmscomponents/machinerentalinvoice/fetchmachinerentalinvoice/fetchMachineRentalInvoice.module').then(m => m.FetchMachineRentalInvoiceModule)
  //  },

  //  {
  //    path: 'procurement/pricelist/addpricelist',
  //    loadChildren: () => import('./procurementcomponents/pricelist/addpricelist/addPriceList.module').then(m => m.AddPriceListModule)
  //  },
  //  {
  //    path: 'procurement/pricelist/addpricelist/:id',
  //    loadChildren: () => import('./procurementcomponents/pricelist/addpricelist/addPriceList.module').then(m => m.AddPriceListModule)
  //  },

  //  {
  //    path: 'procurement/pricelist/fetchpricelist',
  //    loadChildren: () => import('./procurementcomponents/pricelist/fetchpricelist/fetchPriceList.module').then(m => m.FetchPriceListModule)
  //  },

  //  //
  //  {
  //    path: 'sales/salescontract/addsalescontract',
  //    loadChildren: () => import('./salescomponents/salescontract/addsalescontract/addSalesContract.module').then(m => m.AddSalesContractModule)
  //  },
  //  {
  //    path: 'sales/salescontract/addsalescontract/:id',
  //    loadChildren: () => import('./salescomponents/salescontract/addsalescontract/addSalesContract.module').then(m => m.AddSalesContractModule)
  //  },

  //  {
  //    path: 'sales/salescontract/fetchsalescontract',
  //    loadChildren: () => import('./salescomponents/salescontract/fetchsalescontract/fetchSalesContract.module').then(m => m.FetchSalesContractModule)
  //  },

  //  {
  //    path: 'sales/productpricing/addproductpricing',
  //    loadChildren: () => import('./salescomponents/productpricing/addproductpricing/addProductPricing.module').then(m => m.AddProductPricingModule)
  //  },
  //  {
  //    path: 'sales/productpricing/addproductpricing/:id',
  //    loadChildren: () => import('./salescomponents/productpricing/addproductpricing/addProductPricing.module').then(m => m.AddProductPricingModule)
  //  },

  //  {
  //    path: 'sales/productpricing/fetchproductpricing',
  //    loadChildren: () => import('./salescomponents/productpricing/fetchproductpricing/fetchProductPricing.module').then(m => m.FetchProductPricingModule)
  //  },

  //  {
  //    path: 'sales/salesdestination/addsalesdestination',
  //    loadChildren: () => import('./salescomponents/salesdestination/addsalesdestination/addSalesDestination.module').then(m => m.AddSalesDestinationModule)
  //  },
  //  {
  //    path: 'sales/salesdestination/addsalesdestination/:id',
  //    loadChildren: () => import('./salescomponents/salesdestination/addsalesdestination/addSalesDestination.module').then(m => m.AddSalesDestinationModule)
  //  },

  //  {
  //    path: 'sales/salesdestination/fetchsalesdestination',
  //    loadChildren: () => import('./salescomponents/salesdestination/fetchsalesdestination/fetchSalesDestination.module').then(m => m.FetchSalesDestinationModule)
  //  },
  //  {
  //    path: 'production/productcosting/addproductcosting',
  //    loadChildren: () => import('./productioncomponents/productcosting/addproductcosting/addProductCosting.module').then(m => m.AddProductCostingModule)
  //  },
  //  {
  //    path: 'production/productcosting/addproductcosting/:id',
  //    loadChildren: () => import('./productioncomponents/productcosting/addproductcosting/addProductCosting.module').then(m => m.AddProductCostingModule)
  //  },

  //  {
  //    path: 'production/productcosting/fetchproductcosting',
  //    loadChildren: () => import('./productioncomponents/productcosting/fetchproductcosting/fetchProductCosting.module').then(m => m.FetchProductCostingModule)
  //  },

  //  {
  //    path: 'inventory/pregiftdelivery/addpregiftdelivery',
  //    loadChildren: () => import('./inventorycomponents/pregiftdelivery/addpregiftdelivery/addPreGiftDelivery.module').then(m => m.AddPreGiftDeliveryModule)
  //  },
  //  {
  //    path: 'inventory/pregiftdelivery/addpregiftdelivery/:id',
  //    loadChildren: () => import('./inventorycomponents/pregiftdelivery/addpregiftdelivery/addPreGiftDelivery.module').then(m => m.AddPreGiftDeliveryModule)
  //  },

  //  {
  //    path: 'inventory/pregiftdelivery/fetchpregiftdelivery',
  //    loadChildren: () => import('./inventorycomponents/pregiftdelivery/fetchpregiftdelivery/fetchPreGiftDelivery.module').then(m => m.FetchPreGiftDeliveryModule)
  //  },

  //  {
  //    path: 'operations/fuelslips/addfuelslips',
  //    loadChildren: () => import('./operationscomponents/fuelslip2/addfuelslip2/addFuelSlip2.module').then(m => m.AddFuelSlip2Module)
  //  },
  //  {
  //    path: 'operations/fuelslips/addfuelslips/:id',
  //    loadChildren: () => import('./operationscomponents/fuelslip2/addfuelslip2/addFuelSlip2.module').then(m => m.AddFuelSlip2Module)
  //  },

  //  {
  //    path: 'operations/fuelslips/fetchfuelslips',
  //    loadChildren: () => import('./operationscomponents/fuelslip2/fetchfuelslip2/fetchFuelSlip2.module').then(m => m.FetchFuelSlip2Module)
  //  },
  //  {
  //    path: 'hrm/objectivekpis/addobjectivekpis',
  //    loadChildren: () => import('./hrmcomponents/objectivekpis/addobjectivekpis/addObjectiveKpis.module').then(m => m.AddObjectiveKpisModule)
  //  },
  //  {
  //    path: 'hrm/objectivekpis/addobjectivekpis/:id',
  //    loadChildren: () => import('./hrmcomponents/objectivekpis/addobjectivekpis/addObjectiveKpis.module').then(m => m.AddObjectiveKpisModule)
  //  },

  //  {
  //    path: 'hrm/objectivekpis/fetchobjectivekpis',
  //    loadChildren: () => import('./hrmcomponents/objectivekpis/fetchobjectivekpis/fetchObjectiveKpis.module').then(m => m.FetchObjectiveKpisModule)
  //  },
  //  {
  //    path: 'hrm/employeeselfapprasal/addemployeeselfapprasal',
  //    loadChildren: () => import('./hrmcomponents/employeeselfapprasal/addemployeeselfapprasal/addEmployeeSelfApprasal.module').then(m => m.AddEmployeeSelfApprasalModule)
  //  },
  //  {
  //    path: 'hrm/employeeselfapprasal/addemployeeselfapprasal/:id',
  //    loadChildren: () => import('./hrmcomponents/employeeselfapprasal/addemployeeselfapprasal/addEmployeeSelfApprasal.module').then(m => m.AddEmployeeSelfApprasalModule)
  //  },

  //  {
  //    path: 'hrm/employeeselfapprasal/fetchemployeeselfapprasal',
  //    loadChildren: () => import('./hrmcomponents/employeeselfapprasal/fetchemployeeselfapprasal/fetchEmployeeSelfApprasal.module').then(m => m.FetchEmployeeSelfApprasalModule)
  //  },
  //  {
  //    path: 'hrm/employeeapprasalmanager/addemployeeapprasalmanager',
  //    loadChildren: () => import('./hrmcomponents/employeeapprasalmanager/addemployeeapprasalmanager/addEmployeeApprasalManager.module').then(m => m.AddEmployeeApprasalManagerModule)
  //  },
  //  {
  //    path: 'hrm/employeeapprasalmanager/addemployeeapprasalmanager/:id',
  //    loadChildren: () => import('./hrmcomponents/employeeapprasalmanager/addemployeeapprasalmanager/addEmployeeApprasalManager.module').then(m => m.AddEmployeeApprasalManagerModule)
  //  },

  //  {
  //    path: 'hrm/employeeapprasalmanager/fetchemployeeapprasalmanager',
  //    loadChildren: () => import('./hrmcomponents/employeeapprasalmanager/fetchemployeeapprasalmanager/fetchEmployeeApprasalManager.module').then(m => m.FetchEmployeeApprasalManagerModule)
  //  },
  //  {
  //    path: 'hrm/personaldevelopmentplan/addpersonaldevelopmentplan',
  //    loadChildren: () => import('./hrmcomponents/personaldevelopmentplan/addpersonaldevelopmentplan/addPersonalDevelopmentPlan.module').then(m => m.AddPersonalDevelopmentPlanModule)
  //  },
  //  {
  //    path: 'hrm/personaldevelopmentplan/addpersonaldevelopmentplan/:id',
  //    loadChildren: () => import('./hrmcomponents/personaldevelopmentplan/addpersonaldevelopmentplan/addPersonalDevelopmentPlan.module').then(m => m.AddPersonalDevelopmentPlanModule)
  //  },

  //  {
  //    path: 'hrm/personaldevelopmentplan/fetchpersonaldevelopmentplan',
  //    loadChildren: () => import('./hrmcomponents/personaldevelopmentplan/fetchpersonaldevelopmentplan/fetchPersonalDevelopmentPlan.module').then(m => m.FetchPersonalDevelopmentPlanModule)
  //  },
  //  {
  //    path: 'hrm/overallassessment/addoverallassessment',
  //    loadChildren: () => import('./hrmcomponents/overallassessment/addoverallassessment/addOverallAssessment.module').then(m => m.AddOverallAssessmentModule)
  //  },
  //  {
  //    path: 'hrm/overallassessment/addoverallassessment/:id',
  //    loadChildren: () => import('./hrmcomponents/overallassessment/addoverallassessment/addOverallAssessment.module').then(m => m.AddOverallAssessmentModule)
  //  },

  //  {
  //    path: 'hrm/overallassessment/fetchoverallassessment',
  //    loadChildren: () => import('./hrmcomponents/overallassessment/fetchoverallassessment/fetchOverallAssessment.module').then(m => m.FetchOverallAssessmentModule)
  //  },

  //  {
  //    path: 'inventory/miscellaneouspricelist/addmiscellaneouspricelist',
  //    loadChildren: () => import('./inventorycomponents/miscellaneouspricelist/addmiscellaneouspricelist/addMiscellaneousPriceList.module').then(m => m.AddMiscellaneousPriceListModule)
  //  },
  //  {
  //    path: 'inventory/miscellaneouspricelist/addmiscellaneouspricelist/:id',
  //    loadChildren: () => import('./inventorycomponents/miscellaneouspricelist/addmiscellaneouspricelist/addMiscellaneousPriceList.module').then(m => m.AddMiscellaneousPriceListModule)
  //  },

  //  {
  //    path: 'inventory/miscellaneouspricelist/fetchmiscellaneouspricelist',
  //    loadChildren: () => import('./inventorycomponents/miscellaneouspricelist/fetchmiscellaneouspricelist/fetchMiscellaneousPriceList.module').then(m => m.FetchMiscellaneousPriceListModule)
  //  },
  //  {
  //    path: 'procurement/landermaster/addlandermaster',
  //    loadChildren: () => import('./procurementcomponents/landermaster/addlandermaster/addLanderMaster.module').then(m => m.AddLanderMasterModule)
  //  },
  //  {
  //    path: 'procurement/landermaster/addlandermaster/:id',
  //    loadChildren: () => import('./procurementcomponents/landermaster/addlandermaster/addLanderMaster.module').then(m => m.AddLanderMasterModule)
  //  },

  //  {
  //    path: 'procurement/landermaster/fetchlandermaster',
  //    loadChildren: () => import('./procurementcomponents/landermaster/fetchlandermaster/fetchLanderMaster.module').then(m => m.FetchLanderMasterModule)
  //  },
  //  {
  //    path: 'inventory/lenderdeliverynoteissue/addlenderdeliverynoteissue',
  //    loadChildren: () => import('./inventorycomponents/lenderdeliverynoteissue/addlenderdeliverynoteissue/addLenderDeliveryNoteIssue.module').then(m => m.AddLenderDeliveryNoteIssueModule)
  //  },
  //  {
  //    path: 'inventory/lenderdeliverynoteissue/addlenderdeliverynoteissue/:id',
  //    loadChildren: () => import('./inventorycomponents/lenderdeliverynoteissue/addlenderdeliverynoteissue/addLenderDeliveryNoteIssue.module').then(m => m.AddLenderDeliveryNoteIssueModule)
  //  },

  //  {
  //    path: 'inventory/lenderdeliverynoteissue/fetchlenderdeliverynoteissue',
  //    loadChildren: () => import('./inventorycomponents/lenderdeliverynoteissue/fetchlenderdeliverynoteissue/fetchLenderDeliveryNoteIssue.module').then(m => m.FetchLenderDeliveryNoteIssueModule)
  //  },

  //  {
  //    path: 'inventory/lenderdeliverynotereceipt/addlenderdeliverynotereceipt',
  //    loadChildren: () => import('./inventorycomponents/lenderdeliverynotereceipt/addlenderdeliverynotereceipt/addLenderDeliveryNoteReceipt.module').then(m => m.AddLenderDeliveryNoteReceiptModule)
  //  },
  //  {
  //    path: 'inventory/lenderdeliverynotereceipt/addlenderdeliverynotereceipt/:id',
  //    loadChildren: () => import('./inventorycomponents/lenderdeliverynotereceipt/addlenderdeliverynotereceipt/addLenderDeliveryNoteReceipt.module').then(m => m.AddLenderDeliveryNoteReceiptModule)
  //  },

  //  {
  //    path: 'inventory/lenderdeliverynotereceipt/fetchlenderdeliverynotereceipt',
  //    loadChildren: () => import('./inventorycomponents/lenderdeliverynotereceipt/fetchlenderdeliverynotereceipt/fetchLenderDeliveryNoteReceipt.module').then(m => m.FetchLenderDeliveryNoteReceiptModule)
  //  },

  //  {
  //    path: 'procurement/landermaster/addlandermaster',
  //    loadChildren: () => import('./procurementcomponents/landermaster/addlandermaster/addLanderMaster.module').then(m => m.AddLanderMasterModule)
  //  },
  //  {
  //    path: 'procurement/landermaster/addlandermaster/:id',
  //    loadChildren: () => import('./procurementcomponents/landermaster/addlandermaster/addLanderMaster.module').then(m => m.AddLanderMasterModule)
  //  },

  //  {
  //    path: 'procurement/landermaster/fetchlandermaster',
  //    loadChildren: () => import('./procurementcomponents/landermaster/fetchlandermaster/fetchLanderMaster.module').then(m => m.FetchLanderMasterModule)
  //  },

  //  {
  //    path: 'hrm/overtime2/addovertime2',
  //    loadChildren: () => import('./hrmcomponents/overtime2/addovertime2/addOverTime2.module').then(m => m.AddOverTime2Module)
  //  },
  //  {
  //    path: 'hrm/overtime2/addovertime2/:id',
  //    loadChildren: () => import('./hrmcomponents/overtime2/addovertime2/addOverTime2.module').then(m => m.AddOverTime2Module)
  //  },

  //  {
  //    path: 'hrm/overtime2/fetchovertime2',
  //    loadChildren: () => import('./hrmcomponents/overtime2/fetchovertime2/fetchOverTime2.module').then(m => m.FetchOverTime2Module)
  //  },

  //  {
  //    path: 'finance/billofexchange/addbillofexchange',
  //    loadChildren: () => import('./financecomponents/billofexchange/addbillofexchange/addBillOfExchange.module').then(m => m.AddBillOfExchangeModule)
  //  },
  //  {
  //    path: 'finance/billofexchange/addbillofexchange/:id',
  //    loadChildren: () => import('./financecomponents/billofexchange/addbillofexchange/addBillOfExchange.module').then(m => m.AddBillOfExchangeModule)
  //  },

  //  {
  //    path: 'finance/billofexchange/fetchbillofexchange',
  //    loadChildren: () => import('./financecomponents/billofexchange/fetchbillofexchange/fetchBillOfExchange.module').then(m => m.FetchBillOfExchangeModule)
  //  },

  {
    path: 'general/feature/userdashboardaccess',
    loadChildren: () => import('./generalcomponents/feature/userdashboardaccess/userdashboardaccess.module').then(m => m.UserDashboardAccessModule)
  },


  //  {
  //    path: 'flourproduction/flourcontrol/addflourcontrol',
  //    loadChildren: () => import('./flourproductioncomponents/flourcontrol/addflourcontrol/addFlourControl.module').then(m => m.AddFlourControlModule)
  //  },
  //  {
  //    path: 'flourproduction/flourcontrol/addflourcontrol/:id',
  //    loadChildren: () => import('./flourproductioncomponents/flourcontrol/addflourcontrol/addFlourControl.module').then(m => m.AddFlourControlModule)
  //  },

  //  {
  //    path: 'flourproduction/flourcontrol/fetchflourcontrol',
  //    loadChildren: () => import('./flourproductioncomponents/flourcontrol/fetchflourcontrol/fetchFlourControl.module').then(m => m.FetchFlourControlModule)
  //  },
  //  {
  //    path: 'flourproduction/brancontrol/addbrancontrol',
  //    loadChildren: () => import('./flourproductioncomponents/brancontrol/addbrancontrol/addBranControl.module').then(m => m.AddBranControlModule)
  //  },
  //  {
  //    path: 'flourproduction/brancontrol/addbrancontrol/:id',
  //    loadChildren: () => import('./flourproductioncomponents/brancontrol/addbrancontrol/addBranControl.module').then(m => m.AddBranControlModule)
  //  },

  //  {
  //    path: 'flourproduction/brancontrol/fetchbrancontrol',
  //    loadChildren: () => import('./flourproductioncomponents/brancontrol/fetchbrancontrol/fetchBranControl.module').then(m => m.FetchBranControlModule)
  //  },
  //  {
  //    path: 'flourproduction/bageweightregistration/addbageweightregistration',
  //    loadChildren: () => import('./flourproductioncomponents/bageweightregistration/addbageweightregistration/addBageWeightRegistration.module').then(m => m.AddBageWeightRegistrationModule)
  //  },
  //  {
  //    path: 'flourproduction/bageweightregistration/addbageweightregistration/:id',
  //    loadChildren: () => import('./flourproductioncomponents/bageweightregistration/addbageweightregistration/addBageWeightRegistration.module').then(m => m.AddBageWeightRegistrationModule)
  //  },

  //  {
  //    path: 'flourproduction/bageweightregistration/fetchbageweightregistration',
  //    loadChildren: () => import('./flourproductioncomponents/bageweightregistration/fetchbageweightregistration/fetchBageWeightRegistration.module').then(m => m.FetchBageWeightRegistrationModule)
  //  },
  //  {
  //    path: 'flourproduction/flourdistraction/addflourdistraction',
  //    loadChildren: () => import('./flourproductioncomponents/flourdistraction/addflourdistraction/addFlourDistraction.module').then(m => m.AddFlourDistractionModule)
  //  },
  //  {
  //    path: 'flourproduction/flourdistraction/addflourdistraction/:id',
  //    loadChildren: () => import('./flourproductioncomponents/flourdistraction/addflourdistraction/addFlourDistraction.module').then(m => m.AddFlourDistractionModule)
  //  },

  //  {
  //    path: 'flourproduction/flourdistraction/fetchflourdistraction',
  //    loadChildren: () => import('./flourproductioncomponents/flourdistraction/fetchflourdistraction/fetchFlourDistraction.module').then(m => m.FetchFlourDistractionModule)
  //  },
  //  {
  //    path: 'flourproduction/flourprodjobcard/addflourprodjobcard',
  //    loadChildren: () => import('./flourproductioncomponents/flourprodjobcard/addflourprodjobcard/addFlourProdJobCard.module').then(m => m.AddFlourProdJobCardModule)
  //  },
  //  {
  //    path: 'flourproduction/flourprodjobcard/addflourprodjobcard/:id',
  //    loadChildren: () => import('./flourproductioncomponents/flourprodjobcard/addflourprodjobcard/addFlourProdJobCard.module').then(m => m.AddFlourProdJobCardModule)
  //  },

  //  {
  //    path: 'flourproduction/flourprodjobcard/fetchflourprodjobcard',
  //    loadChildren: () => import('./flourproductioncomponents/flourprodjobcard/fetchflourprodjobcard/fetchFlourProdJobCard.module').then(m => m.FetchFlourProdJobCardModule)
  //  },

  //  {
  //    path: 'hrm/travelrequest/addtravelrequest',
  //    loadChildren: () => import('./hrmcomponents/travelrequest/addtravelrequest/addTravelRequest.module').then(m => m.AddTravelRequestModule)
  //  },
  //  {
  //    path: 'hrm/travelrequest/addtravelrequest/:id',
  //    loadChildren: () => import('./hrmcomponents/travelrequest/addtravelrequest/addTravelRequest.module').then(m => m.AddTravelRequestModule)
  //  },

  //  {
  //    path: 'hrm/travelrequest/fetchtravelrequest',
  //    loadChildren: () => import('./hrmcomponents/travelrequest/fetchtravelrequest/fetchTravelRequest.module').then(m => m.FetchTravelRequestModule)
  //  },
  //  {
  //    path: 'hrm/medicalconsultation/addmedicalconsultation',
  //    loadChildren: () => import('./hrmcomponents/medicalconsultation/addmedicalconsultation/addMedicalConsultation.module').then(m => m.AddMedicalConsultationModule)
  //  },
  //  {
  //    path: 'hrm/medicalconsultation/addmedicalconsultation/:id',
  //    loadChildren: () => import('./hrmcomponents/medicalconsultation/addmedicalconsultation/addMedicalConsultation.module').then(m => m.AddMedicalConsultationModule)
  //  },

  //  {
  //    path: 'hrm/medicalconsultation/fetchmedicalconsultation',
  //    loadChildren: () => import('./hrmcomponents/medicalconsultation/fetchmedicalconsultation/fetchMedicalConsultation.module').then(m => m.FetchMedicalConsultationModule)
  //  },
  //  {
  //    path: 'flourproduction/productiontaskdetails/addproductiontaskdetails',
  //    loadChildren: () => import('./flourproductioncomponents/productiontaskdetails/addproductiontaskdetails/addProductionTaskDetails.module').then(m => m.AddProductionTaskDetailsModule)
  //  },
  //  {
  //    path: 'flourproduction/productiontaskdetails/addproductiontaskdetails/:id',
  //    loadChildren: () => import('./flourproductioncomponents/productiontaskdetails/addproductiontaskdetails/addProductionTaskDetails.module').then(m => m.AddProductionTaskDetailsModule)
  //  },

  //  {
  //    path: 'flourproduction/productiontaskdetails/fetchproductiontaskdetails',
  //    loadChildren: () => import('./flourproductioncomponents/productiontaskdetails/fetchproductiontaskdetails/fetchProductionTaskDetails.module').then(m => m.FetchProductionTaskDetailsModule)
  //  },
  //  {
  //    path: 'flourproduction/productionmanpowerdetails/addproductionmanpowerdetails',
  //    loadChildren: () => import('./flourproductioncomponents/productionmanpowerdetails/addproductionmanpowerdetails/addProductionManPowerDetails.module').then(m => m.AddProductionManPowerDetailsModule)
  //  },
  //  {
  //    path: 'flourproduction/productionmanpowerdetails/addproductionmanpowerdetails/:id',
  //    loadChildren: () => import('./flourproductioncomponents/productionmanpowerdetails/addproductionmanpowerdetails/addProductionManPowerDetails.module').then(m => m.AddProductionManPowerDetailsModule)
  //  },

  //  {
  //    path: 'flourproduction/productionmanpowerdetails/fetchproductionmanpowerdetails',
  //    loadChildren: () => import('./flourproductioncomponents/productionmanpowerdetails/fetchproductionmanpowerdetails/fetchProductionManPowerDetails.module').then(m => m.FetchProductionManPowerDetailsModule)
  //  },
  //  {
  //    path: 'flourproduction/productiontechnicalindent/addproductiontechnicalindent',
  //    loadChildren: () => import('./flourproductioncomponents/productiontechnicalindent/addproductiontechnicalindent/addProductionTechnicalIndent.module').then(m => m.AddProductionTechnicalIndentModule)
  //  },
  //  {
  //    path: 'flourproduction/productiontechnicalindent/addproductiontechnicalindent/:id',
  //    loadChildren: () => import('./flourproductioncomponents/productiontechnicalindent/addproductiontechnicalindent/addProductionTechnicalIndent.module').then(m => m.AddProductionTechnicalIndentModule)
  //  },

  //  {
  //    path: 'flourproduction/productiontechnicalindent/fetchproductiontechnicalindent',
  //    loadChildren: () => import('./flourproductioncomponents/productiontechnicalindent/fetchproductiontechnicalindent/fetchProductionTechnicalIndent.module').then(m => m.FetchProductionTechnicalIndentModule)
  //  },

  //  {
  //    path: 'hrm/travelrequest/addtravelrequest',
  //    loadChildren: () => import('./hrmcomponents/travelrequest/addtravelrequest/addTravelRequest.module').then(m => m.AddTravelRequestModule)
  //  },
  //  {
  //    path: 'hrm/travelrequest/addtravelrequest/:id',
  //    loadChildren: () => import('./hrmcomponents/travelrequest/addtravelrequest/addTravelRequest.module').then(m => m.AddTravelRequestModule)
  //  },

  //  {
  //    path: 'hrm/travelrequest/fetchtravelrequest',
  //    loadChildren: () => import('./hrmcomponents/travelrequest/fetchtravelrequest/fetchTravelRequest.module').then(m => m.FetchTravelRequestModule)
  //  },
  //  {
  //    path: 'hrm/medicalconsultation/addmedicalconsultation',
  //    loadChildren: () => import('./hrmcomponents/medicalconsultation/addmedicalconsultation/addMedicalConsultation.module').then(m => m.AddMedicalConsultationModule)
  //  },
  //  {
  //    path: 'hrm/medicalconsultation/addmedicalconsultation/:id',
  //    loadChildren: () => import('./hrmcomponents/medicalconsultation/addmedicalconsultation/addMedicalConsultation.module').then(m => m.AddMedicalConsultationModule)
  //  },

  //  {
  //    path: 'hrm/medicalconsultation/fetchmedicalconsultation',
  //    loadChildren: () => import('./hrmcomponents/medicalconsultation/fetchmedicalconsultation/fetchMedicalConsultation.module').then(m => m.FetchMedicalConsultationModule)
  //  },

  //  {
  //    path: 'hrm/laptopreceiptacknowledgement/addlaptopreceiptacknowledgement',
  //    loadChildren: () => import('./hrmcomponents/laptopreceiptacknowledgement/addlaptopreceiptacknowledgement/addLaptopReceiptAcknowledgement.module').then(m => m.AddLaptopReceiptAcknowledgementModule)
  //  },
  //  {
  //    path: 'hrm/laptopreceiptacknowledgement/addlaptopreceiptacknowledgement/:id',
  //    loadChildren: () => import('./hrmcomponents/laptopreceiptacknowledgement/addlaptopreceiptacknowledgement/addLaptopReceiptAcknowledgement.module').then(m => m.AddLaptopReceiptAcknowledgementModule)
  //  },

  //  {
  //    path: 'hrm/laptopreceiptacknowledgement/fetchlaptopreceiptacknowledgement',
  //    loadChildren: () => import('./hrmcomponents/laptopreceiptacknowledgement/fetchlaptopreceiptacknowledgement/fetchLaptopReceiptAcknowledgement.module').then(m => m.FetchLaptopReceiptAcknowledgementModule)
  //  },

  //  {
  //    path: 'inventory/agent/addagent',
  //    loadChildren: () => import('./inventorycomponents/agent/addagent/addAgent.module').then(m => m.AddAgentModule)
  //  },
  //  {
  //    path: 'inventory/agent/addagent/:id',
  //    loadChildren: () => import('./inventorycomponents/agent/addagent/addAgent.module').then(m => m.AddAgentModule)
  //  },

  //  {
  //    path: 'inventory/agent/fetchagent',
  //    loadChildren: () => import('./inventorycomponents/agent/fetchagent/fetchAgent.module').then(m => m.FetchAgentModule)
  //  },
  //  {
  //    path: 'inventory/vessaldetails/addvessaldetails',
  //    loadChildren: () => import('./inventorycomponents/vessaldetails/addvessaldetails/addVessalDetails.module').then(m => m.AddVessalDetailsModule)
  //  },
  //  {
  //    path: 'inventory/vessaldetails/addvessaldetails/:id',
  //    loadChildren: () => import('./inventorycomponents/vessaldetails/addvessaldetails/addVessalDetails.module').then(m => m.AddVessalDetailsModule)
  //  },

  //  {
  //    path: 'inventory/vessaldetails/fetchvessaldetails',
  //    loadChildren: () => import('./inventorycomponents/vessaldetails/fetchvessaldetails/fetchVessalDetails.module').then(m => m.FetchVessalDetailsModule)
  //  },
  //  {
  //    path: 'inventory/truckregistration/addtruckregistration',
  //    loadChildren: () => import('./inventorycomponents/truckregistration/addtruckregistration/addTruckRegistration.module').then(m => m.AddTruckRegistrationModule)
  //  },
  //  {
  //    path: 'inventory/truckregistration/addtruckregistration/:id',
  //    loadChildren: () => import('./inventorycomponents/truckregistration/addtruckregistration/addTruckRegistration.module').then(m => m.AddTruckRegistrationModule)
  //  },

  //  {
  //    path: 'inventory/truckregistration/fetchtruckregistration',
  //    loadChildren: () => import('./inventorycomponents/truckregistration/fetchtruckregistration/fetchTruckRegistration.module').then(m => m.FetchTruckRegistrationModule)
  //  },
  //  {
  //    path: 'inventory/wheatdispatchnote/addwheatdispatchnote',
  //    loadChildren: () => import('./inventorycomponents/wheatdispatchnote/addwheatdispatchnote/addWheatDispatchNote.module').then(m => m.AddWheatDispatchNoteModule)
  //  },
  //  {
  //    path: 'inventory/wheatdispatchnote/addwheatdispatchnote/:id',
  //    loadChildren: () => import('./inventorycomponents/wheatdispatchnote/addwheatdispatchnote/addWheatDispatchNote.module').then(m => m.AddWheatDispatchNoteModule)
  //  },
  //  {
  //    path: 'inventory/wheatdispatchnote/fetchwheatdispatchnote',
  //    loadChildren: () => import('./inventorycomponents/wheatdispatchnote/fetchwheatdispatchnote/fetchWheatDispatchNote.module').then(m => m.FetchWheatDispatchNoteModule)
  //  },
  //  {
  //    path: 'inventory/vessalweighbridge/addvessalweighbridge',
  //    loadChildren: () => import('./inventorycomponents/vessalweighbridge/addvessalweighbridge/addVessalWeighBridge.module').then(m => m.AddVessalWeighBridgeModule)
  //  },
  //  {
  //    path: 'inventory/vessalweighbridge/addvessalweighbridge/:id',
  //    loadChildren: () => import('./inventorycomponents/vessalweighbridge/addvessalweighbridge/addVessalWeighBridge.module').then(m => m.AddVessalWeighBridgeModule)
  //  },
  //  {
  //    path: 'inventory/vessalweighbridge/fetchvessalweighbridge',
  //    loadChildren: () => import('./inventorycomponents/vessalweighbridge/fetchvessalweighbridge/fetchVessalWeighBridge.module').then(m => m.FetchVessalWeighBridgeModule)
  //  },
  //  {
  //    path: 'hrm/questiongroup/addquestiongroup',
  //    loadChildren: () => import('./hrmcomponents/questiongroup/addquestiongroup/addQuestionGroup.module').then(m => m.AddQuestionGroupModule)
  //  },
  //  {
  //    path: 'hrm/questiongroup/addquestiongroup/:id',
  //    loadChildren: () => import('./hrmcomponents/questiongroup/addquestiongroup/addQuestionGroup.module').then(m => m.AddQuestionGroupModule)
  //  },

  //  {
  //    path: 'hrm/questiongroup/fetchquestiongroup',
  //    loadChildren: () => import('./hrmcomponents/questiongroup/fetchquestiongroup/fetchQuestionGroup.module').then(m => m.FetchQuestionGroupModule)
  //  },
  //  {
  //    path: 'hrm/question/addquestion',
  //    loadChildren: () => import('./hrmcomponents/question/addquestion/addQuestion.module').then(m => m.AddQuestionModule)
  //  },
  //  {
  //    path: 'hrm/question/addquestion/:id',
  //    loadChildren: () => import('./hrmcomponents/question/addquestion/addQuestion.module').then(m => m.AddQuestionModule)
  //  },

  //  {
  //    path: 'hrm/question/fetchquestion',
  //    loadChildren: () => import('./hrmcomponents/question/fetchquestion/fetchQuestion.module').then(m => m.FetchQuestionModule)
  //  },
  //  {
  //    path: 'hrm/survey/addsurvey',
  //    loadChildren: () => import('./hrmcomponents/survey/addsurvey/addSurvey.module').then(m => m.AddSurveyModule)
  //  },
  //  {
  //    path: 'hrm/survey/addsurvey/:id',
  //    loadChildren: () => import('./hrmcomponents/survey/addsurvey/addSurvey.module').then(m => m.AddSurveyModule)
  //  },

  //  {
  //    path: 'hrm/survey/fetchsurvey',
  //    loadChildren: () => import('./hrmcomponents/survey/fetchsurvey/fetchSurvey.module').then(m => m.FetchSurveyModule)
  //  },
  //  {
  //    path: 'hrm/employeesurvey/addemployeesurvey',
  //    loadChildren: () => import('./hrmcomponents/employeesurvey/addemployeesurvey/addEmployeeSurvey.module').then(m => m.AddEmployeeSurveyModule)
  //  },
  //  {
  //    path: 'hrm/employeesurvey/addemployeesurvey/:id',
  //    loadChildren: () => import('./hrmcomponents/employeesurvey/addemployeesurvey/addEmployeeSurvey.module').then(m => m.AddEmployeeSurveyModule)
  //  },

  //  //    {
  //  //         path: 'hrm/employeesurvey/fetchemployeesurvey',
  //  //         loadChildren: () => import('./hrmcomponents/employeesurvey/fetchemployeesurvey/fetchEmployeeSurvey.module').then(m => m.FetchEmployeeSurveyModule)
  //  //   },
  //  {
  //    path: 'qualitycontrol/productionbatch/addproductionbatch',
  //    loadChildren: () => import('./qualitycontrolcomponents/productionbatch/addproductionbatch/addProductionBatch.module').then(m => m.AddProductionBatchModule)
  //  },
  //  {
  //    path: 'qualitycontrol/productionbatch/addproductionbatch/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/productionbatch/addproductionbatch/addProductionBatch.module').then(m => m.AddProductionBatchModule)
  //  },

  //  {
  //    path: 'qualitycontrol/productionbatch/fetchproductionbatch',
  //    loadChildren: () => import('./qualitycontrolcomponents/productionbatch/fetchproductionbatch/fetchProductionBatch.module').then(m => m.FetchProductionBatchModule)
  //  },
  //  {
  //    path: 'qualitycontrol/flourbrand/addflourbrand',
  //    loadChildren: () => import('./qualitycontrolcomponents/flourbrand/addflourbrand/addFlourBrand.module').then(m => m.AddFlourBrandModule)
  //  },
  //  {
  //    path: 'qualitycontrol/flourbrand/addflourbrand/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/flourbrand/addflourbrand/addFlourBrand.module').then(m => m.AddFlourBrandModule)
  //  },

  //  {
  //    path: 'qualitycontrol/flourbrand/fetchflourbrand',
  //    loadChildren: () => import('./qualitycontrolcomponents/flourbrand/fetchflourbrand/fetchFlourBrand.module').then(m => m.FetchFlourBrandModule)
  //  },
  //  {
  //    path: 'qualitycontrol/wheatcleaningconditioning/addwheatcleaningconditioning',
  //    loadChildren: () => import('./qualitycontrolcomponents/wheatcleaningconditioning/addwheatcleaningconditioning/addWheatCleaningConditioning.module').then(m => m.AddWheatCleaningConditioningModule)
  //  },
  //  {
  //    path: 'qualitycontrol/wheatcleaningconditioning/addwheatcleaningconditioning/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/wheatcleaningconditioning/addwheatcleaningconditioning/addWheatCleaningConditioning.module').then(m => m.AddWheatCleaningConditioningModule)
  //  },

  //  {
  //    path: 'qualitycontrol/wheatcleaningconditioning/fetchwheatcleaningconditioning',
  //    loadChildren: () => import('./qualitycontrolcomponents/wheatcleaningconditioning/fetchwheatcleaningconditioning/fetchWheatCleaningConditioning.module').then(m => m.FetchWheatCleaningConditioningModule)
  //  },
  //  {
  //    path: 'qualitycontrol/millcheckup/addmillcheckup',
  //    loadChildren: () => import('./qualitycontrolcomponents/millcheckup/addmillcheckup/addMillCheckUp.module').then(m => m.AddMillCheckUpModule)
  //  },
  //  {
  //    path: 'qualitycontrol/millcheckup/addmillcheckup/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/millcheckup/addmillcheckup/addMillCheckUp.module').then(m => m.AddMillCheckUpModule)
  //  },

  //  {
  //    path: 'qualitycontrol/millcheckup/fetchmillcheckup',
  //    loadChildren: () => import('./qualitycontrolcomponents/millcheckup/fetchmillcheckup/fetchMillCheckUp.module').then(m => m.FetchMillCheckUpModule)
  //  },

  //  {
  //    path: 'qualitycontrol/productionbatch/addproductionbatch',
  //    loadChildren: () => import('./qualitycontrolcomponents/productionbatch/addproductionbatch/addProductionBatch.module').then(m => m.AddProductionBatchModule)
  //  },
  //  {
  //    path: 'qualitycontrol/productionbatch/addproductionbatch/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/productionbatch/addproductionbatch/addProductionBatch.module').then(m => m.AddProductionBatchModule)
  //  },

  //  {
  //    path: 'qualitycontrol/productionbatch/fetchproductionbatch',
  //    loadChildren: () => import('./qualitycontrolcomponents/productionbatch/fetchproductionbatch/fetchProductionBatch.module').then(m => m.FetchProductionBatchModule)
  //  },
  //  {
  //    path: 'qualitycontrol/flourbrand/addflourbrand',
  //    loadChildren: () => import('./qualitycontrolcomponents/flourbrand/addflourbrand/addFlourBrand.module').then(m => m.AddFlourBrandModule)
  //  },
  //  {
  //    path: 'qualitycontrol/flourbrand/addflourbrand/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/flourbrand/addflourbrand/addFlourBrand.module').then(m => m.AddFlourBrandModule)
  //  },

  //  {
  //    path: 'qualitycontrol/flourbrand/fetchflourbrand',
  //    loadChildren: () => import('./qualitycontrolcomponents/flourbrand/fetchflourbrand/fetchFlourBrand.module').then(m => m.FetchFlourBrandModule)
  //  },
  //  {
  //    path: 'qualitycontrol/wheatcleaningconditioning/addwheatcleaningconditioning',
  //    loadChildren: () => import('./qualitycontrolcomponents/wheatcleaningconditioning/addwheatcleaningconditioning/addWheatCleaningConditioning.module').then(m => m.AddWheatCleaningConditioningModule)
  //  },
  //  {
  //    path: 'qualitycontrol/wheatcleaningconditioning/addwheatcleaningconditioning/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/wheatcleaningconditioning/addwheatcleaningconditioning/addWheatCleaningConditioning.module').then(m => m.AddWheatCleaningConditioningModule)
  //  },

  //  {
  //    path: 'qualitycontrol/wheatcleaningconditioning/fetchwheatcleaningconditioning',
  //    loadChildren: () => import('./qualitycontrolcomponents/wheatcleaningconditioning/fetchwheatcleaningconditioning/fetchWheatCleaningConditioning.module').then(m => m.FetchWheatCleaningConditioningModule)
  //  },
  //  {
  //    path: 'qualitycontrol/millcheckup/addmillcheckup',
  //    loadChildren: () => import('./qualitycontrolcomponents/millcheckup/addmillcheckup/addMillCheckUp.module').then(m => m.AddMillCheckUpModule)
  //  },
  //  {
  //    path: 'qualitycontrol/millcheckup/addmillcheckup/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/millcheckup/addmillcheckup/addMillCheckUp.module').then(m => m.AddMillCheckUpModule)
  //  },

  //  {
  //    path: 'qualitycontrol/millcheckup/fetchmillcheckup',
  //    loadChildren: () => import('./qualitycontrolcomponents/millcheckup/fetchmillcheckup/fetchMillCheckUp.module').then(m => m.FetchMillCheckUpModule)
  //  },


  //  //Routing

  //  {
  //    path: 'qualitycontrol/chemicalanalysis/addchemicalanalysis',
  //    loadChildren: () => import('./qualitycontrolcomponents/chemicalanalysis/addchemicalanalysis/addChemicalAnalysis.module').then(m => m.AddChemicalAnalysisModule)
  //  },
  //  {
  //    path: 'qualitycontrol/chemicalanalysis/addchemicalanalysis/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/chemicalanalysis/addchemicalanalysis/addChemicalAnalysis.module').then(m => m.AddChemicalAnalysisModule)
  //  },

  //  {
  //    path: 'qualitycontrol/chemicalanalysis/fetchchemicalanalysis',
  //    loadChildren: () => import('./qualitycontrolcomponents/chemicalanalysis/fetchchemicalanalysis/fetchChemicalAnalysis.module').then(m => m.FetchChemicalAnalysisModule)
  //  },

  //  {
  //    path: 'qualitycontrol/chemicalphysicalanalysis/addchemicalphysicalanalysis',
  //    loadChildren: () => import('./qualitycontrolcomponents/chemicalphysicalanalysis/addchemicalphysicalanalysis/addChemicalPhysicalAnalysis.module').then(m => m.AddChemicalPhysicalAnalysisModule)
  //  },
  //  {
  //    path: 'qualitycontrol/chemicalphysicalanalysis/addchemicalphysicalanalysis/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/chemicalphysicalanalysis/addchemicalphysicalanalysis/addChemicalPhysicalAnalysis.module').then(m => m.AddChemicalPhysicalAnalysisModule)
  //  },

  //  {
  //    path: 'qualitycontrol/chemicalphysicalanalysis/fetchchemicalphysicalanalysis',
  //    loadChildren: () => import('./qualitycontrolcomponents/chemicalphysicalanalysis/fetchchemicalphysicalanalysis/fetchChemicalPhysicalAnalysis.module').then(m => m.FetchChemicalPhysicalAnalysisModule)
  //  },

  //  {
  //    path: 'qualitycontrol/chemicalphysicalanalysis2/addchemicalphysicalanalysis2',
  //    loadChildren: () => import('./qualitycontrolcomponents/chemicalphysicalanalysis2/addchemicalphysicalanalysis2/addChemicalPhysicalAnalysis2.module').then(m => m.AddChemicalPhysicalAnalysis2Module)
  //  },
  //  {
  //    path: 'qualitycontrol/chemicalphysicalanalysis2/addchemicalphysicalanalysis2/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/chemicalphysicalanalysis2/addchemicalphysicalanalysis2/addChemicalPhysicalAnalysis2.module').then(m => m.AddChemicalPhysicalAnalysis2Module)
  //  },

  //  {
  //    path: 'qualitycontrol/chemicalphysicalanalysis2/fetchchemicalphysicalanalysis2',
  //    loadChildren: () => import('./qualitycontrolcomponents/chemicalphysicalanalysis2/fetchchemicalphysicalanalysis2/fetchChemicalPhysicalAnalysis2.module').then(m => m.FetchChemicalPhysicalAnalysis2Module)
  //  },


  //  {
  //    path: 'finance/budgetline/addbudgetline',
  //    loadChildren: () => import('./financecomponents/budgetline/addbudgetline/addBudgetLine.module').then(m => m.AddBudgetLineModule)
  //  },
  //  {
  //    path: 'finance/budgetline/addbudgetline/:id',
  //    loadChildren: () => import('./financecomponents/budgetline/addbudgetline/addBudgetLine.module').then(m => m.AddBudgetLineModule)
  //  },

  //  {
  //    path: 'finance/budgetline/fetchbudgetline',
  //    loadChildren: () => import('./financecomponents/budgetline/fetchbudgetline/fetchBudgetLine.module').then(m => m.FetchBudgetLineModule)
  //  },
  //  {
  //    path: 'finance/budgetlineaccountmapping/fetchbudgetlineaccountmapping',
  //    loadChildren: () => import('./financecomponents/budgetlineaccountmapping/budgetLineAccountMapping.module').then(m => m.BudgetLineAccountMappingModule)
  //  },

  //  {
  //    path: 'report/commercial/uninvoicedmanifests',
  //    loadChildren: () => import('./reports/commercial/UnInvoicedManifestsByInterval/UnInvoicedManifestsByIntervalReport.module').then(m => m.UnInvoicedManifestsByIntervalReportModule)
  //  },

  //  {
  //    path: 'hrm/advanceforecloser/addadvanceforecloser',
  //    loadChildren: () => import('./hrmcomponents/advanceforecloser/addadvanceforecloser/addAdvanceForeCloser.module').then(m => m.AddAdvanceForeCloserModule)
  //  },
  //  {
  //    path: 'hrm/advanceforecloser/addadvanceforecloser/:id',
  //    loadChildren: () => import('./hrmcomponents/advanceforecloser/addadvanceforecloser/addAdvanceForeCloser.module').then(m => m.AddAdvanceForeCloserModule)
  //  },

  //  {
  //    path: 'hrm/advanceforecloser/fetchadvanceforecloser',
  //    loadChildren: () => import('./hrmcomponents/advanceforecloser/fetchadvanceforecloser/fetchAdvanceForeCloser.module').then(m => m.FetchAdvanceForeCloserModule)
  //  },

  //  {
  //    path: 'sales/customeradvancedetails/addcustomeradvancedetails',
  //    loadChildren: () => import('./salescomponents/customeradvancedetails/addcustomeradvancedetails/addCustomerAdvanceDetails.module').then(m => m.AddCustomerAdvanceDetailsModule)
  //  },
  //  {
  //    path: 'sales/customeradvancedetails/addcustomeradvancedetails/:id',
  //    loadChildren: () => import('./salescomponents/customeradvancedetails/addcustomeradvancedetails/addCustomerAdvanceDetails.module').then(m => m.AddCustomerAdvanceDetailsModule)
  //  },

  //  {
  //    path: 'sales/customeradvancedetails/fetchcustomeradvancedetails',
  //    loadChildren: () => import('./salescomponents/customeradvancedetails/fetchcustomeradvancedetails/fetchCustomerAdvanceDetails.module').then(m => m.FetchCustomerAdvanceDetailsModule)
  //  },
  //  {
  //    path: 'finance/budgetlinegroup/addbudgetlinegroup',
  //    loadChildren: () => import('./financecomponents/budgetlinegroup/addbudgetlinegroup/addBudgetLineGroup.module').then(m => m.AddBudgetLineGroupModule)
  //  },
  //  {
  //    path: 'finance/budgetlinegroup/addbudgetlinegroup/:id',
  //    loadChildren: () => import('./financecomponents/budgetlinegroup/addbudgetlinegroup/addBudgetLineGroup.module').then(m => m.AddBudgetLineGroupModule)
  //  },

  //  {
  //    path: 'finance/budgetlinegroup/fetchbudgetlinegroup',
  //    loadChildren: () => import('./financecomponents/budgetlinegroup/fetchbudgetlinegroup/fetchBudgetLineGroup.module').then(m => m.FetchBudgetLineGroupModule)
  //  },
  //  {
  //    path: 'general/userresetpassword',
  //    loadChildren: () => import('./generalcomponents/userresetpassword/userresetpassword.module').then(m => m.UserResetPasswordModule)
  //  },

  //  {
  //    path: 'qualitycontrol/wheattransferanalysissheet/addwheattransferanalysissheet',
  //    loadChildren: () => import('./qualitycontrolcomponents/wheattransferanalysissheet/addwheattransferanalysissheet/addWheatTransferAnalysisSheet.module').then(m => m.AddWheatTransferAnalysisSheetModule)
  //  },
  //  {
  //    path: 'qualitycontrol/wheattransferanalysissheet/addwheattransferanalysissheet/:id',
  //    loadChildren: () => import('./qualitycontrolcomponents/wheattransferanalysissheet/addwheattransferanalysissheet/addWheatTransferAnalysisSheet.module').then(m => m.AddWheatTransferAnalysisSheetModule)
  //  },

  //  {
  //    path: 'qualitycontrol/wheattransferanalysissheet/fetchwheattransferanalysissheet',
  //    loadChildren: () => import('./qualitycontrolcomponents/wheattransferanalysissheet/fetchwheattransferanalysissheet/fetchWheatTransferAnalysisSheet.module').then(m => m.FetchWheatTransferAnalysisSheetModule)
  //  },

  //  {
  //    path: 'finance/aradjustment2/addaradjustment2',
  //    loadChildren: () => import('./financecomponents/aradjustment2/addaradjustment2/addARAdjustment2.module').then(m => m.AddARAdjustment2Module)
  //  },
  //  {
  //    path: 'finance/aradjustment2/addaradjustment2/:id',
  //    loadChildren: () => import('./financecomponents/aradjustment2/addaradjustment2/addARAdjustment2.module').then(m => m.AddARAdjustment2Module)
  //  },


  //  {
  //    path: 'inventory/transporter/addtransporter',
  //    loadChildren: () => import('./inventorycomponents/transporter/addtransporter/addTransporter.module').then(m => m.AddTransporterModule)
  //  },
  //  {
  //    path: 'inventory/transporter/addtransporter/:id',
  //    loadChildren: () => import('./inventorycomponents/transporter/addtransporter/addTransporter.module').then(m => m.AddTransporterModule)
  //  },

  //  {
  //    path: 'inventory/transporter/fetchtransporter',
  //    loadChildren: () => import('./inventorycomponents/transporter/fetchtransporter/fetchTransporter.module').then(m => m.FetchTransporterModule)
  //  },


  //  {
  //    path: 'inventory/locationtransferissue/addlocationtransferissue',
  //    loadChildren: () => import('./inventorycomponents/locationtransferissue1/addlocationtransferissue1/addLocationTransferIssue1.module').then(m => m.AddLocationTransferIssue1Module)
  //  },
  //  {
  //    path: 'inventory/locationtransferissue/addlocationtransferissue/:id',
  //    loadChildren: () => import('./inventorycomponents/locationtransferissue1/addlocationtransferissue1/addLocationTransferIssue1.module').then(m => m.AddLocationTransferIssue1Module)
  //  },

  //  {
  //    path: 'inventory/locationtransferissue/fetchlocationtransferissue',
  //    loadChildren: () => import('./inventorycomponents/locationtransferissue1/fetchlocationtransferissue1/fetchLocationTransferIssue1.module').then(m => m.FetchLocationTransferIssue1Module)
  //  },
  //  //
  //  {
  //    path: 'inventory/locationtransferreceipt/addlocationtransferreceipt',
  //    loadChildren: () => import('./inventorycomponents/locationtransferreceipt1/addlocationtransferreceipt1/addLocationTransferReceipt1.module').then(m => m.AddLocationTransferReceipt1Module)
  //  },
  //  {
  //    path: 'inventory/locationtransferreceipt/addlocationtransferreceipt/:id',
  //    loadChildren: () => import('./inventorycomponents/locationtransferreceipt1/addlocationtransferreceipt1/addLocationTransferReceipt1.module').then(m => m.AddLocationTransferReceipt1Module)
  //  },

  //  {
  //    path: 'inventory/locationtransferreceipt/fetchlocationtransferreceipt',
  //    loadChildren: () => import('./inventorycomponents/locationtransferreceipt1/fetchlocationtransferreceipt1/fetchLocationTransferReceipt1.module').then(m => m.FetchLocationTransferReceipt1Module)
  //  },

  //  {
  //    path: 'finance/budgetscreen/addbudgetscreen',
  //    loadChildren: () => import('./financecomponents/budgetscreen/addbudgetscreen/addBudgetScreen.module').then(m => m.AddBudgetScreenModule)
  //  },
  //  {
  //    path: 'finance/budgetscreen/addbudgetscreen/:id',
  //    loadChildren: () => import('./financecomponents/budgetscreen/addbudgetscreen/addBudgetScreen.module').then(m => m.AddBudgetScreenModule)
  //  },

  //  {
  //    path: 'finance/budgetscreen/fetchbudgetscreen',
  //    loadChildren: () => import('./financecomponents/budgetscreen/fetchbudgetscreen/fetchBudgetScreen.module').then(m => m.FetchBudgetScreenModule)
  //  },


  //  {
  //    path: 'finance/importexpensemapping/addimportexpensemapping',
  //    loadChildren: () => import('./financecomponents/importexpensemapping/addimportexpensemapping/addImportExpenseMapping.module').then(m => m.AddImportExpenseMappingModule)
  //  },
  //  {
  //    path: 'finance/importexpensemapping/addimportexpensemapping/:id',
  //    loadChildren: () => import('./financecomponents/importexpensemapping/addimportexpensemapping/addImportExpenseMapping.module').then(m => m.AddImportExpenseMappingModule)
  //  },

  //  {
  //    path: 'finance/importexpensemapping/fetchimportexpensemapping',
  //    loadChildren: () => import('./financecomponents/importexpensemapping/fetchimportexpensemapping/fetchImportExpenseMapping.module').then(m => m.FetchImportExpenseMappingModule)
  //  },
  //  {
  //    path: 'report/finance/agewiseadjustedpayablereport',
  //    loadChildren: () => import('./reports/finance/AgewiseAdjustedPayable/AgewiseAdjustedPayableReport.module').then(m => m.AgewiseAdjustedPayableReportModule)
  //  },
  //  {
  //    path: 'report/finance/agewiseadjustedreceivablereport',
  //    loadChildren: () => import('./reports/finance/AgewiseAdjustedReceivable/AgewiseAdjustedReceivableReport.module').then(m => m.AgewiseAdjustedReceivableReportModule)
  //  },


  //  {
  //    path: 'sales/salesreturnsales/addsalesreturnsales',
  //    loadChildren: () => import('./salescomponents/salesreturnsales/addsalesreturnsales/addSalesReturnSales.module').then(m => m.AddSalesReturnSalesModule)
  //  },
  //  {
  //    path: 'sales/salesreturnsales/addsalesreturnsales/:id',
  //    loadChildren: () => import('./salescomponents/salesreturnsales/addsalesreturnsales/addSalesReturnSales.module').then(m => m.AddSalesReturnSalesModule)
  //  },

  //  {
  //    path: 'sales/salesreturnsales/fetchsalesreturnsales',
  //    loadChildren: () => import('./salescomponents/salesreturnsales/fetchsalesreturnsales/fetchSalesReturnSales.module').then(m => m.FetchSalesReturnSalesModule)
  //  },

  //  {
  //    path: 'inventory/itemstockcriteria/additemstockcriteria',
  //    loadChildren: () => import('./inventorycomponents/itemstockcriteria/additemstockcriteria/addItemStockCriteria.module').then(m => m.AddItemStockCriteriaModule)
  //  },
  //  {
  //    path: 'inventory/itemstockcriteria/additemstockcriteria/:id',
  //    loadChildren: () => import('./inventorycomponents/itemstockcriteria/additemstockcriteria/addItemStockCriteria.module').then(m => m.AddItemStockCriteriaModule)
  //  },

  //  {
  //    path: 'inventory/itemstockcriteria/fetchitemstockcriteria',
  //    loadChildren: () => import('./inventorycomponents/itemstockcriteria/fetchitemstockcriteria/fetchItemStockCriteria.module').then(m => m.FetchItemStockCriteriaModule)
  //  },

  //  {
  //    path: 'finance/forecasting/addforecasting',
  //    loadChildren: () => import('./financecomponents/forecasting/addforecasting/addForecasting.module').then(m => m.AddForecastingModule)
  //  },
  //  {
  //    path: 'finance/forecasting/addforecasting/:id',
  //    loadChildren: () => import('./financecomponents/forecasting/addforecasting/addForecasting.module').then(m => m.AddForecastingModule)
  //  },
  //  {
  //    path: 'finance/forecasting/addforecasting/:id/:isView',
  //    loadChildren: () => import('./financecomponents/forecasting/addforecasting/addForecasting.module').then(m => m.AddForecastingModule)
  //  },
  //  {
  //    path: 'finance/forecasting/fetchforecasting',
  //    loadChildren: () => import('./financecomponents/forecasting/fetchforecasting/fetchForecasting.module').then(m => m.FetchForecastingModule)
  //  },

  {
    path: 'general/dashboardreportpanelmapping/adddashboardreportpanelmapping',
    loadChildren: () => import('./generalcomponents/feature/dashboardreportpanelmapping/adddashboardreportpanelmapping/addDashboardReportPanelMapping.module').then(m => m.AddDashboardReportPanelMappingModule)
  },
  {
    path: 'general/dashboardreportpanelmapping/adddashboardreportpanelmapping/:id',
    loadChildren: () => import('./generalcomponents/feature/dashboardreportpanelmapping/adddashboardreportpanelmapping/addDashboardReportPanelMapping.module').then(m => m.AddDashboardReportPanelMappingModule)
  },
  {
    path: 'general/dashboardreportpanelmapping/adddashboardreportpanelmapping/:id/:isView',
    loadChildren: () => import('./generalcomponents/feature/dashboardreportpanelmapping/adddashboardreportpanelmapping/addDashboardReportPanelMapping.module').then(m => m.AddDashboardReportPanelMappingModule)
  },
  {
    path: 'general/dashboardreportpanelmapping/fetchdashboardreportpanelmapping',
    loadChildren: () => import('./generalcomponents/feature/dashboardreportpanelmapping/fetchdashboardreportpanelmapping/fetchDashboardReportPanelMapping.module').then(m => m.FetchDashboardReportPanelMappingModule)
  },

  //  {
  //    path: 'inventory/shortageissueinventory/addshortageissueinventory',
  //    loadChildren: () => import('./inventorycomponents/shortageissueinventory/addshortageissueinventory/addShortageIssueInventory.module').then(m => m.AddShortageIssueInventoryModule)
  //  },
  //  {
  //    path: 'inventory/shortageissueinventory/addshortageissueinventory/:id',
  //    loadChildren: () => import('./inventorycomponents/shortageissueinventory/addshortageissueinventory/addShortageIssueInventory.module').then(m => m.AddShortageIssueInventoryModule)
  //  },
  //  {
  //    path: 'inventory/shortageissueinventory/addshortageissueinventory/:id/:isView',
  //    loadChildren: () => import('./inventorycomponents/shortageissueinventory/addshortageissueinventory/addShortageIssueInventory.module').then(m => m.AddShortageIssueInventoryModule)
  //  },
  {
    path: 'inventory/inventoryshortage/fetchinventoryshortage',
    loadChildren: () => import('./inventorycomponents/inventoryshortage/fetchinventoryshortage/fetchInventoryShortage.module').then(m => m.FetchInventoryShortageModule)
  },
  {
    path: 'inventory/inventoryshortage/addinventoryshortage',
    loadChildren: () => import('./inventorycomponents/inventoryshortage/addinventoryshortage/addInventoryShortage.module').then(m => m.AddInventoryShortageModule)
  },
  {
    path: 'inventory/inventoryshortage/addinventoryshortage/:id',
    loadChildren: () => import('./inventorycomponents/inventoryshortage/addinventoryshortage/addInventoryShortage.module').then(m => m.AddInventoryShortageModule)
  },
  //  {
  //    path: 'inventory/shortageissueinventory/fetchshortageissueinventory',
  //    loadChildren: () => import('./inventorycomponents/shortageissueinventory/fetchshortageissueinventory/fetchShortageIssueInventory.module').then(m => m.FetchShortageIssueInventoryModule)
  //  },
  //  {
  //    path: 'inventory/excessreceiptinventory/addexcessreceiptinventory',
  //    loadChildren: () => import('./inventorycomponents/excessreceiptinventory/addexcessreceiptinventory/addExcessReceiptInventory.module').then(m => m.AddExcessReceiptInventoryModule)
  //  },
  //  {
  //    path: 'inventory/excessreceiptinventory/addexcessreceiptinventory/:id',
  //    loadChildren: () => import('./inventorycomponents/excessreceiptinventory/addexcessreceiptinventory/addExcessReceiptInventory.module').then(m => m.AddExcessReceiptInventoryModule)
  //  },
  //  {
  //    path: 'inventory/excessreceiptinventory/addexcessreceiptinventory/:id/:isView',
  //    loadChildren: () => import('./inventorycomponents/excessreceiptinventory/addexcessreceiptinventory/addExcessReceiptInventory.module').then(m => m.AddExcessReceiptInventoryModule)
  //  },
  //  {
  //    path: 'inventory/excessreceiptinventory/fetchexcessreceiptinventory',
  //    loadChildren: () => import('./inventorycomponents/excessreceiptinventory/fetchexcessreceiptinventory/fetchExcessReceiptInventory.module').then(m => m.FetchExcessReceiptInventoryModule)
  //  },

  //  {
  //    path: 'sales/salepricelist/addsalepricelist',
  //    loadChildren: () => import('./salescomponents/salepricelist/addsalepricelist/addSalePriceList.module').then(m => m.AddSalePriceListModule)
  //  },
  //  {
  //    path: 'sales/salepricelist/addsalepricelist/:id',
  //    loadChildren: () => import('./salescomponents/salepricelist/addsalepricelist/addSalePriceList.module').then(m => m.AddSalePriceListModule)
  //  },
  //  {
  //    path: 'sales/salepricelist/fetchsalepricelist',
  //    loadChildren: () => import('./salescomponents/salepricelist/fetchsalepricelist/fetchSalePriceList.module').then(m => m.FetchSalePriceListModule)
  //  },

  {
    path: 'general/salarygrade/salarygrade',
    loadChildren: () => import('./generalcomponents/salarygrade/salarygrade.module').then(m => m.SalaryGradeModule)
  },


  //  {
  //    path: 'hrm/taxes/addtaxes',
  //    loadChildren: () => import('./hrmcomponents/taxes/addtaxes/addTaxes.module').then(m => m.AddTaxesModule)
  //  },
  //  {
  //    path: 'hrm/taxes/addtaxes/:id',
  //    loadChildren: () => import('./hrmcomponents/taxes/addtaxes/addTaxes.module').then(m => m.AddTaxesModule)
  //  },
  //  {
  //    path: 'hrm/taxes/fetchtaxes',
  //    loadChildren: () => import('./hrmcomponents/taxes/fetchtaxes/fetchTaxes.module').then(m => m.FetchTaxesModule)
  //  },


  //  {
  //    path: 'hrm/consolidatedovertime/addconsolidatedovertime',
  //    loadChildren: () => import('./hrmcomponents/consolidatedovertime/addconsolidatedovertime/addConsolidatedOverTime.module').then(m => m.AddConsolidatedOverTimeModule)
  //  },
  //  {
  //    path: 'hrm/consolidatedovertime/addconsolidatedovertime/:id',
  //    loadChildren: () => import('./hrmcomponents/consolidatedovertime/addconsolidatedovertime/addConsolidatedOverTime.module').then(m => m.AddConsolidatedOverTimeModule)
  //  },
  //  {
  //    path: 'hrm/consolidatedovertime/fetchconsolidatedovertime',
  //    loadChildren: () => import('./hrmcomponents/consolidatedovertime/fetchconsolidatedovertime/fetchConsolidatedOverTime.module').then(m => m.FetchConsolidatedOverTimeModule)
  //  },


  //  {
  //    path: 'report/finance/allinventorytransactionsreport',
  //    loadChildren: () => import('./reports/finance/AllInventoryTransactions/AllInventoryTransactionsReport.module').then(m => m.AllInventoryTransactionsReportModule)
  //  },


  //  {
  //    path: 'custody/openingbalancecustody/addopeningbalancecustody',
  //    loadChildren: () => import('./custodycomponents/openingbalancecustody/addopeningbalancecustody/addOpeningBalanceCustody.module').then(m => m.AddOpeningBalanceCustodyModule)
  //  },
  //  {
  //    path: 'custody/openingbalancecustody/addopeningbalancecustody/:id',
  //    loadChildren: () => import('./custodycomponents/openingbalancecustody/addopeningbalancecustody/addOpeningBalanceCustody.module').then(m => m.AddOpeningBalanceCustodyModule)
  //  },
  //  {
  //    path: 'custody/openingbalancecustody/fetchopeningbalancecustody',
  //    loadChildren: () => import('./custodycomponents/openingbalancecustody/fetchopeningbalancecustody/fetchOpeningBalanceCustody.module').then(m => m.FetchOpeningBalanceCustodyModule)
  //  },
  //  {
  //    path: 'custody/issuetotruck/addissuetotruck',
  //    loadChildren: () => import('./custodycomponents/issuetotruck/addissuetotruck/addIssueToTruck.module').then(m => m.AddIssueToTruckModule)
  //  },
  //  {
  //    path: 'custody/issuetotruck/addissuetotruck/:id',
  //    loadChildren: () => import('./custodycomponents/issuetotruck/addissuetotruck/addIssueToTruck.module').then(m => m.AddIssueToTruckModule)
  //  },
  //  {
  //    path: 'custody/issuetotruck/fetchissuetotruck',
  //    loadChildren: () => import('./custodycomponents/issuetotruck/fetchissuetotruck/fetchIssueToTruck.module').then(m => m.FetchIssueToTruckModule)
  //  },
  //  {
  //    path: 'custody/receiptfromtruck/addreceiptfromtruck',
  //    loadChildren: () => import('./custodycomponents/receiptfromtruck/addreceiptfromtruck/addReceiptFromTruck.module').then(m => m.AddReceiptFromTruckModule)
  //  },
  //  {
  //    path: 'custody/receiptfromtruck/addreceiptfromtruck/:id',
  //    loadChildren: () => import('./custodycomponents/receiptfromtruck/addreceiptfromtruck/addReceiptFromTruck.module').then(m => m.AddReceiptFromTruckModule)
  //  },
  //  {
  //    path: 'custody/receiptfromtruck/fetchreceiptfromtruck',
  //    loadChildren: () => import('./custodycomponents/receiptfromtruck/fetchreceiptfromtruck/fetchReceiptFromTruck.module').then(m => m.FetchReceiptFromTruckModule)
  //  },

  //  {
  //    path: 'finance/audittransaction/addaudittransaction',
  //    loadChildren: () => import('./financecomponents/audittransaction/addaudittransaction/addAuditTransaction.module').then(m => m.AddAuditTransactionModule)
  //  },
  //  {
  //    path: 'finance/audittransaction/addaudittransaction/:id',
  //    loadChildren: () => import('./financecomponents/audittransaction/addaudittransaction/addAuditTransaction.module').then(m => m.AddAuditTransactionModule)
  //  },

  //  {
  //    path: 'finance/audittransaction/fetchaudittransaction',
  //    loadChildren: () => import('./financecomponents/audittransaction/fetchaudittransaction/fetchAuditTransaction.module').then(m => m.FetchAuditTransactionModule)
  //  },

  //  {
  //    path: 'custody/openingbalancecustody/addopeningbalancecustody',
  //    loadChildren: () => import('./custodycomponents/openingbalancecustody/addopeningbalancecustody/addOpeningBalanceCustody.module').then(m => m.AddOpeningBalanceCustodyModule)
  //  },
  //  {
  //    path: 'custody/openingbalancecustody/addopeningbalancecustody/:id',
  //    loadChildren: () => import('./custodycomponents/openingbalancecustody/addopeningbalancecustody/addOpeningBalanceCustody.module').then(m => m.AddOpeningBalanceCustodyModule)
  //  },
  //  {
  //    path: 'custody/openingbalancecustody/fetchopeningbalancecustody',
  //    loadChildren: () => import('./custodycomponents/openingbalancecustody/fetchopeningbalancecustody/fetchOpeningBalanceCustody.module').then(m => m.FetchOpeningBalanceCustodyModule)
  //  },
  //  {
  //    path: 'custody/issuetotruck/addissuetotruck',
  //    loadChildren: () => import('./custodycomponents/issuetotruck/addissuetotruck/addIssueToTruck.module').then(m => m.AddIssueToTruckModule)
  //  },
  //  {
  //    path: 'custody/issuetotruck/addissuetotruck/:id',
  //    loadChildren: () => import('./custodycomponents/issuetotruck/addissuetotruck/addIssueToTruck.module').then(m => m.AddIssueToTruckModule)
  //  },
  //  {
  //    path: 'custody/issuetotruck/fetchissuetotruck',
  //    loadChildren: () => import('./custodycomponents/issuetotruck/fetchissuetotruck/fetchIssueToTruck.module').then(m => m.FetchIssueToTruckModule)
  //  },
  //  {
  //    path: 'custody/receiptfromtruck/addreceiptfromtruck',
  //    loadChildren: () => import('./custodycomponents/receiptfromtruck/addreceiptfromtruck/addReceiptFromTruck.module').then(m => m.AddReceiptFromTruckModule)
  //  },
  //  {
  //    path: 'custody/receiptfromtruck/addreceiptfromtruck/:id',
  //    loadChildren: () => import('./custodycomponents/receiptfromtruck/addreceiptfromtruck/addReceiptFromTruck.module').then(m => m.AddReceiptFromTruckModule)
  //  },
  //  {
  //    path: 'custody/receiptfromtruck/fetchreceiptfromtruck',
  //    loadChildren: () => import('./custodycomponents/receiptfromtruck/fetchreceiptfromtruck/fetchReceiptFromTruck.module').then(m => m.FetchReceiptFromTruckModule)
  //  },


  //  {
  //    path: 'hrm/taxes/addtaxes',
  //    loadChildren: () => import('./hrmcomponents/taxes/addtaxes/addTaxes.module').then(m => m.AddTaxesModule)
  //  },
  //  {
  //    path: 'hrm/taxes/addtaxes/:id',
  //    loadChildren: () => import('./hrmcomponents/taxes/addtaxes/addTaxes.module').then(m => m.AddTaxesModule)
  //  },
  //  {
  //    path: 'hrm/taxes/fetchtaxes',
  //    loadChildren: () => import('./hrmcomponents/taxes/fetchtaxes/fetchTaxes.module').then(m => m.FetchTaxesModule)
  //  },

  //  {
  //    path: 'cms/containerfillingatcontainerpark/addcontainerfillingatcontainerpark',
  //    loadChildren: () => import('./cmscomponents/containerfillingatcontainerpark/addcontainerfillingatcontainerpark/addContainerFillingAtContainerPark.module').then(m => m.AddContainerFillingAtContainerParkModule)
  //  },
  //  {
  //    path: 'cms/containerfillingatcontainerpark/addcontainerfillingatcontainerpark/:id',
  //    loadChildren: () => import('./cmscomponents/containerfillingatcontainerpark/addcontainerfillingatcontainerpark/addContainerFillingAtContainerPark.module').then(m => m.AddContainerFillingAtContainerParkModule)
  //  },
  //  {
  //    path: 'cms/containerfillingatcontainerpark/fetchcontainerfillingatcontainerpark',
  //    loadChildren: () => import('./cmscomponents/containerfillingatcontainerpark/fetchcontainerfillingatcontainerpark/fetchContainerFillingAtContainerPark.module').then(m => m.FetchContainerFillingAtContainerParkModule)
  //  },

  //  {
  //    path: 'hrm/extraleaves/addextraleaves',
  //    loadChildren: () => import('./hrmcomponents/extraleaves/addextraleaves/addExtraLeaves.module').then(m => m.AddExtraLeavesModule)
  //  },
  //  {
  //    path: 'hrm/extraleaves/addextraleaves/:id',
  //    loadChildren: () => import('./hrmcomponents/extraleaves/addextraleaves/addExtraLeaves.module').then(m => m.AddExtraLeavesModule)
  //  },
  //  {
  //    path: 'hrm/extraleaves/fetchextraleaves',
  //    loadChildren: () => import('./hrmcomponents/extraleaves/fetchextraleaves/fetchExtraLeaves.module').then(m => m.FetchExtraLeavesModule)
  //  },


  //  {
  //    path: 'inventory/wheatdispatchnoteafs/addwheatdispatchnoteafs',
  //    loadChildren: () => import('./inventorycomponents/wheatdispatchnoteafs/addwheatdispatchnoteafs/addWheatDispatchNoteAFS.module').then(m => m.AddWheatDispatchNoteAFSModule)
  //  },
  //  {
  //    path: 'inventory/wheatdispatchnoteafs/addwheatdispatchnoteafs/:id',
  //    loadChildren: () => import('./inventorycomponents/wheatdispatchnoteafs/addwheatdispatchnoteafs/addWheatDispatchNoteAFS.module').then(m => m.AddWheatDispatchNoteAFSModule)
  //  },
  //  {
  //    path: 'inventory/wheatdispatchnoteafs/fetchwheatdispatchnoteafs',
  //    loadChildren: () => import('./inventorycomponents/wheatdispatchnoteafs/fetchwheatdispatchnoteafs/fetchWheatDispatchNoteAFS.module').then(m => m.FetchWheatDispatchNoteAFSModule)
  //  },

  //  {
  //    path: 'report/finance/agewisereceivablewithduereport',
  //    loadChildren: () => import('./reports/finance/AgewiseReceivableWithDue/AgewiseReceivableWithDueReport.module').then(m => m.AgewiseReceivableWithDueReportModule)
  //  },
  //  {
  //    path: 'report/finance/agewisepayablewithduereport',
  //    loadChildren: () => import('./reports/finance/AgewisePayableWithDue/AgewisePayableWithDueReport.module').then(m => m.AgewisePayableWithDueReportModule)
  //  },



  //  {
  //    path: 'inventory/lenderinvoice/addlenderinvoice',
  //    loadChildren: () => import('./inventorycomponents/lenderinvoice/addlenderinvoice/addLenderInvoice.module').then(m => m.AddLenderInvoiceModule)
  //  },
  //  {
  //    path: 'inventory/lenderinvoice/addlenderinvoice/:id',
  //    loadChildren: () => import('./inventorycomponents/lenderinvoice/addlenderinvoice/addLenderInvoice.module').then(m => m.AddLenderInvoiceModule)
  //  },
  //  {
  //    path: 'inventory/lenderinvoice/fetchlenderinvoice',
  //    loadChildren: () => import('./inventorycomponents/lenderinvoice/fetchlenderinvoice/fetchLenderInvoice.module').then(m => m.FetchLenderInvoiceModule)
  //  },

  //  {
  //    path: 'finance/transwisesegmentupdate/addtranswisesegmentupdate',
  //    loadChildren: () => import('./financecomponents/transwisesegmentupdate/addtranswisesegmentupdate/addTransWiseSegmentUpdate.module').then(m => m.AddTransWiseSegmentUpdateModule)
  //  },
  //  {
  //    path: 'finance/transwisesegmentupdate/addtranswisesegmentupdate/:id',
  //    loadChildren: () => import('./financecomponents/transwisesegmentupdate/addtranswisesegmentupdate/addTransWiseSegmentUpdate.module').then(m => m.AddTransWiseSegmentUpdateModule)
  //  },
  //  {
  //    path: 'finance/transwisesegmentupdate/fetchtranswisesegmentupdate',
  //    loadChildren: () => import('./financecomponents/transwisesegmentupdate/fetchtranswisesegmentupdate/fetchTransWiseSegmentUpdate.module').then(m => m.FetchTransWiseSegmentUpdateModule)
  //  },
  //  {
  //    path: 'finance/openingbalance/addopeningbalancefulldetails',
  //    loadChildren: () => import('./financecomponents/openingbalance/addopeningbalancefulldetails/addOpeningBalanceFullDetails.module').then(m => m.AddOpeningBalanceFullDetailsModule)
  //  },
  //  {
  //    path: 'finance/openingbalance/addopeningbalancefulldetails/:id',
  //    loadChildren: () => import('./financecomponents/openingbalance/addopeningbalancefulldetails/addOpeningBalanceFullDetails.module').then(m => m.AddOpeningBalanceFullDetailsModule)
  //  },
  //  {
  //    path: 'finance/openingbalance/fetchopeningbalancefulldetails',
  //    loadChildren: () => import('./financecomponents/openingbalance/fetchopeningbalancefulldetails/fetchOpeningBalanceFullDetails.module').then(m => m.FetchOpeningBalanceFullDetailsModule)
  //  },
  //  {
  //    path: 'inventory/locationtransferindent/addlocationtransferindent',
  //    loadChildren: () => import('./inventorycomponents/locationtransferindent/addlocationtransferindent/addLocationTransferIndent.module').then(m => m.AddLocationTransferIndentModule)
  //  },
  //  {
  //    path: 'inventory/locationtransferindent/addlocationtransferindent/:id',
  //    loadChildren: () => import('./inventorycomponents/locationtransferindent/addlocationtransferindent/addLocationTransferIndent.module').then(m => m.AddLocationTransferIndentModule)
  //  },
  //  {
  //    path: 'inventory/locationtransferindent/fetchlocationtransferindent',
  //    loadChildren: () => import('./inventorycomponents/locationtransferindent/fetchlocationtransferindent/fetchLocationTransferIndent.module').then(m => m.FetchLocationTransferIndentModule)
  //  },

  //  {
  //    path: 'finance/multiplecustomerreceipt/addmultiplecustomerreceipt',
  //    loadChildren: () => import('./financecomponents/multiplecustomerreceipt/addmultiplecustomerreceipt/addMultipleCustomerReceipt.module').then(m => m.AddMultipleCustomerReceiptModule)
  //  },
  //  {
  //    path: 'finance/multiplecustomerreceipt/addmultiplecustomerreceipt/:id',
  //    loadChildren: () => import('./financecomponents/multiplecustomerreceipt/addmultiplecustomerreceipt/addMultipleCustomerReceipt.module').then(m => m.AddMultipleCustomerReceiptModule)
  //  },
  //  {
  //    path: 'finance/multiplecustomerreceipt/fetchmultiplecustomerreceipt',
  //    loadChildren: () => import('./financecomponents/multiplecustomerreceipt/fetchmultiplecustomerreceipt/fetchMultipleCustomerReceipt.module').then(m => m.FetchMultipleCustomerReceiptModule)
  //  },


  //  {
  //    path: 'finance/accountadjustment/addaccountadjustment',
  //    loadChildren: () => import('./financecomponents/accountadjustment/addaccountadjustment/addAccountAdjustment.module').then(m => m.AddAccountAdjustmentModule)
  //  },
  //  {
  //    path: 'finance/accountadjustment/addaccountadjustment/:id',
  //    loadChildren: () => import('./financecomponents/accountadjustment/addaccountadjustment/addAccountAdjustment.module').then(m => m.AddAccountAdjustmentModule)
  //  },
  //  {
  //    path: 'finance/accountadjustment/addaccountadjustment/:id/:isView',
  //    loadChildren: () => import('./financecomponents/accountadjustment/addaccountadjustment/addAccountAdjustment.module').then(m => m.AddAccountAdjustmentModule)
  //  },

  {
    path: 'procurement/transportcharges2/addtransportcharges2',
    loadChildren: () => import('./procurementcomponents/transportcharges2/addtransportcharges2/addTransportCharges2.module').then(m => m.AddTransportCharges2Module)
  },
  {
    path: 'procurement/transportcharges2/addtransportcharges2/:id',
    loadChildren: () => import('./procurementcomponents/transportcharges2/addtransportcharges2/addTransportCharges2.module').then(m => m.AddTransportCharges2Module)
  },
  {
    path: 'procurement/transportcharges2/fetchtransportcharges2',
    loadChildren: () => import('./procurementcomponents/transportcharges2/fetchtransportcharges2/fetchTransportCharges2.module').then(m => m.FetchTransportCharges2Module)
  },

  //  {
  //    path: 'finance/cjournalvoucherimport/addcjournalvoucherimport',
  //    loadChildren: () => import('./financecomponents/cjournalvoucher/addcjournalvoucherimport/addCJournalVoucherImport.module').then(m => m.AddCJournalVoucherImportModule)
  //  },
  //  {
  //    path: 'finance/paymentrequest1/addpaymentrequest1',
  //    loadChildren: () => import('./financecomponents/paymentrequest1/addpaymentrequest1/addPaymentRequest1.module').then(m => m.AddPaymentRequest1Module)
  //  },
  //  {
  //    path: 'finance/paymentrequest1/addpaymentrequest1/:id',
  //    loadChildren: () => import('./financecomponents/paymentrequest1/addpaymentrequest1/addPaymentRequest1.module').then(m => m.AddPaymentRequest1Module)
  //  },
  //  {
  //    path: 'finance/paymentrequest1/fetchpaymentrequest1',
  //    loadChildren: () => import('./financecomponents/paymentrequest1/fetchpaymentrequest1/fetchPaymentRequest1.module').then(m => m.FetchPaymentRequest1Module)
  //  },
  //  {
  //    path: 'general/feature/userapproveaccess',
  //    loadChildren: () => import('./generalcomponents/feature/userapproveaccess/userapproveaccess.module').then(m => m.UserApproveAccessModule)
  //  },


  //  {
  //    path: 'sales/miscellaneousinvoice/addmiscellaneousinvoice',
  //    loadChildren: () => import('./salescomponents/miscellaneousinvoice/addmiscellaneousinvoice/addMiscellaneousInvoice.module').then(m => m.AddMiscellaneousInvoiceModule)
  //  },
  //  {
  //    path: 'sales/miscellaneousinvoice/addmiscellaneousinvoice/:id',
  //    loadChildren: () => import('./salescomponents/miscellaneousinvoice/addmiscellaneousinvoice/addMiscellaneousInvoice.module').then(m => m.AddMiscellaneousInvoiceModule)
  //  },
  //  {
  //    path: 'sales/miscellaneousinvoice/fetchmiscellaneousinvoice',
  //    loadChildren: () => import('./salescomponents/miscellaneousinvoice/fetchmiscellaneousinvoice/fetchMiscellaneousInvoice.module').then(m => m.FetchMiscellaneousInvoiceModule)
  //  },


  //  {
  //    path: 'finance/transactionamendment/addtransactionamendment',
  //    loadChildren: () => import('./financecomponents/transactionamendment/addtransactionamendment/addTransactionAmendment.module').then(m => m.AddTransactionAmendmentModule)
  //  },
  //  {
  //    path: 'finance/transactionamendment/addtransactionamendment/:id',
  //    loadChildren: () => import('./financecomponents/transactionamendment/addtransactionamendment/addTransactionAmendment.module').then(m => m.AddTransactionAmendmentModule)
  //  },
  //  {
  //    path: 'finance/transactionamendment/fetchtransactionamendment',
  //    loadChildren: () => import('./financecomponents/transactionamendment/fetchtransactionamendment/fetchTransactionAmendment.module').then(m => m.FetchTransactionAmendmentModule)
  //  },

  //  {
  //    path: 'userchat',
  //    loadChildren: () => import('./generalcomponents/userchat/addUserChat.module').then(m => m.AddUserChatModule)
  //  },
  //  {
  //    path: 'sales/salestarget/addsalestarget',
  //    loadChildren: () => import('./salescomponents/salestarget/addsalestarget/addSalesTarget.module').then(m => m.AddSalesTargetModule)
  //  },
  //  {
  //    path: 'sales/salestarget/addsalestarget/:id',
  //    loadChildren: () => import('./salescomponents/salestarget/addsalestarget/addSalesTarget.module').then(m => m.AddSalesTargetModule)
  //  },
  //  {
  //    path: 'sales/salestarget/fetchsalestarget',
  //    loadChildren: () => import('./salescomponents/salestarget/fetchsalestarget/fetchSalesTarget.module').then(m => m.FetchSalesTargetModule)
  //  },

  //  {
  //    path: 'hrm/ticketbookinginformation/addticketbookinginformation',
  //    loadChildren: () => import('./hrmcomponents/ticketbookinginformation/addticketbookinginformation/addTicketBookingInformation.module').then(m => m.AddTicketBookingInformationModule)
  //  },
  //  {
  //    path: 'hrm/ticketbookinginformation/addticketbookinginformation/:id',
  //    loadChildren: () => import('./hrmcomponents/ticketbookinginformation/addticketbookinginformation/addTicketBookingInformation.module').then(m => m.AddTicketBookingInformationModule)
  //  },

  //  {
  //    path: 'hrm/ticketbookinginformation/fetchticketbookinginformation',
  //    loadChildren: () => import('./hrmcomponents/ticketbookinginformation/fetchticketbookinginformation/fetchTicketBookingInformation.module').then(m => m.FetchTicketBookingInformationModule)
  //  },

  //  //
  //              {
  //                  path: 'inventory/locationtransferissue1/addlocationtransferissue1',
  //                  loadChildren: () => import('./inventorycomponents/locationtransferissue1/addlocationtransferissue1/addLocationTransferIssue1.module').then(m => m.AddLocationTransferIssue1Module)
  //              },
  //              {
  //                  path: 'inventory/locationtransferissue1/addlocationtransferissue1/:id',
  //                  loadChildren: () => import('./inventorycomponents/locationtransferissue1/addlocationtransferissue1/addLocationTransferIssue1.module').then(m => m.AddLocationTransferIssue1Module)
  //              },
  //              {
  //                  path: 'inventory/locationtransferissue1/fetchlocationtransferissue1',
  //                  loadChildren: () => import('./inventorycomponents/locationtransferissue1/fetchlocationtransferissue1/fetchLocationTransferIssue1.module').then(m => m.FetchLocationTransferIssue1Module)
  //              },
  //              //
  //              {
  //                  path: 'inventory/locationtransferreceipt1/addlocationtransferreceipt1',
  //                  loadChildren: () => import('./inventorycomponents/locationtransferreceipt1/addlocationtransferreceipt1/addLocationTransferReceipt1.module').then(m => m.AddLocationTransferReceipt1Module)
  //              },
  //              {
  //                  path: 'inventory/locationtransferreceipt1/addlocationtransferreceipt1/:id',
  //                  loadChildren: () => import('./inventorycomponents/locationtransferreceipt1/addlocationtransferreceipt1/addLocationTransferReceipt1.module').then(m => m.AddLocationTransferReceipt1Module)
  //              },
  //              {
  //                  path: 'inventory/locationtransferreceipt1/fetchlocationtransferreceipt1',
  //                  loadChildren: () => import('./inventorycomponents/locationtransferreceipt1/fetchlocationtransferreceipt1/fetchLocationTransferReceipt1.module').then(m => m.FetchLocationTransferReceipt1Module)
  //              },


  //  {
  //    path: 'operations/vehicleregistration/addvehicleregistration',
  //    loadChildren: () => import('./operationscomponents/vehicleregistration/addvehicleregistration/addVehicleRegistration.module').then(m => m.AddVehicleRegistrationModule)
  //  },
  //  {
  //    path: 'operations/vehicleregistration/addvehicleregistration/:id',
  //    loadChildren: () => import('./operationscomponents/vehicleregistration/addvehicleregistration/addVehicleRegistration.module').then(m => m.AddVehicleRegistrationModule)
  //  },
  //  {
  //    path: 'operations/vehicleregistration/fetchvehicleregistration',
  //    loadChildren: () => import('./operationscomponents/vehicleregistration/fetchvehicleregistration/fetchVehicleRegistration.module').then(m => m.FetchVehicleRegistrationModule)
  //  },


  //  {
  //    path: 'procurement/transporteradjustmentinvoice/addtransporteradjustmentinvoice',
  //    loadChildren: () => import('./procurementcomponents/transporteradjustmentinvoice/addtransporteradjustmentinvoice/addTransporterAdjustmentInvoice.module').then(m => m.AddTransporterAdjustmentInvoiceModule)
  //  },
  //  {
  //    path: 'procurement/transporteradjustmentinvoice/addtransporteradjustmentinvoice/:id',
  //    loadChildren: () => import('./procurementcomponents/transporteradjustmentinvoice/addtransporteradjustmentinvoice/addTransporterAdjustmentInvoice.module').then(m => m.AddTransporterAdjustmentInvoiceModule)
  //  },
  //  {
  //    path: 'procurement/transporteradjustmentinvoice/fetchtransporteradjustmentinvoice',
  //    loadChildren: () => import('./procurementcomponents/transporteradjustmentinvoice/fetchtransporteradjustmentinvoice/fetchTransporterAdjustmentInvoice.module').then(m => m.FetchTransporterAdjustmentInvoiceModule)
  //  },

  //{
  //  path: 'hrm/dynamicobjectives/adddynamicobjectives',
  //  loadChildren: () => import('./hrmcomponents/dynamicobjectives/adddynamicobjectives/addDynamicObjectives.module').then(m => m.AddDynamicObjectivesModule)
  //},
  //{
  //  path: 'hrm/dynamicobjectives/adddynamicobjectives/:id',
  //  loadChildren: () => import('./hrmcomponents/dynamicobjectives/adddynamicobjectives/addDynamicObjectives.module').then(m => m.AddDynamicObjectivesModule)
  //},
  //{
  //  path: 'hrm/dynamicobjectives/fetchdynamicobjectives',
  //  loadChildren: () => import('./hrmcomponents/dynamicobjectives/fetchdynamicobjectives/fetchDynamicObjectives.module').then(m => m.FetchDynamicObjectivesModule)
  //},

  {
    path: 'hrm/dynamicobjectives/adddynamicobjectives',
    loadChildren: () => import('./hrmcomponents/dynamicobjectivesv1/adddynamicobjectives/addDynamicObjectivesV1.module').then(m => m.AddDynamicObjectivesV1Module)
  },
  {
    path: 'hrm/dynamicobjectives/adddynamicobjectives/:id',
    loadChildren: () => import('./hrmcomponents/dynamicobjectivesv1/adddynamicobjectives/addDynamicObjectivesV1.module').then(m => m.AddDynamicObjectivesV1Module)
  },
  {
    path: 'hrm/dynamicobjectives/fetchdynamicobjectives',
    loadChildren: () => import('./hrmcomponents/dynamicobjectivesv1/fetchdynamicobjectives/fetchDynamicObjectivesV1.module').then(m => m.FetchDynamicObjectivesV1Module)
  },

  {
    path: 'hrm/dynamicobjectives/adddynamicobjectiveschangerequest',
    loadChildren: () => import('./hrmcomponents/dynamicobjectiveschangerequest/adddynamicobjectiveschangerequest/addDynamicObjectivesChangeRequest.module').then(m => m.AddDynamicObjectivesChangeRequestModule)
  },
  {
    path: 'hrm/dynamicobjectives/adddynamicobjectiveschangerequest/:id',
    loadChildren: () => import('./hrmcomponents/dynamicobjectiveschangerequest/adddynamicobjectiveschangerequest/addDynamicObjectivesChangeRequest.module').then(m => m.AddDynamicObjectivesChangeRequestModule)
  },
  {
    path: 'hrm/dynamicobjectives/fetchdynamicobjectiveschangerequest',
    loadChildren: () => import('./hrmcomponents/dynamicobjectiveschangerequest/fetchdynamicobjectiveschangerequest/fetchDynamicObjectivesChangeRequest.module').then(m => m.FetchDynamicObjectivesChangeRequestModule)
  },

  //  {
  //    path: 'hrm/competenciesobjectives/addcompetenciesobjectives',
  //    loadChildren: () => import('./hrmcomponents/competenciesobjectives/addcompetenciesobjectives/addCompetenciesObjectives.module').then(m => m.AddCompetenciesObjectivesModule)
  //  },
  //  {
  //    path: 'hrm/competenciesobjectives/addcompetenciesobjectives/:id',
  //    loadChildren: () => import('./hrmcomponents/competenciesobjectives/addcompetenciesobjectives/addCompetenciesObjectives.module').then(m => m.AddCompetenciesObjectivesModule)
  //  },
  //  {
  //    path: 'hrm/competenciesobjectives/fetchcompetenciesobjectives',
  //    loadChildren: () => import('./hrmcomponents/competenciesobjectives/fetchcompetenciesobjectives/fetchCompetenciesObjectives.module').then(m => m.FetchCompetenciesObjectivesModule)
  //  },

  {
    path: 'hrm/competenciesobjectivesmaster/addcompetenciesobjectivesmaster',
    loadChildren: () => import('./hrmcomponents/competenciesobjectivesmaster/addcompetenciesobjectivesmaster/addCompetenciesObjectivesMaster.module').then(m => m.AddCompetenciesObjectivesMasterModule)
  },
  {
    path: 'hrm/competenciesobjectivesmaster/addcompetenciesobjectivesmaster/:id',
    loadChildren: () => import('./hrmcomponents/competenciesobjectivesmaster/addcompetenciesobjectivesmaster/addCompetenciesObjectivesMaster.module').then(m => m.AddCompetenciesObjectivesMasterModule)
  },
  {
    path: 'hrm/competenciesobjectivesmaster/fetchcompetenciesobjectivesmaster',
    loadChildren: () => import('./hrmcomponents/competenciesobjectivesmaster/fetchcompetenciesobjectivesmaster/fetchCompetenciesObjectivesMaster.module').then(m => m.FetchCompetenciesObjectivesMasterModule)
  },

  {
    path: 'hrm/constantobjectives/addconstantobjectives',
    loadChildren: () => import('./hrmcomponents/constantobjectives/addconstantobjectives/addConstantObjectives.module').then(m => m.AddConstantObjectivesModule)
  },
  {
    path: 'hrm/constantobjectives/addconstantobjectives/:id',
    loadChildren: () => import('./hrmcomponents/constantobjectives/addconstantobjectives/addConstantObjectives.module').then(m => m.AddConstantObjectivesModule)
  },
  {
    path: 'hrm/constantobjectives/fetchconstantobjectives',
    loadChildren: () => import('./hrmcomponents/constantobjectives/fetchconstantobjectives/fetchConstantObjectives.module').then(m => m.FetchConstantObjectivesModule)
  },

  //{
  //  path: 'hrm/employeeperformance/addemployeeperformance',
  //  loadChildren: () => import('./hrmcomponents/employeeperformance/addemployeeperformance/addEmployeePerformance.module').then(m => m.AddEmployeePerformanceModule)
  //},
  //{
  //  path: 'hrm/employeeperformance/addemployeeperformance/:id',
  //  loadChildren: () => import('./hrmcomponents/employeeperformance/addemployeeperformance/addEmployeePerformance.module').then(m => m.AddEmployeePerformanceModule)
  //},
  //{
  //  path: 'hrm/employeeperformance/fetchemployeeperformance',
  //  loadChildren: () => import('./hrmcomponents/employeeperformance/fetchemployeeperformance/fetchEmployeePerformance.module').then(m => m.FetchEmployeePerformanceModule)
  //},

  {
    path: 'hrm/employeeperformance/addemployeeperformance',
    loadChildren: () => import('./hrmcomponents/employeeperformancev1/addemployeeperformance/addEmployeePerformanceV1.module').then(m => m.AddEmployeePerformanceV1Module)
  },
  {
    path: 'hrm/employeeperformance/addemployeeperformance/:id',
    loadChildren: () => import('./hrmcomponents/employeeperformancev1/addemployeeperformance/addEmployeePerformanceV1.module').then(m => m.AddEmployeePerformanceV1Module)
  },
  {
    path: 'hrm/employeeperformance/fetchemployeeperformance',
    loadChildren: () => import('./hrmcomponents/employeeperformancev1/fetchemployeeperformance/fetchEmployeePerformanceV1.module').then(m => m.FetchEmployeePerformanceV1Module)
  },

  //
  {
    path: 'hrm/employeeperformanceyearly/addemployeeperformanceyearly',
    loadChildren: () => import('./hrmcomponents/employeeperformanceyearly/addemployeeperformanceyearly/addEmployeePerformanceYearly.module').then(m => m.AddEmployeePerformanceYearlyModule)
  },
  {
    path: 'hrm/employeeperformanceyearly/addemployeeperformanceyearly/:id',
    loadChildren: () => import('./hrmcomponents/employeeperformanceyearly/addemployeeperformanceyearly/addEmployeePerformanceYearly.module').then(m => m.AddEmployeePerformanceYearlyModule)
  },
  {
    path: 'hrm/employeeperformanceyearly/fetchemployeeperformanceyearly',
    loadChildren: () => import('./hrmcomponents/employeeperformanceyearly/fetchemployeeperformanceyearly/fetchEmployeePerformanceYearly.module').then(m => m.FetchEmployeePerformanceYearlyModule)
  },


  //  {
  //    path: 'finance/empadjustment/addempadjustment',
  //    loadChildren: () => import('./financecomponents/empadjustment/addempadjustment/addEMPAdjustment.module').then(m => m.AddEMPAdjustment2Module)
  //  },
  //  {
  //    path: 'finance/empadjustment/addempadjustment/:id',
  //    loadChildren: () => import('./financecomponents/empadjustment/addempadjustment/addEMPAdjustment.module').then(m => m.AddEMPAdjustment2Module)
  //  },
  //  {
  //    path: 'finance/empadjustment/addempadjustment/:id/:isView',
  //    loadChildren: () => import('./financecomponents/empadjustment/addempadjustment/addEMPAdjustment.module').then(m => m.AddEMPAdjustment2Module)
  //  },

  //  {
  //    path: 'hrm/leavereceipt/addleavereceipt',
  //    loadChildren: () => import('./hrmcomponents/leavereceipt/addleavereceipt/addLeaveReceipt.module').then(m => m.AddLeaveReceiptModule)
  //  },
  //  {
  //    path: 'hrm/leavereceipt/addleavereceipt/:id',
  //    loadChildren: () => import('./hrmcomponents/leavereceipt/addleavereceipt/addLeaveReceipt.module').then(m => m.AddLeaveReceiptModule)
  //  },

  //  {
  //    path: 'hrm/evaluater/addevaluater',
  //    loadChildren: () => import('./hrmcomponents/evaluater/addevaluater/addEvaluater.module').then(m => m.AddEvaluaterModule)
  //  },

  //  {
  //    path: 'hrm/evaluatee/addevaluatee/:id',
  //    loadChildren: () => import('./hrmcomponents/evaluatee/addevaluatee/addEvaluatee.module').then(m => m.AddEvaluateeModule)
  //  },
  //  {
  //    path: 'hrm/evaluatee/addevaluatee',
  //    loadChildren: () => import('./hrmcomponents/evaluatee/addevaluatee/addEvaluatee.module').then(m => m.AddEvaluateeModule)
  //  },
  //  {
  //    path: 'hrm/evaluatee/fetchevaluatee',
  //    loadChildren: () => import('./hrmcomponents/evaluatee/fetchevaluatee/fetchEvaluatee.module').then(m => m.FetchEvaluateeModule)
  //  },


  //  {
  //    path: 'finance/discount/adddiscount',
  //    loadChildren: () => import('./financecomponents/discount/adddiscount/addDiscount.module').then(m => m.AddDiscountModule)
  //  },
  //  {
  //    path: 'finance/discount/adddiscount/:id',
  //    loadChildren: () => import('./financecomponents/discount/adddiscount/addDiscount.module').then(m => m.AddDiscountModule)
  //  },
  //  {
  //    path: 'finance/discount/fetchdiscount',
  //    loadChildren: () => import('./financecomponents/discount/fetchdiscount/fetchDiscount.module').then(m => m.FetchDiscountModule)
  //  },
  //  {
  //    path: 'report/sales/customerwisesalesinvoice',
  //    loadChildren: () => import('./reports/sales/customerwisesalesinvoice/CustomerwiseSalesInvoiceReport.module').then(m => m.CustomerwiseSalesInvoiceReportModule)
  //  },
  //  {
  //    path: 'report/finance/ageingreceivableswithduecommodityreport',
  //    loadChildren: () => import('./reports/finance/AgeingReceivableswithduecommodity/AgeingReceivablesWithDueCommodityReport.module').then(m => m.AgeingReceivablesWithDueCommodityReportModule)
  //  },
  //  {
  //    path: 'report/finance/ageingreceivableswithdueflourcommodityreport',
  //    loadChildren: () => import('./reports/finance/AgeingReceivableswithdueflourcommodity/AgeingReceivablesWithDueFlourCommodityReport.module').then(m => m.AgeingReceivablesWithDueFlourCommodityReportModule)
  //  },

  //  {
  //    path: 'sales/taxonsales/addtaxonsales',
  //    loadChildren: () => import('./salescomponents/taxonsales/addtaxonsales/addTaxOnSales.module').then(m => m.AddTaxOnSalesModule)
  //  },
  //  {
  //    path: 'sales/taxonsales/addtaxonsales/:id',
  //    loadChildren: () => import('./salescomponents/taxonsales/addtaxonsales/addTaxOnSales.module').then(m => m.AddTaxOnSalesModule)
  //  },
  //  {
  //    path: 'sales/taxonsales/fetchtaxonsales',
  //    loadChildren: () => import('./salescomponents/taxonsales/fetchtaxonsales/fetchTaxOnSales.module').then(m => m.FetchTaxOnSalesModule)
  //  },


  {
    path: 'hrm/constantobjectivesmaster/addconstantobjectivesmaster',
    loadChildren: () => import('./hrmcomponents/constantobjectivesmaster/addconstantobjectivesmaster/addConstantObjectivesMaster.module').then(m => m.AddConstantObjectivesMasterModule)
  },
  {
    path: 'hrm/constantobjectivesmaster/addconstantobjectivesmaster/:id',
    loadChildren: () => import('./hrmcomponents/constantobjectivesmaster/addconstantobjectivesmaster/addConstantObjectivesMaster.module').then(m => m.AddConstantObjectivesMasterModule)
  },
  {
    path: 'hrm/constantobjectivesmaster/fetchconstantobjectivesmaster',
    loadChildren: () => import('./hrmcomponents/constantobjectivesmaster/fetchconstantobjectivesmaster/fetchConstantObjectivesMaster.module').then(m => m.FetchConstantObjectivesMasterModule)
  },


  {
    path: 'finance/aradjustment3/addaradjustment3',
    loadChildren: () => import('./financecomponents/aradjustment3/addaradjustment3/addARAdjustment3.module').then(m => m.AddARAdjustment3Module)
  },
  {
    path: 'finance/aradjustment3/addaradjustment3/:id',
    loadChildren: () => import('./financecomponents/aradjustment3/addaradjustment3/addARAdjustment3.module').then(m => m.AddARAdjustment3Module)
  },

  {
    path: 'finance/apadjustment/addapadjustment',
    loadChildren: () => import('./financecomponents/apadjustment/addapadjustment/addAPAdjustment.module').then(m => m.AddAPAdjustmentModule)
  },
  {
    path: 'finance/apadjustment/addapadjustment/:id',
    loadChildren: () => import('./financecomponents/apadjustment/addapadjustment/addAPAdjustment.module').then(m => m.AddAPAdjustmentModule)
  },
  //
  {
    path: 'inventory/stockreceiptssistercompany/addstockreceiptssistercompany',
    loadChildren: () => import('./inventorycomponents/stockreceiptssistercompany/addstockreceiptssistercompany/addStockReceiptsSisterCompany.module').then(m => m.AddStockReceiptsSisterCompanyModule)
  },
  {
    path: 'inventory/stockreceiptssistercompany/addstockreceiptssistercompany/:id',
    loadChildren: () => import('./inventorycomponents/stockreceiptssistercompany/addstockreceiptssistercompany/addStockReceiptsSisterCompany.module').then(m => m.AddStockReceiptsSisterCompanyModule)
  },

  {
    path: 'inventory/stockreceiptssistercompany/fetchstockreceiptssistercompany',
    loadChildren: () => import('./inventorycomponents/stockreceiptssistercompany/fetchstockreceiptssistercompany/fetchStockReceiptsSisterCompany.module').then(m => m.FetchStockReceiptsSisterCompanyModule)
  },
  //
  {
    path: 'inventory/sistercompany/addsistercompany',
    loadChildren: () => import('./inventorycomponents/sistercompany/addsistercompany/addSisterCompany.module').then(m => m.AddSisterCompanyModule)
  },
  {
    path: 'inventory/sistercompany/addsistercompany/:id',
    loadChildren: () => import('./inventorycomponents/sistercompany/addsistercompany/addSisterCompany.module').then(m => m.AddSisterCompanyModule)
  },

  {
    path: 'inventory/sistercompany/fetchsistercompany',
    loadChildren: () => import('./inventorycomponents/sistercompany/fetchsistercompany/fetchSisterCompany.module').then(m => m.FetchSisterCompanyModule)
  },
  //
  {
    path: 'inventory/storesissuesistercompany/addstoresissuesistercompany',
    loadChildren: () => import('./inventorycomponents/storesissuesistercompany/addstoresissuesistercompany/addStoresIssueSisterCompany.module').then(m => m.AddStoresIssueSisterCompanyModule)
  },
  {
    path: 'inventory/storesissuesistercompany/addstoresissuesistercompany/:id',
    loadChildren: () => import('./inventorycomponents/storesissuesistercompany/addstoresissuesistercompany/addStoresIssueSisterCompany.module').then(m => m.AddStoresIssueSisterCompanyModule)
  },

  {
    path: 'inventory/storesissuesistercompany/fetchstoresissuesistercompany',
    loadChildren: () => import('./inventorycomponents/storesissuesistercompany/fetchstoresissuesistercompany/fetchStoresIssueSisterCompany.module').then(m => m.FetchStoresIssueSisterCompanyModule)
  },



  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'error/404',
  },
];

export { Routing };
